<template>
  <div> 
    <p v-if="(!isProd() || activeFrontV2) && state !== 'edit-posted'" @click="switchInterface" class="switchOldVersion" style="color: rgb(107, 31, 77); font-size: 15px; font-weight: 500; cursor: pointer; margin-bottom: 17px;float: right;">Testez notre nouvelle interface (beta)</p>
    <component-loader :progress="90" :unlimitedProgress="true" v-if="showLoader" :activeClose="true" v-on:close="showLoader = false"></component-loader>
    <div class="form-wrapper" v-if="validated!==true">
      <div :class="`typePost-wrapper ${false && 'hide-div'}`" v-if="state != 'reshare' && state != 'retweet' && state !== 'edit-posted'">
        <div v-if="standardPostEnabled()" class="typePost" :class="{ 'active' : typePost === 'standard'}" @click="confirmReset('standard')">
          <!-- <input type="radio" name="content" value="standard" v-model="typePost" @change="confirmReset('standard', typePost)"> -->
          <div class="typePost-content">
            <p>{{$t('dash.posts.standard')}}</p>
          </div>
        </div>
        <div class="typePost" :class="{ 'active' : typePost === 'image'}" v-if="activeImage" @click="confirmReset('image')">
          <!-- <input type="radio" name="content" value="image" v-model="typePost" @change="confirmReset('image', typePost)"> -->
          <div class="typePost-content">
            <p>{{$t('dash.posts.image')}}</p>
          </div>
        </div>
        <div class="typePost" :class="{ 'active' : typePost === 'video'}" v-if="activeVideo" @click="confirmReset('video')">
          <!-- <input type="radio" name="content" value="video" v-model="typePost" @change="confirmReset('video', typePost)"> -->
          <div class="typePost-content">
            <p>{{$t('dash.posts.video')}}</p>
          </div>
        </div>
        <div v-if="!activeInstagramStories && onlyInstagramSelected()" class="typePost disabled" :class="[{ 'active' : typePost === 'story'}]">
          <!-- <input type="radio" name="content" value="story" v-model="typePost" :disabled="!hasStoryConfig" @change="confirmReset('story')"> -->
          <div class="typePost-content" @click="changePlanConciergerie = true">
            <Tooltip
                  :text="$t('dash.plan.change_to_get_features')"
                  position="top"
                >
                <p>Story</p>
                &nbsp;
            </Tooltip>
          </div>
        </div>
        <div v-else-if="(activeInstagramStories && onlyInstagramSelected() && getPageInfoByBot(bot[0]).instagram_username) 
          || (bot.length === 0 && getPageInfo && getPageInfo.network === 'instagram' && getPageInfo.instagram_username) || credentialsKnown" 
          class="typePost" :class="[{ 'active' : typePost === 'story', 'disabled': !hasStoryConfig && hasIsGroup}]" @click="hasStoryConfig || !hasIsGroup ? confirmReset('story') : null">
          <!-- <input type="radio" name="content" value="story" v-model="typePost" :disabled="!hasStoryConfig" @change="confirmReset('story')"> -->
          <div class="typePost-content" v-if="!hasStoryConfig && hasIsGroup" @click="showConciergerieForm()">
            <Tooltip 
                  :text="$t('dash.bots.status_proxy')"
                  position="top"
                >
                <p>Story</p>
                &nbsp;
            </Tooltip>
          </div>
          <div class="typePost-content" v-else>
            <p>Story</p>
          </div>
          
        </div>
        <div v-else-if="activeInstagramStories && onlyInstagramSelected() || (bot.length === 0 && getPageInfo && getPageInfo.network === 'instagram')" 
          class="typePost" :class="[{ 'active' : typePost === 'story', 'disabled': !hasStoryConfig && hasIsGroup}]">
          <input type="radio" name="content" value="story" :disabled="!hasStoryConfig" v-model="typePost" @click="showConciergerieForm()">
          
          <div class="typePost-content" v-if="!hasStoryConfig && hasIsGroup" @click="showConciergerieForm()">
            <Tooltip 
                :text="$t('dash.bots.status_proxy')"
                position="top"
            >
                <p>Story</p>
                &nbsp;
            </Tooltip>
          </div>
          <div class="typePost-content" v-else>
            <p>Story</p>
          </div>
        </div>
        <div class="typePost disabled" :class="{ 'active' : typePost === 'document'}" v-if="onlyLinkedinSelected() && !activeLinkedinConciergerie">
          <!-- <input type="radio" name="content" value="document" v-model="typePost" :disabled="true" @change="confirmReset('document')"> -->
          <div class="typePost-content" @click="changePlanConciergerie = true">
            <Tooltip v-if="!hasStoryConfig"
                :text="$t('dash.plan.change_to_get_features')"
                position="top"
            >
              <p>{{$t('dash.posts.document')}}</p>
              &nbsp;
            </Tooltip>
          </div>
        </div>
        <div class="typePost" :class="{ 'active' : typePost === 'document', 'disabled': !hasStoryConfig}" v-if="onlyLinkedinSelected() && activeLinkedinConciergerie" @click="hasStoryConfig ? confirmReset('document') : null">
          <!-- <input type="radio" name="content" value="document" v-model="typePost" :disabled="!hasStoryConfig"  @change="confirmReset('document')"> -->
          <div class="typePost-content" v-if="!hasStoryConfig" @click="showConciergerieForm()">
            <Tooltip
                :text="$t('dash.bots.status_proxy')"
                position="top"
            >
                <p >{{$t('dash.posts.document')}}</p>
                &nbsp;
            </Tooltip>
          </div>
          <div class="typePost-content" v-else>
            <p>{{$t('dash.posts.document')}}</p>
          </div>
        </div>
        <div class="typePost disabled" :class="{ 'active' : typePost === 'poll'}" v-if="onlyLinkedinSelected() && !activeLinkedinConciergerie">
          <!-- <input type="radio" name="content" value="poll" v-model="typePost" :disabled="true" @change="confirmReset('poll')"> -->
          <div class="typePost-content" @click="changePlanConciergerie = true">
            <Tooltip
                :text="$t('dash.plan.change_to_get_features')"
                position="top"
            >
              <p>{{$t('dash.posts.poll')}}</p>
              &nbsp;
            </Tooltip>
          </div>
        </div>
        <div class="typePost" :class="{ 'active' : typePost === 'poll', 'disabled': !hasStoryConfig && !onlyWhatsappSelected()}" v-else-if="(onlyLinkedinSelected() && activeLinkedinConciergerie) || onlyWhatsappSelected()" @click="hasStoryConfig || onlyWhatsappSelected() ? confirmReset('poll') : null">
          <!-- <input type="radio" name="content" value="poll" v-model="typePost" :disabled="!hasStoryConfig" @change="confirmReset('poll')"> -->
          <div class="typePost-content" v-if="!hasStoryConfig && !onlyWhatsappSelected()" @click="showConciergerieForm()">
            <Tooltip
                :text="$t('dash.bots.status_proxy')"
                position="top"
            >
                <p>{{$t('dash.posts.poll')}}</p>
                &nbsp;
            </Tooltip>
          </div>
          <div class="typePost-content" v-else>
            <p>{{$t('dash.posts.poll')}}</p>
          </div>
        </div>
        <vs-prompt class="popup-credentials"
          title="Identifiants Instagram"
          color="info"
          @cancel="() => {instagramCredentialsPopup=false; this.typePost = 'standard'}"
          @accept="sendInstagramCredentials"
          @close="() => {instagramCredentialsPopup=false; this.typePost = 'standard'}"
          :is-valid="instagramUsername.length > 0 && instagramPassword.length > 0"
          :active.sync="instagramCredentialsPopup">
          <div class="con-exemple-prompt">
            <p>Aucun identifiants renseignés pour cette page, ajoutez les : </p>
            <vs-input label="Nom d'utilisateur ou Email" placeholder="" v-model="instagramUsername"/>
            <vs-input type="password" label="Mot de passe" placeholder="" v-model="instagramPassword"/>
            <vs-alert :active="instagramUsername.length === 0 || instagramPassword.length === 0" color="danger" icon="new_releases" >
                Les champs ne peuvent pas être vide.
            </vs-alert>
          </div>
        </vs-prompt>
        
        
      </div>

      <div class="stories-tabs" v-if="typePost=='story'">
        <draggable class="stories-tabs drag-tabs" v-model="storyMultiple">
          <span v-for="(story, idx) of storyMultiple" :class="`stories-tab ${story.isActive && 'active'}`" :key="story.id" @click="selectMultipleStory(idx)">
            {{`Story ${idx+1}`}} 
            <span v-if="storyMultiple.length > 1" class="stories-tab-remove" @click="e => removeMultipleStory(e, idx)">
              <i class="fa-solid fa-plus"></i>
            </span>
          </span>
        </draggable>
          
        <span v-if="storyMultiple.length < 10" class="stories-tab stories-tab-add" @click="addMultipleStory">
          +
        </span>

      </div>

      <!-- <form @submit.prevent="validate('posts')" data-vv-scope="posts"> -->
      <form @submit.prevent="confirmPost" data-vv-scope="posts">
        <div class="form-inputs">
          <!-- <div class="pages-sidebar" :class="{'contract': !advancedTabs}" v-click-outside="contractTabs"> -->
          <div class="pages-sidebar" :class="{'contract': tabsIsMinimize}">
            <div class="table-title" @click="toggleExpandTabs">
                <p>{{$t('dash.posts.title')}}</p>
            </div>
            <div class="show-setting">
              <!-- <i class="material-icons expand-btn minimize" @click="toggleExpandTabs" v-if="advancedTabs">navigate_before</i>
              <i class="material-icons expand-btn maximize" @click="toggleExpandTabs" v-if="!advancedTabs">navigate_next</i> -->
              <i class="material-icons expand-btn minimize" @click="toggleExpandTabs" v-if="!tabsIsMinimize">navigate_before</i>
              <i class="material-icons expand-btn maximize" @click="toggleExpandTabs" v-if="tabsIsMinimize">navigate_next</i>
            </div>
            <div class="search-page">
              <vs-input
                v-model="pageFilter"
                :class="{'input': true}"
                color="#B20564"
                class="inputx"
                icon-after="true"  icon="search"
                :placeholder="$t('dash.settings.user.label.page_filter')"
              />
            </div>
            <div class="filter-selected">
              <span @click="filterSelected = !filterSelected">{{ $t(!filterSelected ? `dash.pages-sidebar.filter-selected${bot.length > 1 ? '-multi' : ''}` : 'dash.pages-sidebar.filter-all') }}</span>
              <Tooltip :text="$t(!selectAllPages ? `dash.pages-sidebar.cta-select-all` : 'dash.pages-sidebar.cta-unselect-all')" position="top">
                <img v-if="!selectAllPages" @click="selectAllPages = !selectAllPages" alt="Select all pages" src="../../../assets/img/select_all_icon.svg">
                <img v-else @click="selectAllPages = !selectAllPages" alt="Unselect pages" src="../../../assets/img/unselect_icon.svg">
                &nbsp;
              </Tooltip>
            </div>
            <ul :class="[{'selected-pages': filterSelected}]">
              <!-- <li class="group" v-for="group in groups" :key="group.id" :class="[{'show': group.show, 'hide': !checkPagesInGroup(group) || checkGroupFilter(group)}]"> -->
              <li class="group" v-for="group in groups.filter(f => (!checkPagesInGroup(f) || checkGroupFilter(f)) == false)" :key="group.id" :class="[{'show': group.show, 'hide': !checkPagesInGroup(group) || checkGroupFilter(group)}]">
                <div class="group-wrapper">
                  <img v-if="!group.show" @click="toggleShowGroup(group)" alt="show group" class="show-group" src="../../../assets/img/icon-show-group.svg"/>
                  <img v-else @click="toggleShowGroup(group)" alt="hide group" class="hide-group" src="../../../assets/img/icon-hide-group.svg"/>
                  <div class="group-content">
                    <Tooltip :text="group.name" position="top">
                      <div class="group-name messagedefilant"><div :data-text="group.name"><span>{{ group.name }}</span></div></div>
                      &nbsp;
                    </Tooltip>
                  </div>
                  <div class="checkbox">
                    <input
                      type="checkbox"
                      :id="`group-${group.id}`"
                      name="groups[]"
                      :value="group.id"
                      v-model="selectedGroups"
                      @change="checkGroup(group)"
                      :disabled="!isUserPremiumActive && !isUserPartner"
                    >
                    <span class="checkmark" :class="[{deselect: checkAllPagesGroupSelected(group)}]">
                      <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                      <span class="material-icons">remove</span>
                    </span>
                  </div>
                </div>
                <ul>
                  <!-- <div v-for="item in group.pages" :key="item">
                    <li class="page" v-if="findPage(item)"
                          :class="[{ disabled: !checkLock(findPage(item).page.network), 'hide': !checkPageFilter(findPage(item).page) || !checkSelected(findPage(item).page) }]"> -->
                  <div v-for="item in group.pages.filter(f => findPage(f) && (!checkPageFilter(findPage(f).page) || !checkSelected(findPage(f).page)) == false)" :key="item">       
                    <li class="page" v-if="findPage(item)" :class="[{ disabled: !checkLock(findPage(item).page.network)}]">
                      <div class="page-wrapper" :class="{disabled: !checkLock(findPage(item).page.network)}">
                        <div class="checkbox">
                          <input
                            type="checkbox"
                            :id="`pages-${findPage(item).id}`"
                            name="pages[]"
                            :value="findPage(item).id"
                            v-model="bot"
                            :disabled="!checkLock(findPage(item).page.network) || (findPage(item).page.network == 'pinterest' && getBoardPagePinterest && getBoardPagePinterest != findPage(item).id) || (!findPage(item).status && ['linkedin', 'instagram'].includes(findPage(item).page.network) && !isConciergerie(findPage(item).page))"
                          >
                          <span class="checkmark"> 
                            <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                          </span>
                        </div>
                        <div class="page-content">
                          <Tooltip :text="(!checkLock(findPage(item).page.network) || (findPage(item).page.network == 'pinterest' && getBoardPagePinterest && getBoardPagePinterest != findPage(item).id) || (!findPage(item).status && ['linkedin', 'instagram'].includes(findPage(item).page.network) && !isConciergerie(findPage(item).page))) 
                                                        ? `${findPage(item).page.name} ${$t('dash.bots.status_ko')}`
                                                        : findPage(item).page.name"
                                      position="top">
                            <page-image-avatar :page="findPage(item).page"/>
                            <div class="page-name messagedefilant"><div :data-text="findPage(item).page.name"><span>{{ findPage(item).page.name }}</span></div></div>
                            &nbsp;
                          </Tooltip>
                          <component-conciergerie 
                            v-if="(activeLinkedinConciergerie || activeInstagramConciergerie) && ['linkedin', 'instagram'].includes(findPage(item).page.network)"
                            :page="findPage(item).page" 
                            v-on:getPagesEvent="getPagesEvent"
                            v-on:closeActiveConciergerie="closeActiveConciergerie"
                          ></component-conciergerie>
                        </div>
                      </div>
                    </li>
                  </div>
                </ul>
              </li>
              <!-- <li class="page" v-for="(item, index) in listPages" :key="item.id"
                    :class="[{ disabled: !checkLock(item.page.network), 'hide': !checkPageFilter(item.page) || pageInGroup(item.page) || !checkSelected(item.page) }]"> -->
              <li class="page" v-for="(item, index) in listPages.filter(f => (!checkPageFilter(f.page) || pageInGroup(f.page) || !checkSelected(f.page)) == false)" :key="item.id" 
                    :class="[{ disabled: !checkLock(item.page.network)}]">
                <div class="page-wrapper" :class="{disabled: !checkLock(item.page.network) || (!isUserPremiumActive && index != 0 && !isUserPartner)}">
                  <i class="material-icons">navigate_next</i>
                  <div class="page-content">
                    <Tooltip :text="(!checkLock(item.page.network) || (item.page.network == 'pinterest' && getBoardPagePinterest && getBoardPagePinterest != item.id) || (!item.status && ['linkedin', 'instagram'].includes(item.page.network) && !isConciergerie(item.page))) 
                                                ? `${item.page.name} - ${$t('dash.bots.status_ko')}`
                                                : item.page.name" 
                                position="top">
                      <page-image-avatar :page="item.page"/>
                      <div class="page-name messagedefilant"><div :data-text="item.page.name"><span>{{ item.page.name }}</span></div></div>
                      &nbsp;
                    </Tooltip>
                    <component-conciergerie 
                      v-if="(activeLinkedinConciergerie || activeInstagramConciergerie) && ['linkedin', 'instagram'].includes(item.page.network)"
                      :page="item.page" 
                      v-on:getPagesEvent="getPagesEvent"
                      v-on:closeActiveConciergerie="closeActiveConciergerie"  
                    ></component-conciergerie>
                  </div>
                  <div class="checkbox">
                    <input
                      type="checkbox"
                      :id="`pages-${item.id}`"
                      name="pages[]"
                      :value="item.id"
                      v-model="bot"
                      :disabled="!checkLock(item.page.network) || (!isUserPremiumActive && index != 0 && !isUserPartner) || (item.page.network == 'pinterest' && getBoardPagePinterest && getBoardPagePinterest != item.id) || (!item.status && ['linkedin', 'instagram'].includes(item.page.network) && !isConciergerie(item.page))"
                    >
                    <span class="checkmark">
                      <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                    </span>
                  </div>
                </div>
              </li>
            </ul>
            <!-- <div v-if="filterSelected" @click="filterSelected = !filterSelected" class="filter-selected-add-pages">
              <div>
                <img src="../../../assets/img/chevron_double_down_o_icon.svg"/>
                {{ $t('dash.pages-sidebar.filter-all') }}
              </div>
            </div> -->
          </div>
        
          <div class="input-wrapper" v-if="(typePost !== 'story' || isPremiumInstagramAccount) && !onlyTiktokSelected() && !(typePost === 'video' && onlyInstagramSelected() && !shareAfterPost)">
            <div class="disable-story-btn"  @click.stop="() => {(typePost === 'story' && !onlyInstagramConciergerieSelected()) && showConciergerieForm()}">
                <Tooltip style="width: 100%;" :active="(typePost === 'story' && !onlyInstagramConciergerieSelected())" :text="$t('dash.bots.status_proxy')">
                  <vs-input
                    nope.v-validate="'required'"
                    :class="{'input': true,
                    'is-danger': (errors.has('posts.url') || !validURL(form.url)) && !(typePost === 'story' && !onlyInstagramConciergerieSelected()) }"
                    vs-size="large"
                    color="#B20564"
                    type="text"
                    name="url"
                    class="inputx lower-input"
                    v-bind:placeholder="$t('dash.posts.overlay.link_placeholder')"
                    v-model="form.url"
                    :disabled="state == 'reshare' || state == 'retweet' || (typePost === 'story' && !onlyInstagramConciergerieSelected())"
                    @input="() => $store.commit(`updateStorificationLink`, {active: true})"
                    data-qa="form-post-url"
                  />
                </Tooltip>
            </div>
            <span class="not-valid-url" v-if="!validURL(form.url) && !(typePost === 'story' && !onlyInstagramConciergerieSelected())">{{ $t('dash.posts.overlay.invalid_url') }}</span>
          </div>
          <div class="input-wrapper" v-if="typePost === 'story' && form.url">
            <!-- <vs-input @input="(e) => $store.commit(`updateStorificationLink`, {text: e})" v-model="storyLinkText" @keypress.enter.prevent label="Lien personnalisé (optionnel) : " placeholder="Texte du lien" /> -->
            <vs-input @input="(e) => $store.commit(`updateStorificationLink`, {text: e})" :value="($store.getters.storification && $store.getters.storification.link && $store.getters.storification.link.text) || storyLinkText" @keypress.enter.prevent label="Lien personnalisé (optionnel) : " placeholder="Texte du lien" />

          </div>

          <div class="options-wrapper">
            <div class="advanced" v-if="!showOptionsWrapper
                                            && (bots.find(b => bot.includes(b.id) && (b.hashtagPrefix || b.hashtag))
                                            || bots.find(b => bot.includes(b.id) && b.mentions && Object.keys(b.mentions).length !== 0)
                                            || bots.find(b => bot.includes(b.id) && b.hashtagsAuto && Object.keys(b.hashtagsAuto).length !== 0))" 
                @click="showOptionsWrapper = true">{{ $t('dash.posts.advanced-options') }}</div>
            <ul v-if="showOptionsWrapper && state != 'retweet'">
              <li v-if="bots.find(b => bot.includes(b.id) && (b.hashtagPrefix || b.hashtag))">
                <input type="checkbox" name="content" value="false" v-model="activePrefixSuffix">
                <span class="checkmark">
                  <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                </span>
                <p>{{ $t('dash.posts.active_prefix_suffix') }}</p>
              </li>
              <li v-if="bots.find(b => bot.includes(b.id) && b.mentions && Object.keys(b.mentions).length !== 0)">
                <input type="checkbox" name="content" value="false" v-model="activeMentionsAutoReplace">
                <span class="checkmark">
                  <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                </span>
                <p>{{ $t('dash.posts.active_mentions_auto_replace') }}</p>
              </li>
              <li v-if="bots.find(b => bot.includes(b.id) && b.hashtagsAuto && Object.keys(b.hashtagsAuto).length !== 0)">
                <input type="checkbox" name="content" value="false" v-model="activeHashtagsAutoAdd">
                <span class="checkmark">
                  <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                </span>
                <p>{{ $t('dash.posts.active_hashtags_auto_add') }}</p>
              </li>
              <li v-if="typePost === 'story' && templateDefault">
                <input type="checkbox" name="template" :checked="templateManual === templateDefault" @change="() => {templateManual ? templateManual = null : templateManual = templateDefault}" >
                <span class="checkmark">
                  <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                </span>
                <p>{{ $t('dash.posts.active_template_story') }}</p>
              </li>
            </ul>
              <div class="input-wrapper" v-if="(shareAfterPost && form.url && typePost !== 'story')">
                <vs-input @keypress.enter.prevent @input="(e) => $store.commit(`updateStorificationLink`, {text: e})" :value="$store.getters.storificationLinkText" :label="$t('dash.template.custom_link')" />
              </div>
              <div v-if="['image', 'standard', 'video'].includes(typePost) && atLeastInstagramConciergerieSelected() && state !== 'edit-posted'" class="share-story">
                <vs-checkbox class="share-story-box" @change="(e) => e.target.checked && (!$store.getters.storification || $store.getters.storification.link === null) && $store.commit(`updateStorificationLink`, {active: true})" v-model="shareAfterPost">{{ $t('dash.bots.shared_story') }}</vs-checkbox>
              </div>
            </div>
            <div v-if="(typePost === 'story' || (shareAfterPost && state !== 'edit-posted' && ['image', 'standard', 'video'].includes(typePost) && onlyInstagramConciergerieSelected())) && !atLeastInstagramFullConciergerieSelected()" class="share-story story-fb">
                <div class="disable-story-btn"  @click.stop="() => {(typePost === 'story' && !onlyInstagramConciergerieSelected()) && showConciergerieForm()}">
                  <Tooltip :active="(typePost === 'story' && !onlyInstagramConciergerieSelected())" :text="$t('dash.bots.status_proxy')">
                    <vs-checkbox :disabled="(typePost === 'story' && !onlyInstagramConciergerieSelected())" class="share-story-box" v-model="storyShareToFacebook">{{ $t('dash.bots.shared_story_fb') }}</vs-checkbox>
                  </Tooltip>
                </div>
            </div>
            <div v-if="(shareAfterPost && form.url && typePost !== 'story' && ['image', 'standard'].includes(typePost) && atLeastInstagramConciergerieSelected())" class="share-story story-fb">
                <vs-checkbox class="share-story-box" @change="(e) => $store.commit(`updateStorificationLink`, {active: e.target.checked})" :checked="$store.getters.storificationLinkIsActive">{{ $t('dash.bots.shared_story_link_active') }}</vs-checkbox>
            </div>
            <div class="layer-background" v-if="typePost !== 'story' && (['image', 'video'].includes(typePost) && shareAfterPost && atLeastInstagramConciergerieSelected()) && ((url || form.url || form.video))">
              {{$t('dash.posts.background.colors.label')}}
              <input :value="$store.getters.storificationBackgroundColor" @change="(e) => $store.commit(`updateStorificationBackgroundColor`, e.target.value)" type="color"/>
              <button type="button" class="btn-add" @click="(e) => $store.commit(`updateStorificationBackgroundColor`, null)">
                Reset
              </button>
            </div>

            <div v-if="typePost !== 'story' && (['image', 'standard', 'video'].includes(typePost) && shareAfterPost && atLeastInstagramConciergerieSelected())" class="poll-story">
              <!-- <vs-checkbox class="poll-story-check" :checked="pollStory" @change="pollStory ? pollStory=null : pollStory={question: '', options: [], x: 170, y: 200} ">{{$t('dash.posts.poll')}}</vs-checkbox> -->
              <vs-checkbox class="poll-story-check" :checked="$store.getters.storificationPoll" @change="$store.getters.storificationPoll ? $store.commit('updateStorificationPoll', null) : $store.commit('updateStorificationPoll', {question: '', options: []})">{{$t('dash.posts.poll')}}</vs-checkbox>
              <div class="poll-story-inputs" v-if="$store.getters.storificationPoll">
                <vs-input maxlength="50" class="poll-story-question" :label="$t('dash.post.poll.question.label')" placeholder="Question ?" :value="$store.getters.storificationPoll.question" @input="(e) => $store.commit('updateStorificationPoll', {question:  e})"/>
                <div class="poll-story-options">
                  <vs-input maxlength="40" class="poll-story-option" :label="$t('dash.post.poll.option.label') + ' 1'" :value="$store.getters.storificationPoll.options[0] || ''" placeholder="Oui" @input="(e) => $store.commit('updateStorificationPollOption', {index: 0, option: e})"/>
                  <vs-input maxlength="40" class="poll-story-option" :label="$t('dash.post.poll.option.label') + ' 2'" :value="$store.getters.storificationPoll.options[1] || ''" placeholder="Non" @input="(e) => $store.commit('updateStorificationPollOption', {index: 1, option: e})"/>
                  <vs-input maxlength="40" class="poll-story-option" :label="$t('dash.post.poll.option.label') + ' 3'" :value="$store.getters.storificationPoll.options[2] || ''" placeholder="Optional" @input="(e) => $store.commit('updateStorificationPollOption', {index: 2, option: e})"/>
                  <vs-input maxlength="40" class="poll-story-option" :label="$t('dash.post.poll.option.label') + ' 4'" :value="$store.getters.storificationPoll.options[3] || ''" placeholder="Optional" @input="(e) => $store.commit('updateStorificationPollOption', {index: 3, option: e})"/>
                </div>
              </div>
            </div>
            <div v-if="typePost !== 'story' && (['image', 'standard', 'video'].includes(typePost) && shareAfterPost && atLeastInstagramConciergerieSelected())" class="poll-story">
              <!-- <vs-checkbox class="poll-story-check" :checked="sliderStory" @change="sliderStory ? sliderStory=null : sliderStory={question: '', emoji: '😍', color: '#ffffff', x: 170, y: 200} ">{{$t('dash.posts.slider')}}</vs-checkbox> -->
              <vs-checkbox class="poll-story-check" :checked="$store.getters.storificationSlider" @change="$store.getters.storificationSlider ? $store.commit('updateStorificationSlider', null) : $store.commit('updateStorificationSlider', {question: '', emoji: '😍', color: 0})">{{$t('dash.posts.slider')}}</vs-checkbox>
              <div class="slider-story-params" v-if="$store.getters.storificationSlider">
                <vs-input maxlength="45" class="poll-story-question" :label="$t('dash.post.poll.question.label')" placeholder="(Optionnel)" :value="$store.getters.storificationSlider.question" @input="(e) => $store.commit('updateStorificationSlider', {question:  e})"/>
                <div class="textarea-emoji-picker" v-click-outside="() => sliderEmojiPicker = false">
                  <span @click="() => sliderEmojiPicker = !sliderEmojiPicker" class="emoji">{{$store.getters.storificationSlider.emoji}}</span>
                  <picker
                    class="emoji-picker-slider"
                      :data="emojiIndex"
                      v-show="sliderEmojiPicker"
                      title="Pick your emoji..."
                      emoji="point_up"
                      @select="(e) => $store.commit('updateStorificationSlider', {emoji: e.native})"
                    />
                </div>
              </div>
            </div>
            <div v-if="typePost !== 'story' && (['image', 'standard', 'video'].includes(typePost) && shareAfterPost && atLeastInstagramConciergerieSelected())" class="poll-story">
              <!-- <vs-checkbox class="poll-story-check" :checked="sliderStory" @change="sliderStory ? sliderStory=null : sliderStory={question: '', emoji: '😍', color: '#ffffff', x: 170, y: 200} ">{{$t('dash.posts.slider')}}</vs-checkbox> -->
              <vs-checkbox class="poll-story-check" :checked="$store.getters.storificationQuestion" @change="$store.getters.storificationQuestion ? $store.commit('updateStorificationQuestion', null) : $store.commit('updateStorificationQuestion', {text: '', avatar: '', color: 0})">{{$t('dash.detail.history.difference.pollStory.question')}}</vs-checkbox>
              <div class="slider-story-params" v-if="$store.getters.storificationQuestion">
                <vs-input maxlength="45" class="poll-story-question" :label="$t('dash.post.poll.question.label')" placeholder="Posez-moi une question" :value="$store.getters.storificationQuestion.text" @input="(e) => $store.commit('updateStorificationQuestion', {text:  e})"/>
              </div>
            </div>

          <div v-if="typePost !== 'story' && (['image', 'standard', 'video'].includes(typePost) && shareAfterPost && atLeastInstagramConciergerieSelected())" class="mentions-story">
              <button type="button" class="btn-add" @click="() => openMentionWidget()">{{$t('dash.bots.mention_name_placeholder')}}</button>
              <p v-if="$store.getters.storificationMentions && $store.getters.storificationMentions.length">Mentions :
                <span class="location-string" :key="mention.pk" v-for="(mention, idx) in $store.getters.storificationMentions">
                  <!-- <span @click="hideMentionWidget(mention.pk, false)" v-if="mention.hide" class="hidder material-icons">visibility</span> -->
                  <span @click="$store.commit('updateStorificationMention', {index: idx, hide: false})" v-if="mention.hide" class="hidder material-icons">visibility</span>
                  <!-- <span @click="hideMentionWidget(mention.pk, true)" v-else class="hidder material-icons">visibility_off</span> -->
                  <span @click="$store.commit('updateStorificationMention', {index: idx, hide: true})" v-else class="hidder material-icons">visibility_off</span>
                  {{mention.id}} 
                  <!-- <span @click="removeMentionWidget(mention.pk)" class="remove-location">x</span> -->
                  <span @click="$store.commit('removeStorificationMention', idx)" class="remove-location">x</span>
                </span>
              </p>
               <dialog ref="searchMentionWidget" class="searchTag">
                <div @keydown.prevent.enter="" class="auto-mentions">
                  <button type="button" @click="addMentionWidget()">OK</button>
                  <input v-if="searchMention[selectedBotMention]" :placeholder="$t(`dash.posts.overlay.search_mention_placeholder_instagram_direct`)"
                    @keyup="searchMentions('Mention')"
                    v-model="searchMention[selectedBotMention].search"
                    ref="inputSearchMentionTag"
                  />
                  <ul id="loadableContent-list-mentions" v-if="searchMention[selectedBotMention] && searchMention[selectedBotMention].results && searchMention[selectedBotMention].results.length">
                      <div v-for="(mention, index) in searchMention[selectedBotMention].results.filter(e => !userTags.list.map(ee => ee.id).includes(e.pk))" :key="index">  
                        <li @click="selectMention('Mention', mention)" :class="{'select': mentionIsSelected('Mention', mention) == true}" v-if="mentionIsSelected('Mention', mention)">
                          <div :class="searchMention[selectedBotMention].bot.page.network">
                            <img :alt="mention.name" class="image" :src="mention.image" v-if="mention.image"/>
                            <div class="content">
                              <p class="name">{{ mention.name }}</p>
                              <p class="screen_name id">@{{ mention.id }}</p>
                              <p class="screen_name" v-if="mention.subtitle">{{ mention.subtitle }}</p>
                            </div>
                          </div>
                          <div class="checkmark" v-show="mentionIsSelected('Mention', mention) == true">
                            <i class="material-icons">check</i>
                          </div>
                        </li>
                      </div>
                    </ul>
                    <ul id="loadableContent-list-mentions" v-else-if="searchMention[selectedBotMention] && searchMention[selectedBotMention].results">
                      <li>
                        <p>Aucun resultat</p>
                      </li>
                    </ul>
                    <ul id="loadableContent-list-mentions" class="empty" v-else></ul>
                </div>
              </dialog>
          </div>

          <div v-if="typePost !== 'story' && (['image', 'standard', 'video'].includes(typePost) && shareAfterPost && atLeastInstagramConciergerieSelected())" class="mentions-story">
              <button type="button" class="btn-add" @click="() => openHashtagWidget()">{{$t('dash.bots.hashtags_name_placeholder')}}</button>
              <p v-if="$store.getters.storificationHashtags && $store.getters.storificationHashtags.length">Hashtags :
                <span class="location-string" :key="mention.pk" v-for="(mention, idx) in $store.getters.storificationHashtags">
                  <!-- <span @click="hideMentionWidget(mention.pk, false)" v-if="mention.hide" class="hidder material-icons">visibility</span> -->
                  <span @click="$store.commit('updateStorificationHashtag', {index: idx, hide: false})" v-if="mention.hide" class="hidder material-icons">visibility</span>
                  <!-- <span @click="hideMentionWidget(mention.pk, true)" v-else class="hidder material-icons">visibility_off</span> -->
                  <span @click="$store.commit('updateStorificationHashtag', {index: idx, hide: true})" v-else class="hidder material-icons">visibility_off</span>
                  #{{mention.hashtag}} 
                  <!-- <span @click="removeMentionWidget(mention.pk)" class="remove-location">x</span> -->
                  <span @click="$store.commit('removeStorificationHashtag', idx)" class="remove-location">x</span>
                </span>
              </p>
               <dialog ref="searchHashtagWidget" class="searchTag">
                <div @keydown.prevent.enter="" class="auto-mentions">
                  <button type="button" @click="addHashtagWidget()">OK</button>
                  <input v-if="searchHashtag[selectedBotHashtag]" :placeholder="$t(`dash.posts.overlay.search_hashtag_placeholder`)"
                    @keyup="searchMentions('Hashtag')"
                    v-model="searchHashtag[selectedBotHashtag].search"
                    ref="inputSearchMentionTag"
                  />
                  <ul id="loadableContent-list-mentions" v-if="searchHashtag[selectedBotHashtag] && searchHashtag[selectedBotHashtag].results && searchHashtag[selectedBotHashtag].results.length">
                      <div v-for="(mention, index) in searchHashtag[selectedBotHashtag].results" :key="index">  
                        <li @click="selectMention('Hashtag', mention)" :class="{'select': mentionIsSelected('Hashtag', mention) == true}">
                          <div :class="searchHashtag[selectedBotHashtag].bot.page.network">
                            <!-- <img :alt="mention.name" class="image" :src="mention.image" v-if="mention.image"/> -->
                             <div class="content">    
                              <p class="name">{{ `#${mention.hashtag}` }}</p>
                              <p class="count">{{ `${mention.count} ${ 'Post' }${mention.count > 1 ? 's': ''}` }}</p>
                            </div>
                          </div>
                          <div class="checkmark" v-show="mentionIsSelected('Hashtag', mention) == true">
                            <i class="material-icons">check</i>
                          </div>
                        </li>
                      </div>
                    </ul>
                    <ul id="loadableContent-list-mentions" v-else-if="searchHashtag[selectedBotHashtag] && searchHashtag[selectedBotHashtag].results">
                      <li>
                        <p>Aucun resultat</p>
                      </li>
                    </ul>
                    <ul id="loadableContent-list-mentions" class="empty" v-else></ul>
                </div>
              </dialog>
          </div>
          <ShopSticker v-if="typePost !== 'story' && (['image', 'standard', 'video'].includes(typePost) && shareAfterPost && atLeastInstagramConciergerieSelected())" :pageId="bots.find(e => bot.includes(e.id) && e.page && e.page.story_config && e.page.network === 'instagram') ? bots.find(e => bot.includes(e.id) && e.page && e.page.story_config && e.page.network === 'instagram').page.id : null" :isConciergerie="atLeastInstagramConciergerieSelected()"
          class="music-btn" :products="$store.getters.storificationProduct ? $store.getters.storificationProduct.items : []" @reconnect="showConciergerieForm" @insertShop="(shop) => $store.commit('updateStorificationProduct', {items: shop})">
          </ShopSticker>
          <div v-if="typePost !== 'story' && (['image', 'standard', 'video'].includes(typePost) && shareAfterPost && atLeastInstagramConciergerieSelected()) && $store.getters.storificationProduct" class="layers-preview">
            <div class="layer-preview" v-for="product in $store.getters.storificationProduct.items" :key="product.id" >
              <span class="remove-layer" @click="removeProduct(product.id)">x</span>
              <img :src="product.image" :alt="product.text">
              <p>{{product.text}}</p>
            </div>
          </div>
          <div class="input-wrapper">            
            <span v-if="typePost === 'story' && !storyShare" v-click-outside="hideEmojiPicker">
              <div v-for="(txt, idx) in $store.getters.storificationTexts" :key="idx" class="textarea-emoji-picker" >
                <picker
                  v-if="state != 'retweet'"
                  :data="emojiIndex"
                  v-show="showEmojiPickerInstagram === idx"
                  title="Pick your emoji..."
                  emoji="point_up"
                  @select="(e) => addEmoji(e,idx)"
                />
                <span 
                  v-if="state != 'retweet' && (txt.content.trim().length > 0 || instagramTexts.filter(e => e.content !== '').length === 0 && idx ===0)"
                  class="emoji-trigger tooltip"
                  :class="{ 'triggered': showEmojiPickerInstagram === idx }"
                  @click="e => toggleEmojiPicker(e, idx)"
                >
                  <svg
                    style="width:20px;height:20px"
                    viewBox="0 0 24 24"
                  >
                    <path fill="#888888" d="M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z" />
                  </svg>
                  <span class="tooltip-text">{{ $t('dash.add-emoji.title') }}</span>
                </span>
                
                <span class="add-mention tooltip" @click="toggleShowMentions('Mention', idx)" v-if="txt.content.trim().length > 0 || instagramTexts.filter(e => e.content !== '').length === 0 && idx ===0">
                  @
                  <span class="tooltip-text">{{ $t('dash.add-mention.title') }}</span>
                </span>
                
                <span class="add-mention add-hashtag tooltip" @click="toggleShowMentions('Hashtag', idx)" :class="{ 'disabled': !activeSearchHashtags}" v-if="txt.content.trim().length > 0 || instagramTexts.filter(e => e.content !== '').length === 0 && idx ===0 && activeSearchHashtags">
                  #
                  <span class="tooltip-text">{{ $t('dash.add-hashtag.title') }}</span>
                </span>
                
                <span class="add-mention ai-generate tooltip" ref="ailoadableButton" @click="getAccrochesByAI()">
                  <span class="material-icons">lightbulb_outline</span>
                  <span class="tooltip-text">{{ $t('dash.auto-generate-text.title') }}</span>
                </span>
                <span class="add-mention tooltip hide-txt" @click="$store.commit(`updateStorificationText`, {visible: !txt.visible, index: idx})" v-if="txt.content.trim().length > 0 || instagramTexts.filter(e => e.content !== '').length === 0 && idx ===0">
                  <span v-if="!txt.visible" class="material-icons">visibility</span>
                  <span v-else class="material-icons">visibility_off</span>
                  <span v-if="!txt.visible" class="tooltip-text">{{ $t('dash.show-text.title') }}</span>
                  <span v-else class="tooltip-text">{{ $t('dash.hide-text.title') }}</span>
                </span>

                
                <!-- <vs-textarea
                  v-if="txt.content.trim().length > 0 || instagramTexts.filter(e => e.content !== '').length === 0 && idx ===0"
                  :disabled="state == 'retweet'"
                  :class="{'input': true,
                    'is-danger': errors.has('posts.title') }"
                  vs-size="large"
                  color="#B20564"
                  name="title"
                  class="inputx textarea-emoji"
                  :placeholder="$t('dash.posts.overlay.description_placeholder')"
                  v-model.lazy="txt.content"
                  ref="inputTitle"
                  @click="[closeAutoMentions(), checkAddMention(idx)]"
                  @keyup="[checkAddMention(idx), textAreaAdjust(`title-post${idx}`)]"
                  :id="`title-post${idx}`"
                /> -->
                <div v-if="txt.content.trim().length > 0 || instagramTexts.filter(e => e.content !== '').length === 0 && idx ===0"
                  class="vs-con-textarea inputx" 
                  style="border:1px solid rgba(0, 0, 0, 0.08);">
                  <textarea
                    :disabled="state == 'retweet'"
                    name="title"
                    class="vs-textarea"
                    :placeholder="$t('dash.posts.overlay.description_placeholder')"
                    v-model="txt.content"
                    @change="(e) => $store.commit(`updateStorificationText`, {content: e.target.value})"
                    ref="inputTitle"
                    :id="`title-post${idx}`"
                    @click="[closeAutoMentions(), checkAddMention(idx)]"
                    @keyup="[checkAddMention(idx), textAreaAdjust(`title-post${idx}`)]"
                  ></textarea>
                </div>
                <!-- <div class="vs-textarea--count" v-if="limitText && (txt.content.trim().length > 0 || instagramTexts.filter(e => e.content !== '').length === 0 && idx ===0)">
                  {{ sizeCurrentMessageByRsLimit }} / {{ limitText }} ({{ rsLimit }})
                </div> -->
                <div @keydown.prevent.enter="" class="auto-mentions row box" v-if="checkActiveMentionsSearch && ((typeof openAutoMentions == 'boolean' && openAutoMentions) || openAutoMentions === idx) && searchMention.length > 0">
                  <div class="connected-pages">
                    <div class="selected-page">
                      <div
                        class="page"
                        v-for="(item, index) in searchMention"
                        :key="index"
                      >
                        <Tooltip
                          :text="item.bot.page.network"
                          position="top"
                        >
                          <input
                            type="radio"
                            :id="`bot-index-${index}`"
                            name="page"
                            :value="index"
                            v-model="selectedBotMention" 
                            @click="changeMentionNetwork('Mention', index)"   
                          >
                          <div class="page-wrapper">
                            <div class="page-content">
                              <div class="vertical-align">
                                <div class="page-img-wrapper">
                                  <img
                                    v-if="item.bot.page.network === 'facebook'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_fb.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'twitter'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_tw.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'linkedin'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_linkedin.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'instagram'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_instagram.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'bluesky'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_bluesky.png')"
                                  />
                                  
                                </div>
                                <p class="page-name">{{ item.bot.page.network }}</p>
                              </div>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                    <Tooltip 
                      :text="$t('dash.tooltip.remove_mentions')" 
                      position="top"
                      v-if="isAddOrEditMentions('Mention', idx) == 'edit' || (previewEdited && previewEdited.mention && previewEdited.mention.edit)"
                      class="cancel"
                      style="position: absolute; top: 0; right: 70px; text-align: center;"
                    >
                      <vs-button 
                        class="btnx" 
                        type="flat" 
                        @click="removeMentions('Mention', idx)" 
                        icon="delete"
                      ></vs-button>
                      &nbsp;
                    </Tooltip>
                    <vs-button
                      class="page-btn"
                      vs-type="filled"
                      color="#6a1f4c"
                      @click.prevent="validateMentions('Mention', idx)"
                    >OK</vs-button>
                  </div>
                  <vs-input
                    color="#B20564"
                    type="text"
                    name="search-mention"
                    class="inputx"
                    id="storyMentionsInput"
                    :placeholder="$t(`dash.posts.overlay.search_mention_placeholder_${searchMention[selectedBotMention].bot.page.network}${searchMention[selectedBotMention].bot.page.story_config && searchMention[selectedBotMention].bot.page.story_config.created && (!searchMention[selectedBotMention].bot.page.story_config.lock || searchMention[selectedBotMention].bot.page.story_config.lock < Date.now()) ? '_direct' : ''}`)"
                    v-model="searchMention[selectedBotMention].search"
                    v-on:keyup="searchMentions('Mention')"
                    v-on:click="searchMentions('Mention')"
                    ref="inputSearchMentionStory"
                    autocomplete="off"
                  />
                  <ul id="loadableContent-list-mentions" v-if="searchMention[selectedBotMention].results && searchMention[selectedBotMention].results.length">
                    <div v-for="(mention, index) in searchMention[selectedBotMention].results" :key="index">  
                      <li @click="selectMention('Mention', mention)" :class="{'select': mentionIsSelected('Mention', mention) == true}" v-if="mentionIsSelected('Mention', mention)">
                        <div :class="searchMention[selectedBotMention].bot.page.network">
                          <img :alt="mention.name" class="image" :src="mention.image" v-if="mention.image"/>
                          <span class="image" v-else></span>
                          <div class="content">
                            <p class="name">{{ mention.name }}</p>
                            <img alt="verified account" src="../../../assets/img/validated-twitter.png" v-if="searchMention[selectedBotMention].bot.page.network == 'twitter'"/>
                            <p class="screen_name id" v-if="searchMention[selectedBotMention].bot.page.network == 'facebook'">{{ mention.id }}</p>
                            <p class="screen_name" v-else-if="searchMention[selectedBotMention].bot.page.network == 'bluesky'">@{{ mention.subtitle }}</p>
                            <p class="screen_name" v-else>@{{ searchMention[selectedBotMention].bot.page.network == 'twitter' ? mention.screen_name : (searchMention[selectedBotMention].bot.page.network == 'instagram' && mention.id) ? mention.id : mention.name }}</p>
                            <p class="description" v-if="searchMention[selectedBotMention].bot.page.network == 'twitter'">{{ mention.description }}</p>
                            <p class="screen_name" v-if="mention.subtitle && searchMention[selectedBotMention].bot.page.network != 'bluesky'">{{ mention.subtitle }}</p>
                          </div>
                        </div>
                        <div class="checkmark" v-show="mentionIsSelected('Mention', mention) == true">
                          <i class="material-icons">check</i>
                        </div>
                      </li>
                    </div>
                  </ul>
                  <ul id="loadableContent-list-mentions" v-else-if="searchMention[selectedBotMention].results">
                    <li>
                      <p>Aucun resultat</p>
                    </li>
                  </ul>
                  <ul id="loadableContent-list-mentions" class="empty" v-else></ul>
                  <!-- <vs-button class="cancel" v-if="isAddOrEditMentions('Mention', idx) == 'edit'" @click="removeMentions('Mention', idx)">
                    {{ $t('dash.button.cancel') }}
                  </vs-button> -->
                </div>
                <div @keydown.prevent.enter="" class="auto-mentions auto-hashtags row box" v-if="checkActiveHashtagsSearch && ((typeof openAutoHashtags == 'boolean' && openAutoHashtags) || openAutoHashtags === idx) && searchHashtag.length > 0">
                  <div class="connected-pages">
                    <div class="selected-page">
                      <div
                        class="page"
                        v-for="(item, index) in searchHashtag"
                        :key="index"
                      >
                        <Tooltip
                          :text="item.bot.page.network"
                          position="top"
                        >
                          <input
                            type="radio"
                            :id="`bot-index-${index}`"
                            name="page"
                            :value="index"
                            v-model="selectedBotHashtag" 
                            @click="changeMentionNetwork('Hashtag', index)"   
                          >
                          <div class="page-wrapper">
                            <div class="page-content">
                              <div class="vertical-align">
                                <div class="page-img-wrapper">
                                  <img
                                    v-if="item.bot.page.network === 'facebook'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_fb.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'twitter'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_tw.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'linkedin'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_linkedin.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'instagram'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_instagram.png')"
                                  />
                                  
                                </div>
                                <p class="page-name">{{ item.bot.page.network }}</p>
                              </div>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                    <vs-button
                      class="page-btn"
                      vs-type="filled"
                      color="#6a1f4c"
                      @click.prevent="validateMentions('Hashtag', idx)"
                    >OK</vs-button>
                  </div>
                  <vs-input
                    color="#B20564"
                    type="text"
                    name="search-mention"
                    class="inputx"
                    :placeholder="$t(`dash.posts.overlay.search_hashtag_placeholder`)"
                    v-model="searchHashtag[selectedBotHashtag].search"
                    v-on:keyup="searchMentions('Hashtag')"
                    v-on:click="searchMentions('Hashtag')"
                    ref="inputSearchMentionStory"
                    autocomplete="off"
                  />
                  <ul id="loadableContent-list-mentions">
                    <div v-for="(mention, index) in searchHashtag[selectedBotHashtag].results" :key="index">  
                      <li @click="selectMention('Hashtag', mention)" :class="{'select': mentionIsSelected('Hashtag', mention) == true}" v-if="mention.hashtag">
                        <div :class="searchHashtag[selectedBotHashtag].bot.page.network">
                          <div class="content">    
                            <p class="name">{{ `#${mention.hashtag}` }}</p>
                            <p class="count">{{ `${mention.count} ${searchHashtag[selectedBotHashtag].bot.page.network === 'twitter' ? 'Tweet' : 'Post' }${mention.count > 1 ? 's': ''}` }}</p>
                          </div>
                        </div>
                        <div class="checkmark" v-show="mentionIsSelected('Hashtag', mention) == true">
                          <i class="material-icons">check</i>
                        </div>
                      </li>
                    </div>
                  </ul>
                  <vs-button class="cancel" v-if="isAddOrEditMentions('Hashtag', idx) == 'edit'" @click="removeMentions('Hashtag', idx)">
                    {{ $t('dash.button.cancel') }}
                  </vs-button>
                </div>
              </div>
            </span>
            <div v-if="typePost !== 'story'" class="textarea-emoji-picker" v-click-outside="hideEmojiPicker">
              <div class="styles-text-buttons" v-if="!atLeastNetworkSelected('bluesky')">
                <span @click="styleSelection('bold')" class="emoji-trigger tooltip" :class="{ 'triggered': styledText().includes('bold') }">
                  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#888888" d="M3 19V1h8a5 5 0 0 1 3.88 8.16A5.5 5.5 0 0 1 11.5 19H3zm7.5-8H7v5h3.5a2.5 2.5 0 1 0 0-5zM7 4v4h3a2 2 0 1 0 0-4H7z"/>
                  </svg>
                  <span class="tooltip-text">{{ $t('dash.bold.title') }}</span>
                </span>
                <span @click="styleSelection('italic')" class="emoji-trigger tooltip" :class="{ 'triggered': styledText().includes('italic') }">
                  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#888888" d="M 7 4 L 7 5 L 9.9921875 5 L 8 15.955078 L 8 16 L 5 16 L 5 17 L 12 17 L 12 16 L 9.0078125 16 L 11 5.0449219 L 11 5 L 14 5 L 14 4 L 7 4 z "/>
                  </svg>
                  <span class="tooltip-text">{{ $t('dash.italic.title') }}</span>
                </span>
                <!-- <span @click="styleSelection('underline')" class="emoji-trigger tooltip" :class="{ 'triggered': styledText().includes('underline') }">
                  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#888888" d="M6 3.5C6 3.22386 5.77614 3 5.5 3C5.22386 3 5 3.22386 5 3.5V9.95455C5 12.7363 7.23385 15 10 15C12.7661 15 15 12.7363 15 9.95455V3.5C15 3.22386 14.7761 3 14.5 3C14.2239 3 14 3.22386 14 3.5V9.95455C14 12.1935 12.2044 14 10 14C7.79559 14 6 12.1935 6 9.95455V3.5Z"/>
                    <path fill="#888888" d="M5 16.5C5 16.2239 5.22386 16 5.5 16H14.5C14.7761 16 15 16.2239 15 16.5C15 16.7761 14.7761 17 14.5 17H5.5C5.22386 17 5 16.7761 5 16.5Z"/>
                  </svg>
                  <span class="tooltip-text">{{ $t('dash.underline.title') }}</span>
                </span> -->
              </div>
                <picker
                  v-if="state != 'retweet' && !atLeastNetworkSelected('bluesky')"
                  :data="emojiIndex"
                  v-show="showEmojiPicker"
                  title="Pick your emoji..."
                  emoji="point_up"
                  @select="addEmoji"
                />
                <span
                  v-if="state != 'retweet' && !atLeastNetworkSelected('bluesky')"
                  class="emoji-trigger tooltip"
                  :class="{ 'triggered': showEmojiPicker }"
                  @click="toggleEmojiPicker"
                >
                  <svg
                    style="width:20px;height:20px"
                    viewBox="0 0 24 24"
                  >
                    <path fill="#888888" d="M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z" />
                  </svg>
                  <span class="tooltip-text">{{ $t('dash.add-emoji.title') }}</span>
                </span> 

                <span class="add-mention tooltip" @click="toggleShowMentions('Mention')">
                  @
                  <span class="tooltip-text">{{ $t('dash.add-mention.title') }}</span>
                </span>

                <span v-if="checkActiveLocationSearch" class="add-mention add-location tooltip" @click="toggleShowMentions('Location')">
                  <svg enable-background="new 0 0 32 32" height="20px" id="Layer_1" version="1.1" viewBox="0 0 32 32" width="20px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="location"><path clip-rule="evenodd" d="M16.002,17.746c3.309,0,6-2.692,6-6s-2.691-6-6-6   c-3.309,0-6,2.691-6,6S12.693,17.746,16.002,17.746z M16.002,6.746c2.758,0,5,2.242,5,5s-2.242,5-5,5c-2.758,0-5-2.242-5-5   S13.244,6.746,16.002,6.746z" /><path clip-rule="evenodd" d="M16,0C9.382,0,4,5.316,4,12.001c0,7,6.001,14.161,10.376,19.194   C14.392,31.215,15.094,32,15.962,32c0.002,0,0.073,0,0.077,0c0.867,0,1.57-0.785,1.586-0.805   c4.377-5.033,10.377-12.193,10.377-19.194C28.002,5.316,22.619,0,16,0z M16.117,29.883c-0.021,0.02-0.082,0.064-0.135,0.098   c-0.01-0.027-0.084-0.086-0.129-0.133C12.188,25.631,6,18.514,6,12.001C6,6.487,10.487,2,16,2c5.516,0,10.002,4.487,10.002,10.002   C26.002,18.514,19.814,25.631,16.117,29.883z"/></g></svg>
                  <span class="tooltip-text">{{ $t('dash.add-location.title') }}</span>
                </span>

                <span class="add-mention add-hashtag tooltip" @click="toggleShowMentions('Hashtag')" :class="{ 'disabled': !activeSearchHashtags}" v-if="activeSearchHashtags">
                  #
                  <span class="tooltip-text">{{ $t('dash.add-hashtag.title') }}</span>
                </span>

                <span class="add-mention ai-generate tooltip" ref="ailoadableButton" @click="getAccrochesByAI()">
                  <span class="material-icons">lightbulb_outline</span>
                  <span class="tooltip-text">{{ $t('dash.auto-generate-text.title') }}</span>
                </span>
                
              <!-- <vs-textarea v-if="typePost !== 'story'"
                v-validate="state != 'reshare' && state != 'retweet' ? 'required' : ''"
                :disabled="state == 'retweet'"
                :class="{'input': true,
                  'is-danger': errors.has('posts.title') }"
                vs-size="large"
                color="#B20564"
                name="title"
                class="inputx"
                :placeholder= inputTitleText
                v-model.lazy="form.title"
                ref="inputTitle"
                id="title-post"
                @click="[closeAutoMentions(), checkAddMention()]"
                @keyup="[checkAddMention(), textAreaAdjust('title-post')]"
                data-qa="form-post-message"
              /> -->
              <div v-if="typePost !== 'story'"
                class="vs-con-textarea inputx" 
                style="border:1px solid rgba(0, 0, 0, 0.08);">
                <textarea
                  :disabled="state == 'retweet'"
                  name="title"
                  class="vs-textarea"
                  :placeholder= inputTitleText
                  v-model="form.title"
                  ref="inputTitle"
                  id="title-post"
                  @click="[closeAutoMentions(), checkAddMention()]"
                  @keyup="[checkAddMention(), textAreaAdjust('title-post')]"
                  data-qa="form-post-message"
                ></textarea>
              </div>
              <div class="vs-textarea--count" v-if="limitText">
                {{ sizeCurrentMessageByRsLimit }} / {{ limitText }} ({{ rsLimit }})
              </div>

              <div @keydown.prevent.enter="" class="auto-mentions row box" v-if="checkActiveMentionsSearch && typeof openAutoMentions == 'boolean' && openAutoMentions && searchMention.length > 0">
                <div class="pos-relative">

                  <div class="connected-pages">
                    <div class="selected-page">
                      <div
                        class="page"
                        v-for="(item, index) in searchMention"
                        :key="index"
                      >
                        <Tooltip
                          :text="item.bot.page.network"
                          position="top"
                        >
                          <input
                            type="radio"
                            :id="`bot-index-${index}`"
                            name="page"
                            :value="index"
                            v-model="selectedBotMention" 
                            @click="changeMentionNetwork('Mention', index)"   
                          >
                          <div class="page-wrapper">
                            <div class="page-content">
                              <div class="vertical-align">
                                <div class="page-img-wrapper">
                                  <img
                                    v-if="item.bot.page.network === 'facebook'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_fb.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'twitter'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_tw.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'linkedin'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_linkedin.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'instagram'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_instagram.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'bluesky'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_bluesky.png')"
                                  />
                                  
                                </div>
                                <p class="page-name">{{ item.bot.page.network }}</p>
                              </div>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                    <Tooltip 
                      :text="$t('dash.tooltip.remove_mentions')" 
                      position="top"
                      v-if="isAddOrEditMentions('Mention') == 'edit' || (previewEdited && previewEdited.mention && previewEdited.mention.edit)"
                      class="cancel"
                      style="position: absolute; top: 0; right: 70px; text-align: center;"
                    >
                      <vs-button 
                        class="btnx" 
                        type="flat" 
                        @click="removeMentions('Mention')" 
                        icon="delete"
                      ></vs-button>
                      &nbsp;
                    </Tooltip>
                    <vs-button
                      class="page-btn"
                      vs-type="filled"
                      color="#6a1f4c"
                      @click.prevent="validateMentions('Mention')"
                    >OK</vs-button>
                  </div>
                </div>
                <vs-input
                  color="#B20564"
                  type="text"
                  name="search-mention"
                  class="inputx"
                  :placeholder="$t(`dash.posts.overlay.search_mention_placeholder_${searchMention[selectedBotMention].bot.page.network}${searchMention[selectedBotMention].bot.page.story_config && searchMention[selectedBotMention].bot.page.story_config.created && (!searchMention[selectedBotMention].bot.page.story_config.lock || searchMention[selectedBotMention].bot.page.story_config.lock < Date.now()) ? '_direct' : ''}`)"
                  v-model="searchMention[selectedBotMention].search"
                  v-on:keyup="searchMentions('Mention')"
                  ref="inputSearchMention"
                  autocomplete="off"
                />
                <ul id="loadableContent-list-mentions laaa" v-if="searchMention[selectedBotMention].results && searchMention[selectedBotMention].results.length">
                  <div v-for="(mention, index) in searchMention[selectedBotMention].results" :key="index">  
                    <li @click="selectMention('Mention', mention)" :class="{'select': mentionIsSelected('Mention', mention) == true}" v-if="mentionIsSelected('Mention', mention)">
                      <div :class="searchMention[selectedBotMention].bot.page.network">
                        <img :alt="mention.name" class="image" :src="mention.image" v-if="mention.image"/>
                        <span class="image" v-else></span>
                        <div class="content">
                          <p class="name">{{ mention.name }}</p>
                          <img alt="verified account" src="../../../assets/img/validated-twitter.png" v-if="searchMention[selectedBotMention].bot.page.network == 'twitter'"/>
                          <p class="screen_name id" v-if="searchMention[selectedBotMention].bot.page.network == 'facebook'">{{ mention.id }}</p>
                          <p class="screen_name" v-else-if="searchMention[selectedBotMention].bot.page.network == 'bluesky'">@{{ mention.subtitle }}</p>
                          <p class="screen_name" v-else>@{{ searchMention[selectedBotMention].bot.page.network == 'twitter' ? mention.screen_name : (searchMention[selectedBotMention].bot.page.network == 'instagram' && mention.id) ? mention.id : mention.name }}</p>
                          <p class="description" v-if="searchMention[selectedBotMention].bot.page.network == 'twitter'">{{ mention.description }}</p>
                          <p class="screen_name" v-if="mention.subtitle && searchMention[selectedBotMention].bot.page.network != 'bluesky'">{{ mention.subtitle }}</p>
                        </div>
                      </div>
                      <div class="checkmark" v-show="mentionIsSelected('Mention', mention) == true">
                        <i class="material-icons">check</i>
                      </div>
                    </li>
                  </div>
                </ul>
                <ul id="loadableContent-list-mentions" class="empty" v-else-if="searchMention[selectedBotMention].results">
                  <li>
                    <p>Aucun resultat</p>
                  </li>
                </ul>
                <ul id="loadableContent-list-mentions" v-else></ul>
              </div>
              <div @keydown.prevent.enter="" class="auto-mentions auto-hashtags row box" v-if="checkActiveHashtagsSearch && openAutoHashtags && searchHashtag.length > 0">
                <div class="connected-pages">
                  <div class="selected-page">
                    <div
                      class="page"
                      v-for="(item, index) in searchHashtag"
                      :key="index"
                    >
                      <Tooltip
                        :text="item.bot.page.network"
                        position="top"
                      >
                        <input
                          type="radio"
                          :id="`bot-index-${index}`"
                          name="page"
                          :value="index"
                          v-model="selectedBotHashtag" 
                          @click="changeMentionNetwork('Hashtag', index)"   
                        >
                        <div class="page-wrapper">
                          <div class="page-content">
                            <div class="vertical-align">
                              <div class="page-img-wrapper">
                                <img
                                  v-if="item.bot.page.network === 'facebook'"
                                  size="25px"
                                  :src="require('../../../assets/img/icon_fb.png')"
                                />
                                <img
                                  v-else-if="item.bot.page.network === 'twitter'"
                                  size="25px"
                                  :src="require('../../../assets/img/icon_tw.png')"
                                />
                                <img
                                  v-else-if="item.bot.page.network === 'linkedin'"
                                  size="25px"
                                  :src="require('../../../assets/img/icon_linkedin.png')"
                                />
                                <img
                                  v-else-if="item.bot.page.network === 'instagram'"
                                  size="25px"
                                  :src="require('../../../assets/img/icon_instagram.png')"
                                />
                                
                              </div>
                              <p class="page-name">{{ item.bot.page.network }}</p>
                            </div>
                          </div>
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                  <Tooltip 
                    :text="$t('dash.tooltip.remove_mentions')" 
                    position="top"
                    v-if="isAddOrEditMentions('Hashtag') == 'edit' || (previewEdited && previewEdited.hashtag && previewEdited.hashtag.edit)"
                    class="cancel"
                    style="position: absolute; top: 0; right: 70px; text-align: center;"
                  >
                    <vs-button 
                      class="btnx" 
                      type="flat" 
                      @click="removeMentions('Hashtag')" 
                      icon="delete"
                    ></vs-button>
                    &nbsp;
                  </Tooltip>
                  <vs-button
                    class="page-btn"
                    vs-type="filled"
                    color="#6a1f4c"
                    @click.prevent="validateMentions('Hashtag')"
                  >OK</vs-button>
                </div>
                <vs-input
                  color="#B20564"
                  type="text"
                  name="search-mention"
                  class="inputx"
                  :placeholder="$t(`dash.posts.overlay.search_hashtag_placeholder`)"
                  v-model="searchHashtag[selectedBotHashtag].search"
                  v-on:keyup="searchMentions('Hashtag')"
                  ref="inputSearchMention"
                  autocomplete="off"
                />
                <ul id="loadableContent-list-mentions">
                  <div v-for="(mention, index) in searchHashtag[selectedBotHashtag].results" :key="index">  
                    <li @click="selectMention('Hashtag', mention)" :class="{'select': mentionIsSelected('Hashtag', mention) == true}" v-if="mention.hashtag">
                      <div :class="searchHashtag[selectedBotHashtag].bot.page.network">
                        <div class="content">
                          <p class="name">{{ `#${mention.hashtag}` }}</p>
                          <p class="count">{{ `${mention.count} ${searchHashtag[selectedBotHashtag].bot.page.network === 'twitter' ? 'Tweet' : 'Post' }${mention.count > 1 ? 's': ''}` }}</p>
                        </div>
                      </div>
                      <div class="checkmark" v-show="mentionIsSelected('Hashtag', mention) == true">
                        <i class="material-icons">check</i>
                      </div>
                    </li>
                  </div>
                </ul>
              </div>
              <div @keydown.prevent.enter="" class="auto-mentions row box" v-if="checkActiveLocationSearch && openAutoLocations && searchLocation.length > 0">
                  <div class="connected-pages">
                    <div class="selected-page">
                      <div
                        class="page"
                        v-for="(item, index) in searchLocation"
                        :key="index"
                      >
                        <Tooltip
                          :text="item.bot.page.network"
                          position="top"
                        >
                          <input
                            type="radio"
                            :id="`bot-index-${index}`"
                            name="page"
                            :value="index"
                            v-model="selectedBotLocation" 
                            @click="changeMentionNetwork('Location', index)"   
                          >
                          <div class="page-wrapper">
                            <div class="page-content">
                              <div class="vertical-align">
                                <div class="page-img-wrapper">
                                  <img
                                    v-if="item.bot.page.network === 'facebook'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_fb.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'twitter'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_tw.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'linkedin'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_linkedin.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'instagram'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_instagram.png')"
                                  />
                                  
                                </div>
                                <p class="page-name">{{ item.bot.page.network }}</p>
                              </div>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                    <vs-button
                      class="page-btn"
                      vs-type="filled"
                      color="#6a1f4c"
                      @click.prevent="selectLocation(searchLocation[selectedBotLocation].selected)"
                    >OK</vs-button>
                  </div>
                  <vs-input
                    color="#B20564"
                    type="text"
                    name="search-mention"
                    class="inputx"
                    :placeholder="$t(`dash.posts.overlay.search_location_placeholder`)"
                    v-model="searchLocation[selectedBotLocation].search"
                    v-on:keyup="searchMentions('Location')"
                    v-on:click="searchMentions('Location')"
                    ref="inputSearchMentionStory"
                    autocomplete="off"
                  />
                  <ul id="loadableContent-list-mentions">
                    <div v-for="(mention, index) in searchLocation[selectedBotLocation].results" :key="index">
                      <!-- <li @click="selectMention('Location', mention)" :class="{'select': mentionIsSelected('Location', mention) == true}" v-if="mention.location"> -->
                      <li @click="selectMention('Location', mention)" :class="{'select': mentionIsSelected('Location', mention) == true}">
                        <div :class="searchLocation[selectedBotLocation].bot.page.network">
                          <div class="content">    
                            <p class="locations">{{mention.name}}</p>
                            <p class="locations infos" v-if="mention.location">{{mention.location.street}}{{mention.location.street && ','}} {{mention.location.zip}} {{mention.location.city}}{{mention.location.city && ','}} {{mention.location.country}}</p>
                          </div>
                        </div>
                        <div class="checkmark" v-show="mentionIsSelected('Location', mention) == true">
                          <i class="material-icons">check</i>
                        </div>
                      </li>
                    </div>
                  </ul>
                  <vs-button class="cancel" v-if="isAddOrEditMentions('Location') == 'edit'" @click="removeMentions('Location')">
                    {{ $t('dash.button.cancel') }}
                  </vs-button>
              </div>
              
              <vs-prompt class="auto-generate-text"
                :title="$t('dash.auto-generate-text.title')"
                color="info"
                @cancel="() => {openAccrochesAI = false; accrochesAI=null}"
                @accept="changeTextByGenerated()"
                @close="() => {openAccrochesAI = false; accrochesAI=null}"
                :accept-text="$t('dash.confirm')"
                :cancel-text="$t('dash.cancel')"
                :active.sync="openAccrochesAI">
                <div class="con-exemple-prompt">
                  <vs-textarea
                    vs-size="large"
                    color="#B20564"
                    name="title"
                    class="inputx"
                    :placeholder= inputTitleText
                    v-model="editPromptAccroches"
                  />
                  <vs-button class="generate" @click="getAccrochesByAI(true)">
                    {{ $t('dash.generate') }}
                  </vs-button>
                  <ul>
                    <li v-for="(opt, idx) in accrochesAI" :key="idx">
                      <input
                        type="checkbox"
                        :id="`accroche-${idx}`"
                        name="accroches[]"
                        :value="opt"
                        v-model="selectedAccroches"
                      >  
                      {{ opt }}
                    </li>
                  </ul>
                  <component-loader :progress="90" :unlimitedProgress="true" v-if="showPromptLoader" :activeClose="true" v-on:close="showPromptLoader = false"></component-loader>
                </div>
              </vs-prompt>

            </div>
            <div v-if="getBoardPagePinterest || atLeastWonderpushSelected() || atLeastNetworkSelected('youtube')" style="margin-top: 20px">
                 <vs-textarea v-if="typePost !== 'story'"
                v-validate="''"
                :disabled="state == 'retweet'"
                :class="{'input': true,
                  'is-danger': errors.has('posts.title') }"
                vs-size="large"
                color="#B20564"
                name="title"
                class="inputx"
                :placeholder=inputDescriptionText
                v-model.lazy="form.description"
                id="description-post"
                @click="[closeAutoMentions(), checkAddMention()]"
                @keyup="[checkAddMention(), textAreaAdjust('description-post')]"
                data-qa="form-post-message"
              />
                <!-- :counter="limitText" :counter-danger.sync="counterDanger" -->
           </div>

            <div class="comments" v-if="isThreadable()" :class="[{'disable-section': state == 'edit-posted'}]">
              <!-- <ul v-if="form.comments.length">
                <li v-for="(comment, commentIndex) in form.comments" :key="commentIndex">
                  <vs-textarea
                    v-validate="''"
                    vs-size="large"
                    color="#B20564"
                    name="title"
                    class="inputx"
                    :placeholder="$t('dash.posts.overlay.new_comment_placeholder')"
                    v-model="form.comments[commentIndex]"
                    :id="`comment-post-${commentIndex}`"
                    :counter="limitText" :counter-danger.sync="counterDanger"
                    @click="[closeAutoMentions(), checkAddMention()]"
                    @keyup="[checkAddMention(null, commentIndex), textAreaAdjust(`comment-post-${commentIndex}`)]"
                  />
                </li>
              </ul> -->
              <div v-for="(comment, commentIdx) in form.comments" :key="commentIdx" class="textarea-emoji-picker" >
                <span class="remove-comment" @click="removeComment(commentIdx)">
                  <Tooltip
                    :text="$t('dash.post.remove-comment')"
                    position="top"
                  >
                    <i class="material-icons">close</i>&nbsp;
                  </Tooltip>
                </span>
                <picker
                  v-if="!atLeastNetworkSelected('bluesky')"
                  :data="emojiIndex"
                  v-show="showEmojiPickerComment === commentIdx"
                  title="Pick your emoji..."
                  emoji="point_up"
                  @select="(e) => addEmoji(e,null,commentIdx)"
                />
                <span 
                  v-if="!atLeastNetworkSelected('bluesky')"
                  class="emoji-trigger tooltip"
                  :class="{ 'triggered': showEmojiPickerComment === commentIdx }"
                  @click="e => toggleEmojiPicker(e, null, commentIdx)"
                >
                  <svg
                    style="width:20px;height:20px"
                    viewBox="0 0 24 24"
                  >
                    <path fill="#888888" d="M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z" />
                  </svg>
                  <span class="tooltip-text">{{ $t('dash.add-emoji.title') }}</span>
                </span>
                
                <span class="add-mention tooltip" @click="toggleShowMentions('Mention', null, commentIdx)">
                  @
                  <span class="tooltip-text">{{ $t('dash.add-mention.title') }}</span>
                </span>
                
                <span class="add-mention add-hashtag tooltip" @click="toggleShowMentions('Hashtag', null, commentIdx)" :class="{ 'disabled': !activeSearchHashtags}" v-if="activeSearchHashtags">
                  #
                  <span class="tooltip-text">{{ $t('dash.add-hashtag.title') }}</span>
                </span>
                
                <div class="vs-con-textarea inputx" style="border:1px solid rgba(0, 0, 0, 0.08);">
                  <textarea
                    name="title"
                    class="vs-textarea"
                    :placeholder="$t('dash.posts.overlay.new_comment_placeholder')"
                    v-model="form.comments[commentIdx]"
                    :id="`comment-post-${commentIdx}`"
                    @click="[closeAutoMentions(), checkAddMention(null, commentIdx)]"
                    @keyup="[checkAddMention(null, commentIdx), textAreaAdjust(`comment-post-${commentIdx}`)]"
                  ></textarea>
                </div>
                <div @keydown.prevent.enter="" class="auto-mentions row box" v-if="checkActiveMentionsSearch && openAutoMentions === commentIdx && searchMention.length > 0">
                  <div class="connected-pages">
                    <div class="selected-page">
                      <div
                        class="page"
                        v-for="(item, index) in searchMention"
                        :key="index"
                      >
                        <Tooltip
                          :text="item.bot.page.network"
                          position="top"
                        >
                          <input
                            type="radio"
                            :id="`bot-index-${index}`"
                            name="page"
                            :value="index"
                            v-model="selectedBotMention" 
                            @click="changeMentionNetwork('Mention', index)"   
                          >
                          <div class="page-wrapper">
                            <div class="page-content">
                              <div class="vertical-align">
                                <div class="page-img-wrapper">
                                  <img
                                    v-if="item.bot.page.network === 'facebook'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_fb.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'twitter'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_tw.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'linkedin'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_linkedin.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'instagram'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_instagram.png')"
                                  />
                                  
                                </div>
                                <p class="page-name">{{ item.bot.page.network }}</p>
                              </div>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                    <Tooltip 
                      :text="$t('dash.tooltip.remove_mentions')" 
                      position="top"
                      v-if="isAddOrEditMentions('Mention', null, commentIdx) == 'edit' || (previewEdited && previewEdited.mention && previewEdited.mention.edit)"
                      class="cancel"
                      style="position: absolute; top: 0; right: 70px; text-align: center;"
                    >
                      <vs-button 
                        class="btnx" 
                        type="flat" 
                        @click="removeMentions('Mention', null, commentIdx)" 
                        icon="delete"
                      ></vs-button>
                      &nbsp;
                    </Tooltip>
                    <vs-button
                      class="page-btn"
                      vs-type="filled"
                      color="#6a1f4c"
                      @click.prevent="validateMentions('Mention', null, commentIdx)"
                    >OK</vs-button>
                  </div>
                  <vs-input
                    color="#B20564"
                    type="text"
                    name="search-mention"
                    class="inputx"
                    id="storyMentionsInput"
                    :placeholder="$t(`dash.posts.overlay.search_mention_placeholder_${searchMention[selectedBotMention].bot.page.network}${searchMention[selectedBotMention].bot.page.story_config && searchMention[selectedBotMention].bot.page.story_config.created && (!searchMention[selectedBotMention].bot.page.story_config.lock || searchMention[selectedBotMention].bot.page.story_config.lock < Date.now()) ? '_direct' : ''}`)"
                    v-model="searchMention[selectedBotMention].search"
                    v-on:keyup="searchMentions('Mention')"
                    v-on:click="searchMentions('Mention')"
                    ref="inputSearchMentionStory"
                    autocomplete="off"
                  />
                  <ul id="loadableContent-list-mentions" v-if="searchMention[selectedBotMention].results && searchMention[selectedBotMention].results.length">
                    <div v-for="(mention, index) in searchMention[selectedBotMention].results" :key="index">  
                      <li @click="selectMention('Mention', mention)" :class="{'select': mentionIsSelected('Mention', mention) == true}" v-if="mentionIsSelected('Mention', mention)">
                        <div :class="searchMention[selectedBotMention].bot.page.network">
                          <img :alt="mention.name" class="image" :src="mention.image" v-if="mention.image"/>
                          <span class="image" v-else></span>
                          <div class="content">
                            <p class="name">{{ mention.name }}</p>
                            <img alt="verified account" src="../../../assets/img/validated-twitter.png" v-if="searchMention[selectedBotMention].bot.page.network == 'twitter'"/>
                            <p class="screen_name id" v-if="searchMention[selectedBotMention].bot.page.network == 'facebook'">{{ mention.id }}</p>
                            <p class="screen_name" v-else-if="searchMention[selectedBotMention].bot.page.network == 'bluesky'">@{{ mention.subtitle }}</p>
                            <p class="screen_name" v-else>@{{ searchMention[selectedBotMention].bot.page.network == 'twitter' ? mention.screen_name : (searchMention[selectedBotMention].bot.page.network == 'instagram' && mention.id) ? mention.id : mention.name }}</p>
                            <p class="description" v-if="searchMention[selectedBotMention].bot.page.network == 'twitter'">{{ mention.description }}</p>
                            <p class="screen_name" v-if="mention.subtitle && searchMention[selectedBotMention].bot.page.network != 'bluesky'">{{ mention.subtitle }}</p>
                          </div>
                        </div>
                        <div class="checkmark" v-show="mentionIsSelected('Mention', mention) == true">
                          <i class="material-icons">check</i>
                        </div>
                      </li>
                    </div>
                  </ul>
                  <ul id="loadableContent-list-mentions" v-else-if="searchMention[selectedBotMention].results">
                    <li>
                      <p>Aucun resultat</p>
                    </li>
                  </ul>
                  <ul id="loadableContent-list-mentions" class="empty" v-else></ul>
                </div>
                <div @keydown.prevent.enter="" class="auto-mentions auto-hashtags row box" v-if="checkActiveHashtagsSearch && ((typeof openAutoHashtags == 'boolean' && openAutoHashtags) || openAutoHashtags === commentIdx) && searchHashtag.length > 0">
                  <div class="connected-pages">
                    <div class="selected-page">
                      <div
                        class="page"
                        v-for="(item, index) in searchHashtag"
                        :key="index"
                      >
                        <Tooltip
                          :text="item.bot.page.network"
                          position="top"
                        >
                          <input
                            type="radio"
                            :id="`bot-index-${index}`"
                            name="page"
                            :value="index"
                            v-model="selectedBotHashtag" 
                            @click="changeMentionNetwork('Hashtag', index)"   
                          >
                          <div class="page-wrapper">
                            <div class="page-content">
                              <div class="vertical-align">
                                <div class="page-img-wrapper">
                                  <img
                                    v-if="item.bot.page.network === 'facebook'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_fb.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'twitter'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_tw.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'linkedin'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_linkedin.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'instagram'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_instagram.png')"
                                  />
                                  
                                </div>
                                <p class="page-name">{{ item.bot.page.network }}</p>
                              </div>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                    <vs-button
                      class="page-btn"
                      vs-type="filled"
                      color="#6a1f4c"
                      @click.prevent="validateMentions('Hashtag', null, commentIdx)"
                    >OK</vs-button>
                  </div>
                  <vs-input
                    color="#B20564"
                    type="text"
                    name="search-mention"
                    class="inputx"
                    :placeholder="$t(`dash.posts.overlay.search_hashtag_placeholder`)"
                    v-model="searchHashtag[selectedBotHashtag].search"
                    v-on:keyup="searchMentions('Hashtag')"
                    v-on:click="searchMentions('Hashtag')"
                    ref="inputSearchMentionStory"
                    autocomplete="off"
                  />
                  <ul id="loadableContent-list-mentions">
                    <div v-for="(mention, index) in searchHashtag[selectedBotHashtag].results" :key="index">  
                      <li @click="selectMention('Hashtag', mention)" :class="{'select': mentionIsSelected('Hashtag', mention) == true}" v-if="mention.hashtag">
                        <div :class="searchHashtag[selectedBotHashtag].bot.page.network">
                          <div class="content">    
                            <p class="name">{{ `#${mention.hashtag}` }}</p>
                            <p class="count">{{ `${mention.count} ${searchHashtag[selectedBotHashtag].bot.page.network === 'twitter' ? 'Tweet' : 'Post' }${mention.count > 1 ? 's': ''}` }}</p>
                          </div>
                        </div>
                        <div class="checkmark" v-show="mentionIsSelected('Hashtag', mention) == true">
                          <i class="material-icons">check</i>
                        </div>
                      </li>
                    </div>
                  </ul>
                  <vs-button class="cancel" v-if="isAddOrEditMentions('Hashtag', null, commentIdx) == 'edit'" @click="removeMentions('Hashtag', null, commentIdx)">
                    {{ $t('dash.button.cancel') }}
                  </vs-button>
                </div>
              </div>
              <div class="add-comment" @click="addComment">{{ $t('dash.posts.form.add-comment') }}</div>
            </div>
          </div>

          
          <div class="input-wrapper"  v-if="typePost == 'image' && state !== 'edit-posted' && ((onlyListNetworkSelected(['instagram']) && checkPlanOptions(['conciergerie'])) || onlyListNetworkSelected(['threads']))">
            <ul class="mix-carrousel">
              <li>
                <input
                  type="checkbox"
                  :id="`carrousel-mix`"
                  name="carrouselMix[]"
                  :value="true"
                  v-model="isCarrouselMix"
                >  
                {{ $t('dash.posts.form.video.mix') }}
              </li>
            </ul>
          </div>

          <div class="input-wrapper"  v-if="typePost == 'video'">
            <p v-if="messageUpload && onUpload && !isThumbUpload"><span v-if="percentUpload < 101">{{Math.ceil(percentUpload)}}%</span> {{messageUpload}}</p>
            <vs-progress :percent="percentUpload" color="primary" v-if="onUpload && percentUpload < 98 && !isThumbUpload">primary</vs-progress>
            <vs-progress indeterminate color="primary" v-if="onUpload && percentUpload >= 98 && !isThumbUpload">primary</vs-progress>
            <!-- <ul v-if="onlyInstagramSelected()" class="mix-carrousel"> -->
            <ul v-if="(onlyListNetworkSelected(['instagram']) && state !== 'edit-posted' && checkPlanOptions(['conciergerie'])) || onlyListNetworkSelected(['threads']) " class="mix-carrousel">
              <li>
                <input
                  type="checkbox"
                  :id="`carrousel-mix`"
                  name="carrouselMix[]"
                  :value="true"
                  v-model="isCarrouselMix"
                >  
                {{ $t('dash.posts.form.video.mix') }}
              </li>
            </ul>
            <div class="custom-file-input" v-if="state !== 'edit-posted'">
              <div class="file-input">
                <div class="file-btn">
                  <div class="vertical">
                    <img src="../../../assets/img/video-icon.svg" alt="media">
                    <!-- <p>{{$t(`dash.posts.form.video${onlyInstagramSelected() ? (isCarrouselMix ? 's_images' : 's') : ''}`)}}</p> -->
                    <p>{{$t(`dash.posts.form.video${onlyListNetworkSelected(['instagram', 'threads']) ? (isCarrouselMix ? 's_images' : 's') : ''}`)}}</p>
                    <input
                      v-validate="''"
                      :class="{'input': true, 'is-danger': errors.has('posts.file') }"
                      name="file"
                      type="file"
                      id="file"
                      ref="myVideo"
                      @change="selectVideo"
                      :multiple="onlyListNetworkSelected(['instagram', 'threads'])"
                      @click="initInputFile"
                      :disabled="onUpload"
                      :accept="`video/*${onlyListNetworkSelected(['instagram', 'threads']) && isCarrouselMix ? ', image/*' : ''}`"
                    >
                  </div>
                </div>
                <div class="file-name">
                  <div class="vertical">
                    <p v-if="videoname && multipleMedias.length <= 1">{{this.videoname}}</p>
                    <div @click="removeVideo" v-if="videoname && multipleMedias.length <= 1 && !onUpload && videoname !== this.$t('dash.message.no.video')" class="delete-video-thumb">𝗫</div>

                    <div class="help-limit-video">
                      <Tooltip 
                        :text="$t('dash.posts.form.media.video.limit.header')" 
                        position="top"
                      >
                        <img src="../../../assets/img/icon_help.svg" alt="?" @click="openHelpLimitVideo = true" class='telegram-help'/>
                        &nbsp;
                      </Tooltip>
                      <vs-popup class="posts-overlay-limit-video" :title="$t('dash.posts.form.media.video.limit.header')" :active.sync="openHelpLimitVideo">
                        <table>
                            <th></th>
                            <th>
                              {{$t('dash.posts.form.media.video.limit.during')}}
                            </th>
                            <th>
                              {{$t('dash.posts.form.media.video.limit.size')}}
                            </th>
                            <tr>
                              <td>Facebook</td>
                              <td >20 min</td>
                              <td>1 Go</td>
                            </tr>
                            <tr>
                              <td>Facebook reel</td>
                              <td>90 sec</td>
                              <td>1 Go</td>
                            </tr>
                            <tr>
                              <td>Twitter</td>
                              <td>140 sec</td>
                              <td>512 Mo</td>
                            </tr>
                            <tr>
                              <td>Linkedin</td>
                              <!-- <td>15 min</td> -->
                              <td>30 min</td>
                              <td>200 Mo</td>
                            </tr>
                            <tr>
                              <td>Linkedin conciergerie</td>
                              <td>30 min</td>
                              <td>5 Go</td>
                            </tr>
                            <tr>
                              <td>Instagram video</td>
                              <td>60 sec</td>
                              <!-- <td>100 Mo</td> -->
                              <td>1 Go</td>
                            </tr>
                            <tr>
                              <td>Instagram reel</td>
                              <td>15 min</td>
                              <td>1 Go</td>
                            </tr>
                            <tr v-if="atLeastTiktokSelected() && tiktokRequirements">
                              <td>Tiktok</td>
                              <td>{{ tiktokRequirements.max_video_post_duration_sec}} sec</td>
                              <td>X</td>
                            </tr>
                        </table>
                      </vs-popup>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="typePost === 'standard'">
            <p v-if="typePost === 'standard' && messageUpload && onUpload">
              <span v-if="percentUpload < 101"> {{Math.ceil(percentUpload)}}%</span> {{messageUpload}}
            </p>
            <vs-progress :percent="percentUpload" color="primary" v-if="typePost === 'standard' && onUpload && percentUpload < 98">primary</vs-progress>
            <vs-progress indeterminate color="primary" v-if="typePost === 'standard' && onUpload && percentUpload >= 98">primary</vs-progress>
          </div>
          <div class="input-wrapper" v-if="!storyShare && (typePost == 'image' || (typePost == 'video' && thumbPossible()) || typePost === 'story' || typePost === 'document')">
            <p v-if="messageUpload && onUpload && (typePost !== 'video' || isThumbUpload)">
              <span v-if="multipleImages && multipleImages.length > 1">Image {{`${compressedImages.length + 1}/${multipleImages.length}`}} : </span>
              <span v-if="percentUpload < 101"> {{Math.ceil(percentUpload)}}%</span> {{messageUpload}}
            </p>
            <vs-progress :percent="percentUpload" color="primary" v-if="onUpload && percentUpload < 98 && (typePost !== 'video' || isThumbUpload)">primary</vs-progress>
            <vs-progress indeterminate color="primary" v-if="onUpload && percentUpload >= 98 && (typePost !== 'video' || isThumbUpload)">primary</vs-progress>
            <div class="custom-file-input" v-if="multipleMedias.length <= 1 && state !== 'edit-posted'">
              <div class="file-input">
                <div class="file-btn">
                  <div class="vertical">
                    <img src="../../../assets/img/icon_media.png" alt="media">
                    <p>{{$t(typePost == 'video' ? 'dash.posts.form.thumb' : typePost === 'document' ? 'dash.posts.form.document' : typePost === 'story' ? 'dash.posts.form.media.multiple' : 'dash.posts.form.media')}}</p>
                    <input v-if="typePost === 'story'"
                      v-validate="''"
                      :class="{'input': true, 'is-danger': errors.has('posts.file') }"
                      name="file"
                      type="file"
                      id="file"
                      ref="storyFile"
                      @change="() => selectStoryFile()"
                      @click="initInputFile"
                      :multiple="false"
                      :disabled="onUpload"
                      :accept="`image/*, video/*`"
                      />
                    <input v-else
                      v-validate="''"
                      :class="{'input': true, 'is-danger': errors.has('posts.file') }"
                      name="file"
                      type="file"
                      id="file"
                      ref="myFiles"
                      @change="() => select(typePost == 'video' && thumbPossible())"
                      @click="initInputFile"
                      :multiple="carouselPossible() ? true : false"
                      :accept="typePost === 'document' ? 'application/pdf' : `image/*`" />
                  </div>
                </div>
                <div class="file-name" v-if="multipleImages.length <= 1 || form.enclosure">
                  <div class="verti">
                    <p v-if="videoname && storyVideo && !videoReel">{{videoname}}</p>
                    <p v-else-if="filename && !form.enclosure">{{filename}}</p>
                    <p v-else-if="filename && filename.includes('.gif')">{{filename}}</p>
                    <div @click="removeVideo" v-if="videoname && storyVideo && !videoReel && !onUpload && videoname !== this.$t('dash.message.no.video')" class="delete-video-thumb">𝗫</div>
                    <div v-if="url && !storyVideo && !(typePost == 'image' && carouselPossible() && multipleImages.length > 1)" class="del-img-wrapper">
                      <img :class="`${typePost === 'story' && 'story-thumb'} carousel-thumb`" v-if="!storyShare && url && typePost !== 'document'" :src="url">
                      <div @click="removeImage" v-if="url" class="delete-img-thumb">𝗫</div>
                    </div>
                    <div v-if="typePost == 'image'" class="help-limit-video">
                      <Tooltip 
                        :text="$t('dash.posts.form.media.image.limit.header')" 
                        position="top"
                      >
                        <img src="../../../assets/img/icon_help.svg" alt="?" @click="openHelpLimitImage = true" class='telegram-help'/>
                        &nbsp;
                      </Tooltip>
                      <vs-popup class="posts-overlay-limit-video" :title="$t('dash.posts.form.media.image.limit.header')" :active.sync="openHelpLimitImage">
                        <table>
                            <th></th>
                            <th>
                              {{$t('dash.posts.form.media.image.limit.number')}}
                            </th>
                            <th>
                              {{$t('dash.posts.form.media.video.limit.size')}} max
                            </th>
                            <th>
                              Dimension max
                            </th>
                            <th>
                              Dimension min
                            </th>
                            <th>
                              GIF
                            </th>
                            <tr>
                              <td>Facebook</td>
                              <td >80 images</td>
                              <td >&lt; 4 Mo</td>
                              <td >-</td>
                              <td >-</td>
                              <td>N/A</td>
                            </tr>
                            <tr>
                              <td>Twitter</td>
                              <td>4 images</td>
                              <td >&lt; 5 Mo</td>
                              <td >8192x8192</td>
                              <td >4x4</td>
                              <td>350 frames max</td>
                            </tr>
                            <tr>
                              <td>Linkedin</td>
                              <td>20 images</td>
                              <td >-</td>
                              <td >36152320 pixels </td>
                              <td >-</td>
                              <td>250 frames max</td>
                            </tr>
                            <tr>
                              <td>Instagram</td>
                              <td>20 images</td>
                              <td >&lt; 8 Mo</td>
                              <td >1.91:1</td>
                              <td >4:5</td>
                              <td>N/A</td>
                            </tr>
                            <tr>
                              <td>Google Business Profile</td>
                              <td>1 image</td>
                              <td >&lt; 5 Mo</td>
                              <td >-</td>
                              <td >250x250</td>
                              <td>N/A</td>
                            </tr>
                        </table>
                      </vs-popup>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
            <i v-show="errors.has('posts.file')" class="fa fa-warning"></i>
            <span
              v-show="errors.has('posts.file')"
              class="help is-danger"
            >{{ errors.first('posts.file') }}</span>
          </div>

          <div class="input-wrapper" v-if="atLeastNetworkSelected('twitter')">
            <div>
              <div>
                <div class="options-wrapper type-video">
                  <div class="options-wrapper-tilte">
                    <vs-avatar
                      color="transparent"
                      size="18px"
                      :src="require('../../../assets/img/icon_tw.png')"
                    />
                    Twitter
                  </div>
                  <ul>
                    <li class="clearBoth">
                      <span class="select-title">{{ $t(`dash.post.twitter_options.reply_settings.title`) }}</span>
                      <select v-model="twitterOptions.reply_settings" class="reply_settings-input" :disabled="state === 'edit-posted'">
                        <option :value="null">{{$t(`dash.post.twitter_options.reply_settings.none`)}}</option>
                        <option value="following">{{$t(`dash.post.twitter_options.reply_settings.following`)}}</option>
                        <option value="mentionedUsers">{{$t(`dash.post.twitter_options.reply_settings.mentionedUsers`)}}</option>
                        <option value="subscribers">{{$t(`dash.post.twitter_options.reply_settings.subscribers`)}}</option>
                        <option value="verified">{{$t(`dash.post.twitter_options.reply_settings.verified`)}}</option>
                      </select>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="input-wrapper"  v-if="typePost == 'video'">
            <div>
              <div>
                <div class="options-wrapper type-video" v-if="atLeastNetworkSelected('youtube')">
                  <div class="options-wrapper-tilte">
                    <!-- <vs-avatar
                      color="transparent"
                      size="18px"
                      :src="require('../../../assets/img/ico-youtube-circle.svg')"
                    /> -->
                    <vs-avatar
                      color="transparent"
                      size="18px"
                      :src="require('../../../assets/img/logo-youtube.svg')"
                    />
                    Youtube
                  </div>
                  <ul>
                    <!-- <li>
                      <div class="checkbox">
                        <input
                          type="checkbox"
                          :value="true"
                          v-model="youtubeOptions.notifySubscribers"
                        >
                        <span class="checkmark">
                          <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                        </span>
                      </div>
                      <p>{{ $t('dash.posts.youtube_options.notify_subscribers') }}</p>
                    </li>
                    <li>
                      <div class="checkbox">
                        <input
                          type="checkbox"
                          :value="true"
                          v-model="youtubeOptions.madeForKids"
                        >
                        <span class="checkmark">
                          <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                        </span>
                      </div>
                      <p>{{ $t('dash.posts.youtube_options.made_for_kids') }}</p>
                    </li> -->
                    <li>
                      <div class="checkboxes">
                        <ul>
                          <li :class="[{active: youtubeOptions.notifySubscribers}, 'w50']" @click="youtubeOptions.notifySubscribers = !youtubeOptions.notifySubscribers">
                            <Tooltip 
                              :text="$t('dash.posts.youtube_options.notify_subscribers')" 
                              position="top"
                            >
                              <span>{{ $t('dash.posts.youtube_options.notify_subscribers.enabled') }}</span>
                              &nbsp;
                            </Tooltip>
                          </li>
                          <li :class="[{active: !youtubeOptions.madeForKids}, 'w50']" @click="youtubeOptions.madeForKids = !youtubeOptions.madeForKids">
                            <span>{{ $t('dash.posts.youtube_options.made_for_kids') }}</span>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li class="clearBoth">
                      <span class="select-title">{{ $t(`dash.post.youtube_options.privacy_level.title`) }}</span>
                      <select v-model="youtubeOptions.privacy_level" class="privacy-level-input">
                        <option value="private">{{$t(`dash.post.youtube_options.privacy-level.private`)}}</option>
                        <option value="public">{{$t(`dash.post.youtube_options.privacy-level.public`)}}</option>
                        <option value="unlisted">{{$t(`dash.post.youtube_options.privacy-level.unlisted`)}}</option>
                      </select>
                    </li>
                    <li v-if="youtubeCategories && youtubeCategories.length" class="clearBoth">
                      <span class="select-title">{{ $t(`dash.post.youtube_options.categories.opt.title`) }}</span>
                      <select v-model="youtubeOptions.category" class="privacy-level-input">
                        <option v-for="(opt, idx) in youtubeCategories.filter(c => c.snippet.assignable)" :key="idx" :value="opt.id">{{ opt.snippet.title }}</option>
                      </select>
                    </li>
                    <li class="clearBoth">
                      <span class="vue-tags-title">{{ $t(`dash.post.youtube_options.tags.title`) }}</span>
                      <vue-tags-input
                              v-model="youtubeOptions.tag"
                              :tags="youtubeOptions.tags"
                              :placeholder="$t('dash.post.youtube_options.tags.placeholder')" 
                              @tags-changed="newTags => (youtubeOptions.tags = newTags)"></vue-tags-input>
                              <!--
                                @before-deleting-tag="newTag => {newTag.deleteTag(), youtubeOptions.tags.splice(newTag.index, 1)}"
                      ></vue-tags-input> -->
                    </li>
                    <li class="clearBoth" v-if="youtubePlaylists && youtubePlaylists.length">
                      <span class="select-title">{{ $t(`dash.post.youtube_options.playlist.opt.title`) }}</span>
                      <select v-model="youtubeOptions.playlist" class="playlist-input privacy-level-input">
                        <option :value="null">{{ $t(`dash.post.youtube_options.playlist.opt.none`) }}</option>
                        <option v-for="(opt, idx) in youtubePlaylists" :key="idx" :value="opt.id">{{ opt.snippet.title }}</option>
                      </select>
                    </li>
                  </ul>
                </div>
                <div class="options-wrapper type-video" v-if="atLeastTiktokSelected()">
                  <div class="options-wrapper-tilte">
                    <vs-avatar
                      color="transparent"
                      size="18px"
                      :src="require('../../../assets/img/icon_tiktok.png')"
                    />
                    TikTok
                  </div>
                  <ul>
                    <!-- <li>
                      <div class="checkbox">
                        <input
                          type="checkbox"
                          :value="true"
                          v-model="tiktokOptions.comment_disabled"
                        >
                        <span class="checkmark">
                          <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                        </span>
                      </div>
                      <p>{{ $t('dash.posts.tiktok_options.comment_disabled') }}</p>
                    </li>
                    <li>
                      <div class="checkbox">
                        <input
                          type="checkbox"
                          :value="true"
                          v-model="tiktokOptions.duet_disabled"
                        >
                        <span class="checkmark">
                          <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                        </span>
                      </div>
                      <Tooltip 
                        :text="$t('dash.posts.tiktok_options.duet_disabled.detail')" 
                        position="top"
                      >
                        <span>{{ $t('dash.posts.tiktok_options.duet_disabled') }}</span>
                        &nbsp;
                      </Tooltip>
                    </li>
                    <li>
                      <div class="checkbox">
                        <input
                          type="checkbox"
                          :value="true"
                          v-model="tiktokOptions.stitch_disabled"
                        >
                        <span class="checkmark">
                          <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                        </span>
                      </div>
                      <Tooltip 
                        :text="$t('dash.posts.tiktok_options.stitch_disabled.detail')" 
                        position="top"
                      >
                        <span>{{ $t('dash.posts.tiktok_options.stitch_disabled') }}</span>
                        &nbsp;
                      </Tooltip>
                    </li> -->
                    <li>
                      <div class="checkboxes">
                        <ul>
                          <li :class="[{active: tiktokOptions.comment_disabled}, 'w50']" @click="tiktokOptions.comment_disabled = !tiktokOptions.comment_disabled">
                            <span>{{ $t('dash.posts.tiktok_options.comment_disabled') }}</span>
                          </li>
                          <li :class="[{active: tiktokOptions.duet_disabled}, 'w50']" @click="tiktokOptions.duet_disabled = !tiktokOptions.duet_disabled">
                            <Tooltip 
                              :text="$t('dash.posts.tiktok_options.duet_disabled.detail')" 
                              position="top"
                            >
                              <span>{{ $t('dash.posts.tiktok_options.duet_disabled') }}</span>
                              &nbsp;
                            </Tooltip>
                          </li>
                          <li :class="[{active: tiktokOptions.stitch_disabled}, 'w50']" @click="tiktokOptions.stitch_disabled = !tiktokOptions.stitch_disabled">
                            <Tooltip 
                              :text="$t('dash.posts.tiktok_options.stitch_disabled.detail')" 
                              position="top"
                            >
                              <span>{{ $t('dash.posts.tiktok_options.stitch_disabled') }}</span>
                              &nbsp;
                            </Tooltip>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li class="clearBoth">
                      <span class="select-title">{{ $t(`dash.post.privacy-level.opt.title`) }}</span>
                      <select v-model="tiktokOptions.privacy_level" class="privacy-level-input" v-if="tiktokRequirements && tiktokRequirements.privacy_level_options">
                        <option v-for="(opt, idx) in tiktokRequirements.privacy_level_options" :key="idx" :value="opt">{{$t(`dash.post.privacy-level.opt.${opt}`)}}</option>
                      </select>
                    </li>
                  </ul>
                </div>
                <!--<div class="options-wrapper type-video" v-if="atLeastInstagramSelected()">
                  <div class="options-wrapper-tilte">
                    <vs-avatar
                      color="transparent"
                      size="18px"
                      :src="require('../../../assets/img/icon_instagram.png')"
                    />
                    Instagram
                  </div>
                  <ul>
                    <li>
                      <div class="checkboxes" :class="[{disabled: onUpload}]">
                        <ul>
                          <li :class="[{active: !videoReel}, 'w50']" @click="videoReel = !onUpload ? false : videoReel">
                            <span>{{ $t('dash.posts.video') }}</span>
                          </li>
                          <li :class="[{active: videoReel}, 'w50']" @click="videoReel = !onUpload ? true : videoReel">
                            <span>Reel</span>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div> -->
                <div class="options-wrapper type-video" v-if="atLeastFacebookSelected() && state !== 'edit-posted'">
                  <div class="options-wrapper-tilte">
                    <vs-avatar
                      color="transparent"
                      size="18px"
                      :src="require('../../../assets/img/icon_fb.png')"
                    />
                    Facebook
                  </div>
                  <ul>
                    <li>
                      <div class="checkboxes" :class="[{disabled: onUpload}]">
                        <ul>
                          <li :class="[{active: !videoReelFB}, 'w50']" @click="videoReelFB = !onUpload ? false : videoReelFB">
                            <span>{{ $t('dash.posts.video') }}</span>
                          </li>
                          <li :class="[{active: videoReelFB}, 'w50']" @click="videoReelFB = !onUpload ? true : videoReelFB">
                            <span>Reel</span>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="poll" v-if="typePost === 'poll'">
           <div class="poll-question">
             <label class="poll-label" for="poll-question">{{$t('dash.post.poll.question.label')}}</label>
             <textarea maxlength="140" v-model="poll.question" class="poll-input" id="poll-question"></textarea>
             <span class="poll-nb-char">{{poll.question.length}}/140</span>
           </div>
           <div class="poll-options">
             <span v-for="(opt, idx) in poll.options" :key="idx" class="poll-option">
                <label class="poll-label" :for="`poll-option${idx}`">{{$t('dash.post.poll.option.label') + ' ' + (idx+1)}}</label>
                <span class="poll-option-delete" v-if="idx > 1" @click="removePollOption(idx)">{{$t('dash.post.poll.option.remove')}}</span>
                <input maxlength="30" v-model="poll.options[idx]" class="poll-input" :id="`poll-option${idx}`"/>
                <span class="poll-nb-char">{{opt.length}}/30</span>
             </span>
             <vs-button class="poll-option-add" v-if="poll.options.length < 4" @click="addPollOption">{{$t('dash.post.poll.option.add')}}</vs-button>
           </div>
           <div class="poll-duration" v-if="onlyLinkedinSelected()">
             <label class="poll-duration-label">{{$t('dash.post.poll.duration.label')}}</label>
             <select v-model="poll.duration" class="poll-duration-input">
                <option value="86400">{{$t('dash.post.poll.duration.option1')}}</option>
                <option value="259200">{{$t('dash.post.poll.duration.option2')}}</option>
                <option value="604800">{{$t('dash.post.poll.duration.option3')}}</option>
                <option value="1209600">{{$t('dash.post.poll.duration.option4')}}</option>
             </select>
           </div>
          </div>

          <div v-if="typePost === 'document'" :style="{marginBottom: '15px'}">
            <p>{{$t('dash.post.title.document')}}</p><vs-input size="small" v-model="form.documentTitle"/>
          </div>

          <div v-if="typePost === 'story' && !storyVideo && !storyShare" class="">
             <div class="custom-file-input">
              <div class="file-input">
                <div class="file-btn">
                  <div class="vertical">
                    <img src="../../../assets/img/icon_media.png" alt="media">
                    <p>{{$t('dash.posts.form.story.layers')}}</p>
                    <input
                      v-validate="''"
                      :class="{'input': true, 'is-danger': errors.has('posts.file') }"
                      name="file"
                      type="file"
                      id="file"
                      @change="(e) => $store.dispatch('addStorificationLayerDefault', e.target.files[0])"
                      @click="initInputFile"
                      accept="image/*" />
                  </div>
                </div>
                <div class="layers-preview">
                  <div class="layer-preview" v-for="(layer, i) in $store.getters.storificationLayers" :key="i" >
                    <span class="remove-layer" @click="$store.commit('removeStorificationLayer',i)">x</span>
                    <img :src="layer.reader || layer.url" :alt="i">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span v-if="typePost === 'story'" class="add-mention add-location-story tooltip">
            <div class="disable-story-btn"  @click.stop="() => {!onlyInstagramConciergerieSelected() && showConciergerieForm()}">
              <Tooltip style="width: 100%" :active="!onlyInstagramConciergerieSelected()" :text="$t('dash.bots.status_proxy')">
                <button ref="inputSearchMention" :disabled="!onlyInstagramConciergerieSelected()" type="button" class="btn-add" @click="toggleShowMentions('Location')">
                  <svg enable-background="new 0 0 32 32" height="20px" id="Layer_1" version="1.1" viewBox="0 0 32 32" width="20px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="location"><path clip-rule="evenodd" d="M16.002,17.746c3.309,0,6-2.692,6-6s-2.691-6-6-6   c-3.309,0-6,2.691-6,6S12.693,17.746,16.002,17.746z M16.002,6.746c2.758,0,5,2.242,5,5s-2.242,5-5,5c-2.758,0-5-2.242-5-5   S13.244,6.746,16.002,6.746z" /><path clip-rule="evenodd" d="M16,0C9.382,0,4,5.316,4,12.001c0,7,6.001,14.161,10.376,19.194   C14.392,31.215,15.094,32,15.962,32c0.002,0,0.073,0,0.077,0c0.867,0,1.57-0.785,1.586-0.805   c4.377-5.033,10.377-12.193,10.377-19.194C28.002,5.316,22.619,0,16,0z M16.117,29.883c-0.021,0.02-0.082,0.064-0.135,0.098   c-0.01-0.027-0.084-0.086-0.129-0.133C12.188,25.631,6,18.514,6,12.001C6,6.487,10.487,2,16,2c5.516,0,10.002,4.487,10.002,10.002   C26.002,18.514,19.814,25.631,16.117,29.883z"/></g></svg>
                  {{ $store.getters.storificationLocation ? $t('dash.change-location.title') : $t('dash.add-location.title') }}
                </button>
              </Tooltip>
            </div>
            <div class="location-string" v-if="$store.getters.storificationLocation">
              {{$store.getters.storificationLocation.name}} <span  @click="(e) => $store.commit('removeStorificationLocation')" class="remove-location">x</span>
            </div>
            <div @keydown.prevent.enter="" class="auto-mentions row box" v-if=" openAutoLocations && searchLocation.length > 0">
                  <div class="connected-pages">
                    <div class="selected-page">
                      <div
                        class="page"
                        v-for="(item, index) in searchLocation"
                        :key="index"
                      >
                        <Tooltip
                          :text="item.bot.page.network"
                          position="top"
                        >
                          <input
                            type="radio"
                            :id="`bot-index-${index}`"
                            name="page"
                            :value="index"
                            v-model="selectedBotLocation" 
                            @click="changeMentionNetwork('Location', index)"   
                          >
                          <div class="page-wrapper">
                            <div class="page-content">
                              <div class="vertical-align">
                                <div class="page-img-wrapper">
                                  <img
                                    v-if="item.bot.page.network === 'facebook'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_fb.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'twitter'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_tw.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'linkedin'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_linkedin.png')"
                                  />
                                  <img
                                    v-else-if="item.bot.page.network === 'instagram'"
                                    size="25px"
                                    :src="require('../../../assets/img/icon_instagram.png')"
                                  />
                                  
                                </div>
                                <p class="page-name">{{ item.bot.page.network }}</p>
                              </div>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                    <vs-button
                      class="page-btn"
                      vs-type="filled"
                      color="#6a1f4c"
                      @click.prevent="(e) => {$store.commit('updateStorificationLocation',searchLocation[selectedBotLocation].selected); toggleShowMentions('Location')}"
                    >OK</vs-button>
                  </div>
                  <vs-input
                    color="#B20564"
                    type="text"
                    name="search-mention"
                    class="inputx"
                    :placeholder="$t(`dash.posts.overlay.search_location_placeholder`)"
                    v-model="searchLocation[selectedBotLocation].search"
                    v-on:keyup="searchMentions('Location')"
                    v-on:click="searchMentions('Location')"
                    ref="inputSearchMentionStory"
                    autocomplete="off"
                  />
                  <ul id="loadableContent-list-mentions">
                    <div v-for="(mention, index) in searchLocation[selectedBotLocation].results" :key="index">
                      <!-- <li @click="selectMention('Location', mention)" :class="{'select': mentionIsSelected('Location', mention) == true}" v-if="mention.location"> -->
                      <li @click="selectMention('Location', mention)" :class="{'select': mentionIsSelected('Location', mention) == true}">
                        <div :class="searchLocation[selectedBotLocation].bot.page.network">
                          <div class="content">    
                            <p class="locations">{{mention.name}}</p>
                            <p class="locations infos" v-if="mention.location">{{mention.location.street}}{{mention.location.street && ','}} {{mention.location.zip}} {{mention.location.city}}{{mention.location.city && ','}} {{mention.location.country}}</p>
                          </div>
                        </div>
                        <div class="checkmark" v-show="mentionIsSelected('Location', mention) == true">
                          <i class="material-icons">check</i>
                        </div>
                      </li>
                    </div>
                  </ul>
                  <vs-button class="cancel" v-if="isAddOrEditMentions('Location') == 'edit'" @click="removeMentions('Location')">
                    {{ $t('dash.button.cancel') }}
                  </vs-button>
              </div>
          </span>
          <GifSticker v-if="(typePost === 'story' && !storyShare) || (videoReel && atLeastInstagramSelected() && typePost === 'video' && state !== 'edit-posted')" :pageId="bots.find(e => bot.includes(e.id) && e.page && e.page.story_config) ? bots.find(e => bot.includes(e.id) && e.page && e.page.story_config).page.id : null" 
            :disabled="!form.video && typePost === 'video'" class="music-btn" @insertGif="insertGif" @reconnect="showConciergerieForm" :isConciergerie="onlyInstagramConciergerieSelected()">
          </GifSticker>
          <div  v-if="(typePost === 'story' && !storyShare) || (videoReel && atLeastInstagramConciergerieSelected())" class="layers-preview">
            <div class="layer-preview" v-for="gif in (videoReel && typePost === 'video' ? $store.getters.storificationGifsReel : $store.getters.storificationGifs)" :key="gif.id" >
              <span class="remove-layer" @click="removeGif(gif.id)">x</span>
              <img :src="gif.images.preview_gif.url" :alt="gif.name">
            </div>
          </div>

          <div class="music-btn" v-if="((typePost === 'story' && !storyShare) || (videoReel && atLeastInstagramSelected() && typePost === 'video') || (atLeastInstagramSelected() && typePost === 'image')) && state !== 'edit-posted'" @click="() => {!onlyInstagramConciergerieSelected() && showConciergerieForm()}">
          <!-- <div class="music-btn" v-if="(typePost === 'story' && !storyShare) || (videoReel && atLeastInstagramSelected() && typePost === 'video')" @click="() => {!onlyInstagramConciergerieSelected() && showConciergerieForm()}"> -->
            <Tooltip :active="(!form.video && typePost === 'video') || !onlyInstagramConciergerieSelected()" :text="onlyInstagramConciergerieSelected() ? $t('dash.post.error.need_video.title') : $t('dash.bots.status_proxy')">
              <vs-button :disabled="(!form.video && typePost === 'video') || !onlyInstagramConciergerieSelected()" class="note select-music" icon="music_note" @click="() => toggleShowMentions('Music', 0)">{{$t('dash.posts.form.story.music')}}</vs-button>
            </Tooltip>
            <br>
            <div class="info-music" v-if="selectedMusic && selectedMusic.track">
              <vs-icon icon="album"></vs-icon>
              <span>{{selectedMusic.track.title}}  ({{selectedMusic.track.display_artist}})</span>
              <Tooltip v-if="selectedMusic.config" text="valider la configuration">
                <vs-icon @click="videoReel && typePost === 'video' ? $store.commit('updateStorificationMusicReel', {config: false}) : $store.commit('updateStorificationMusic', {config: false})" class="remove-music" icon="done"></vs-icon>
                &nbsp;
              </Tooltip>
              <Tooltip v-else text="configurer la musique">
                <vs-icon @click="videoReel && typePost === 'video' ? $store.commit('updateStorificationMusicReel', {config: true}) : $store.commit('updateStorificationMusic', {config: true})" class="remove-music" icon="edit"></vs-icon>
                &nbsp;
              </Tooltip>
              <vs-icon class="remove-music" v-if="!selectedMusic.paused" @click="videoReel && typePost === 'video' ? $store.commit('updateStorificationMusicReel', {paused: true}) : $store.commit('updateStorificationMusic', {paused: true})" icon="stop_circle"></vs-icon>
              <vs-icon class="remove-music" v-else @click="videoReel && typePost === 'video' ? $store.commit('updateStorificationMusicReel', {paused: false}) : $store.commit('updateStorificationMusic', {paused: false})" icon="play_arrow"></vs-icon>
              <span class="remove-music" @click="removeMusic()">x</span>
              <audio v-if="typePost==='image' && !selectedMusic.paused" autoplay @loadedmetadata="(e) => e.target.currentTime = (selectedMusic.start/1000)" @canplaythrough="(e) => e.target.volume = '0.5'" :src="selectedMusic.track.fast_start_progressive_download_url"></audio>
            </div>
            <div @keydown.prevent.enter="" class="auto-mentions row box music-search" v-if="checkActiveMusicSearch && (openAutoMusics || openAutoMusics===0) && searchMusic.length > 0">
                  <div class="connected-pages">
                    <div class="selected-page">
                      <div
                        class="page"
                        v-for="(item, index) in searchMusic"
                        :key="index"
                      >
                        <Tooltip
                          :text="item.bot.page.network"
                          position="top"
                        >
                          <input
                            type="radio"
                            :id="`bot-index-${index}`"
                            name="page"
                            :value="index"
                            v-model="selectedBotMusic" 
                            @click="changeMentionNetwork('Music', index)"   
                          >
                          <div class="page-wrapper">
                            <div class="page-content">
                              <div class="vertical-align">
                                <div class="page-img-wrapper">
                                  <img
                                    size="25px"
                                    :src="require('../../../assets/img/icon_instagram.png')"
                                  />
                                  
                                </div>
                                <p class="page-name">{{ item.bot.page.network }}</p>
                              </div>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                    <vs-button
                      class="page-btn"
                      vs-type="filled"
                      color="#6a1f4c"
                      @click.prevent="selectMusic(searchMusic[selectedBotMusic].selected)"
                    >OK</vs-button>
                  </div>
                  <vs-input
                    color="#B20564"
                    type="text"
                    name="search-mention"
                    class="inputx"
                    :placeholder="$t(`dash.posts.overlay.search_music_placeholder`)"
                    v-model="searchMusic[selectedBotMusic].search"
                    v-on:keyup="searchMentions('Music')"
                    v-on:click="searchMentions('Music')"
                    ref="inputSearchMentionStory"
                    autocomplete="off"
                  />
                  <audio @canplaythrough="(e) => e.target.volume = '0.5'" :ref="`music-preview-mention`"></audio>
                  <ul id="loadableContent-list-mentions" :ref="'loadableContent-list-music'">
                    <div v-for="(mention, index) in searchMusic[selectedBotMusic].results" :key="index">
                      <!-- <p>TEST</p>   -->
                      <li @click="selectMention('Music', mention)" :class="{'select': mentionIsSelected('Music', mention) == true}" v-if="mention.track">
                        <div :class="`${searchMusic[selectedBotMusic].bot.page.network} music-container`">
                          <img :src="mention.track.cover_artwork_thumbnail_uri" alt="cover">
                          <vs-icon class="music-preview-mention" v-if="$refs[`music-preview-mention`] && !$refs[`music-preview-mention`].paused && $refs[`music-preview-mention`].src === mention.track.progressive_download_url" @click="(e) => mentionMusicPreview(e, mention, 'pause')" icon="pause"></vs-icon>
                          <vs-icon class="music-preview-mention" v-else @click="(e) => mentionMusicPreview(e, mention, 'play')" icon="play_arrow"></vs-icon>
                          <div class="content">
                            
                            <p class="musics">{{mention.track.title}}</p>
                            <p class="musics infos">{{mention.track.display_artist}}</p>
                            <!-- <p class="name">{{ `#${mention.location}` }}</p> -->
                            <!-- <p class="count">{{ `${mention.count} Tweet${mention.count > 1 ? 's': ''}` }}</p> -->
                          </div>
                        </div>
                        <div class="checkmark" v-show="mentionIsSelected('Music', mention) == true">
                          <i class="material-icons">check</i>
                        </div>
                      </li>
                    </div>
                  </ul>
                  <vs-button class="cancel" v-if="isAddOrEditMentions('Music', 0) == 'edit'" @click="removeMentions('Music', 0)">
                    {{ $t('dash.button.cancel') }}
                  </vs-button>
              </div>
          </div>

          <div class="layer-background" v-if="typePost === 'story' && !storyShare && !storyVideo && ((url || form.url))">
            {{$t('dash.posts.background.colors.label')}}
            <input :value="$store.getters.storificationBackgroundColor" @change="(e) => $store.commit(`updateStorificationBackgroundColor`, e.target.value)" type="color"/>
            <button type="button" class="btn-add" @click="(e) => $store.commit(`updateStorificationBackgroundColor`, null)">
              Reset
            </button>
          </div>

          <ShopSticker v-if="(typePost === 'story')" :pageId="bots.find(e => bot.includes(e.id) && e.page && e.page.story_config && e.page.network === 'instagram') ? bots.find(e => bot.includes(e.id) && e.page && e.page.story_config && e.page.network === 'instagram').page.id : null" :isConciergerie="onlyInstagramConciergerieSelected()"
            class="music-btn" :products="$store.getters.storificationProduct ? $store.getters.storificationProduct.items : []" @reconnect="showConciergerieForm" @insertShop="(shop) => $store.commit('updateStorificationProduct', {items: JSON.parse(JSON.stringify(shop))})">
          </ShopSticker>
          <div  v-if="(typePost === 'story' && $store.getters.storificationProduct)" class="layers-preview">
            <div class="layer-preview" v-for="product in $store.getters.storificationProduct.items" :key="product.id" >
              <span class="remove-layer" @click="removeProduct(product.id)">x</span>
              <img :src="product.image" :alt="product.text">
              <p>{{product.text}}</p>
            </div>
          </div>

          <div v-if="typePost === 'story'" class="poll-story">
            <!-- <vs-checkbox class="poll-story-check" :checked="pollStory" @change="pollStory ? pollStory=null : pollStory={question: '', options: [], x: 170, y: 200} ">{{$t('dash.posts.poll')}}</vs-checkbox> -->
            <div class="disable-story-btn"  @click.stop="() => {!onlyInstagramConciergerieSelected() && showConciergerieForm()}">
              <Tooltip :active="!onlyInstagramConciergerieSelected()" :text="$t('dash.bots.status_proxy')">
                <vs-checkbox :disabled="!onlyInstagramConciergerieSelected()" class="poll-story-check" :checked="$store.getters.storificationPoll" @change="$store.getters.storificationPoll ? $store.commit('updateStorificationPoll', null) : $store.commit('updateStorificationPoll', {question: '', options: []})">{{$t('dash.posts.poll')}}</vs-checkbox>
              </Tooltip>
            </div>
            <div class="poll-story-inputs" v-if="$store.getters.storificationPoll">
              <vs-input maxlength="50" class="poll-story-question" :label="$t('dash.post.poll.question.label')" placeholder="Question ?" :value="$store.getters.storificationPoll.question" @input="(e) => $store.commit('updateStorificationPoll', {question:  e})"/>
              <div class="poll-story-options">
                <vs-input maxlength="40" class="poll-story-option" :label="$t('dash.post.poll.option.label') + ' 1'" :value="$store.getters.storificationPoll.options[0] || ''" placeholder="Oui" @input="(e) => $store.commit('updateStorificationPollOption', {index: 0, option: e})"/>
                <vs-input maxlength="40" class="poll-story-option" :label="$t('dash.post.poll.option.label') + ' 2'" :value="$store.getters.storificationPoll.options[1] || ''" placeholder="Non" @input="(e) => $store.commit('updateStorificationPollOption', {index: 1, option: e})"/>
                <vs-input maxlength="40" class="poll-story-option" :label="$t('dash.post.poll.option.label') + ' 3'" :value="$store.getters.storificationPoll.options[2] || ''" placeholder="Optional" @input="(e) => $store.commit('updateStorificationPollOption', {index: 2, option: e})"/>
                <vs-input maxlength="40" class="poll-story-option" :label="$t('dash.post.poll.option.label') + ' 4'" :value="$store.getters.storificationPoll.options[3] || ''" placeholder="Optional" @input="(e) => $store.commit('updateStorificationPollOption', {index: 3, option: e})"/>
              </div>
            </div>
          </div>
          <div v-if="typePost === 'story'" class="poll-story">
            <!-- <vs-checkbox class="poll-story-check" :checked="sliderStory" @change="sliderStory ? sliderStory=null : sliderStory={question: '', emoji: '😍', color: '#ffffff', x: 170, y: 200} ">{{$t('dash.posts.slider')}}</vs-checkbox> -->
            <div class="disable-story-btn"  @click.stop="() => {!onlyInstagramConciergerieSelected() && showConciergerieForm()}">
              <Tooltip :active="!onlyInstagramConciergerieSelected()" :text="$t('dash.bots.status_proxy')">
                <vs-checkbox :disabled="!onlyInstagramConciergerieSelected()" class="poll-story-check" :checked="$store.getters.storificationSlider" @change="$store.getters.storificationSlider ? $store.commit('updateStorificationSlider', null) : $store.commit('updateStorificationSlider', {question: '', emoji: '😍', color: 0})">{{$t('dash.posts.slider')}}</vs-checkbox>
              </Tooltip>
            </div>
            <div class="slider-story-params" v-if="$store.getters.storificationSlider">
              <vs-input maxlength="45" class="poll-story-question" :label="$t('dash.post.poll.question.label')" placeholder="(Optionnel)" :value="$store.getters.storificationSlider.question" @input="(e) => $store.commit('updateStorificationSlider', {question:  e})"/>
              <div class="textarea-emoji-picker" v-click-outside="() => sliderEmojiPicker = false">
                <span @click="() => sliderEmojiPicker = !sliderEmojiPicker" class="emoji">{{$store.getters.storificationSlider.emoji}}</span>
                <picker
                  class="emoji-picker-slider"
                    :data="emojiIndex"
                    v-show="sliderEmojiPicker"
                    title="Pick your emoji..."
                    emoji="point_up"
                    @select="(e) => $store.commit('updateStorificationSlider', {emoji: e.native})"
                  />
              </div>
            </div>
          </div>

          <div v-if="typePost === 'story'" class="poll-story">
            <div class="disable-story-btn"  @click.stop="() => {!onlyInstagramConciergerieSelected() && showConciergerieForm()}">
              <Tooltip :active="!onlyInstagramConciergerieSelected()" :text="$t('dash.bots.status_proxy')">
                <vs-checkbox :disabled="!onlyInstagramConciergerieSelected()" class="poll-story-check" :checked="$store.getters.storificationQuestion" @change="$store.getters.storificationQuestion ? $store.commit('updateStorificationQuestion', null) : $store.commit('updateStorificationQuestion', {text: '', avatar: '', color: 0})">{{$t('dash.detail.history.difference.pollStory.question')}}</vs-checkbox>
              </Tooltip>
            </div>
            <div class="slider-story-params" v-if="$store.getters.storificationQuestion">
              <vs-input maxlength="45" class="poll-story-question" :label="$t('dash.post.poll.question.label')" placeholder="Posez-moi une question" :value="$store.getters.storificationQuestion.text" @input="(e) => $store.commit('updateStorificationQuestion', {text:  e})"/>
            </div>
          </div>

          <div v-if="typePost === 'story'" class="mentions-story">
              <div class="disable-story-btn"  @click.stop="() => {!onlyInstagramConciergerieSelected() && showConciergerieForm()}">
                <Tooltip :active="!onlyInstagramConciergerieSelected()" :text="$t('dash.bots.status_proxy')">
                  <button :disabled="!onlyInstagramConciergerieSelected()" type="button" class="btn-add" @click="() => openMentionWidget()">{{$t('dash.bots.mention_name_placeholder')}}</button>
                </Tooltip>
              </div>
              <p v-if="$store.getters.storificationMentions && $store.getters.storificationMentions.length">Mentions :
                <span class="location-string" :key="mention.pk" v-for="(mention, idx) in $store.getters.storificationMentions">
                  <!-- <span @click="hideMentionWidget(mention.pk, false)" v-if="mention.hide" class="hidder material-icons">visibility</span> -->
                  <span @click="$store.commit('updateStorificationMention', {index: idx, hide: false})" v-if="mention.hide" class="hidder material-icons">visibility</span>
                  <!-- <span @click="hideMentionWidget(mention.pk, true)" v-else class="hidder material-icons">visibility_off</span> -->
                  <span @click="$store.commit('updateStorificationMention', {index: idx, hide: true})" v-else class="hidder material-icons">visibility_off</span>
                  {{mention.id}} 
                  <!-- <span @click="removeMentionWidget(mention.pk)" class="remove-location">x</span> -->
                  <span @click="$store.commit('removeStorificationMention', idx)" class="remove-location">x</span>
                </span>
              </p>
               <dialog ref="searchMentionWidget" class="searchTag">
                <div @keydown.prevent.enter="" class="auto-mentions">
                  <button type="button" @click="addMentionWidget()">OK</button>
                  <input v-if="searchMention[selectedBotMention]" :placeholder="$t(`dash.posts.overlay.search_mention_placeholder_instagram_direct`)"
                    @keyup="searchMentions('Mention')"
                    v-model="searchMention[selectedBotMention].search"
                    ref="inputSearchMentionTag"
                  />
                  <ul id="loadableContent-list-mentions" v-if="searchMention[selectedBotMention] && searchMention[selectedBotMention].results && searchMention[selectedBotMention].results.length">
                      <div v-for="(mention, index) in searchMention[selectedBotMention].results.filter(e => !userTags.list.map(ee => ee.id).includes(e.pk))" :key="index">  
                        <li @click="selectMention('Mention', mention)" :class="{'select': mentionIsSelected('Mention', mention) == true}" v-if="mentionIsSelected('Mention', mention)">
                          <div :class="searchMention[selectedBotMention].bot.page.network">
                            <img :alt="mention.name" class="image" :src="mention.image" v-if="mention.image"/>
                            <div class="content">
                              <p class="name">{{ mention.name }}</p>
                              <p class="screen_name id">@{{ mention.id }}</p>
                              <p class="screen_name" v-if="mention.subtitle">{{ mention.subtitle }}</p>
                            </div>
                          </div>
                          <div class="checkmark" v-show="mentionIsSelected('Mention', mention) == true">
                            <i class="material-icons">check</i>
                          </div>
                        </li>
                      </div>
                    </ul>
                    <ul id="loadableContent-list-mentions" v-else-if="searchMention[selectedBotMention] && searchMention[selectedBotMention].results">
                      <li>
                        <p>Aucun resultat</p>
                      </li>
                    </ul>
                    <ul id="loadableContent-list-mentions" class="empty" v-else></ul>
                </div>
              </dialog>
          </div>

          <div v-if="typePost === 'story'" class="mentions-story">
              <div class="disable-story-btn"  @click.stop="() => {!onlyInstagramConciergerieSelected() && showConciergerieForm()}">
                <Tooltip :active="!onlyInstagramConciergerieSelected()" :text="$t('dash.bots.status_proxy')">
                  <button :disabled="!onlyInstagramConciergerieSelected()" type="button" class="btn-add" @click="() => openHashtagWidget()">{{$t('dash.bots.hashtags_name_placeholder')}}</button>
                </Tooltip>
              </div>
              <p v-if="$store.getters.storificationHashtags && $store.getters.storificationHashtags.length">Hashtags :
                <span class="location-string" :key="mention.pk" v-for="(mention, idx) in $store.getters.storificationHashtags">
                  <!-- <span @click="hideMentionWidget(mention.pk, false)" v-if="mention.hide" class="hidder material-icons">visibility</span> -->
                  <span @click="$store.commit('updateStorificationHashtag', {index: idx, hide: false})" v-if="mention.hide" class="hidder material-icons">visibility</span>
                  <!-- <span @click="hideMentionWidget(mention.pk, true)" v-else class="hidder material-icons">visibility_off</span> -->
                  <span @click="$store.commit('updateStorificationHashtag', {index: idx, hide: true})" v-else class="hidder material-icons">visibility_off</span>
                  #{{mention.hashtag}} 
                  <!-- <span @click="removeMentionWidget(mention.pk)" class="remove-location">x</span> -->
                  <span @click="$store.commit('removeStorificationHashtag', idx)" class="remove-location">x</span>
                </span>
              </p>
               <dialog ref="searchHashtagWidget" class="searchTag">
                <div @keydown.prevent.enter="" class="auto-mentions">
                  <button type="button" @click="addHashtagWidget()">OK</button>
                  <input v-if="searchHashtag[selectedBotHashtag]" :placeholder="$t(`dash.posts.overlay.search_hashtag_placeholder`)"
                    @keyup="searchMentions('Hashtag')"
                    v-model="searchHashtag[selectedBotHashtag].search"
                    ref="inputSearchMentionTag"
                  />
                  <ul id="loadableContent-list-mentions" v-if="searchHashtag[selectedBotHashtag] && searchHashtag[selectedBotHashtag].results && searchHashtag[selectedBotHashtag].results.length">
                      <div v-for="(mention, index) in searchHashtag[selectedBotHashtag].results" :key="index">  
                        <li @click="selectMention('Hashtag', mention)" :class="{'select': mentionIsSelected('Hashtag', mention) == true}">
                          <div :class="searchHashtag[selectedBotHashtag].bot.page.network">
                            <!-- <img :alt="mention.name" class="image" :src="mention.image" v-if="mention.image"/> -->
                             <div class="content">    
                              <p class="name">{{ `#${mention.hashtag}` }}</p>
                              <p class="count">{{ `${mention.count} ${ 'Post' }${mention.count > 1 ? 's': ''}` }}</p>
                            </div>
                          </div>
                          <div class="checkmark" v-show="mentionIsSelected('Hashtag', mention) == true">
                            <i class="material-icons">check</i>
                          </div>
                        </li>
                      </div>
                    </ul>
                    <ul id="loadableContent-list-mentions" v-else-if="searchHashtag[selectedBotHashtag] && searchHashtag[selectedBotHashtag].results">
                      <li>
                        <p>Aucun resultat</p>
                      </li>
                    </ul>
                    <ul id="loadableContent-list-mentions" class="empty" v-else></ul>
                </div>
              </dialog>
          </div>

          <span v-if="typePost == 'image' && carouselPossible() && multipleImages.length > 1">
            <draggable v-model="multipleImages" :move="moveCarousel" :options="{handle: '.drag-only-this', filter: '.no-drag', disabled: (state === 'edit-posted')}">
              <div :class="`input-wrapper`" v-for="obj in multipleImages" :key="obj.id" :id="obj.id">
                <div class="custom-file-input">
                  <div class="file-input">
                    <div :class="`file-name ${obj.file ? 'drag-only-this' : 'no-drag'}`">
                      <div class="vertical carousel-files">
                        <p v-if="obj.filename">{{obj.filename}}</p>
                        <div v-if="url" class="del-img-wrapper">
                          <img class="carousel-thumb" v-if="obj.url" :src="obj.url">
                          <div @click="removeMultipleImages(obj.id)" v-if="obj.url && state !== 'edit-posted'" class="delete-img-thumb">𝗫</div>
                        </div>
                        <img v-if="obj.file && state !== 'edit-posted'" class="drag-icon-carousel" src="../../../assets/img/drag-list2.svg" alt="">
                      </div>
                    </div>
                  </div>
                </div>
                <i v-show="errors.has('posts.file')" class="fa fa-warning"></i>
                <span
                  v-show="errors.has('posts.file')"
                  class="help is-danger"
                >{{ errors.first('posts.file') }}</span>
              </div>
            </draggable>
          </span>

          <span v-if="multipleMedias.length > 1">
            <draggable v-model="multipleMedias" :options="{handle: '.drag-only-this', filter: '.no-drag', disabled: (state === 'edit-posted')}">
              <div :class="`input-wrapper`" v-for="obj in multipleMedias" :key="obj.id" :id="obj.id">
                <div class="custom-file-input">
                  <div class="file-input">
                    <div :class="`file-name ${obj.file ? 'drag-only-this' : 'no-drag'}`">
                      <div class="vertical carousel-files">
                        <p v-if="obj.url">{{obj.name}}</p>
                        <div v-if="obj.url" class="del-img-wrapper">
                          <img v-if="obj.type.includes('image')" class="carousel-thumb" :src="obj.url">
                          <video v-else-if="obj.type.includes('video')" width="37" height="70" class="video-thumb" :src="obj.url"></video>
                          <div @click="removeMultipleMedias(obj.id)" v-if="obj.url && state !== 'edit-posted'" class="delete-img-thumb">𝗫</div>
                        </div>
                        <img v-if="obj.url && state !== 'edit-posted'" class="drag-icon-carousel" src="../../../assets/img/drag-list2.svg" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </draggable>
          </span>

          <div class="layer-background" v-if="typePost === 'story' && !storyVideo && !storyShare">
            <vs-select @change="(e) => $store.commit('updateStorificationTemplate',e)" v-model="templateManual">
              <vs-select-item :text="$t('dash.post.story.select-template.no_template')" :value="null"/>
              <vs-select-item v-if="getPageInfoByBot(bot[0]).name === 'nextplzofficiel'" text="Template NextPlz" value="template_nextplz"/>
              <vs-select-item v-else text="Template 1" value="template1"/>
              <vs-select-item text="Template 2" value="template2"/>
              <vs-select-item v-if="hasStoryTemplate" :text="$t('dash.post.story.select-template.custom_template')" value="custom"/>
            </vs-select>
          </div>

          <div class="input-wrapper" v-if="typePost === 'story'&& !storyVideo">
            <div class="disable-story-btn"  @click.stop="() => {!onlyInstagramConciergerieSelected() && showConciergerieForm()}">
                <Tooltip :active="!onlyInstagramConciergerieSelected()" :text="$t('dash.bots.status_proxy')">
                  <vs-input :disabled="!onlyInstagramConciergerieSelected()" size="large" class="shared-story-url" v-model="sharedStoryUrl" :label="$t('dash.post.shared_story')" placeholder="ex: https://www.instagram.com/p/CkZKETvycAf/" />
                </Tooltip>
            </div>
          </div>
          

          <span class="ratio-carousel" v-if="typePost == 'image' && carouselPossible() && atLeastInstagramSelected() && multipleImages.length > 1 && state !== 'edit-posted'">
            Ratio: 
            <input @change="changeCarrouselRatio" type="radio" name="ratio" id="original" :value="0" v-model="carrouselRatio" /> Original
            <input @change="changeCarrouselRatio" type="radio" name="ratio" id="landscape" :value="1.91/1" v-model="carrouselRatio" /> 16:9
            <input checked @change="changeCarrouselRatio" type="radio" name="ratio" id="square" :value="1" v-model="carrouselRatio" /> 1:1
            <input @change="changeCarrouselRatio" type="radio" name="ratio" id="vertical" :value="4/5" v-model="carrouselRatio" /> 4:5
          </span>

          <!-- <div class="tag-buttons" v-if="['image', 'video'].includes(typePost) && ((atLeastInstagramConciergerieSelected() && multipleMedias.length <= 1 && !atLeastFacebookSelected()) || (atLeastFacebookSelected() && videoReelFB && typePost === 'video' && !atLeastInstagramSelected()))"> -->
          <div class="tag-buttons" v-if="['image', 'video'].includes(typePost) && ((atLeastInstagramConciergerieSelected() && multipleMedias.length <= 1) || (atLeastFacebookSelected() && videoReelFB && typePost === 'video' && !atLeastInstagramSelected()))">
            <Tooltip v-if="atLeastInstagramConciergerieSelected()" :active="(typePost === 'image' && !url && !form.url) || (typePost === 'video' && !form.video)" :text="typePost === 'video' ? $t('dash.post.error.need_video.title') : $t('dash.post.error.need_image.title')" position="top">
              &nbsp;
              <button type="button" class="btn-add" :disabled="(typePost === 'image' && !url && !form.url) || (typePost === 'video' && !form.video)" @click="() => openTag()">{{$t('dash.posts.form.add_tag')}}</button>
            </Tooltip>
            <Tooltip :active="(typePost === 'image' && !url && !form.url) || (typePost === 'video' && !form.video) || (userTags && userTags.collab && userTags.collab.length >= 5)" :text=" (userTags && userTags.collab && userTags.collab.length >= 5) ? $t('dash.post.collab.limit') : (typePost === 'video' ? $t('dash.post.error.need_video.title') : $t('dash.post.error.need_image.title'))" position="top">
            &nbsp;
              <button type="button" class="btn-add" :disabled="(typePost === 'image' && !url && !form.url) || (typePost === 'video' && !form.video)  || (userTags && userTags.collab && userTags.collab.length >= 5)" @click="() => openTag(true)">{{$t('dash.posts.form.add_colab')}}</button>
            </Tooltip>
            
            <p v-if="userTags.list.filter(e => !userTags.collab.includes(e.id)).length">Tags :
              <span class="location-string" :key="tag.id" v-for="tag of userTags.list.filter(e => e.id !== userTags.collab && !userTags.collab.includes(e.id))">
                    {{tag.username}} <span  @click="removeTag(tag.id)" class="remove-location">x</span>
              </span>
            </p>
            
            <p v-if="userTags.collab && userTags.collab.length">Collab :
              <span v-for="collab of userTags.list.filter(e => userTags.collab.includes(e.id))" :key="collab.id" class="location-string">
                    {{collab.username}} <span  @click="removeTag(collab.id)" class="remove-location">x</span>
              </span>
            </p>

            <Tooltip v-if="atLeastInstagramConciergerieSelected()" :active="(typePost === 'image' && !url && !form.url) || (typePost === 'video' && !form.video)" :text="typePost === 'video' ? $t('dash.post.error.need_video.title') : $t('dash.post.error.need_image.title')" position="top">
            &nbsp;
              <ShopSticker :pageId="bots.find(e => bot.includes(e.id) && e.page && e.page.story_config && e.page.network === 'instagram') ? bots.find(e => bot.includes(e.id) && e.page && e.page.story_config && e.page.network === 'instagram').page.id : null" :isConciergerie="atLeastInstagramConciergerieSelected()"
                class="btn-add product" ref="shop-tag" :disabled="(typePost === 'image' && !url && !form.url) || (typePost === 'video' && !form.video)" :tagUse="typePost === 'image' ? 'image' : 'video'" @click="() => openTag(false, true)" :products="productTags" @reconnect="showConciergerieForm" @insertShop="(shop) => typePost === 'image' ? addTagProduct(shop) : $store.commit('updateStorificationProduct', {items: shop})">
              </ShopSticker>
              <!-- <button type="button" class="btn-add" :disabled="(typePost === 'image' && !url && !form.url) || (typePost === 'video' && !form.video)" @click="() => openTag()">{{$t('dash.post.btn.add_shop')}}</button> -->
            </Tooltip>

             <div v-if="atLeastInstagramConciergerieSelected() && productTags" class="layers-preview">
              <div class="layer-preview" v-for="product in productTags" :key="product.id" >
                <span class="remove-layer" @click="removeTagProduct(product.id)">x</span>
                <img :src="product.image" :alt="product.text">
                <p>{{product.text}}</p>
              </div>
            </div>

            <dialog ref="tagImage" class="tag-img-container" @click="cheekDialogOutsideClose">
              <h4>{{$t('dash.posts.text.tag_img')}} <span @click="closeTagImage">&#x2715;</span></h4>
              <img v-if="!multipleImages || multipleImages.length < 2" :class="(userTags && userTags.collab && userTags.collab.length >= 5) && 'disabled'" @click="tagImageLocation" :src="url || (meta && meta.og && meta.og.image)"/>
              <carousel v-else
                :perPage="1" 
                :scrollPerPage="true" 
                :paginationEnabled="true" 
                :adjustableHeight="true" 
                :centerMode="true"
                :class="(userTags && userTags.collab && userTags.collab.length >= 5) && 'disabled'"
                v-model="userTagPage"
              >
                <slide v-for="(media, index) in multipleImages.filter(e => e.file)" :key="media.id" :data-index="index" @slideClick="tagImageLocation">
                  <div>
                    <img :id="`tagImg${index}`" @mousemove="e => {e.target.setAttribute('data-offsetX', e.offsetX); e.target.setAttribute('data-offsetY', e.offsetY);}" :class="(userTags && userTags.collab && userTags.collab.length >= 5) && 'disabled'" :style="`aspect-ratio: ${media.ratio === 0 ? firstImageAspectRatio : media.ratio} ;width: 494px; object-fit: 'cover';`" class="carrousel-image" :src="media.url" />
                  </div>
                </slide>
              </carousel>
              <p v-if="(userTags && userTags.collab && userTags.collab.length >= 5)" id="tooltip-collab">{{$t('dash.post.collab.limit')}}</p>
              <span :style="{display: ((!multipleImages || multipleImages.length < 2) || tag.index === userTagPage) ? 'inline':'none', top: `${tag.y*100}%`, left: `${tag.x*100}%`, fontWeight: `${userTags.collab.includes(tag.id) ? 'bold' : 'normal'}`}" 
              class="tag-label" v-for="tag of userTags.list" :key="tag.id">
                {{tag.username}} 
                <span @click="removeTag(tag.id)" class="remove-tag">&#x2715;</span>
              </span>
              <span :style="{display: ((!multipleImages || multipleImages.length < 2) || tag.index === userTagPage) ? 'flex':'none', top: `${tag.y*100}%`, left: `${tag.x*100}%`}" 
              class="tag-label shop-label" v-for="tag of productTags" :key="tag.id">
                <img :src="tag.image"/>
                <span>{{tag.text && tag.text.slice(0, 10) + "..."}}</span>
                <span @click="removeTagProduct(tag.id)" class="remove-tag">&#x2715;</span>
              </span>
              <dialog ref="searchTagImg" class="searchTag">
                <div @keydown.prevent.enter="" class="auto-mentions" v-if="dialogImageTagIsOpen">
                  <button type="button" @click="addTag('searchTagImg')">OK</button>
                  <input v-if="searchMention[selectedBotMention]" :placeholder="$t(`dash.posts.overlay.search_mention_placeholder_instagram_direct`)"
                    @keyup="searchMentions('Mention')"
                    v-model="searchMention[selectedBotMention].search"
                    ref="inputSearchMentionTagImage"
                  />
                  <ul id="loadableContent-list-mentions" v-if="searchMention[selectedBotMention] && searchMention[selectedBotMention].results && searchMention[selectedBotMention].results.length">
                      <div v-for="(mention, index) in searchMention[selectedBotMention].results.filter(e => !userTags.list.map(ee => ee.id).includes(e.pk))" :key="index">  
                        <li @click="selectMention('Mention', mention)" :class="{'select': mentionIsSelected('Mention', mention) == true}" v-if="mentionIsSelected('Mention', mention)">
                          <div :class="searchMention[selectedBotMention].bot.page.network">
                            <img :alt="mention.name" class="image" :src="mention.image" v-if="mention.image"/>
                            <div class="content">
                              <p class="name">{{ mention.name }}</p>
                              <p class="name">{{ mention.id }}</p>
                            </div>
                          </div>
                          <div class="checkmark" v-show="mentionIsSelected('Mention', mention) == true">
                            <i class="material-icons">check</i>
                          </div>
                        </li>
                      </div>
                    </ul>
                    <ul id="loadableContent-list-mentions" v-else-if="searchMention[selectedBotMention] && searchMention[selectedBotMention].results">
                      <li>
                        <p>Aucun resultat</p>
                      </li>
                    </ul>
                    <ul id="loadableContent-list-mentions" class="empty" v-else></ul>
                </div>
              </dialog>
            </dialog>
            <dialog ref="searchTag" class="searchTag">
              <div @keydown.prevent.enter="" class="auto-mentions">
                <button type="button" @click="addTag('searchTag')">OK</button>
                <input v-if="searchMention[selectedBotMention]" :placeholder="$t(`dash.posts.overlay.search_mention_placeholder_instagram_direct`)"
                  @keyup="searchMentions('Mention')"
                  v-model="searchMention[selectedBotMention].search"
                  ref="inputSearchMentionTag"
                />
                <ul id="loadableContent-list-mentions" v-if="searchMention[selectedBotMention] && searchMention[selectedBotMention].results && searchMention[selectedBotMention].results.length">
                    <div v-for="(mention, index) in searchMention[selectedBotMention].results.filter(e => !userTags.list.map(ee => ee.id).includes(e.pk))" :key="index">  
                      <li @click="selectMention('Mention', mention)" :class="{'select': mentionIsSelected('Mention', mention) == true}" v-if="mentionIsSelected('Mention', mention)">
                        <div :class="searchMention[selectedBotMention].bot.page.network">
                          <img :alt="mention.name" class="image" :src="mention.image" v-if="mention.image"/>
                          <div class="content">
                            <p class="name">{{ mention.name }}</p>
                            <p class="screen_name id">@{{ mention.id }}</p>
                            <p class="screen_name" v-if="mention.subtitle">{{ mention.subtitle }}</p>
                          </div>
                        </div>
                        <div class="checkmark" v-show="mentionIsSelected('Mention', mention) == true">
                          <i class="material-icons">check</i>
                        </div>
                      </li>
                    </div>
                  </ul>
                  <ul id="loadableContent-list-mentions" v-else-if="searchMention[selectedBotMention] && searchMention[selectedBotMention].results">
                    <li>
                      <p>Aucun resultat</p>
                    </li>
                  </ul>
                  <ul id="loadableContent-list-mentions" class="empty" v-else></ul>
              </div>
            </dialog>
          </div>

          <div v-if="checkActiveLocationSearch" class="location">
            <div class="container-location">{{$t("dash.posts.location")}} 
              <template v-if="searchLocationInput">
                <div class="location-string" v-if="searchLocationInput && searchLocationInput.facebook && atLeastNetworkSelected('facebook')">
                  {{searchLocationInput.facebook}} <span  @click="removeLocation('facebook')" class="remove-location">x</span>
                  <img
                    size="25px"
                    :src="require('../../../assets/img/icon_fb.png')"
                  />
                </div>
                <div class="location-string" v-if="searchLocationInput && searchLocationInput.instagram && atLeastNetworkSelected('instagram')">
                  {{searchLocationInput.instagram}} <span  @click="removeLocation('instagram')" class="remove-location">x</span>
                  <img
                    size="25px"
                    :src="require('../../../assets/img/icon_instagram.png')"
                  />
                </div>
              </template>
              <span v-else>
                {{$t("dash.bot.sources.none")}}
              </span>
            </div>
          </div>

          <vs-popup :active.sync="carouselPopupMessage" title="Voulez vous continuer ?">
            <p class="popup-content">
              {{carouselPopupMessage}}
            </p>
            <div :style="{display: 'flex', justifyContent: 'center', marginTop: '40px'}">
              <vs-button :style="{marginRight: '30px'}" @click="carouselPopupMessage = null">Annuler</vs-button>
              <vs-button @click="validate('posts')">Continuer</vs-button>
            </div>
          </vs-popup>

          
          <div class="options-wrapper" v-if="getBoardPagePinterest">
            <div class="options-wrapper-tilte">
              <vs-avatar
                color="transparent"
                size="18px"
                :src="require('../../../assets/img/ico-pinterest-circle.png')"
              />
              Pinterest
            </div>
            <div style="display: flex;">

              <select v-model="form.boardSelected" style="margin-top:15px; min-width: 175px;" v-if="boards && boards.board && boards.board.items" @change="checkChildsBoard()">
                <option  v-for="(item,index) in boards.board.items" :value="item" :key="index">
                  {{ item.name }}
                </option>
              </select>

              <select 
                  style="margin-top:15px; min-width: 175px;" 
                  v-if="form.boardSelected && form.boardSelected.childs && form.boardSelected.childs.board && form.boardSelected.childs.board.items.length"
                  v-model="form.boardSelected.childs.selected">
                <option :value="null">{{$t('dash.post.board.choice')}}</option>
                <option  v-for="(item,index) in form.boardSelected.childs.board.items" :value="item" :key="index">
                  {{ item.name }}
                </option>
              </select>
              

              <div style="display: flex; margin-left: 10px;">
                <vs-input label="Créer un nouveau tableau" placeholder="" v-model="newBoardName"/> 
                <vs-button
                        style=" padding: 0px; height: 30px !important; width: 70px; padding-left: 10px;padding-right: 10px; margin-left: 5px;margin-top: 15px;"
                        class="page-btn"
                        vs-type="filled"
                        color="#6a1f4c"
                        @click.prevent="newBoardofPinterest()"
                      >créer</vs-button>
              </div>
            </div>
          </div>
        </div>
        <vs-collapse v-if="bot.length>0" :key="keyRefresh" :class="[{'screenshot': hideToScreenshot}]">
          <vs-collapse-item v-for="(item, index) in reverseBot" :key="index" :class="getPageInfoByBot(item) ? getPageInfoByBot(item).network : ''" :open="true" class="open-item">
            <div slot="header" v-if="getPageInfoByBot(item)">
              <page-image-avatar :page="getPageInfoByBot(item)"/>
              {{ getPageInfoByBot(item).name }}
            </div>
            <div class="preview" :id="`preview-post-${item}`" :ref="`preview-post-${item}`">
              <!-- <story-maker v-if="typePost === 'story' || (videoReel && videos && videos.instagram_reel && getPageInfoByBot(item).network === 'instagram' && isConciergerie(getPageInfoByBot(item)))" :screenWidth="324" :screenHeight="576" :injectedText="index === 0 ? instagramTextsUpdater : instagramTexts"  :injectedBackground="instagramBackgroundColor" :enableHighlight="reverseBot.length === 1" @updateLinkPosition="(pos) => instagramLinkPosition = {...instagramLinkPosition, ...pos}" @updatePollPosition="pos => pollStory = {...pollStory, ...pos}"
              :injectedImage="videoReel ? null : (!!storyShare || (state === 'edit-draft') ? form.enclosure : url) || (typeof form.enclosure === 'string' ? form.enclosure : null)" :injectedLink="isPremiumInstagramAccount && !videoReel ? form.url || null : null" :autoImage="false" @changeText="updateTextWithStory" @newBackground="(v) => instagramBackgroundColor = v" :validMentions="validMentions" :validHashtags="validHashtags" :posiLink="instagramLinkPosition"
                @cancelStory="cancelStory" :mentions="JSON.parse(localStorage.bots).find(b => b.id == item)" @sendHighlight="(h) => highlightInstagram = h"
                :confirmDeleteExt="deleteStory" @cropImage="cropImage" :onlyViewMode="index!==0" :pageInfo="getPageInfoByBot(item)" :acceptPrefix="activePrefixSuffix" :acceptReplaceHashtag="activeHashtagsAutoAdd" :autoCrop="isNewImage" :template="templateManual" :templateConfig="templateManual === 'custom' ? bots.find(e => e.id === item).storyTemplate : null" 
                ref="storymaker" :manualLayers="layers" :linkText="storyLinkText" :draft="state === 'edit-draft'" :poll="pollStory" @changeLinkColor="changeLinkColorStory"
                :video="videoReel ? videos.instagram_reel : form.video" :isVideo="storyVideo || videoReel" :isShare="storyShare" :isVisualShare="storySharedVisual" @toggleVisual="sharedStoryToggleVisual" 
                :music="selectedMusic" @setMusicDuration="setMusicDuration" @setMusicStartTime="setMusicStartTime"
                :gifs="selectedGifs" 
                @removeLink="() => form.url = null" @removePoll="() => pollStory=null" @removeSlider="() => sliderStory=null" @removeGif="(id) => removeGif(id)" @removeMention="(id) => removeMentionWidget(id)" @removeLayer="(idx) => removeLayer(idx)"
                :isReel="videoReel" :reelText="form.title"
                :userTagsReel="userTags && userTags.list && userTags.list.length > 0 ? userTags : null" 
                :activeMentionsAutoReplace="activeMentionsAutoReplace" 
                :activeHashtagsAutoAdd="activeHashtagsAutoAdd"
                :post="{...form, title: formTitleCopy, video: videos[videoType(item)] || form.video || null}" 
                :activePrefixSuffix="activePrefixSuffix" :editPostValue="editPostValue" v-on:editPostLive="editPostLive" v-on:currentPostLive="currentPostLive"
                v-on:addMention="addMention"
                @updateGifs="gifs => selectedGifs=gifs" 
                @updateWidgetMention="mentionsWidget => storyMentions=mentionsWidget" 
                @updateLayers="layersNew => layers=layersNew" 
                @updateSliderPosition="pos => sliderStory = {...sliderStory, ...pos}" :slider="sliderStory" @changeSliderColor="changeSliderColorStory"
                :mentionsWidget="storyMentions" @changeMentionsWidgetColor="(idx) => storyMentions[idx].color = (storyMentions[idx].color + 1)%4"
                >
              </story-maker> -->
              <preview-post v-if="getPageInfoByBot(item) && getPageInfoByBot(item).network" 
                :page="state == 'retweet' ? getPageInfo : getPageInfoByBot(item)" 
                :post="{...form, title: formTitleCopy, video: videos[videoType(item)] || form.video || null}" 
                :retweet="state == 'retweet' ? getPageInfoByBot(item) : null" 
                :resharePage="state == 'reshare' ? getPageInfo : null" 
                :reshare="state == 'reshare' ? post : null" 
                :image="url" 
                :activeMentionsAutoReplace="activeMentionsAutoReplace" 
                :activeHashtagsAutoAdd="activeHashtagsAutoAdd" 
                :activePrefixSuffix="activePrefixSuffix" 
                :validMentions="validMentions"
                :validHashtags="validHashtags"
                :typePost="typePost"
                :live="true"
                :doScreenshot="doScreenshot"
                v-on:editPostLive="editPostLive"
                v-on:removeCustomized="removeCustomized"
                :editPostValue="editPostValue"
                :schedulingOverlay="scheduling"
                v-on:currentPostLive="currentPostLive"
                :currentPostFieldEdit="currentPostFieldEdit"
                :pdfTitle="form.documentTitle"
                :poll="poll"
                :multipleImages="multipleImages"
                :multipleMedias="multipleMedias"
                :injectedSnippetTitle="snippetTitle"
                :injectedSnippet="snippet"
                v-on:updateMultipleImages="updateMultipleImages"
                v-on:changeSnippetTitle="(snippet_title) => {snippetTitle = snippet_title}"
                v-on:changeSnippet="modifySnippetLink"
                v-on:closeAutoMentions="closeAutoMentions"
                v-on:editMention="editMention"
                v-on:addMention="addMention"
                :previewEdited="previewEdited"
                :videoReel="getPageInfoByBot(item).network == 'facebook' ? videoReelFB : (videoReel && getPageInfoByBot(item).network == 'instagram')"
                :shareAfterPost="shareAfterPost"
                :storyShareToFacebook="storyShareToFacebook"
                :storificationObject="storificationObject"
                :location="selectedLocation ? selectedLocation[getPageInfoByBot(item).network] : null"
                :compressedImages="compressedImages"
                :highlightStoryEnable="reverseBot.length < 2"
                :userTags="userTags && userTags.list && userTags.list.length > 0 ? userTags : null"
                :productTags="productTags"
                :index="index"
                >
              </preview-post>
              <!-- <canvas :id="`canvas-video-${item}`" :ref="`canvas-video-${item}`" crossorigin="anonymous" ></canvas> -->
                <!-- <div v-if="typePost === 'story' && storyShareToFacebook" >
                  <div class="vertical-line">
                    <span>Facebook</span>
                  </div>
                  <story-maker v-if="typePost === 'story'" :screenWidth="324" :screenHeight="576" :injectedText="instagramTexts"  :injectedBackground="instagramBackgroundColor" :enableHighlight="reverseBot.length === 1"
                  :injectedImage="(!!storyShare || state === 'edit-draft' ? form.enclosure : url) || (typeof form.enclosure === 'string' ? form.enclosure : null)" :injectedLink="isPremiumInstagramAccount ? form.url || null : null" :autoImage="false" :validMentions="validMentions" :posiLink="instagramLinkPosition"
                    :mentions="JSON.parse(localStorage.bots).find(b => b.id == item)"
                    :confirmDeleteExt="deleteStory" :onlyViewMode="true" :pageInfo="getPageInfoByBot(item)" :acceptPrefix="activePrefixSuffix" :acceptReplaceHashtag="activeHashtagsAutoAdd" :autoCrop="isNewImage" :template="templateManual" :templateConfig="templateManual === 'custom' ? bots.find(e => e.id === item).storyTemplate : null" 
                    ref="storymaker" :manualLayers="layers" :linkText="storyLinkText" :draft="state === 'edit-draft'" :poll="pollStory" :slider="sliderStory"
                    :video="form.video" :isVideo="storyVideo" :isShare="storyShare" :isVisualShare="storySharedVisual"
                    :gifs="selectedGifs" :mentionsWidget="storyMentions">
                  </story-maker>
                </div> -->
            </div>  
          </vs-collapse-item>
        </vs-collapse>
        
        <div class="planning" v-if="optimalTimes && activeOptimalTimes">
          <component-optimal-posts-planning
            :interaction="true"
            :network="this.getPageInfoByBot(this.bot).network"
            :optimalTimes="this.optimalTimes"
            v-on:setScheduleDate="changeScheduleDate"
            v-on:refreshData="refreshOptimalTimes">
          </component-optimal-posts-planning>
        </div>

        <div v-if="!(localStorage && localStorage.preview_overlay)" class="button-wrapper" :class="tabsIsMinimize ? 'large' : ''">  
        <template v-if="['Admin', 'Editor', 'Writter'].includes(getUserRole)">      
          <vs-button
            v-if="scheduling.show===false && state=='edit'"
            class="page-btn"
            vs-type="filled"
            color="#6a1f4c"
            @click.prevent="deleteScheduled"
          >{{$t('dash.button.delete')}}</vs-button>
          <template v-if="['Admin', 'Editor'].includes(getUserRole)">
            <!-- confirm post -->
            <Tooltip 
              :text="$t(onUpload ? 'dash.tooltip.upload_media' : 'dash.post.error.need_image.title')" 
              position="top"
              v-if="cantConnect"
              style="float:right;"
            >
              <vs-button 
                :disabled="true"
                @click="confirmPost" 
                class="page-btn"
                vs-type="filled"
                color="#6a1f4c"
                data-qa="form-post-submit"
              >{{ $t(state == 'retweet' ? 'dash.button.retweet' : 'dash.button.post')}} ({{ bot.length}})</vs-button>
              &nbsp;
            </Tooltip>
            <vs-button 
              v-else-if="scheduling.show===false && !((!haveContentToPost && typePost !== 'story' && !(onlyTiktokSelected() && videos.tiktok)) || onUpload)" 
              :disabled="showConfirmPost"
              @click="confirmPost" 
              class="page-btn"
              vs-type="filled"
              color="#6a1f4c"
              data-qa="form-post-submit"
            >{{ $t(state == 'retweet' ? 'dash.button.retweet' : state == 'edit-posted' ? 'dash.button.edit' : 'dash.button.post')}} ({{ bot.length}})</vs-button>
          </template>
          <vs-prompt
            class="confirm-post"
            :title="$t('dash.confirm.post.title')"
            @accept="storyMultiple.length > 1 ? validateMultipleStory('post') : validate('posts')"
            :accept-text="$t('dash.confirm')"
            :cancel-text="$t('dash.cancel')"
            :active.sync="showConfirmPost">
              <div class="warning-no-media" v-if="typePost === 'standard' && (!form.url || form.url == '')">
                {{ $t('dash.confirm.post.warning_standard_without_url') }}
              </div>
              <vs-collapse v-if="bot.length>0">
                <vs-collapse-item v-for="(item, index) in reverseBot" :key="index" :class="getPageInfoByBot(item) ? getPageInfoByBot(item).network : ''" :open="true" class="open-item">
                  <div slot="header" v-if="getPageInfoByBot(item)">
                    <page-image-avatar :page="getPageInfoByBot(item)"/>
                    {{ getPageInfoByBot(item).name }}
                  </div>
                  <div class="preview">
                    <!-- <story-maker 
                      v-if="typePost === 'story' || (videoReel && videos && videos.instagram_reel && getPageInfoByBot(item).network === 'instagram' && isConciergerie(getPageInfoByBot(item)))" :screenWidth="324" :screenHeight="576" :injectedText="instagramTexts" :injectedBackground="instagramBackgroundColor" :enableHighlight="reverseBot.length === 1" :template="templateManual" :validMentions="validMentions" :posiLink="instagramLinkPosition"
                      :injectedImage="videoReel ? null : url" :injectedLink="isPremiumInstagramAccount && !videoReel ? form.url || null : null" :autoImage="true" :onlyViewMode="true" :pageInfo="getPageInfoByBot(item)" :acceptPrefix="activePrefixSuffix" :acceptReplaceHashtag="activeHashtagsAutoAdd" :mentions="JSON.parse(localStorage.bots).find(b => b.id == item)" :templateConfig="templateManual === 'custom' ? bots.find(e => e.id === item).storyTemplate : null" 
                      :manualLayers="layers" :linkText="storyLinkText" :draft="state === 'edit-draft'" :poll="pollStory" :shareFacebook="storyShareToFacebook" :slider="sliderStory"
                      :video="videoReel ? videos.instagram_reel : form.video" :isVideo="storyVideo || videoReel" :isShare="storyShare" :isVisualShare="storySharedVisual" @toggleVisual="sharedStoryToggleVisual"
                      :music="selectedMusic" :gifs="selectedGifs"
                      :isReel="videoReel" :reelText="form.title"
                      :userTagsReel="userTags && userTags.list && userTags.list.length > 0 ? userTags : null" 
                      :activeMentionsAutoReplace="activeMentionsAutoReplace" 
                      :activeHashtagsAutoAdd="activeHashtagsAutoAdd"
                      :post="{...form, title: formTitleCopy, video: videos[videoType(item)] || form.video || null}" 
                      :activePrefixSuffix="activePrefixSuffix" :editPostValue="editPostValue" :mentionsWidget="storyMentions">
                    </story-maker> -->
                    <preview-post v-if="getPageInfoByBot(item) && getPageInfoByBot(item).network" 
                      :page="state == 'retweet' ? getPageInfo : getPageInfoByBot(item)" 
                      :post="{...form, title: formTitleCopy, description: (getBoardPagePinterest || atLeastWonderpushSelected() || atLeastNetworkSelected('youtube') ? form.description : formTitleCopy), video: videos[videoType(item)] || form.video || null}" :retweet="state == 'retweet' ? getPageInfoByBot(item) : null" 
                      :resharePage="state == 'reshare' ? getPageInfo : null" 
                      :reshare="state == 'reshare' ? post : null" 
                      :image="url" 
                      :activeMentionsAutoReplace="activeMentionsAutoReplace" 
                      :activeHashtagsAutoAdd="activeHashtagsAutoAdd" 
                      :activePrefixSuffix="activePrefixSuffix" 
                      :validMentions="validMentions"
                      :validHashtags="validHashtags"
                      :typePost="typePost"
                      :showLive="true"
                      :editPostValue="editPostValue"
                      :schedulingOverlay="scheduling"
                      :pdfTitle="form.documentTitle"
                      :poll="poll"
                      :injectedSnippetTitle="snippetTitle"
                      :injectedSnippet="snippet"
                      :multipleImages="multipleImages"
                      :multipleMedias="multipleMedias"
                      :shareAfterPost="shareAfterPost"
                      :storyShareToFacebook="storyShareToFacebook"
                      :storificationObject="storificationObject"
                      :videoReel="getPageInfoByBot(item).network == 'facebook' ? videoReelFB : videoReel"
                      :location="selectedLocation ? selectedLocation[getPageInfoByBot(item).network] : null"
                      :userTags="userTags && userTags.list && userTags.list.length > 0 ? userTags : null"></preview-post>
                  </div>  
                </vs-collapse-item>
              </vs-collapse>
          </vs-prompt>

          <div class="schedule">            
            <div class="schedule-wrapper" v-if="scheduling.show!==false">

              <component-datepicker
                class="posts-datepicker"
                v-on:picked="picked"
                :date="new Date(scheduling.date)"
                :now="true"
              ></component-datepicker>
              <div class="posts-timepicker">
                <img src="../../../assets/img/icon_time_black.svg" alt="time">
                <vue-timepicker v-model="scheduling.time" :key="scheduling.time.mm" :hour-range="rangeHour" :minute-range="rangeMinute" @change="changeRangeSchedulingTime" auto-scroll :minute-interval="minuteInterval"></vue-timepicker>
              </div>

              <!-- <div ref="loadableButton"
                @click="[showOptimalTimes(), isDisable=true]"
                :disable="isDisable || bot.length != 1"
                color="#6a1f4c"
                class ="btn-img vs-con-loading__container btn-optimal-times">
                <p>Help</p>
              </div> -->
            </div>

            <!-- confirm post scheduled -->
            <Tooltip 
              :text="$t('dash.plan.change_to_get_features')" 
              position="top"
              v-if="scheduling.show===false && ((!isUserPremiumActive && !isUserPartner) || (!checkLock('planner'))) && state !== 'edit-posted'"
            >
              <vs-button
                :disabled="true"
                class="page-btn btn-img"
                color="#6a1f4c"
                vs-type="filled"
                data-qa="form-post-schedule"
              >
                <p>{{$t('dash.button.schedule')}}</p>
                <img src="../../../assets/img/icon_time_white.svg" alt="schedule">
              </vs-button>
              &nbsp;
            </Tooltip>
            <vs-button
              v-else-if="scheduling.show===false && state !== 'edit-posted'"
              @click.prevent="[schedule(), isDisable=false, activeOptimalTimes=false]"
              class="page-btn btn-img"
              color="#6a1f4c"
              vs-type="filled"
              data-qa="form-post-schedule"
            >
              <p>{{$t('dash.button.schedule')}}</p>
              <img src="../../../assets/img/icon_time_white.svg" alt="schedule">
            </vs-button>
            <Tooltip 
              :text="$t(onUpload ? 'dash.tooltip.upload_media' : 'dash.post.error.need_image.title')" 
              position="top"
              style="float: left;"
              v-else-if="['Admin', 'Editor'].includes(getUserRole) && (((!haveContentToPost && typePost !== 'story')  && !(onlyTiktokSelected() && videos.tiktok)) || onUpload || missingDataToPost) && state !== 'edit-posted'"
            >
              <vs-button 
                @click="confirmPost" 
                :disabled="true"
                class="page-btn btn-img"
                vs-type="filled"
                color="#6a1f4c"
                data-qa="form-post-submit-schedule"
              >
                <p>{{$t((state === 'edit' ? 'dash.button.modify' : 'dash.button.schedule'))}} ({{ bot.length}})</p>
                <img src="../../../assets/img/icon_time_white.svg" alt="schedule">
              </vs-button>
              &nbsp;
            </Tooltip>
            <vs-button 
              v-else-if="['Admin', 'Editor'].includes(getUserRole) && state !== 'edit-posted'"
              @click="confirmPost" 
              :disabled="showConfirmPost"
              class="page-btn btn-img"
              vs-type="filled"
              color="#6a1f4c"
              data-qa="form-post-submit-schedule"
            >
              <p>{{$t(isAffectedPost() ? 'dash.button.validate' : (state === 'edit' ? 'dash.button.modify' : 'dash.button.schedule'))}} ({{ bot.length}})</p>
              <img src="../../../assets/img/icon_time_white.svg" alt="schedule">
            </vs-button>
            
          </div>
          
          <a class="cancel-btn" @click.prevent="scheduling.show=false; activeOptimalTimes=false; initTooltip()" v-if="scheduling.show===true">
            <p>
              <Tooltip :text="$t('dash.tooltip.cancel_scheduled')" position="top">
                <span>{{$t('dash.button.cancel')}}</span>&nbsp;
              </Tooltip>
            </p> 
          </a>
        </template>

          <div class="top-btn">
            <!-- close post form -->
            <vs-button
              @click.prevent="close()"
              class="page-btn close"
              color="#6a1f4c"
              vs-type="filled"
            >
              <!-- <p>{{$t('dash.button.close')}}</p> -->
              <p>{{$t('dash.button.cancel')}}</p>
            </vs-button>

            <!-- draft -->
            <!-- <Tooltip :text="$t('dash.tooltip.save_draft')" position="top"> -->
            <Tooltip :text="$t(((!(haveContentToPost || form.title.length) && typePost !== 'story') && !(onlyTiktokSelected() && videos.tiktok)) || onUpload ? ((onUpload ? 'dash.tooltip.upload_media' : 'dash.post.error.need_image.title')) :'dash.tooltip.save_draft')" position="top">
              <vs-button 
                @click="saveDraft(false)" 
                class="page-btn"
                vs-type="filled"
                color="#6a1f4c"
                :disabled="((!(haveContentToPost || form.title.length) && typePost !== 'story') && !(onlyTiktokSelected() && videos.tiktok)) || onUpload"
                data-qa="save-post-draft"
              >{{ $t((state === 'edit' ? 'dash.button.duplicate' : 'dash.button.save')) }}</vs-button>
              &nbsp;
            </Tooltip>
            <!-- <Tooltip :text="$t('dash.tooltip.restore_last_post')" position="top">
              <vs-button 
                v-if="state === 'new' && localStorage.last_post_draft"
                @click="fillFormWithDraft(true)" 
                class="page-btn restore"
                vs-type="filled"
                color="#6a1f4c"
                data-qa="restore-last-post"
              >{{ $t('dash.button.restore') }}</vs-button>
              &nbsp;
            </Tooltip> -->
            <a class="cancel-btn" @click.prevent="fillFormWithDraft(true)" v-if="state === 'new' && localStorage.last_post_draft">
              <p>
                <Tooltip :text="$t('dash.tooltip.restore_last_post')" position="top">
                  <span>{{$t('dash.button.restore')}}</span>&nbsp;
                </Tooltip>
              </p> 
            </a>
            <vs-button 
              v-if="state === 'edit-draft'"
              @click="removeDraft" 
              class="page-btn remove-draft"
              vs-type="filled"
              color="#6a1f4c"
              data-qa="delete-post-draft"
            >{{ $t('dash.button.delete') }}</vs-button>

            <!-- assigation -->
            <vs-button
              @click.prevent="popupSelectUser = true"
              class="page-btn"
              color="#6a1f4c"
              vs-type="filled"
            >
              <p v-if="affectedTo && affectedTo.users">{{$t('dash.post.affected_to.title') + ` : ${affectedTo.users.map(u => `${u.firstname} ${u.lastname}`).join(', ')}`}}</p>
              <p v-else-if="affectedTo && affectedTo.user">{{$t('dash.post.affected_to.title') + (affectedTo.user ? ` : ${affectedTo.user.firstname} ${affectedTo.user.lastname}` : '')}}</p>
              <p v-else-if="affectedTo">{{$t('dash.post.affected_to.title') + (affectedTo ? ` : ${affectedTo.firstname} ${affectedTo.lastname}` : '')}}</p>
              <p v-else>{{$t('dash.post.affected_to.title')}}</p>
            </vs-button>
            <vs-popup class="overlay groups shared-planner affected_to post-sidebar" 
              :title="$t('dash.inbox.event.affected_to.title')" 
              :active.sync="popupSelectUser">
                  
              <component-users-selector
                v-if="popupSelectUser"
                v-on:submit="addAffectedToPost"
                :manager="true"
                :usersAdded="affectedTo ? (affectedTo.users ? affectedTo.users : [affectedTo.user || affectedTo]) : []"
                :type="'affected_to'"
                :editOptionValidation="affectedTo ? affectedTo.optionValidation : null"
              ></component-users-selector>
      
            </vs-popup>
          </div>
        </div>

      </form>
    </div>
        
    <vs-popup class="overlay posts-overlay-change-plan-conciergerie" :title="$t('dash.plan.active_conciergerie_to_get_features')" :active.sync="changePlanConciergerie">
      <p>{{ $t('dash.plan.active_conciergerie_to_get_features.content') }}</p> 
      <br/>
      <vs-button
              @click="goToSettings"
              class="btn-large btn-img"
              color="#303030"
              vs-type="filled"
      >
          <p>{{$t('dash.button.changeplan')}}</p>
          <img src="../../../assets/img/icon_unlock.svg" alt="unlock">
      </vs-button>
    </vs-popup>

    <component-conciergerie-form 
      v-if="activeConciergerie"
      :page="activeConciergerie"
      :activeConciergerie="activeConciergerie" 
      v-on:getPagesEvent="getPagesEvent"
      v-on:closeActiveConciergerie="closeActiveConciergerie"
    ></component-conciergerie-form>
    
  </div>
</template>

<script>
  import moment, { duration } from 'moment'

  import VueTimepicker from 'vue2-timepicker'
  import Posts from '../../mixins/Posts'
  import Pages from '../../mixins/Pages'
  import User from '../../mixins/User'
  import Bots from '../../mixins/Bots'
  import Drafts from '../../mixins/Drafts'
  import Video from '../../mixins/Video'
  import Upgradable from '../../mixins/Upgradable'
  import Notif from '../../mixins/Notif'
  import componentDatepicker from './../Datepicker.vue'
  import emojiData from '@/constants/emoji-mart-vue-fast/all.json'
  import { Picker, EmojiIndex  } from 'emoji-mart-vue-fast'
  import 'emoji-mart-vue-fast/css/emoji-mart.css'
  import ClickOutside from 'vue-click-outside'
  import PreviewPost from './../PreviewPost.vue'
  import componentOptimalPostsPlanning from '../OptimalPostsPlanning.vue'
  import StoryMaker from '../StoryMaker.vue'
  import PageImageAvatar from '../PageImageAvatar.vue'
  import draggable from 'vuedraggable'
  import SSE from '../../../utils/sse.js'
  import { v4 as uuidv4 } from 'uuid';
  import componentConciergerie from './Conciergerie.vue'
  import componentConciergerieForm from './ConciergerieForm.vue'
  import componentLoader from './../overlay/Loader.vue'
  import VueTagsInput from '@johmun/vue-tags-input'
  import { parseGIF, decompressFrames } from 'gifuct-js'
  import Tooltip from './../tooltip/tooltipInit.vue'
  import GifSticker from './../GifSticker.vue'
  import ShopSticker from './../ShopSticker.vue'
  import Fonts from '../../../utils/Fonts'
  import Queuer from '../../../utils/Queuer'
  import Button from '../utils/button.vue'
  import componentUsersSelector from './UsersSelector'
  // import html2canvas from'html2canvas-fitcontain'
  import { Carousel, Slide } from 'vue-carousel';


  String.prototype.indexOfRegex = function(regex, fromIndex){
    var str = fromIndex ? this.substring(fromIndex) : this;
    var match = str.match(regex);
    return match ? str.indexOf(match[0]) + fromIndex : -1;
  }

  String.prototype.lastIndexOfRegex = function(regex, fromIndex){
    var str = fromIndex ? this.substring(0, fromIndex) : this;
    var match = str.match(regex);
    return match ? str.lastIndexOf(match[match.length-1]) : -1;
  }

  export default {
  name: 'component-posts-overlay',


  components: {
    componentDatepicker,
    VueTimepicker,
    Picker,
    PreviewPost,
    componentOptimalPostsPlanning,
    StoryMaker,
    PageImageAvatar,
    draggable,
    componentConciergerie,
    componentConciergerieForm,
    componentLoader,
    VueTagsInput,
    Tooltip,
    GifSticker,
    ShopSticker,
    Button,
    componentUsersSelector,
    Carousel,
    Slide
  },

  mixins: [User, Posts, Bots, Drafts, Video, Upgradable, Notif, Pages],

  props: {
    storyShare: String,
    linked: {
      type: Array,
      required: true
    },
    bots: {
      type: Array,
      required: true
    },
    validated: Boolean,
    state: String,
    post: Object,
    page: String,
    pages: Array,
    content: String,
    scheduledOverlay: Object,
    showAdd: Boolean,
    activeOptimalTimes: Boolean,
    recap: Array,
    groupsCopy: Array,
    tabsIsMinimize: Boolean
  },

  computed: {

    activeFrontV2() {
      const activeAccounts = [
        '9e046e84-5b26-4c94-8379-9a88ea278490', //le divan
        '092d91e3-a47a-4b54-b36f-06299c1c4333', //collectifoups
        '09bfe424-87e9-46a0-a3d0-4d4c23a9e6b2', //lafeemaraboute
        'ab38413a-845a-4dd4-b122-cffa2b454658', //leconnecteur-biarritz
        '70465c72-23bd-4e1e-8339-78045d855f71', //handicall
        'f7c98363-9ae1-49eb-8158-8c99efe26d53', //leboulon
        'c7952eab-a5fc-482b-9aa0-eb2acb1bdcbc', //ai-facturing
        'e7271d76-8c25-4d35-9969-62bd90ff0323', //hommedumatch
        'a03617ff-2f27-4914-be3c-22a61879cad5', //mpsimmo
        'b15957bb-0983-4dcd-b807-71708fd05805', //banyuls
        '8478452f-909b-4775-a2b4-329fbd0a90ec', //cyberid
        '1ee34989-ec74-4242-94d2-c8a4623d4153', //spl-occitanie-events
        'a107edd0-c5ab-4175-935b-96ae8f7b19a1', //tse
        'f6102ca6-fd8d-41a2-8123-f9a87ffe7630', //guyotenvironnement
        'b15957bb-0983-4dcd-b807-71708fd05805', //banyuls-sur-mer
        'e172d1f7-0077-470c-b549-0be53f9ab1e8', //pellenc
        '378fff5b-2b4a-4555-8577-be21e3f4f4c1', //cyrillignac
      ]
      let user = JSON.parse(localStorage.user)
      const force = localStorage.forceBeta ? JSON.parse(localStorage.forceBeta) : false
      return activeAccounts.includes(user.account) || user.email.includes('@mashup-web.') || force
    },

    haveContentToPost() {
      return (this.typePost === 'standard' && ((this.form.title && this.form.title.length) || (this.form.url && this.form.url.length > 0)))
                || (this.typePost === 'image' && ((this.form.enclosure && this.form.enclosure.length > 0) || (this.multipleImages && this.multipleImages.length > 0) || ((this.meta && this.meta.og && this.meta.og.image) || (this.meta && this.meta.images && this.meta.images.length && this.meta.images[0].url))))
                || (this.typePost === 'video' && ((this.form.video && this.form.video.length > 0) || (this.multipleMedias && this.multipleMedias.length > 0)))
                || (this.typePost === 'poll' && (this.poll.question && this.poll.question.length && this.poll.options.length >= 2 && this.poll.options.every(e => e !== '')))
                || (this.typePost === 'document' && ((this.form.file || this.url) && this.form.documentTitle && this.form.documentTitle.length))
    },

    hideToScreenshot() {
      return localStorage && localStorage.preview_overlay
    },

    selectedMusic() {
      return this.typePost === 'video' && this.videoReel ? this.$store.getters.storificationMusicReel : this.$store.getters.storificationMusic;
    },

    instagramTexts() {
      return this.typePost === 'video' && this.videoReel ? this.$store.getters.storificationTextsReel : this.$store.getters.storificationTexts;
    },

    hexaStoryBackgroundColor() {
      if (!this.instagramBackgroundColor || this.instagramBackgroundColor.length < 3) return null;
      const rgbToHex = (r, g, b) => `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`
      return rgbToHex(this.instagramBackgroundColor[0],this.instagramBackgroundColor[1],this.instagramBackgroundColor[2]);
    },
  
    dialogImageTagIsOpen() {
      console.log("dialogImageTagIsOpen", this.$refs['searchTagImg']);
      return this.searchMention && this.$refs['searchTagImg'] && this.$refs['searchTagImg'].open;
    },

    getUserRole() {
      const user = localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null
      if(!user) return null
      if(user.admin)
        return 'Admin'
      else
        return user.role && user.role.length
                    ? user.role[0]
                    : 'Editor'
      
    },

    cantConnect() {
      return this.scheduling.show===false && this.missingDataToPost
      // && ((!this.form.title && this.typePost !== 'story' 
      // && !(this.onlyTiktokSelected())) || this.onUpload 
      // || (this.typePost === 'video' && !this.video && !this.video && (Object.values(this.videos).includes("encoding...") || Object.values(this.videos).every(e => e === null)))
      // || (this.typePost === 'standard' && this.bot.some((item) => ['instagram', 'pinterest'].includes(this.getPageInfoByBot(item).network)) && !((this.meta.og && this.meta.og.image) || (this.meta.images && this.meta.images.length && this.meta.images[0].url))))
    },

    missingDataToPost() {
      // return ((!this.form.title && this.typePost !== 'story' 
      return ((!this.haveContentToPost  && this.typePost !== 'story' 
      && !(this.onlyTiktokSelected())) || this.onUpload 
      || (this.typePost === 'video' && !this.videos && (Object.values(this.videos).includes("encoding...") || Object.values(this.videos).every(e => e === null)))
      || (this.typePost === 'standard' && this.bot.some((item) => ['instagram', 'pinterest'].includes(this.getPageInfoByBot(item).network)) && !((this.meta && this.meta.og && this.meta.og.image) || (this.meta && this.meta.images && this.meta.images.length && this.meta.images[0].url))))
    },

    botsGoogleOnly() {
      let bots = this.bots.filter(b => this.bot.includes(b.id))
      return (!bots.find(b => b.type !== 'google') && bots.find(b => b.type === 'google'))
    },

    templateDefault() {
      let b = this.bots.find(bot => bot.id === this.bot[0])
      return b.storyTemplate ? (b.storyTemplate.predefined || 'custom') : null;
    },

    activeLinkedinConciergerie() {
      // const user = JSON.parse(localStorage.user)
      return this.checkLock('linkedin_credentials') //|| user.email.includes("@mashup-web.com")
    },

    activeInstagramConciergerie() {
      // const user = JSON.parse(localStorage.user)
      return this.checkLock('instagram_credentials') //|| user.email.includes("@mashup-web.com")
    },

    activeDocument() {
      if (this.bot.length === 0) return false;
      let selectedBots = this.bot.map(id => this.bots.find(e => e.id === id));
      console.log("selectedBots active doc", selectedBots);
      return selectedBots.every(e => e && e.page && (e.page.network === 'linkedin' && e.page.story_config && e.page.story_config.created || e.page.network === 'whatsapp'));
    },

    activeVideo(){
      return !this.bot.some(id => this.bots.find(b => b.id == id && (['google', 'telegram', 'bluesky', 'pinterest'].includes(b.page.network) || (b.page.network == 'facebook' && b.page.isGroup))))
    },

    activeImage(){
      return !this.bot.some(id => this.bots.find(b => b.id == id && ['telegram', 'tiktok', 'youtube'].includes(b.page.network)))
    },

     getBoardPagePinterest(){
       let bot 
       let page
        
        for (let i = 0; i < this.bot.length; i++) {

        bot = this.bots.find(b => b.id == this.bot[i])
         if(bot && bot.page.network == 'pinterest'){
          this.getBoardofPinterest(bot.page)
          return this.bot[i]
        }
       }
        return false
      },
    inputTitleText(){
      if( this.getBoardPagePinterest && this.bot.length == 1)
        return this.$t('dash.posts.overlay.description_placeholder_title_pinterest')
      if((this.getBoardPagePinterest || this.atLeastWonderpushSelected() || this.atLeastNetworkSelected('youtube')) && this.bot.length > 1)
        return this.$t('dash.posts.overlay.description_placeholder_title_pinterest_multiple')
      if(!this.getBoardPagePinterest || !this.atLeastWonderpushSelected() || !this.atLeastNetworkSelected('youtube'))
        return this.$t('dash.posts.overlay.description_placeholder')
    },
    inputDescriptionText(){
        return this.$t('dash.posts.overlay.description_pinterest_simple_placeholder')
    },

    hasStoryConfigLinkedin() {
      if (this.bot.length === 0) return false;
      return this.bot.filter(e => this.getPageInfoByBot(e).network === 'linkedin').every((item) => {
        return this.getPageInfoByBot(item).story_config && this.getPageInfoByBot(item).story_config.created && (!this.getPageInfoByBot(item).story_config.lock || this.getPageInfoByBot(item).story_config.lock < Date.now());
      });
    },

    hasStoryConfig() {
      if (this.bot.length === 0) return false;
      return this.bot.every((item) => {
        return this.getPageInfoByBot(item).story_config && this.getPageInfoByBot(item).story_config.created && (!this.getPageInfoByBot(item).story_config.lock || this.getPageInfoByBot(item).story_config.lock < Date.now());
      });
    },

    hasStoryTemplate() {
      if (this.bot.length === 0) return false;
      return this.bot.every((item) => {
        return this.bots.find(b => b.id == item).storyTemplate && this.bots.find(b => b.id == item).storyTemplate.configuration;
      });
    },

    hasIsGroup() {
      if (this.bot.length === 0) return false;
      return this.bot.every((item) => {
        return this.getPageInfoByBot(item).isGroup;
      });
    },

    localStorage() {
      return localStorage;
    },

    activeInstagramStories() {
      const accounts = [
        '63fc164e-60da-41a7-9619-0c5fe6561239', //next-plz
        'b0291610-4743-4420-91ee-ea5699647106', //motoblouz
        'a8276ad6-bfe0-4866-a5b0-9fbf14003b27', //objectifgard
        '1863bfe3-f179-49a5-8baa-b1edb7e3282d', //doorinsider
        '9b76ba80-38e5-4b8f-9705-6aaf5259b946', //iadfrance
        '36522076-7ed1-4964-8323-1fd8d773012f', //agenceqg
        '7f0e5b02-a627-432f-89eb-83317b03e478', //santeclair.fr
        '90e789fa-7377-434c-b719-132aa8bcd1d2',  //keepeo.fr
        'cbdec673-84ab-401b-8882-0a72fa29b510',  //archi-tech.digital
        '6a1edfc6-eed2-4945-a48b-5be437a5e955',  //uncertainnicolas
        '411af69b-6839-421f-87d3-2cac55a5cbb3', //auto123
          '485a2ce9-b925-4962-a7eb-3abefebfd134', //komeocreation
      ]

      const user = JSON.parse(localStorage.user)
      return accounts.includes(user.account) || this.checkLock('instagram_credentials') || user.email.includes("@mashup-web.com")
    },

    reverseBot() {
      return [...this.bot].sort((a, b) => {
        let infosA = this.getPageInfoByBot(a);
        let infosB = this.getPageInfoByBot(b);
        if (this.isConciergerie(infosA) && infosA.network === 'instagram') {
          return -1;
        }
        if (this.isConciergerie(infosB) && infosB.network === 'instagram') {
          return 1;
        }
        return 0;
      })
      // return this.bot
      // eslint-disable-next-line 
      //return this.bot.reverse()
    },

    samePageBots() {
      const { page, bots } = this
      if (!page) return bots
      if(this.post && this.post._bots && !(this.post.page.length && this.post.page[0].draft)) {
        return Array.isArray(this.post._bots) 
                  ? this.post._bots 
                  : [this.post._bots]
      } 
      return this.pages ? this.pages.map(p => bots.find(b => b.page.id == p)) : []
    },

    getBotEachPages(){
      const { bots, linked } = this
      let botsTmp = []
      linked.forEach(p => {
        let tmp = bots.find(b => b.page.id == p.id)
        if(tmp) botsTmp.push(tmp)
      })
      return botsTmp
    },

    sameNetworkPages(){
      const { page, bots, linked } = this
      let network = linked.find(l => l.id == page).network
      let botsTmp = []
      linked.filter(l => l.network == network && !(l.isGroup && l.network == 'facebook')).forEach(p => {
        let tmp = bots.find(b => b.page.id == p.id)
        if(tmp) botsTmp.push(tmp)
      })
      return botsTmp
    },

    getPageInfo() {
      const { page, linked } = this
      return linked.find(x => x.id === page)
    },

    sizeCurrentMessageByRsLimit() {
      if(this.rsLimit) {
        let bot = this.bots.find(b => b.type == this.rsLimit.toLowerCase())
        let message = this.getMessage(bot.id)

        if(this.rsLimit.toLowerCase() == 'twitter') {
          const twttr = require('twitter-text')
          console.log('twttr length', twttr.default.parseTweet(message))
          return twttr.default.parseTweet(message).weightedLength
          // let regexUrl = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|www\.[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z\u00C0-\u017F0-9]+\.[^\s]{2,}|www\.[a-zA-Z\u00C0-\u017F0-9]+\.[^\s]{2,})/g
          // if(message && message.match(regexUrl))
          //   return message.length - message.match(regexUrl).reduce((previous, current) => previous + current.length, 0)
        }

        return message && message.length
      }
      return null
    },

    limitText(){
      let botTw = []
      let botGmb = []
      let botLkn = []
      let botInsta = []
      let botFB = []
      let botThreads = []
      let botBluesky = []
      let botYoutube = []
      let limitText = null

      botTw = this.bots.filter(b => this.bot.includes(b.id) && b.page.network == 'twitter')
      botGmb = this.bots.filter(b => this.bot.includes(b.id) && b.page.network == 'google')
      botLkn = this.bots.filter(b => this.bot.includes(b.id) && b.page.network == 'linkedin')
      botInsta = this.bots.filter(b => this.bot.includes(b.id) && b.page.network == 'instagram')
      botFB = this.bots.filter(b => this.bot.includes(b.id) && b.page.network == 'facebook')
      botThreads = this.bots.filter(b => this.bot.includes(b.id) && b.page.network == 'threads')
      botBluesky = this.bots.filter(b => this.bot.includes(b.id) && b.page.network == 'bluesky')
      botYoutube = this.bots.filter(b => this.bot.includes(b.id) && b.page.network == 'youtube')

      let maxHashtagLength = 0
      let maxHashtagPrefixLength = 0

      // eslint-disable-next-line
      this.rsLimit = null

      if(botYoutube.length) {
        // eslint-disable-next-line
        this.rsLimit = 'Youtube'
        botYoutube.forEach(b => {
          if(this.activePrefixSuffix){
            if(b.hashtag && b.hashtag.length > maxHashtagLength)
              maxHashtagLength = b.hashtag.length
            if(b.hashtagPrefix && b.hashtagPrefix.length > maxHashtagPrefixLength)
              maxHashtagPrefixLength = b.hashtagPrefix.length
          }
        })

        limitText = 100
        if(this.activePrefixSuffix){
          if(maxHashtagLength > 0)
            limitText = limitText - maxHashtagLength - 1
          if(maxHashtagPrefixLength > 0)
            limitText = limitText - maxHashtagPrefixLength - 1
        }
      } 
      else if(botTw.length) {
        // eslint-disable-next-line
        this.rsLimit = 'Twitter'
        botTw.forEach(b => {
          if(this.activePrefixSuffix){
            if(b.hashtag && b.hashtag.length > maxHashtagLength)
              maxHashtagLength = b.hashtag.length
            if(b.hashtagPrefix && b.hashtagPrefix.length > maxHashtagPrefixLength)
              maxHashtagPrefixLength = b.hashtagPrefix.length
          }
        })

        // limitText = 280
        limitText = botTw.find(b => !b.page.story_config || b.page.story_config.verified_type == 'none') ? 280 : 25000
        if(this.form.url)
          limitText = limitText - 23 - 1 //- 2

        // let regexUrl = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|www\.[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z\u00C0-\u017F0-9]+\.[^\s]{2,}|www\.[a-zA-Z\u00C0-\u017F0-9]+\.[^\s]{2,})/g
        // if(this.form.title && this.form.title.match(regexUrl))
        //   limitText = limitText - (23 * this.form.title.match(regexUrl).length)

        // // € counted as char*2
        // let regex = /€|•/gi
        // while (this.form.title && regex.exec(this.form.title)) 
        //   limitText--
        
        if(this.activePrefixSuffix){
          if(maxHashtagLength > 0)
            limitText = limitText - maxHashtagLength - 1
          if(maxHashtagPrefixLength > 0)
            limitText = limitText - maxHashtagPrefixLength - 1
        }
      }
      else if(botBluesky.length) {
        // eslint-disable-next-line
        this.rsLimit = 'Bluesky'
        botBluesky.forEach(b => {
          if(this.activePrefixSuffix){
            if(b.hashtag && b.hashtag.length > maxHashtagLength)
              maxHashtagLength = b.hashtag.length
            if(b.hashtagPrefix && b.hashtagPrefix.length > maxHashtagPrefixLength)
              maxHashtagPrefixLength = b.hashtagPrefix.length
          }
        })

        limitText = 300
        if(this.activePrefixSuffix){
          if(maxHashtagLength > 0)
            limitText = limitText - maxHashtagLength - 1
          if(maxHashtagPrefixLength > 0)
            limitText = limitText - maxHashtagPrefixLength - 1
        }
      } 
      else if(botThreads.length) {
        // eslint-disable-next-line
        this.rsLimit = 'Threads'
        botThreads.forEach(b => {
          if(this.activePrefixSuffix){
            if(b.hashtag && b.hashtag.length > maxHashtagLength)
              maxHashtagLength = b.hashtag.length
            if(b.hashtagPrefix && b.hashtagPrefix.length > maxHashtagPrefixLength)
              maxHashtagPrefixLength = b.hashtagPrefix.length
          }
        })

        limitText = 500
        if(this.activePrefixSuffix){
          if(maxHashtagLength > 0)
            limitText = limitText - maxHashtagLength - 1
          if(maxHashtagPrefixLength > 0)
            limitText = limitText - maxHashtagPrefixLength - 1
        }
      } 
      else if(botGmb.length) {
        // eslint-disable-next-line
        this.rsLimit = 'Google'
        botGmb.forEach(b => {
          if(this.activePrefixSuffix){
            if(b.hashtag && b.hashtag.length > maxHashtagLength)
              maxHashtagLength = b.hashtag.length
            if(b.hashtagPrefix && b.hashtagPrefix.length > maxHashtagPrefixLength)
              maxHashtagPrefixLength = b.hashtagPrefix.length
          }
        })

        limitText = 1300
        if(this.activePrefixSuffix){
          if(maxHashtagLength > 0)
            limitText = limitText - maxHashtagLength - 1
          if(maxHashtagPrefixLength > 0)
            limitText = limitText - maxHashtagPrefixLength - 1
        }
      } else if (botInsta.length) {
        // eslint-disable-next-line
        this.rsLimit = 'Instagram'
        botInsta.forEach(b => {
          if(this.activePrefixSuffix){
            if(b.hashtag && b.hashtag.length > maxHashtagLength)
              maxHashtagLength = b.hashtag.length
            if(b.hashtagPrefix && b.hashtagPrefix.length > maxHashtagPrefixLength)
              maxHashtagPrefixLength = b.hashtagPrefix.length
          }
        })

        limitText = 2200;
        if(this.activePrefixSuffix){
          if(maxHashtagLength > 0)
            limitText = limitText - maxHashtagLength - 1
          if(maxHashtagPrefixLength > 0)
            limitText = limitText - maxHashtagPrefixLength - 1
        }
      } else if (botLkn.length) {
        // eslint-disable-next-line
        this.rsLimit = 'Linkedin'
        botLkn.forEach(b => {
          if(this.activePrefixSuffix){
            if(b.hashtag && b.hashtag.length > maxHashtagLength)
              maxHashtagLength = b.hashtag.length
            if(b.hashtagPrefix && b.hashtagPrefix.length > maxHashtagPrefixLength)
              maxHashtagPrefixLength = b.hashtagPrefix.length
          }
        })

        limitText = 3000;
        if(this.activePrefixSuffix){
          if(maxHashtagLength > 0)
            limitText = limitText - maxHashtagLength - 1
          if(maxHashtagPrefixLength > 0)
            limitText = limitText - maxHashtagPrefixLength - 1
        }

      } else if (botFB.length) {
        // eslint-disable-next-line
        this.rsLimit = 'Facebook'
        botFB.forEach(b => {
          if(this.activePrefixSuffix){
            if(b.hashtag && b.hashtag.length > maxHashtagLength)
              maxHashtagLength = b.hashtag.length
            if(b.hashtagPrefix && b.hashtagPrefix.length > maxHashtagPrefixLength)
              maxHashtagPrefixLength = b.hashtagPrefix.length
          }
        })

        limitText = 63206;
        if(this.activePrefixSuffix){
          if(maxHashtagLength > 0)
            limitText = limitText - maxHashtagLength - 1
          if(maxHashtagPrefixLength > 0)
            limitText = limitText - maxHashtagPrefixLength - 1
        }
      }

      if(limitText && !botTw.length && ['image', 'video'].includes(this.typePost) && this.form.url && this.form.url != '')
        limitText = limitText - this.form.url.length

      return limitText
    },

    checkActiveMentionsSearch(){
      if(this.bot.length >= 1){
        // let bot = this.bots.find(b => b.id == this.bot[0])
        // if(bot && ['twitter', 'facebook', 'instagram', 'linkedin'].includes(bot.page.network))
        if(this.bots.filter(b => this.bot.includes(b.id) && ['twitter', 'facebook', 'instagram', 'linkedin', 'bluesky'].includes(b.page.network)).length)
          return true
      }
      return false
    },

    checkActiveHashtagsSearch(){
      if(this.bot.length >= 1 && this.bot.map(b => this.bots.find(bot => b == bot.id)).find(bot => bot && ['twitter', 'instagram'].includes(bot.type)))
          return true
      return false
    },

    checkActiveLocationSearch(){
      // return false
      // return (this.typePost !== 'story' && this.atLeastInstagramSelected() && (this.multipleImages.length <= 1 || this.multipleMedias.length <= 1) && !this.atLeastFacebookSelected()) || (this.atLeastFacebookSelected() && this.videoReelFB && this.typePost === 'video' && !this.atLeastInstagramSelected())
      // return (this.typePost !== 'story' && this.atLeastInstagramSelected() && (this.multipleImages.length <= 1 || this.multipleMedias.length <= 1)) || (this.atLeastFacebookSelected() && this.videoReelFB && this.typePost === 'video')
      return ( this.typePost !== 'story' && this.atLeastInstagramSelected() && (this.multipleImages.length <= 1 || this.multipleMedias.length <= 1)) || (this.atLeastFacebookSelected() && (this.typePost !== 'video' || (this.videoReelFB && this.typePost === 'video')))
    },

    checkActiveMusicSearch(){
      return (this.typePost === 'story' && this.onlyInstagramSelected()) || (this.atLeastInstagramConciergerieSelected());
    },

    getNetwork(){
      let bot = this.bots.find(b => b.id == this.bot[0])
      return bot ? bot.page.network : null
    },
    
    listPages() {
      if(['new', 'inqueue-edit', 'duplicate-post', 'duplicate-post-unique', 'edit-draft'].includes(this.state) || (this.state === 'edit' && this.post.page && this.post.page.length && this.post.page[0].draft ))
        return this.getBotEachPages
      else if(['reshare', 'retweet'].includes(this.state))
        return this.sameNetworkPages
      return this.samePageBots
    },

    activeSearchHashtags() {
      if (!this.bot || this.bot.length === 0) return false;
      return this.bot.some((item) => ['twitter', 'instagram'].includes(this.getPageInfoByBot(item).network));
    },
    allPages() {
      return this.$store.getters['selectPage/selectPageAllPages'];
    },

    firstImageAspectRatio() {
      let ratio = "1";
      if (this.multipleImages && this.multipleImages.length > 0) {
        let img = new Image();
        img.src = this.multipleImages[0].url
        ratio = `${img.width} / ${img.height}`;
      }
      console.log("aspect ratio calculated", ratio);
      return ratio;
    }
  },

  watch: {

    isCarrouselMix: function() {
      if(this.isCarrouselMix && this.typePost == 'image') {
        this.typePost = 'video'
        let multipleMedias = this.multipleImages.map(i => {
          return {
            ...i,
            name: i.filename,
            type: 'image/png'
          }
        })
        this.resetFields('video')
        this.videoReel = false
        this.multipleMedias = multipleMedias
        this.$forceUpdate();
      }
    },

    typePost: function() {
      if(this.isCarrouselMix && this.typePost == 'image') {
        this.isCarrouselMix = false
      }
    },

    '$store.getters.emittedObject': {
      handler: function(emittedObject) {
        console.log("WATCH",emittedObject);
        if (emittedObject && emittedObject.message) {
          switch (emittedObject.message) {
            case "updateCroppedImage": {
              const blob = emittedObject.data;
              if (blob) {
                //!! TODO: Vérifier
                // this.form.enclosure = URL.createObjectURL(blob);
                if (this.form.enclosure && !this.form.enclosure.includes("blob:")) {
                  this.form.enclosure = `${this.form.enclosure}`;
                } else {
                  this.form.enclosure = URL.createObjectURL(blob);
                }
                this.form.file = new File([blob], this.filename || (this.form.file && this.form.file.name) || `website-${this.form.url.split('/').pop()}.jpg`, {type: blob.type}); //Blob to file
                this.url = URL.createObjectURL(blob); // Blob to URL
              }
              break;
            }
            case "resetStory": {
              this.form.enclosure = null;
              this.form.file = null;
              this.form.video = null;
              this.videos = [];
              this.multipleMedias = []
              this.url = null;
              this.filename = 'No file selected';
              this.form.url = null;
              this.storyVideo = false;
              // this.$nextTick(() => this.$store.dispatch("resetStorification"));
              break;
            }
            case "removeLink": {
              this.form.url = null;
              break;
            }
            default: 
              console.log("emittedObject received : ", emittedObject.message, emittedObject.data);
              break;
          }
        }
      },
    },

    activePrefixSuffix: function() {
      localStorage.setItem('activePrefixSuffix', JSON.stringify(this.activePrefixSuffix))
    },
    activeHashtagsAutoAdd: function() {
      localStorage.setItem('activeHashtagsAutoAdd', JSON.stringify(this.activeHashtagsAutoAdd))
    },
    activeMentionsAutoReplace: function() {
      localStorage.setItem('activeMentionsAutoReplace', JSON.stringify(this.activeMentionsAutoReplace))
    },

    selectAllPages: function() {
      if(this.selectAllPages)
        this.bot = this.listPages.filter(p => !(!this.checkLock(p.page.network) || (!this.isUserPremiumActive && !this.isUserPartner) || (p.page.network == 'pinterest' && this.getBoardPagePinterest && this.getBoardPagePinterest != p.id) || (!p.status && !this.isConciergerie(p.page))))
                                  .map(p => p.id)
      else 
        this.bot = []
    },

    multipleImages: function() {
      if (this.multipleImages && this.multipleImages[0]) {
        this.form.file = this.multipleImages[0].file;
        this.filename = this.multipleImages[0].filename;
        this.url = this.multipleImages[0].url;
      }

      if(this.userTags && this.userTags.list.length) {
        this.userTags.list = this.userTags.list.map(l => {
          l.index = this.multipleImages.findIndex(i => i.id == l.image)
          return l
        }).filter(l => l.index >= 0)
      }
    },

    // multipleMedias: function() {
    //   this.videoReel = this.multipleMedias && this.multipleMedias.length > 1 ? false : true
    // },

    sharedStoryUrl: function() {
      if (/\/([a-zA-Z0-9_-]{11})/.test(this.sharedStoryUrl)) {
        console.log("sharedStoryUrl");
        this.getInfoInstagram({url: encodeURI(this.sharedStoryUrl), id: this.getPageInfoByBot(this.bot[0]).id }).then(res => {
          this.setStoryShare(res.body.info);
          this.form.enclosure = res.body.image.url;
          this.form.title = res.body.description;
          this.storificationObject = {
            username: res.body.username,
            isCarousel: res.body.isCarousel
          };

          if (this.storySharedVisual === true) {
            this.storySharedVisual = this.form.title;
          }
          this.$forceUpdate();
        })
      } else {
        this.storificationObject = null;
        this.form.enclosure = null;
        this.form.title = null;
        this.setStoryShare(null);

      }
    },

    groupsCopy: function(){
      this.groups = this.groupsCopy
      if(this.groups && this.groups.length){
        this.groups = this.groups.filter(group => group.pages.length)
        this.groups.forEach(g => {
          if(this.bots.filter(b => g.pages.includes(b.page.id) && this.bot.includes(b.id)).length == g.pages.length){
            if(!this.selectedGroups.includes(g.id)) {
              this.selectedGroups.push(g.id)
            }
          }
          else {
            if(this.selectedGroups.includes(g.id)) {
              this.selectedGroups.splice(this.selectedGroups.findIndex(s => s == g.id), 1) 
            }
          }
        })
      }
    },

    'scheduling.time': function() {
      let scheduleDate = moment().add(1, 'minutes').format()
      if((this.scheduling.time.HH && this.scheduling.time.HH != '' && parseInt(this.scheduling.time.HH) < 24) == false
            || (this.scheduling.time.mm && this.scheduling.time.mm != '' && parseInt(this.scheduling.time.mm) < 60) == false) {
        this.scheduling.date = moment.utc(scheduleDate).local().format()
        this.scheduling.lastScheduled = moment.utc(scheduleDate).local().format()
        this.scheduling.time.HH = moment.utc(scheduleDate).local().hour() < 10 
                                  ? `0${moment.utc(scheduleDate).local().hour()}`
                                  : `${moment.utc(scheduleDate).local().hour()}`
        this.scheduling.time.mm = moment.utc(scheduleDate).local().minute() < 10 
                                  ?`0${moment.utc(scheduleDate).local().minute()}`
                                  : `${moment.utc(scheduleDate).local().minute()}`
      }
    },

    'form.url': function(){
      if (!this.form.url) return
      let currentUrl = this.form.url
      setTimeout(() => {
        if(currentUrl == this.form.url){
          this.getNewsMeta(this.form.url).then(res => {
            const { success, meta } = res.body
            if (!success || success !== true) 
              this.meta = null
            this.meta = meta
          })
        }
      }, 500)
    },
    'form.title': function() {
      let message = this.form.title
      setTimeout(() => {
        if(this.form.title == message) this.formTitleCopy = this.form.title
      }, 500)
    },
    'form.comments': {
      handler(val, oldVal){
        this.$forceUpdate();
      },
      deep: true
    },
    samePageBots: function(val) {
      if(this.state !== 'edit-draft' && this.state !== 'new') {
        if (this.samePageBots && this.samePageBots.length)
          this.bot = this.samePageBots.filter(b => b && b.id).map(b => b.id)
        else 
          this.bot = []
      }
    },
    state: function() {
      this.fillForm()
    },
    post: function() {
      if(this.showAdd) {
        this.initForm()
        this.fillForm()
      }
    },
    scheduledOverlay: function(){
      this.initForm()
      this.fillForm()
      if((this.state === 'edit' && this.post.page && this.post.page.length && this.post.page[0].draft) == false)
        this.initSchedulingDate(this.scheduledOverlay.day, this.scheduledOverlay.hour, this.scheduledOverlay.minute)

      this.setRangeHourMinutes()
    },
    videoReel: async function(val, old){

      let limit = this.videoReel ? 15*60 : 60
      let {size, duration} = await this.getVideoInfo(this.form.video);
      if(duration > limit) {
        this.videoReel = old;
        this.notify({
          title: this.$t('dash.notifications.error_title'),
          text: this.$t('dash.notifications.limit_duration_file_exceeded'),
          color:'success',
          time: 10000,
          id: 'norepeat'
        })
        return;
      }
      let t = this.videoReel ? 'instagram_reel' : 'instagram';
      this.videos[t] = this.form.video;

      // eslint-disable-next-line no-useless-escape
      // if (this.typePost === 'video' && /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/.test(this.form.video) && this.atLeastInstagramSelected()) {
      //   let t = this.videoReel ? 'instagram_reel' : 'instagram'
      //   if (!this.videos[t]) {
      //     this.onUpload = true;
      //     this.videos[t] = 'encoding...';
      //     this.percentUpload = 0;
      //     this.messageUpload = this.$t("dash.message.convert.part2");
      //     this.normalizeVideo(t, this.form.video);
      //   }
      // }
    },
    videoReelFB: async function(val, old){

      let limit = this.videoReelFB ? 90 : 1200
      let {size, duration} = await this.getVideoInfo(this.form.video);
      if(duration > limit) {
        this.videoReelFB = old;
        this.notify({
          title: this.$t('dash.notifications.error_title'),
          text: this.$t('dash.notifications.limit_duration_file_exceeded'),
          color:'success',
          time: 10000,
          id: 'norepeat'
        })
        return;
      }
      let t = this.videoReelFB ? 'facebook_reel' : 'facebook';
      this.videos[t] = this.form.video;

      // eslint-disable-next-line no-useless-escape
      // if (this.typePost === 'video' && /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/.test(this.form.video) && this.atLeastFacebookSelected()) {
      //   let t = this.videoReelFB ? 'facebook_reel' : 'facebook'
      //   if (!this.videos[t]) {
      //     this.onUpload = true;
      //     this.videos[t] = 'encoding...';
      //     this.percentUpload = 0;
      //     this.messageUpload = this.$t("dash.message.convert.part2");
      //     this.normalizeVideo(t, this.form.video);
      //   }
      // }
    },
    bot: async function(val, old){
      if(val && val.length == 0) this.filterSelected = false
      if(this.bot.length == this.listPages.filter(p => !(!this.checkLock(p.page.network) || (!this.isUserPremiumActive && !this.isUserPartner) || (p.page.network == 'pinterest' && this.getBoardPagePinterest && this.getBoardPagePinterest != p.id) || (!p.status && !this.isConciergerie(p.page)))).length)
        this.selectAllPages = true
      if(this.state == 'edit' && this.typePost =='story' && old.length == 0) return

      //init interval scheduled time 5min on twitter
      this.minuteInterval = 1

      //init help button (optimalTimes)
      this.isDisable = false

      if(this.typePost === 'video' && !this.activeVideo) {
        this.typePost = 'standard'
        this.resetFields('standard')
      }
      
      // eslint-disable-next-line no-useless-escape
      if (this.typePost === 'video' && /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/.test(this.form.video)) {
        let difference = val.filter(x => !old.includes(x));
        if (difference.length > 0) {
          let t = this.bots.find(e => difference[0] === e.id).type;
          
          // let limit = ['tiktok', 'instagram'].includes(t) ? 60 : (t == 'twitter' ? 140 : (t == 'linkedin' ? 900 : 1200))
          let limit = t == 'tiktok' ? 60 : (t == 'instagram' ? (this.videoReel ? 15*60 : 60) : (t == 'twitter' ? 140 : (t == 'linkedin' ? 30*60 : 1200)))
          let min = ['tiktok', 'instagram'].includes(t) ? 3 : 1
          // let sizeLimit = t == 'tiktok' ? 50 : (t == 'instagram' ? 100 : (t == 'twitter' ? 512 : (t == 'linkedin' ? (this.hasStoryConfig ? 5000 : 200) : 1000)))
          let sizeLimit = t == 'tiktok' ? 50 : (t == 'instagram' ? 1000 : (t == 'twitter' ? 512 : (t == 'linkedin' ? (this.hasStoryConfigLinkedin ? 5000 : 200) : 1000)))

          if (t == 'instagram' && this.videoReel) {
            t = 'instagram_reel'
          }
          if (t == 'instagram' && this.storyVideo) {
            t = 'story'
          }

          if (t == 'facebook' && this.videoReelFB) {
            t = 'facebook_reel'
          }

          if (this.storyVideo && !this.videoReel) {
            limit = 30;
          }

          let {size, duration} = await this.getVideoInfo(this.form.video);

          if(min > duration || duration > limit || size > sizeLimit * 1024 * 1024) {
            this.bot = old;
            this.notify({
              title: this.$t('dash.notifications.error_title'),
              text: this.$t('dash.notifications.limit_duration_file_exceeded'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
            return;
          }
          this.videos[t] = this.form.video;
          // if (!this.videos[t]) {
          //     this.onUpload = true;
          //     this.videos[t] = 'encoding...';
          //     this.percentUpload = 0;
          //     this.messageUpload = this.$t("dash.message.convert.part2");
          //     this.normalizeVideo(t, this.form.video);
          // }
        } 
      }
      if(this.typePost == 'story' && !(this.activeInstagramStories && this.onlyInstagramSelected() && this.getPageInfoByBot(this.bot[0]).instagram_username)){
        this.typePost = 'standard'
        this.resetFields('standard')
      } else if (this.typePost == 'document' && !this.activeDocument) {
        console.log('document');
        this.typePost = 'standard'
        this.resetFields('standard')
      } else if (this.typePost !== 'video' && !this.standardPostEnabled() && !this.activeImage) {
        this.typePost = 'video'
        this.resetFields('video')
      } else if (this.typePost == 'standard' && !this.standardPostEnabled()) {
        this.typePost = 'image'
        this.resetFields('image')
      } else if (this.typePost == 'poll' && !this.activeDocument) {
        this.typePost = 'standard'
        this.resetFields('standard')
      }

      if(this.atLeastNetworkSelected('twitter') && this.state === 'new'){
        let botTwitter = this.bots.find(b => this.bot.includes(b.id) && b.type == 'twitter')
        if(botTwitter.storyTemplate && botTwitter.storyTemplate.reply_settings)
          this.twitterOptions = botTwitter.storyTemplate
      }

      if(this.atLeastTiktokSelected()){
        this.getTiktokRequirements(this.bots.find(b => this.bot.includes(b.id) && b.type == 'tiktok').id)
          .then(result => {
            if(result && result.body && result.body.creator_info){
              this.tiktokRequirements = result.body.creator_info
              this.tiktokOptions = {
                comment_disabled: this.tiktokRequirements.comment_disabled,
                duet_disabled: this.tiktokRequirements.duet_disabled,
                stitch_disabled: this.tiktokRequirements.stitch_disabled,
                privacy_level: this.tiktokRequirements.privacy_level_options[0]
              }
            }
            else {
              this.tiktokRequirements = {
                comment_disabled: false,
                duet_disabled: true,
                stitch_disabled: true,
                privacy_level: ["SELF_ONLY"],
                max_video_post_duration_sec: 600
              }

              // this.notify({
              //   title:'Erreur',
              //   text:this.$t('dash.error.token.tiktok'),
              //   color:'success',
              //   time: 10000,
              //   id: 'norepeat'
              // })
            }
          })
      }

      if(this.atLeastNetworkSelected('youtube')){
        this.getYoutubeCategories(this.bots.find(b => this.bot.includes(b.id) && b.type == 'youtube').id, this.$i18n.locale)
          .then(result => {
            if(result && result.body && result.body.categories){
              this.youtubeCategories = result.body.categories
            }
            else
              this.youtubeCategories = [{id:22, snippet: {title: "People & Blogs"}}]
          })
          .then(() => {
            this.getYoutubePlaylists(this.bots.find(b => this.bot.includes(b.id) && b.type == 'youtube').id)
            .then(resultPlaylists => {
              if(resultPlaylists && resultPlaylists.body && resultPlaylists.body.playlists){
                this.youtubePlaylists = resultPlaylists.body.playlists
              }
            })
          })

          
      }

      this.groups.forEach(g => {
        if(this.bots.filter(b => g.pages.includes(b.page.id) && this.bot.includes(b.id)).length == g.pages.length){
          if(!this.selectedGroups.includes(g.id) && document.getElementById(`group-${g.id}`)) {
            this.selectedGroups.push(g.id)
            document.getElementById(`group-${g.id}`).checked = true
          }
        }
        else {
          if(this.selectedGroups.includes(g.id) && document.getElementById(`group-${g.id}`)) {
            this.selectedGroups.splice(this.selectedGroups.findIndex(s => s == g.id), 1) 
            document.getElementById(`group-${g.id}`).checked = false
          }
        }
      })

      // update searchMentions if defined (add/remove RS)
      if(this.searchMention && this.searchMention.length){
        this.bot.forEach(bId => {
          let bot = this.bots.find(b => b.id == bId)
          if(bot && bot.type && !this.searchMention.find(m => m.bot.type == bot.type)){
            let searchMention = JSON.parse(JSON.stringify(this.searchMention[this.searchMention.length - 1]))
            searchMention.bot = bot
            this.searchMention.push(searchMention)
          }
        })
        if(this.searchMention.find(m => !this.bot.includes(m.bot.id))){
          let index = this.searchMention.findIndex(m => !this.bot.includes(m.bot.id))
          this.searchMention.splice(index, 1)
        }
      }

      // remove post if unselect page in edit post multi-pages
      let pageRemoved = old.filter(x => !val.includes(x));
      if (pageRemoved.length > 0 && this.state === 'edit' 
                && this.post.page && this.post.page.length && this.post.page[0].posts_multipages 
                && this.post.page[0].posts_multipages.find(p => p.bot == pageRemoved[0])) {
        let news = {...this.post}
        news.id = this.post.page[0].posts_multipages.find(p => p.bot == pageRemoved[0])._id
        news._id = news.id
        news.page[0].id = this.bots.find(b => b.id == pageRemoved[0]).uid
        news.page[0].network = this.bots.find(b => b.id == pageRemoved[0]).type
        news.page[0].post_number = this.post.page[0].posts_multipages.find(p => p.bot == pageRemoved[0]).postId
        news._bots = this.bots.filter(b => b.id == pageRemoved[0])
        const restorePage = () => {
          this.bot.push(pageRemoved[0])      
          this.$forceUpdate();
        }
        this.$vs.dialog({
          type:'confirm',
          color: 'danger',
          title: this.$t("dash.post.remove-scheduled.title"),
          text: this.$t("dash.post.remove-scheduled.content"),
          acceptText: this.$t("dash.response.yes"),
          accept: () => this.$emit('deleteScheduled', news, true),
          cancelText: this.$t("dash.response.no"),
          cancel: () => setTimeout(() => restorePage(), 500)
        })
      }

      // if multiMedias & add network not allowed
      let pageAdded = val.filter(x => !old.includes(x));
      // if(pageAdded.length && this.multipleMedias.length > 1 && (!this.onlyInstagramSelected())){
      if(pageAdded.length && this.multipleMedias.length > 1 && (!this.onlyListNetworkSelected(['instagram', 'threads']))){        
        let saveMedias = this.multipleMedias
        this.multipleMedias = []
        const removePage = () => {
          this.bot = this.bot.filter(b => b != pageAdded[0])   
          this.multipleMedias = saveMedias   
          this.$forceUpdate();
        }
        this.$vs.dialog({
          type:'confirm',
          color: 'danger',
          title: this.$t("dash.post.remove-multiple-medias.title"),
          text: this.$t("dash.post.remove-multiple-medias.content"),
          acceptText: this.$t("dash.response.yes"),
          accept: () => {
            this.multipleMedias = []
            this.videoReel = true
            this.videos['instagram_reel'] = this.form.video;
            // this.normalizeVideo('instagram_reel', this.form.video);
          },
          cancelText: this.$t("dash.response.no"),
          cancel: () => setTimeout(() => removePage(), 500)
        })
      }

      this.$emit('updatePages', this.bot)
    }
  },

  mounted() {
    moment.locale(this.$i18n.locale)
    localStorage.setItem('mentionsAdded', JSON.stringify([]))
    localStorage.setItem('hashtagsAdded', JSON.stringify([]))
    this.fetchUserInfo()
    this.$ga.page('/dash/posts/create')
    this.setPages()
    if (this.samePageBots && this.samePageBots.length) 
      this.bot = this.samePageBots.map(b => b.id)
    if (this.state !== 'new') {
      if (this.state !== 'edit' && this.state !== 'inqueue-edit')
        this.setPage()
      this.fillForm()
    }
    else
      this.bot = this.pages.map(p => this.bots.find(b => b.page.id == p).id)

    this.setRangeHourMinutes()

    if(this.scheduledOverlay && this.scheduledOverlay.day && ((this.state === 'edit' && this.post.page && this.post.page.length && this.post.page[0].draft) || this.state === 'edit-draft') == false)
      this.initSchedulingDate(this.scheduledOverlay.day, this.scheduledOverlay.hour, this.scheduledOverlay.minute)

    this.groups = this.groupsCopy
    if(this.groups && this.groups.length){
      this.groups = this.groups.filter(group => group.pages.length)
      this.groups.forEach(g => {
        if(this.bots.filter(b => g.pages.includes(b.page.id) && this.bot.includes(b.id)).length == g.pages.length){
          if(!this.selectedGroups.includes(g.id)) {
            this.selectedGroups.push(g.id)
          }
        }
        else {
          if(this.selectedGroups.includes(g.id)) {
            this.selectedGroups.splice(this.selectedGroups.findIndex(s => s == g.id), 1) 
          }
        }
      })
    }

    if(localStorage.activePrefixSuffix)
      this.activePrefixSuffix = JSON.parse(localStorage.activePrefixSuffix)
    if(localStorage.activeHashtagsAutoAdd)
      this.activeHashtagsAutoAdd = JSON.parse(localStorage.activeHashtagsAutoAdd)
    if(localStorage.activeMentionsAutoReplace)
      this.activeMentionsAutoReplace = JSON.parse(localStorage.activeMentionsAutoReplace)
  },

  data() {
    return {
      userTags: {
        list: [],
        collab: []
      },
      productTags: [],
      userTagPage: 0,
      storificationObject: null,
      storyMentions: [],
      bodyAddStorage: [],
      storyMultiple: [{id: uuidv4(), isActive: true}],
      selectedLocation: null,
      locations: [],
      selectedGifs: [],
      // selectedMusic: null,
      searchLocationInput: null,
      searchMusicInput: '',
      shareAfterPost: false,
      sharedStoryUrl: '',
      storySharedVisual: null,
      storyVideo: false,
      pollStory: null,
      sliderStory: null,
      sliderEmojiPicker: false,
      storyLinkText: '',
      snippetTitle: null,
      popupTitleSnippet: false,
      carouselPopupMessage: null,
      carouselOrderDragElement: null,
      snippet: null,
      poll: {
        question: '',
        options: ['', ''],
        duration: '604800',
      },
      layers: [],
      carrouselRatio: 4/5,
      multipleImages: [],
      multipleImagesOriginal: [],
      multipleMedias: [],
      carrouselInitialSwipe: [],
      carrouselTimeDrag: true,
      carrouselTimeOut: null,
      templateManual: null,
      instagramLinkPosition: {
        x: 160,
        y: 440,
        color: 0
      },
      highlightInstagram: null,
      instagramBackgroundColor: null,
      isPremiumInstagramAccount: true,
      isNewImage: true,
      // instagramTexts: [],
      instagramTextsUpdater: [],
      credentialsKnown: false,
      instagramUsername: '',
      instagramPassword: '',
      newBoardName : null,
      instagramCredentialsPopup: false,
      deleteStory: false,
      // Pages scroll
      scroll: false,
      scrollPos: 0,
      filename: this.$t('dash.message.no.file'),
      videoname: this.$t('dash.message.no.video'),
      isDisable: false,
      scheduling: {
        lastScheduled: null,
        show: false,
        // date: moment()
        //         .add(moment().minute()+12 >= 60 && moment().hour()+1 >23 ? 1 : 0, 'days')
        //         .hour(moment().minute()+12 >= 60 ? (moment().hour()+1 > 23 ? '00' : moment().hour()+1) : moment().hour())
        //         .minute(moment().minute()+12 >= 60 ? moment().minute()+12-60 : moment().minute()+12)
        //         .second(0),
        // date: moment().add(12, 'minutes').second(0),
        date: moment().add(1, 'minutes').second(0),
        time: {
          // HH: `${moment().minute()+12 >= 60 ? (moment().hour()+1 > 23 ? '00' : moment().hour()+1) : moment().hour()}`,
          // mm: `${moment().minute()+12 >= 60 ? `0${moment().minute()+12-60}` : moment().minute()+12}`
          HH: `${moment().minute()+1 >= 60 ? (moment().hour()+1 > 23 ? '00' : moment().hour()+1) : moment().hour()}`,
          mm: `${moment().minute()+1 >= 60 ? `0${moment().minute()+1-60}` : moment().minute()+1}`
        }
      },

      bot: [],

      form: {
        page: 0,
        name: null,
        url: '',
        boardSelected: null,
        description: null,
        file: null,
        date: null,
        time: null,
        title: '',
        video: null,
        documentTitle: null,
        comments: []
      },
      formTitleCopy: '',
      url: null,

      timerCheckStopTyping: null,

      tiktokRequirements: null,
      tiktokOptions: {
        comment_disabled: false,
        duet_disabled: true,
        stitch_disabled: true,
        privacy_level: "SELF_ONLY"
      },

      youtubeCategories: null,
      youtubePlaylists: null,
      youtubeOptions: {
        notifySubscribers: true,
        madeForKids: false,
        privacy_level: 'public',
        category : '22',
        tag: '',
        tags: [],
        playlist: null
      },
      twitterOptions: {
        reply_settings: null
      },
      facebookOptions: null,

      showEmojiPicker: false,
      showEmojiPickerInstagram: -1,
      showEmojiPickerComment: -1,

      emojiIndex: new EmojiIndex(emojiData),

      
      openHelpLimitEditing: false,
      openHelpLimitVideo: false,
      openHelpLimitImage: false,

      showConfirmPost: false,

      // rangeHour: [[moment().minute()+12 >= 60 ? (moment().hour()+1 > 23 ? 0 : moment().hour()+1) : moment().hour(), 23]],
      // rangeMinute: [[moment().minute()+12 >= 60 ? moment().minute()+12-60 : moment().minute()+12, 59]],
      rangeHour: [[moment().minute()+1 >= 60 ? (moment().hour()+1 > 23 ? 0 : moment().hour()+1) : moment().hour(), 23]],
      rangeMinute: [[moment().minute()+1 >= 60 ? moment().minute()+1-60 : moment().minute()+1, 59]],
      minuteInterval: 1,

      counterDanger: false,

      onUpload: false,
      percentUpload: 0,
      messageUpload: '',
      typePost: 'standard',
      keyRefresh: Math.random().toString(36),

      activeMentionsAutoReplace: true,
      activeHashtagsAutoAdd: true,
      activePrefixSuffix: true,

      optimalTimes: null,
      lastPageReporting: null,

      autoMentions: [],
      openAutoMentions: false,
      boards: null,
      searchMention: [],
      selectedBotMention: 0,
      validMentions: [],

      autoHashtags: [],
      openAutoHashtags: false,
      searchHashtag: [],
      selectedBotHashtag: 0,
      validHashtags: [],

      autoLocation: [],
      openAutoLocations: false,
      searchLocation: [],
      selectedBotLocation: 0,
      validLocation: [],

      autoMusic: [],
      openAutoMusics: false,
      searchMusic: [],
      selectedBotMusic: 0,
      validMusic: [],

      previewEdited: null,

      meta: null,

      editPostValue: [],
      currentPostFieldEdit: null,

      pageFilter: '',
      groups: [],
      selectedGroups: [],
      firstSelectGroup: true,
      showOptionsWrapper: false,
      // advancedTabs: true,
      filterSelected: true,
      selectAllPages: false,

      videos: {
        twitter: null,
        facebook: null,
        facebook_reel: null,
        linkedin: null,
        instagram: null,
        instagram_reel: null,
        story: null,
      },

      videoReel: true,
      videoReelFB: false,
      isCarrouselMix: false,

      lastNotif: {
        text: null,
        date: null
      },

      changePlanConciergerie: false,
      activeConciergerie: false,
      storyShareToFacebook: false,
      rsLimit: null,

      accrochesAI: null,
      openAccrochesAI: false,
      selectedAccroches: [],
      editPromptAccroches: null,

      showLoader: false,
      showPromptLoader: false,

      compressedImages: [],
      isThumbUpload: false,

      popupSelectUser: false,
      affectedTo: null,
      doScreenshot: false
    }
  },

  directives: {
    ClickOutside
  },

  beforeMount() {
    window.addEventListener('resize', this.setPages)
  }, 

  beforeDestroy() {

    if (localStorage['version_'] !== 'old') {
      this.$router.push({
          name: 'posts2'
      })
      return
    }
    
    window.removeEventListener('resize', this.setPages)
    const pagesSelected = this.bot.reduce((acc, botId)=> {

      const botConfig = this.bots.find(bot => bot.id == botId)
      if (botConfig && botConfig.page && botConfig.page.id && this.allPages[botConfig.page.id]) {
        acc.push(this.allPages[botConfig.page.id])
      }
     
      return acc
    },[])

    console.log("beforeDestroy page overlay",pagesSelected)
    this.$store.commit('selectPage/updatePagesSelected', { pagesId: pagesSelected.map(p => p.id)});
   
  },

  methods: {

    async checkChildsBoard() {
      let bot = this.bots.find(b => b.id == this.getBoardPagePinterest)
      this.form.boardSelected.childs = await this.getChildsBoardPinterest(bot.page, this.form.boardSelected.id)
      this.form.boardSelected.childs = this.form.boardSelected.childs.body
      this.form.boardSelected.childs.selected = null
      this.$forceUpdate()
    },

    isProd() {
      return process.env.VUE_APP_API_HOST == 'https://api.saas.mashup-web.com'
    },

    isAffectedPost() {
      return  !this.state.includes('duplicate-post') && (this.post && this.post.data && this.post.data.affectedTo 
                && ((this.post.data.affectedTo.user && this.post.data.affectedTo.user.id == this.getUserId()) 
                      || (this.post.data.affectedTo.users && this.post.data.affectedTo.users.find(u => u.id == this.getUserId()))))
              || (this.post && this.post.page && this.post.page.length && this.post.page[0].affectedTo 
                      && ((this.post.page[0].affectedTo.user && this.post.page[0].affectedTo.user.id == this.getUserId()) 
                            || (this.post.page[0].affectedTo.users && this.post.page[0].affectedTo.users.find(u => u.id == this.getUserId()))))
    },

    getUserId() {
      const user = localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null
      if(!user) return null
      return user.id      
    },

    async addAffectedToPost(users, optionValidation) {
      this.popupSelectUser = false
      if(users.length == 0) { 
        this.affectedTo = null
        return
      }
      this.affectedTo = {...users[0], optionValidation}
      if(users.length > 1)
        this.affectedTo.users = users
    },

    async screenshotStory() {
      let toFill = {};
      this.$store.dispatch(`emitData`, {message: "captureStoryScreenshot", data: toFill});
      await new Promise((resolve, reject) => {
        let compt = 0
        const interval = setInterval(() => {
          if (toFill.screenshot != null || compt > 30) {
            clearInterval(interval);
            resolve(toFill.screenshot);
          } else {
            console.log("Wainting Screenshot...");
          }
          compt++
        }, 500);
      });
      console.log(toFill.screenshot);
      this.$store.commit("updateStorificationScreenshot", toFill.screenshot);
    },

    addComment() {
      if(!this.form.comments) this.form.comments = []
      if(this.form.comments.every(c => c.trim() != ''))
        this.form.comments.push('')
      this.$forceUpdate();
    },

    removeComment(commentIdx) {
      this.form.comments.splice(commentIdx, 1);
      this.$forceUpdate();
    },

    storyAverageImageBackgroundColor() {
      // this.$refs.storymaker[0].getAverageImageBackground();
    },

    hideStoryText(idx, hide=true) {
      let text = [...this.instagramTexts];
      if (hide) {
        text[idx].x = -100;
        text[idx].y = -100;
        text[idx].hide = true;
      } else {
        let screenWidth = 324;
        let screenHeight = 576;
        text[idx].x = screenWidth / 2 - 15;
        text[idx].y = screenHeight / 2 - 50;
        text[idx].hide = false;
      }
      let w = text[idx].w;
      let h = text[idx].h;
      this.updateTextWithStory(text, idx, w, h);
    },

    hideMentionWidget(id, hide=true) {
      let mentionIdx = this.storyMentions.findIndex(e => e.pk === id);
      if (mentionIdx >= 0) {
        this.$set(this.storyMentions[mentionIdx], 'hide', hide);
        console.log(this.storyMentions[mentionIdx]);
      }
      
    },


    openMentionWidget() {
      console.log(this.$refs['searchMentionWidget']);
      this.$refs['searchMentionWidget'].show();
      this.searchMention = this.bots.filter(e => this.bot.includes(e.id) && e.page.network == "instagram" && e.page.story_config && e.page.story_config.created).map(bot => {
          return {
            bot,
            start: 0,
            end: 0,
            selected: null,
            search: '',
            results: null,
          }
        })
    },

    openHashtagWidget() {
      console.log(this.$refs['searchHashtagWidget']);
      this.$refs['searchHashtagWidget'].show();
      this.searchHashtag = this.bots.filter(e => this.bot.includes(e.id) && e.page.network == "instagram" && e.page.story_config && e.page.story_config.created).map(bot => {
          return {
            bot,
            start: 0,
            end: 0,
            selected: null,
            search: '',
            results: null,
          }
        })
    },

    removeMentionWidget(id) {
      this.storyMentions = this.storyMentions.filter(e => e.pk !== id);
    },

    addMentionWidget() {
      console.log("Add mention widget");
      this.$refs['searchMentionWidget'].close();
      const selected = this.searchMention[this.selectedBotMention].selected;
      console.log(selected);
      if (selected && selected.id) {
        delete selected.image;
        selected.color = 0;
        // this.storyMentions.push(selected);
        this.$store.commit("addStorificationMention", selected);
      }
    },

    addHashtagWidget() {
      console.log("Add hashtag widget");
      this.$refs['searchHashtagWidget'].close();
      let selected = this.searchHashtag[this.selectedBotMention].selected;
      console.log(selected);
      if (selected && selected.length) {
        // this.storyMentions.push(selected);
        console.log(selected);
        this.$store.commit("addStorificationHashtag", selected);
      }
    },
    
    insertGif(gif) {
      console.log("GIF to insert : ", gif);
      // this.selectedGifs.push(gif);
      this.videoReel && this.typePost === 'video' ? this.$store.commit('addStorificationGifReel', gif) : this.$store.commit('addStorificationGif', gif);
      this.storyVideo = true;
    },

    initTooltip() {
      // document.querySelector(`.vs-tooltip`).remove()
    },

    checkStopTyping() {
      //actually not used (called on @keyup textarea)
      clearTimeout(this.timerCheckStopTyping);

      this.timerCheckStopTyping = setTimeout(async () => {
        let selectionStart = this.$refs.inputTitle.selectionStart
        let selectionEnd = this.$refs.inputTitle.selectionEnd
        this.$refs.inputTitle.blur()
        await this.$nextTick()
        this.$refs.inputTitle.focus()
        this.$nextTick(() => {
          this.$refs.inputTitle.selectionStart = selectionStart
          this.$refs.inputTitle.selectionEnd = selectionEnd
        });
      }, 500);
    },

    textAreaAdjust(element) {
      document.getElementById(element).style.height = "1px";
      document.getElementById(element).style.height = (25+document.getElementById(element).scrollHeight)+"px";
    },

    allTextAreasAdjust() {
      let textareas = document.getElementsByTagName('textarea')
      textareas.forEach(t => {
        t.style.height = "1px";
        t.style.height = (25+t.scrollHeight)+"px";
      })
    },

    setMusicStartTime(time) {
      if (this.selectedMusic) {
        // this.selectedMusic = {...this.selectedMusic, startTime: time};
      }
    },

    async setMusicDuration(duration) {
      if (this.selectedMusic) {
        if (!duration) {
          duration = 15000;
          if (this.$refs.myVideo && this.$refs.myVideo.files && this.$refs.myVideo.files[0]) {
            console.log("ICI")
            duration = await new Promise((resolve, reject) => {
              console.log("LAA")
              let video = document.createElement('video');
              video.preload = 'metadata';
              video.onloadedmetadata = function() {
                window.URL.revokeObjectURL(video.src);
                console.log(video.duration)
                return resolve(video.duration*1000);
              }
              video.src = URL.createObjectURL(this.$refs.myVideo.files[0]);
            })
          }            
        }
        console.log("Duration: ",duration);
        this.videoReel && this.typePost === 'video' ? this.$store.commit("updateStorificationMusicReel", {duration}) : this.$store.commit("updateStorificationMusic", {duration});
        // this.selectedMusic = {...this.selectedMusic, duration};
      }
    },

    toggleMusicConfig(value) {
      if (value === false) {
        // let {start, duration} = this.$refs.storymaker[0].getMusicInformations();
        // this.setMusicStartTime(start);
        // this.setMusicDuration(duration);
      }
      // this.selectedMusic = {...this.selectedMusic, config: value}
    },

    removeMusic() {
      // this.selectedMusic = null;
      this.videoReel && this.typePost === 'video' ? this.$store.commit("updateStorificationMusicReel", null) : this.$store.commit("updateStorificationMusic", null);
      if (!this.form.video) {
        this.storyVideo = false;
      }
    },

    mentionMusicPreview(e, music, state) {
      e.stopPropagation();
      let audio = this.$refs[`music-preview-mention`]
      console.log(audio, music, state)
      audio.pause();
      if (state === 'play') {
        audio.src = music.track.progressive_download_url;
        audio.currentTime = music.track.highlight_start_times_in_ms[0]/1000
        audio.play();
      }
      this.$forceUpdate();
      // for (let k = 0; k < this.searchMusic[this.selectedBotMusic].results.length; k++) {
      //   let audio = this.$refs[`music-${idx}`]
      //   console.log(audio, idx, k)
      //   if (k === idx) {
      //     if (audio[0].paused) {
      //       console.log("play");
      //       audio[0].play();
      //     } else {
      //       audio[0].pause();
      //     }
      //   } else {
      //     if (!audio[0].paused) {
      //       audio[0].pause();
      //     }
      //   } 
      // }

    },

    changeLinkColorStory(color) {
      console.log('color',color);
      this.$set(this.instagramLinkPosition, "color", color || 0);
    },

    changeSliderColorStory(color) {
      console.log('color',color);
      this.$set(this.sliderStory, "color", color);
    },
    
    cheekDialogOutsideClose(event) {
      var rect = event.target.getBoundingClientRect();
      var isInDialog=(rect.top <= event.clientY && event.clientY <= rect.top + rect.height
        && rect.left <= event.clientX && event.clientX <= rect.left + rect.width);
      if (!isInDialog) {
          event.target.close();
      }
    },

    openTag(collab=false, product=false) {
      console.log("opentag");

      if(collab || product)
        this.selectedBotMention = this.searchMention.findIndex(s => s.bot.type == 'instagram')
      
       if (this.typePost === 'image') {
        //need to choose location
        if (this.url || (this.meta && this.meta.og && this.meta.og.image)) {
          if (collab) this.$refs['tagImage'].setAttribute("data-collab", collab);
          if (product) {
            this.$refs['tagImage'].setAttribute("data-product", product);
            this.$refs['tagImage'].show();
            return;
          }
          this.$refs['tagImage'].showModal();
        }
      } else {
        // direct open mention
        if (collab) this.$refs['searchTag'].setAttribute("data-collab", collab);
        if (product) {
          this.$refs['tagImage'].setAttribute("data-product", product);
          this.$refs["shop-tag"].addShop();
        } else {
          this.$refs['searchTag'].show();
          this.searchMention = this.bots.filter(e => this.bot.includes(e.id) && (/* e.page.network == "facebook" ||  */(e.page.network == "instagram" && e.page.story_config && e.page.story_config.created))).map(bot => {
            return {
              bot,
              start: 0,
              end: 0,
              selected: null,
              search: '',
              results: null,
            }
          })
          console.log(this.searchMention);
        }
        
      }
      
    },

    closeTagImage() {
      this.$refs['tagImage'].close()
      this.$refs["shop-tag"].shopIsOpen = false;
      this.$refs['tagImage'].removeAttribute("data-collab");
      this.$refs['tagImage'].removeAttribute("data-product");
    },

    tagImageLocation(event) {
      console.log("tagImageLocation");
      console.log(event);
      if (!event.target) {
        event.target = document.getElementById(`tagImg${event.index}`)
        event.offsetX = parseFloat(event.target.getAttribute("data-offsetX"))
        event.offsetY = parseFloat(event.target.getAttribute("data-offsetY"))
      }
      console.log(event);
      let x = event.offsetX/event.target.offsetWidth;
      let y = (event.offsetY+3)/event.target.offsetHeight;
      console.log(x, y);
      const isProduct = this.$refs['tagImage'].getAttribute("data-product");
      if (isProduct) {
        console.log(this.$refs['tagImage'].getBoundingClientRect())
        let rect = this.$refs['tagImage'].getBoundingClientRect();
        this.$refs["shop-tag"].$refs['searchTagImgShop'].setAttribute("data-x", x);
        this.$refs["shop-tag"].$refs['searchTagImgShop'].setAttribute("data-y", y);
        this.$refs["shop-tag"].$refs['searchTagImgShop'].setAttribute("data-index", event.index);
        this.$refs["shop-tag"].$refs['searchTagImgShop'].style.top = rect.y + (y*rect.height) + "px";
        this.$refs["shop-tag"].$refs['searchTagImgShop'].style.left = rect.x + (x*rect.width) + 300 + "px";
        this.$refs["shop-tag"].addShop();
        return;
      }
      const collab = this.$refs['tagImage'].getAttribute("data-collab");
      this.$refs['searchTagImg'].setAttribute("data-collab", collab);
      this.$refs['searchTagImg'].setAttribute("data-x", x);
      this.$refs['searchTagImg'].setAttribute("data-y", y);
      this.$refs['searchTagImg'].setAttribute("data-index", event.index);
      this.$refs['searchTagImg'].style.top = (y*100) + "%";
      this.$refs['searchTagImg'].style.left = (x*100) + "%";
      this.$refs['searchTagImg'].show();
      this.searchMention = this.bots.filter(e => this.bot.includes(e.id) && e.page.network == "instagram" && e.page.story_config && e.page.story_config.created).map(bot => {
        return {
          bot,
          start: 0,
          end: 0,
          selected: null,
          search: '',
          results: null,
        }
      })
    },

    addTag(refName) {
      this.$refs[refName].close();
      const collab = this.$refs[refName].getAttribute("data-collab");
      const x = this.$refs[refName].getAttribute("data-x");
      const y = this.$refs[refName].getAttribute("data-y");
      const index = (!this.multipleImages || this.multipleImages.length) < 2 ? 0 : parseInt(this.$refs[refName].getAttribute("data-index"));
      this.$refs[refName].removeAttribute("data-collab");
      const selected = this.searchMention[this.selectedBotMention].selected;
      console.log(selected, !!collab, this.userTags);
      if (selected && selected.id) {
        this.userTags.list.push({
          id: selected.pk || selected.id,
          name: selected.name,
          username: selected.id,
          x: x || undefined,
          y: y || undefined,
          index: index || 0,
          image: this.multipleImages[index].id
        })
        if (collab && collab !== 'null') {
          // if (this.userTags.collab) this.removeTag(this.userTags.collab);
          this.userTags.collab.push(selected.pk || selected.id);
        }
      }
    },

    addTagProduct(product) {
      console.log("addTagProduct",product);
      const x = this.$refs["shop-tag"].$refs["searchTagImgShop"].getAttribute("data-x");
      const y = this.$refs["shop-tag"].$refs["searchTagImgShop"].getAttribute("data-y");
      const index = (!this.multipleImages || this.multipleImages.length) < 2 ? 0 : parseInt(this.$refs["shop-tag"].$refs["searchTagImgShop"].getAttribute("data-index"));
      this.productTags.push({
        id: product.id,
        merchantId: product.merchantId,
        text: product.text,
        image: product.image,
        variant: product.variant,
        description: product.description,
        x,
        y,
        index
      })
      this.$store.commit('updateStorificationProduct', {items: this.productTags})

    },

    removeTagProduct(id) {
      this.productTags = this.productTags.filter(e => e.id !== id);
    },

    removeTag(id) {
      this.userTags.list = this.userTags.list.filter(e => e.id !== id);
      this.userTags.collab = this.userTags.collab.filter(e => e !== id);
      // if (this.userTags.collab === id) {
      //   this.userTags.collab = null;
      // }
    },

    setRangeHourMinutes(){
      const today = moment().hour(0).minute(0).second(0)
        console.log('date', today.unix(), moment(this.scheduledOverlay.day).unix())
      if(today.unix() == moment(this.scheduledOverlay.day).unix()){
        this.rangeHour = [
          [
            // moment().minute()+12 >= 60 
            moment().minute()+1 >= 60 
              ? (moment().hour()+1 > 23 ? 0 : moment().hour()+1) 
              : moment().hour(), 
            23
          ]
        ]
        this.rangeMinute = [
          [
            // moment().minute()+12 >= 60 
            //   ? `0${moment().minute()+12-60}` 
            //   : moment().minute()+12, 
            // 59
            moment().minute()+1 >= 60 
              ? `0${moment().minute()+1-60}` 
              : moment().minute()+1, 
            59
          ]
        ]
      }
      else {
        this.rangeHour = [[0, 23]]
        this.rangeMinute = [[0, 59]]
      }
    },

    async getAccrochesByAI(edit=false) {
      let search = this.form.title
      if(edit) 
        search = this.editPromptAccroches   
      else 
        this.editPromptAccroches = this.form.title
      
      if(!search.length && this.form.url.length && this.meta) {
        search = this.meta.og && this.meta.og.title ? this.meta.og.title : this.meta.meta.title
        search += `\n${this.meta.og && this.meta.og.description ? this.meta.og.description : this.meta.meta.description}`
      }

      if(search.length) {
        this.showLoader = true
        this.accrochesAI = []
        if(edit)
          this.showPromptLoader = true
        this.generateTextByAI(search).then(res => {
          
          this.showLoader = false
          if(edit)
            this.showPromptLoader = false

          if(res && res.body && res.body.success){
            this.accrochesAI = res.body.accoches
            this.openAccrochesAI = true
          }
          else
            this.notify({
              title:'Erreur',
              text:JSON.stringify(res.body),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
        })
      }
      else {
        this.accrochesAI = []
        this.openAccrochesAI = true
      }
    },

    changeTextByGenerated() {
      this.form.title = ''
      this.selectedAccroches.forEach(accroche =>{
        this.form.title += accroche + '\n\n'
      })
      this.openAccrochesAI = false
      this.accrochesAI = null
    },

    isConciergerie(page) {
      // let isLocked = await this.checkLockDirectApi(page);
      return page.story_config && page.story_config.created && (!page.story_config.lock || page.story_config.lock < Date.now());
    },

    limitTextByBot(bot){
      let limitText = null

      let maxHashtagLength = 0
      let maxHashtagPrefixLength = 0

      if(this.activePrefixSuffix){
        if(bot.hashtag && bot.hashtag.length > maxHashtagLength)
          maxHashtagLength = bot.hashtag.length
        if(bot.hashtagPrefix && bot.hashtagPrefix.length > maxHashtagPrefixLength)
          maxHashtagPrefixLength = bot.hashtagPrefix.length
      }

      if(bot.page.network == 'youtube') {
        limitText = 100
      } else if(bot.page.network == 'twitter') {
        // limitText = 280
        limitText = !bot.page.story_config || bot.page.story_config.verified_type == 'none' ? 280 : 25000

        const isRemoveUrlInMessageToPost = (bot) => {
          let indexEdit = this.editPostValue ? this.editPostValue.findIndex(p => p.page == bot.page.id) : null
          return indexEdit >= 0 && this.editPostValue[indexEdit] ? this.editPostValue[indexEdit].removeUrlInMessage : false
        }

        if(this.form.url && !isRemoveUrlInMessageToPost(bot))
          limitText = limitText - 23 - 1 //- 2

        // let regexUrl = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|www\.[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z\u00C0-\u017F0-9]+\.[^\s]{2,}|www\.[a-zA-Z\u00C0-\u017F0-9]+\.[^\s]{2,})/g
        // if(this.form.title && this.form.title.match(regexUrl))
        //   limitText = limitText - (23 * this.form.title.match(regexUrl).length)

        // // € counted as char*2
        // let regex = /€|•/gi
        // while (this.form.title && regex.exec(this.form.title)) 
        //   limitText--
      } else if(bot.page.network == 'bluesky') {
        limitText = 300
      } else if(bot.page.network == 'threads') {
        limitText = 500
      } else if(bot.page.network == 'google') {
        limitText = 1300
      } else if (bot.page.network == 'instagram') {
        limitText = 2200;
      } else if (bot.page.network == 'linkedin') {
        limitText = 3000;
      } else if (bot.page.network == 'facebook') {
        limitText = 63206;
      }
      
      if(this.activePrefixSuffix){
        if(maxHashtagLength > 0)
          limitText = limitText - maxHashtagLength - 1
        if(maxHashtagPrefixLength > 0)
          limitText = limitText - maxHashtagPrefixLength - 1
      }

      if(limitText && bot.page.network != 'twitter' && ['image', 'video'].includes(this.typePost) && this.form.url && this.form.url != '')
        limitText = limitText - this.form.url.length

      return limitText
    },

    getPagesEvent() {
      this.$emit("getPagesEvent");
    },

    closeActiveConciergerie() {
      this.activeConciergerie = false
    },

    async getVideoInfo(videoUrl) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('HEAD', videoUrl);
        xhr.onload = function() {
          const size = xhr.getResponseHeader('Content-Length');
          const video = document.createElement('video');
          video.src = videoUrl;
          video.addEventListener('loadedmetadata', function() {
            const duration = video.duration;
            resolve({ size: size, duration: duration });
          });
        };
        xhr.onerror = function() {
          reject(new Error('Error getting video information'));
        };
        xhr.send();
      });
    },

    cancelStory() {
      this.isNewImage = true; 
      this.url = null; 
      this.form.url = null; 
      this.form.file = null;
      this.form.enclosure= null; 
      this.form.title = '';
      this.form.description = '';
      // this.instagramTexts = []; 
      this.filename = 'No file selected'; 
      this.layers = []; 
      this.form.video = null; 
      this.storyVideo=false;
      this.shareAfterPost = false;
      this.sharedStoryUrl = '';
      this.storySharedVisual = null;
      this.instagramLinkPosition = {
        x: 160,
        y: 440,
        color: 0
      }
      this.storyLinkText = '';
      this.pollStory = null;
      this.sliderStory = null;
      this.templateManual = null;
      this.storyShareToFacebook = false;
      // this.selectedMusic = null;
      this.selectedGifs = [];
      this.storyMentions = [];
      this.setStoryShare(null);
    },

    removeMultipleStory(e, idx) {
      e.stopPropagation();
      let active = (this.storyMultiple[idx].isActive);
      this.storyMultiple.splice(idx, 1);
      if (active) {
        this.selectMultipleStory(idx > this.storyMultiple.length-1 ? this.storyMultiple.length-1 : idx)
      }
      
    },

    addMultipleStory() {
      this.storyMultiple.push({id: uuidv4(), isActive: false})
      this.selectMultipleStory(this.storyMultiple.length-1)
    },

    async selectMultipleStory(index) {
      let currentIndex = this.storyMultiple.findIndex(e => e.isActive);
      this.storyMultiple = this.storyMultiple.map((e, idx) => {
        e.isActive = (idx === index);
        return e;
      })
      if (currentIndex >= 0) {
        await this.fillMultipleStory(currentIndex);
      }
      await this.getMultipleStory(index);
      // this.$refs.storymaker[0].updateGifs(this.selectedGifs)
      // this.$refs.storymaker[0].updateMentionsWidget(this.storyMentions)
    },

    async getMultipleStory(index) {
      console.log("GET",this.storyMultiple[index], index)
      if (this.storyMultiple[index].story) {
        await this.$nextTick()
        console.log("GET",this.storyMultiple[index].story.giftsStory, index)
        console.log(this.storyMultiple[index].story);
        let story = this.storyMultiple[index].story;
        this.form.title = story.title;
        // this.$refs.storymaker[0].imageNoUrl = story.imageNoUrl;
        this.form.url = story.url;  
        this.form.description = story.description;
        this.form.file = null;
        this.form.enclosure = story.enclosure ? `${story.enclosure}` : null;
        // console.log("GET MULTIPLE STORY form.enclosure", this.form.enclosure);
        this.form.video = story.video;
        this.storyVideo = story.storyVideo;
        console.log(typeof story.enclosure,story.enclosure );
        if (story.enclosure && typeof story.enclosure !== 'string' && story.enclosure.type !== 'video/mp4') {
          this.selectStoryFile(story.enclosure);
        } else if (story.enclosure && typeof story.enclosure === 'string' && story.enclosure.includes("http")) {

          // Copy to avoid reference errors
          let file = await this.urlToFile(story.enclosure + "")
          this.form.file = file;
          // Assume file is uploaded if there is one, as this is only executed when switching already existing story
          //console.log("GET MULTIPLE STORY form.file", this.form.file);
          // if (this.form.file) this.form.fileUploaded = true;
          //! Removed because images are already uploaded
          // this.form.enclosure = file;
          // this.selectStoryFile(file);

        }
        // this.instagramBackgroundColor = story.background_color;
        // this.highlightInstagram = story.highlight;
        this.storyShare = story.sharedStory;
        this.storySharedVisual = story.sharedVisual;
        this.sharedStoryUrl = story.sharedStoryUrl;
        // this.instagramLinkPosition = story.link;
        // this.templateManual = story.template;
        // this.layers = story.layers;
        // this.pollStory = story.poll ? JSON.parse(story.poll) : null;
        // this.sliderStory = story.slider ? JSON.parse(story.slider) : null;
        // this.storyLinkText = story.linkText;
        this.storyShareToFacebook = story.shareToFacebook;
        // if (story.giftsStory) {
        //   this.selectedGifs = story.giftsStory;
        // }
        // if (story.musicStory) {
          // this.selectedMusic = story.musicStory;
        // }
        // if (story.mentionsWidget) {
        //   this.storyMentions = story.mentionsWidget
        // }
        this.$store.commit("updateStorification", story.storificationData);

        if (story.story_instagram.length > 0) {
          this.instagramTextsUpdater = [];
        }
        for (let txt of story.story_instagram) {
          this.instagramTextsUpdater.push({
            x: txt.x,
            y: txt.y,
            color: txt.color,
            size: txt.size - 2,
            font: txt.font,
            background: txt.background,
            angle: txt.angle,
            w: txt.w,
            h: txt.h,
            content: txt.content
          });
        }
      }
    },

    async fillMultipleStory(index) {
      // this.layers = await this.$refs.storymaker[0].getLayersInformations();
      // this.selectedGifs = await this.$refs.storymaker[0].getGifsInformations();
      // this.storyMentions = await this.$refs.storymaker[0].getMentionsWidgetInformations();
      console.log(this.form.enclosure)

      // if (this.form.file) {
      //   this.form.enclosure = null;
      // // eslint-disable-next-line no-useless-escape
      // } else
      if (!this.form.file && this.form.enclosure && this.form.enclosure != '' && this.form.enclosure !== 'null' && !/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gm.test(this.form.enclosure)) {
        this.form.file = this.base64toFile(`${this.form.enclosure}`, 'instagram_picture')
      }

      // if (this.reverseBot.length > 1 && this.highlightInstagram) {
      //     this.highlightInstagram = null;
      // }
      if (this.reverseBot.length > 1 && this.$store.getters.storificationHightlight) {
          this.$store.commit("updateStorificationHightlight", null);
      }

      // if (this.pollStory && this.typePost === 'story') {
      //   if (!this.pollStory.question) this.pollStory.question = "Question ?";
      //   if (!this.pollStory.options[0]) this.pollStory.options[0] = "OUI";
      //   if (!this.pollStory.options[1]) this.pollStory.options[1] = "NON";
      //   console.log(this.$refs.storymaker);
      //   let el1 = this.$refs.storymaker[0].$el.querySelector('#poll-option-1')
      //   let el2 = this.$refs.storymaker[0].$el.querySelector('#poll-option-2')
      //   this.pollStory.size = [el1.style.fontSize, el2.style.fontSize]
      // }
      // if (this.sliderStory && this.typePost === 'story') {
      //   if (!this.sliderStory.question) this.sliderStory.question = "";
      //   if (!this.sliderStory.emoji) this.sliderStory.emoji = "😍";
      //   if (!this.sliderStory.color) this.sliderStory.color = "#ffffff";

      // }
      let instaTextMention = []
      for (let txt of this.instagramTexts) {
        this.form.title = txt.content;
        if (txt.content) {
          instaTextMention.push({
            x: txt.x,
            y: txt.y,
            content: txt.content,
            color: txt.color,
            size: txt.size + 2,
            font: txt.font,
            background: txt.background,
            angle: txt.angle, 
            w: txt.w,
            h: txt.h,
          })
        }
      }
      this.storyMultiple[index].story = {
        title: this.getMessage(this.bot[0]),
        url: this.validURL(this.form.url) ? this.form.url : '',  
        description: this.form.description || null,
        enclosure: this.form.enclosure ? `${this.form.enclosure}` : null,
        video: this.form.video,
        storyVideo: this.storyVideo,
        // background_color: this.instagramBackgroundColor,
        // highlight: this.highlightInstagram || null,
        sharedStory: this.storyShare,
        sharedVisual: this.storySharedVisual,
        sharedStoryUrl: this.sharedStoryUrl,
        // imageNoUrl: this.$refs.storymaker[0].imageNoUrl,
        story_instagram: instaTextMention,
        storificationData: this.$store.getters.storification, 
        // link: {
        //   x: this.instagramLinkPosition.x,
        //   y: this.instagramLinkPosition.y,
        //   color: this.instagramLinkPosition.color
        // },
        // template: this.templateManual || null,
        // layers: this.layers,
        // poll: this.pollStory ? JSON.stringify(this.pollStory) : null,
        // slider: this.sliderStory ? JSON.stringify(this.sliderStory) : null,
        // linkText: this.storyLinkText || null,
        shareToFacebook: this.storyShareToFacebook,
        // musicStory: this.selectedMusic,
        // giftsStory: this.selectedGifs,
        // mentionsWidget: this.storyMentions,
        // screenshot
      }
      this.cleanMultipleStory();
      console.log('FILL',this.storyMultiple, this.storyMultiple[0].story.enclosure);
    },

    cleanMultipleStory() {
      // this.$refs.storymaker.forEach(e => e.resetStory());
      console.log("cleanMultipleStory");
      this.$store.dispatch('resetStorification'); 
      this.$store.dispatch('emitData', {message: 'resetStory'});
    },

    setStoryShare(value) {
      this.$emit("setStoryShare", value);
    },

    getInstagramMediaInfoByAPI(page, id) {
      return new Promise((resolve, reject) => {
        this.getInstagramMediaInfo(page, id).then(res => {
          console.log(res.body, res);
          if (res.body.error) {
            resolve(res);
          }
          resolve(res.body)
        });
      })
    },

    getLocationsByApi(id, search) {
      console.log(search, this.bots.filter(e => this.bot.includes(e.id) && (e.type === 'instagram' || e.type === 'facebook'))[0].page);
      return new Promise((resolve, reject) => {
        this.getLocation(id, search).then(res => {
          console.log(res.body, res);
          if (res.body.error) {
            resolve(res);
          }
          resolve({body: {word: search, locations: res.body.locations}})
        });
      })      
    },

    getMusicsByApi(id, search) {
      console.log(search, this.bots.filter(e => this.bot.includes(e.id) && e.type === 'instagram')[0].page);
      return new Promise((resolve, reject) => {
//         resolve({"body": {
//     "success": true,
//     "musics": [
//   {
//     "track": {
//       "audio_cluster_id": "1931013540244347",
//       "id": "467704953900320",
//       "title": "Could You Be Loved",
//       "sanitized_title": null,
//       "subtitle": "",
//       "display_artist": "Bob Marley & The Wailers",
//       "artist_id": null,
//       "cover_artwork_uri": "https://cdn.fbsbx.com/v/t65.14500-21/89028193_2646074722346052_2650436610558001152_n.jpg?stp=dst-jpg_p526x296&_nc_cat=1&ccb=1-7&_nc_sid=cbead8&_nc_ohc=Rpausjz2MNgAX-SR3Ov&_nc_ht=cdn.fbsbx.com&oh=00_AfAGZv00yTx4HEocKcWrFcCFsOHrHnNTW8lWwB_GWfc7ww&oe=649C8AE3",
//       "cover_artwork_thumbnail_uri": "https://cdn.fbsbx.com/v/t65.14500-21/89028193_2646074722346052_2650436610558001152_n.jpg?stp=dst-jpg_s168x128&_nc_cat=1&ccb=1-7&_nc_sid=cbead8&_nc_ohc=Rpausjz2MNgAX-SR3Ov&_nc_ht=cdn.fbsbx.com&oh=00_AfBuronljDpnivjKzSBtbaI9V9O1fcLR-FcE-ujSnfsKTA&oe=649C8AE3",
//       "progressive_download_url": "https://scontent-ams4-1.xx.fbcdn.net/v/t39.12897-6/233564097_699309657633530_2778513712732670503_n.m4a?_nc_cat=101&ccb=1-7&_nc_sid=02c1ff&_nc_ohc=BKVDO8A79lEAX-7dEsC&_nc_oc=AQlmu43NVhZVXpKmJakDj0y5m3bWCxA114xShtu0zaEmdO8OTkusJY2bwVGP0moHiHY&_nc_ad=z-m&_nc_cid=0&_nc_ht=scontent-ams4-1.xx&oh=00_AfDm_KuwhxH4DZba0ap4pQWOSk5JZ9E3OlckKN2g-XjA-w&oe=64A03080",
//       "fast_start_progressive_download_url": "https://scontent-ams4-1.xx.fbcdn.net/v/t39.12897-6/233564097_699309657633530_2778513712732670503_n.m4a?_nc_cat=101&ccb=1-7&_nc_sid=02c1ff&_nc_ohc=BKVDO8A79lEAX-7dEsC&_nc_oc=AQlmu43NVhZVXpKmJakDj0y5m3bWCxA114xShtu0zaEmdO8OTkusJY2bwVGP0moHiHY&_nc_ad=z-m&_nc_cid=0&_nc_ht=scontent-ams4-1.xx&oh=00_AfDm_KuwhxH4DZba0ap4pQWOSk5JZ9E3OlckKN2g-XjA-w&oe=64A03080",
//       "web_30s_preview_download_url": null,
//       "reactive_audio_download_url": null,
//       "highlight_start_times_in_ms": [
//         15000,
//         61500,
//         34000
//       ],
//       "is_explicit": false,
//       "dash_manifest": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<!--Generated with https://github.com/google/shaka-packager version v1.6.0-release-->\n<MPD xmlns=\"urn:mpeg:dash:schema:mpd:2011\" xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:cenc=\"urn:mpeg:cenc:2013\" xsi:schemaLocation=\"urn:mpeg:dash:schema:mpd:2011 DASH-MPD.xsd\" profiles=\"urn:mpeg:dash:profile:isoff-on-demand:2011\" minBufferTime=\"PT2S\" type=\"static\" mediaPresentationDuration=\"PT236.989S\">\n  <Period id=\"0\">\n    <AdaptationSet id=\"0\" contentType=\"audio\" subsegmentAlignment=\"true\">\n      <Representation id=\"0\" bandwidth=\"130002\" codecs=\"mp4a.40.2\" mimeType=\"audio/mp4\" audioSamplingRate=\"48000\">\n        <AudioChannelConfiguration schemeIdUri=\"urn:mpeg:dash:23003:3:audio_channel_configuration:2011\" value=\"2\"/>\n        <BaseURL>https://scontent-ams2-1.xx.fbcdn.net/v/t39.12897-6/84675786_2199545467007792_8016398643705675776_n.m4a?_nc_cat=1&amp;ccb=1-7&amp;_nc_sid=02c1ff&amp;_nc_ohc=-NPNticUEQgAX8hUJqE&amp;_nc_ad=z-m&amp;_nc_cid=0&amp;_nc_ht=scontent-ams2-1.xx&amp;oh=00_AfClAjNUgpHhcKvfh2-0ULHeMpM_85bWMDwE4zGCIowMJQ&amp;oe=64A020B3</BaseURL>\n        <SegmentBase indexRange=\"741-2200\" timescale=\"48000\">\n          <Initialization range=\"0-740\"/>\n        </SegmentBase>\n      </Representation>\n    </AdaptationSet>\n  </Period>\n</MPD>\n",
//       "has_lyrics": true,
//       "audio_asset_id": "467704953900320",
//       "duration_in_ms": 236946,
//       "dark_message": null,
//       "allows_saving": true,
//       "ig_username": null
//     },
//     "metadata": {
//       "is_bookmarked": false,
//       "allow_media_creation_with_music": true,
//       "is_trending_in_clips": false
//     },
//     "alacorn_session_id": "0mN7NSLMCAavYgXDI3635"
//   },
//   {
//     "track": {
//       "audio_cluster_id": "190596465112130",
//       "id": "603239956894006",
//       "title": "Stir It Up",
//       "sanitized_title": null,
//       "subtitle": "",
//       "display_artist": "Bob Marley & The Wailers",
//       "artist_id": null,
//       "cover_artwork_uri": "https://cdn.fbsbx.com/v/t65.14500-21/89028193_2646074722346052_2650436610558001152_n.jpg?stp=dst-jpg_p526x296&_nc_cat=1&ccb=1-7&_nc_sid=cbead8&_nc_ohc=Rpausjz2MNgAX-SR3Ov&_nc_ht=cdn.fbsbx.com&oh=00_AfAGZv00yTx4HEocKcWrFcCFsOHrHnNTW8lWwB_GWfc7ww&oe=649C8AE3",
//       "cover_artwork_thumbnail_uri": "https://cdn.fbsbx.com/v/t65.14500-21/89028193_2646074722346052_2650436610558001152_n.jpg?stp=dst-jpg_s168x128&_nc_cat=1&ccb=1-7&_nc_sid=cbead8&_nc_ohc=Rpausjz2MNgAX-SR3Ov&_nc_ht=cdn.fbsbx.com&oh=00_AfBuronljDpnivjKzSBtbaI9V9O1fcLR-FcE-ujSnfsKTA&oe=649C8AE3",
//       "progressive_download_url": "https://scontent-ams4-1.xx.fbcdn.net/v/t39.12897-6/234623221_825959838105651_6386546147967378407_n.m4a?_nc_cat=109&ccb=1-7&_nc_sid=02c1ff&_nc_ohc=7qcTwgg8I5sAX_paDII&_nc_ad=z-m&_nc_cid=0&_nc_ht=scontent-ams4-1.xx&oh=00_AfBNI82Tb8VN7L1RFNdroFKWTJrUMuPSaoyNCW9yYjeVXQ&oe=649FD946",
//       "fast_start_progressive_download_url": "https://scontent-ams4-1.xx.fbcdn.net/v/t39.12897-6/234623221_825959838105651_6386546147967378407_n.m4a?_nc_cat=109&ccb=1-7&_nc_sid=02c1ff&_nc_ohc=7qcTwgg8I5sAX_paDII&_nc_ad=z-m&_nc_cid=0&_nc_ht=scontent-ams4-1.xx&oh=00_AfBNI82Tb8VN7L1RFNdroFKWTJrUMuPSaoyNCW9yYjeVXQ&oe=649FD946",
//       "web_30s_preview_download_url": null,
//       "reactive_audio_download_url": null,
//       "highlight_start_times_in_ms": [
//         25000,
//         5500,
//         50500
//       ],
//       "is_explicit": false,
//       "dash_manifest": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<!--Generated with https://github.com/google/shaka-packager version v1.6.0-release-->\n<MPD xmlns=\"urn:mpeg:dash:schema:mpd:2011\" xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:cenc=\"urn:mpeg:cenc:2013\" xsi:schemaLocation=\"urn:mpeg:dash:schema:mpd:2011 DASH-MPD.xsd\" profiles=\"urn:mpeg:dash:profile:isoff-on-demand:2011\" minBufferTime=\"PT2S\" type=\"static\" mediaPresentationDuration=\"PT331.496S\">\n  <Period id=\"0\">\n    <AdaptationSet id=\"0\" contentType=\"audio\" subsegmentAlignment=\"true\">\n      <Representation id=\"0\" bandwidth=\"129988\" codecs=\"mp4a.40.2\" mimeType=\"audio/mp4\" audioSamplingRate=\"48000\">\n        <AudioChannelConfiguration schemeIdUri=\"urn:mpeg:dash:23003:3:audio_channel_configuration:2011\" value=\"2\"/>\n        <BaseURL>https://scontent-ams2-1.xx.fbcdn.net/v/t39.12897-6/84183610_136500107428129_6081527164031729664_n.m4a?_nc_cat=105&amp;ccb=1-7&amp;_nc_sid=02c1ff&amp;_nc_ohc=pLb5lcfGDGAAX_PBd61&amp;_nc_oc=AQm2CuL6mnzhQWPP52DMoR9XglumCXjLQ8aeUgNjRK-N2RHaJFFbUY7TTcGVPiiKEro&amp;_nc_ad=z-m&amp;_nc_cid=0&amp;_nc_ht=scontent-ams2-1.xx&amp;oh=00_AfC-kE7QL0XptRSqGhm4fYV1VI5kufVWq74Uk7A5xcehGg&amp;oe=64A00DF9</BaseURL>\n        <SegmentBase indexRange=\"741-2764\" timescale=\"48000\">\n          <Initialization range=\"0-740\"/>\n        </SegmentBase>\n      </Representation>\n    </AdaptationSet>\n  </Period>\n</MPD>\n",
//       "has_lyrics": true,
//       "audio_asset_id": "603239956894006",
//       "duration_in_ms": 331453,
//       "dark_message": null,
//       "allows_saving": true,
//       "ig_username": null
//     },
//     "metadata": {
//       "is_bookmarked": false,
//       "allow_media_creation_with_music": true,
//       "is_trending_in_clips": false
//     },
//     "alacorn_session_id": "0mN7NSLMCAavYgXDI3635"
//   },
// ],
//     "word": search
//   }});
//         return
        this.getMusicInstagram(id, search).then(res => {
          console.log(res.body, res, res.body.musics, res.body.musics.track, res.body.musics.metadata);
          if (res.body.error) {
            resolve(res);
          }
          resolve({body: {word: search, musics: res.body.musics}})
          // this.locations = res.body.locations;
        }).catch(e => {
            resolve({body: {error: e}})
          });
      })
    },

    getMusicTrendByApi(id) {
      return new Promise((resolve, reject) => {
        this.getTrendMusicInstagram(id).then(res => {
          console.log(res.body, res, res.body.musics, res.body.musics.track, res.body.musics.metadata);
          if (res.body.error) {
            resolve(res);
          }
          resolve({body: {word: '', musics: res.body.musics}})
          // this.locations = res.body.locations;
        }).catch(e => {
            resolve({body: {error: e}})
          });
      })
    },
    
    // selectLocation(location) {
    //   if (location) {
    //     console.log('selectLocation', location);
    //     this.searchLocationInput = location.name;
    //     this.locations = [];
    //     this.selectedLocation = location;
    //   }
    //   this.toggleShowMentions("Location")
    // },
    selectLocation(location, network) {
      if(this.searchLocation && this.searchLocation.length) {
        // searchLocation[selectedBotLocation].selected
        this.searchLocation.map(loc => {
          if (loc.selected) {
            console.log('selectLocation', loc.selected);
            if(!this.searchLocationInput) this.searchLocationInput = {}
            this.searchLocationInput[loc.bot.type] = loc.selected.name;
            this.locations = [];
            if(!this.selectedLocation) this.selectedLocation = {}
            this.selectedLocation[loc.bot.type] = loc.selected;
            if (loc.bot.type === 'instagram') {
              this.$store.commit("updateStorificationLocation", loc.selected);
            }
          }
        })
      }
      this.toggleShowMentions("Location")
    },

    selectMusic(music) {
      if (music) {
        console.log('selectMusic', music);
        this.searchMusicInput = music.name;
        // this.music = [];
        // this.selectedMusic = music;
        music.start = music.track.highlight_start_times_in_ms.length > 0 ? music.track.highlight_start_times_in_ms[0] : 0;
        music.config = true;
        music.paused = false;
        if (this.typePost === 'image') {
          music.config = false;
          music.paused = true;
        }
        this.videoReel && this.typePost === 'video' ? this.$store.commit("updateStorificationMusicReel", music) : this.$store.commit("updateStorificationMusic", music);
        // this.toggleMusicConfig(true)
        this.setMusicDuration();
        // this.setMusicStartTime(music.track.highlight_start_times_in_ms[0]);
        this.storyVideo = true;
        this.layers = [];
      }
      this.toggleShowMentions("Music", 0)
    },

    removeLocation(network) {
      console.log("remove", network, this.searchLocationInput);
      this.searchLocationInput[network] = null;
      this.locations = [];
      this.selectedLocation[network] = null;
      if (network === 'instagram') {
        this.$store.commit("removeStorificationLocation");
      }
      this.$forceUpdate();
    },

    videoType(item) {
      let t = this.getPageInfoByBot(item).network;
      if (t === 'instagram' && this.videoReel) {
        return 'instagram_reel'
      }
      if (t === 'instagram' && this.storyVideo) {
        return 'story'
      }
      if (t === 'facebook' && this.videoReelFB) {
        return 'facebook_reel'
      }
      return t;
    },

    sharedStoryToggleVisual() {
      this.storySharedVisual = this.storySharedVisual ? null : this.form.title;
    },

    async urlToFile(url) {
      console.log("urlToFile", url);
      return fetch(url, {
        cache: 'no-store',
        mode: 'cors',
        method: 'GET',
      }).then(async response => {
        const contentType = response.headers.get('content-type')
        const blob = await response.blob()
        const filename = url.split('/').pop();
        const file = new File([blob], filename, { contentType })
        return file;
      })
    },

    styledText() {
      // if ((!this.$refs.inputTitle || !this.$refs.inputTitle.$el)) return '';
      if (!this.$refs.inputTitle) return '';
      let b = null;
      // let a = this.$refs.inputTitle.$el.firstElementChild;
      let a = this.$refs.inputTitle;
      if (this.form.title && a.selectionStart !== a.selectionEnd) {
        b = this.form.title.substring(a.selectionStart, a.selectionEnd);
      } else {
        if (this.form.title && !this.form.title.slice(a.selectionStart)) return '';
        if(this.form.title && this.form.title.slice(a.selectionStart).match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu))
          b = this.form.title.slice(a.selectionStart).match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu)[0];
      }
      return Fonts.styledText(b);
    },

    styleSelection(type) {
      // let a = this.$refs.inputTitle.$el.firstElementChild;
      let a = this.$refs.inputTitle;
      if (Array.isArray(a)) {
        a = a[0];
      }
      let start = a.selectionStart;
      let end = a.selectionEnd;
      let styled = '';

      if (start !== end && this.form.title && !Fonts.checkIfMention(this.form.title, start, end)) {
        switch (type) {
          case 'bold': styled = Fonts.bold(this.form.title.substring(start, end));
          break;
          case 'italic': styled = Fonts.italic(this.form.title.substring(start, end));
          break;
          case 'underline': styled = Fonts.underline(this.form.title.substring(start, end));
          break;
          default: styled = this.form.title.substring(start, end);
        }
        this.form.title = this.form.title.substring(0, start) + styled + this.form.title.substring(end);
      }
      a.focus();
      this.$nextTick(() => {
        a.setSelectionRange(start, start+styled.length);
      });
    },

    moveCarousel(e) {
      if (!this.multipleImages[e.draggedContext.index].file || !this.multipleImages[e.draggedContext.futureIndex].file) {
        return false;
      } else { 
        if (this.multipleImages.some(e => !e.twitterOrdered)) {
          this.multipleImages[e.draggedContext.index].twitter = e.draggedContext.futureIndex;
          this.multipleImages[e.draggedContext.futureIndex].twitter = e.draggedContext.index;
        } 
        if (this.multipleImages.some(e => !e.linkedinOrdered)) {
          this.multipleImages[e.draggedContext.index].linkedin = e.draggedContext.futureIndex;
          this.multipleImages[e.draggedContext.futureIndex].linkedin = e.draggedContext.index;
        }
        if (this.multipleImages.some(e => !e.facebookOrdered)) {
          this.multipleImages[e.draggedContext.index].facebook = e.draggedContext.futureIndex;
          this.multipleImages[e.draggedContext.futureIndex].facebook = e.draggedContext.index;
        }

      }
    },

    updateMultipleImages(newMultipleImages) {
      // this.multipleImages = JSON.parse(JSON.stringify(newMultipleImages));
      this.multipleImages = newMultipleImages.map(e => {
        let fileTemp = new File([e.file], e.file.name, { type: e.file.type } );
        let copy = JSON.parse(JSON.stringify(e));
        copy.file = fileTemp;
        return copy;
      })
      
    },

    modifySnippetLink(file){
      console.log("modifySnippetLink", file);
      
      this.uploadImage(file).then(compressedUrl => {
          // this.form.file = null;

          this.form.enclosure = `${compressedUrl}`;
          this.snippet = compressedUrl;
          this.bot.forEach(async id => {
            if (["instagram", "google"].includes(this.bots.find(e => e.id == id).type)) {
              this.editPostLive(this.getPageInfoByBot(id).id, "imageBase64", compressedUrl)
            }
            
          });
          this.$forceUpdate();
      });
      // this.form.enclosure = URL.createObjectURL(file);
      // this.snippet = file;
      // this.bot.forEach(async id => {
      //   if (["instagram", "google"].includes(this.bots.find(e => e.id == id).type)) {
      //     const reader = new FileReader();
      //     reader.onload = (e) => {
      //       this.editPostLive(this.getPageInfoByBot(id).id, "imageBase64", e.target.result)
      //     }
      //     reader.readAsDataURL(file);
      //   }
        
      // });
      // this.$forceUpdate();
    },

    changeCarrouselRatio(elt) {
      this.carrouselRatio = parseFloat(elt.target.value);
      this.multipleImages = this.multipleImages.map(e => {
        e.ratio = parseFloat(elt.target.value)
        return e;
      });
    },

    addMultipleImages(id) {
      console.log(`myFiles${id}`);
      const currentFile = this.$refs[`myFiles${id}`][0].files[0]
      let fileObj = this.multipleImages.find(file => file.id == id);
      let replace = fileObj.file ? true : false;
      let idx = this.multipleImages.findIndex(file => file.id == id);
      console.log("idx", idx);
      fileObj.file = currentFile;
      fileObj.filename = currentFile.name;
      fileObj.url = URL.createObjectURL(currentFile);
      fileObj.ratio = this.carrouselRatio;
      fileObj.facebook = idx == 0 && !replace ? 1 : idx;
      fileObj.twitter = idx == 0 && !replace ? 1 : idx;
      fileObj.linkedin = idx == 0 && !replace ? 1 : idx;
      fileObj.facebookOrdered = false;
      fileObj.twitterOrdered = false;
      fileObj.linkedinOrdered = false;

      console.log(this.carrouselRatio);

      if (this.multipleImages.length == 1) {
        this.multipleImages.unshift({
          url: this.url,
          file: this.form.file,
          filename: this.filename,
          id: Math.random().toString(36).substr(2, 9),
          ratio: this.carrouselRatio,
          facebook: 0,
          twitter: 0,
          linkedin: 0,
          facebookOrdered: false,
          twitterOrdered: false,
          linkedinOrdered: false
        })
      }

      if (!replace) {
        this.multipleImages.push({
          url: null,
          file: null,
          filename: 'No file selected',
          id: Math.random().toString(36).substr(2, 9),
          ratio: null,
        })
      }
    },

    removeMultipleImages(id) {
      let element = this.multipleImages.find(file => file.id == id);
      this.multipleImages = this.multipleImages.filter(file => file.id != id)
      this.multipleImages.map(e => {
        if (e.facebook > element.facebook) {
          e.facebook--;
        }
        if (e.twitter > element.twitter) {
          e.twitter--;
        }
        if (e.linkedin > element.linkedin) {
          e.linkedin--;
        }
        return e;
      })
      this.compressedImages = this.compressedImages.filter(e => e !== id) 

      console.log(this.multipleImages, this.multipleImages.length);
      if (this.multipleImages.filter(e=>e.file).length == 0) {
        this.removeImage();
      }
      else if (this.multipleImages.filter(e=>e.file).length == 1) {
        let media = this.multipleImages.filter(e=>e.file)[0];
        this.form.file = media.file;
        this.filename = media.filename;
        this.url = media.url;
      }
    },

    removeMultipleMedias(id) {
      this.multipleMedias = this.multipleMedias.filter(file => file.id != id)  
      if(this.multipleMedias.length <= 1) {     
        this.videoReel = true
        if(this.multipleMedias.length == 1 && this.multipleMedias[0].type.includes('video')) {
          this.form.video = this.multipleMedias[0].url
          this.videoname = this.multipleMedias[0].name
          this.videos['instagram_reel'] = this.multipleMedias[0].url;
          // this.normalizeVideo('instagram_reel', this.multipleMedias[0].url);
        }
        else {
          this.form.video = null
          this.videoname = null
        }
      }
    },

    removePollOption(index) {
      this.poll.options.splice(index, 1)
    },

    addPollOption() {
      if (this.poll.options.length < 4) {
        this.poll.options.push('')
      }
    },

    toggleExpandTabs() {
      // this.advancedTabs = !this.advancedTabs
      this.$emit('minimizeTabsEvent', !this.tabsIsMinimize)
    },

    contractTabs(){
      // this.advancedTabs = false
      this.$emit('minimizeTabsEvent', true)
    },

    /** check page filter **/
    checkPageFilter(page){
      return page.name.toLowerCase().includes(this.pageFilter.toLowerCase()) || page.network.toLowerCase().includes(this.pageFilter.toLowerCase()) || (this.pageInGroup(page) && this.pageInGroup(page).name.toLowerCase().includes(this.pageFilter.toLowerCase()))
    },

    checkSelected(page) {
      if(!this.filterSelected)
        return true
      else 
        // return this.bot.map(b => this.findBot(b).page).find(s => s.id == page.id)
        return this.bot.map(id => this.bots.find(b => b.id == id) ? this.bots.find(b => b.id == id).page : null).find(s => s && s.id == page.id)
    },

    toggleShowGroup(group) {
      let index = this.groups.findIndex(g => g.id == group.id)
      this.$set(this.groups[index], 'show', !group.show)
    },

    findPage(pageId) {
      return this.listPages.find(p => p.page.id == pageId)
    },

    pageInGroup(page) {
      return this.groups.find(g => g.pages.includes(page.id))
    },

    findBot(id) {
      return this.listPages.find(p => p.id == id)
    },

    checkGroupFilter(group){
      if(!group) return false
      return group.pages.every(p => !this.findPage(p) || (this.findPage(p) && (!this.checkPageFilter(this.findPage(p).page) || !this.checkSelected(this.findPage(p).page))))
    },

    checkPagesInGroup(group) {
      return group.pages.some(p => this.findPage(p))
    },

    checkAllPagesGroupSelected(group){
      // console.log('checkAllPagesGroupSelected', this.bot, this.listPages, group)
      // let countPages = this.bot.map(b => this.findBot(b).page).filter(s => group.pages.includes(s.id)).length
      let countPages = this.bot.map(id => this.bots.find(b => b.id == id) ? this.bots.find(b => b.id == id).page : null).filter(s => s && group.pages.includes(s.id)).length
      return 0 < countPages && countPages < group.pages.length
    },

    checkGroup(group){
      let checkPage = (b) => this.checkLock(b.page.network) && (b.status || (!b.status && this.isConciergerie(b.page)))
      if(this.selectedGroups.includes(group.id) 
            && this.listPages.filter(b => group.pages.includes(b.page.id)).length != this.listPages.filter(b => group.pages.includes(b.page.id) && (!checkPage(b) || (checkPage(b) && this.bot.includes(b.id)))).length ){
        console.log('add page from', group.id)
        this.bot = this.firstSelectGroup 
                                // ? this.listPages.filter(b => group.pages.includes(b.page.id) && checkPage(b)).map(p => p.id)
                                // : [...new Set(this.bot.concat(this.listPages.filter(b => group.pages.includes(b.page.id) && checkPage(b)).map(p => p.id)))] 
                                ? this.listPages.filter(b => group.pages.includes(b.page.id) && checkPage(b) && this.checkPageFilter(b.page)).map(p => p.id)
                                : [...new Set(this.bot.concat(this.listPages.filter(b => group.pages.includes(b.page.id) && checkPage(b) && this.checkPageFilter(b.page)).map(p => p.id)))] 
        this.firstSelectGroup = false

        for(let b of this.bot){
          let botsPage = this.listPages.filter(p => p.page.id == this.findBot(b).page.id)
          if(botsPage.length > 1) 
            this.bot = this.bot.filter(p => !botsPage.slice(1).map(bPage => bPage.id).includes(p))
        }
      }
      else {
        console.log('remove page from', group.id)
        this.bot = this.bot.filter(p => !group.pages.includes(this.listPages.find(l => l.id == p).page.id))
      }
    },

    removeLayer(idx) {
      this.layers.splice(idx, 1);
    },
    
    removeGif(id) {
      let idx = this.videoReel  && this.typePost === 'video' ? this.$store.getters.storificationGifsReel.findIndex(e => e.id === id) : this.$store.getters.storificationGifs.findIndex(e => e.id === id);
      this.videoReel  && this.typePost === 'video' ? this.$store.commit("removeStorificationGifReel", idx) : this.$store.commit("removeStorificationGif", idx);
      // this.selectedGifs = this.selectedGifs.filter(e => e.id !== id);
    },

    removeProduct(id) {
      let idx = this.$store.getters.storificationProduct.items.findIndex(e => e.id === id);
      this.$store.commit("removeStorificationProductItem", idx)
      // this.selectedGifs = this.selectedGifs.filter(e => e.id !== id);
    },


    addNewLayer(event) {
      console.log(event.target.files);
      let files = event.target.files;
      console.log(files[0]);
      let reader = new FileReader();
      reader.onload = (e) => {
        this.layers.push({
          reader: e.target.result,
          file: files[0],
        })
      };
      reader.readAsDataURL(files[0]);
    },

    selectBackgroundColor(e) {
      console.log('selectBackgroundColor', e);
      // this.$store.commit("")
      let hex =  e.target.value.replace('#', '');
      let aRgbHex = hex.match(/.{1,2}/g);
      this.instagramBackgroundColor = [parseInt(aRgbHex[0], 16), parseInt(aRgbHex[1], 16), parseInt(aRgbHex[2], 16)];
      console.log(this.instagramBackgroundColor);
      this.$forceUpdate();
    },

    removeImage() {
      this.url = null;
      this.filename = 'No file selected';
      // if (this.typePost === 'story') {
      //   this.$refs.storymaker[0].removeOnlyImage();
      // }
      this.multipleImages = [];
      this.compressedImages = [];
      this.form.enclosure = null;
    },

    removeVideo() {
      this.form.video = null;
      this.filename = 'No file selected';
      this.videoname = null;
      this.videos = [];
      this.multipleMedias = []
    },

    async editPostLive(page, field, value, storification=false, commentId=null){
      if (field === 'imageBase64' && !(typeof value === 'string')) {
        let compressedUrl = await this.uploadImage(value);
        value = compressedUrl;
        this.editPostLive(page, 'image', compressedUrl);
      }
      if(!this.editPostValue.find(post => post.page == page)){
        let element = {
          page
        }
        if (storification && field == 'scheduling') {
          element["storification"] = value
        } else if(field == 'comment') {
          element.comment = {}
          if(commentId != null && commentId >= 0)
            element.comment[commentId] = value
          else
            element.comment = value
        } else {
          element[field] = value
          if (field == 'scheduling') element["storification"] = JSON.parse(JSON.stringify(value))
        }
        this.editPostValue.push(element)
      }
      else {
        let index = this.editPostValue.findIndex(post => post.page == page)
        if (storification && field == 'scheduling') {
          if (this.editPostValue[index].scheduling && this.editPostValue[index].scheduling.date && this.editPostValue[index].scheduling.time) {
            let stdDate = moment(this.editPostValue[index].scheduling.date).hour(this.editPostValue[index].scheduling.time.HH).minute(this.editPostValue[index].scheduling.time.mm).unix();
            let storificationDate = moment(value.date).hour(value.time.HH).minute(value.time.mm).unix()
            if (stdDate > storificationDate) {
              this.notify({
                title: this.$t("dash.posts.multi-pages.change_scheduled_date.storification.limit"),
                text: this.$t("dash.posts.change_scheduled_date.body.storification.limit.post"),
                color:'warning',
                time: 10000,
                id: 'norepeat'
              })
              this.$set(this.editPostValue[index], "storification", this.editPostValue[index].scheduling)
              return;
            }
          }
          this.$set(this.editPostValue[index], "storification", value)
        } else if(field == 'comment') {          
          if(commentId != null && commentId >= 0)
            this.editPostValue[index].comment[commentId] = value
          else
            this.editPostValue[index].comment = value
        } else {
          if (field == 'scheduling') this.$set(this.editPostValue[index], "storification", JSON.parse(JSON.stringify(value)))
          this.$set(this.editPostValue[index], field, value)
        }
      }
    },

    removeCustomized(page){
      this.editPostValue = this.editPostValue.filter(p => p.page != page)
    },

    currentPostLive(page, field){
      this.currentPostFieldEdit = { page, field }
    },

    async newBoardofPinterest(){

      let isSection = false
      if(this.form.boardSelected)
        isSection = await new Promise((resolve, reject) => {
          this.$vs.dialog({
            type:'confirm',
            color: 'primary',
            title: this.$t('dash.post.board.choice.type.title'),
            cancelText: this.$t('dash.post.board.choice.type.btn-board'),
            cancel: async () => {        
              resolve(false);
            },
            acceptText: this.$t('dash.post.board.choice.type.btn-section'),
            accept: async () => {        
              resolve(true);
            }
          })
        })

      if(this.newBoardName){
        this.$vs.loading({color : 'primary'})
        let bot = this.bots.find(b => b.id == this.getBoardPagePinterest)
        await this.createBoardPinterest(bot.page,this.newBoardName, isSection ? this.form.boardSelected.id : null)
        .then( async (res) => {  
          if(res.body.board.code)
          {
            this.notify({
              title:'Erreur',
              text:res.body.board.message,
              color:'success',
              time: 10000,
              id: 'norepeat'
            }, {
              component: "PostsOverlay",
              action: "createBoardPinterest",
              params: {
                botPage: bot.page,
                newBoardName: this.newBoardName
              }
            })
            this.$vs.loading.close()
          }
          else{
          this.form.boardSelected = res.body.board
          this.boards = await this.getBoardPinterest(bot.page)
          this.boards = this.boards.body
          this.newBoardName = ''
          this.$vs.loading.close()

          this.notify({
            title:'Tableau ajouté',
            text:'Le tableau a bien été ajouté à la liste.',
            color:'success',
            time: 10000,
            id: 'norepeat'
          })
        }
        })}
      else{
        this.notify({
            title:'Veuillez ajouter un nom au tableau',
            text:'',
            color:'success',
            time: 10000,
            id: 'norepeat'
          })
      }
    },

    async getBoardofPinterest(page){
      this.boards = null 
      this.boards = await this.getBoardPinterest(page)
      this.boards = this.boards.body
      if(this.boards && this.boards.board) {
        this.form.boardSelected = this.boards.board.items[0]
        let bot = this.bots.find(b => b.id == this.getBoardPagePinterest)
        if(bot && bot.storyTemplate){
          if(bot.storyTemplate.boardPinterest){
            this.form.boardSelected = bot.storyTemplate.boardPinterest  
          }
        }
        await this.checkChildsBoard()
      }
    },

    changeScheduleDate(dayStr, hour){
  
      let days = {
          sunday: 0,
          monday: 1,
          tuesday: 2,
          wednesday: 3,
          thursday: 4,
          friday: 5,
          saturday: 6,
      }

      let weekDayNum= days[dayStr]
      
      this.scheduling.show = true
      
      if(weekDayNum > moment().day()){
        this.scheduling.date = moment(moment().day(weekDayNum)).format()
      }else if (weekDayNum == moment().day()) {
        this.scheduling.date = moment().hour() < hour ? moment(moment().day(weekDayNum)).format()  : (moment().day(weekDayNum).add(7,'day').format())
      }else{
        this.scheduling.date = (moment().day(weekDayNum).add(7,'day').format())
      }

      this.scheduling.time.HH = hour < 10 ? `0${hour}` : `${hour}`
      this.scheduling.time.mm = '00'
    },

    showOptimalTimes(){
      if(this.bot.length) {
        const pageId = this.getPageInfoByBot(this.bot[0]).id
        // check if data in localstorage & if the selected bot is for the same page of this data
        if(localStorage.optimalTimes && JSON.parse(localStorage.optimalTimes) && Array.isArray(JSON.parse(localStorage.optimalTimes)) && JSON.parse(localStorage.optimalTimes).find(t => t.page == pageId)){ 
          this.optimalTimes = JSON.parse(localStorage.optimalTimes).find(t => t.page == pageId).value
          this.activeOptimalTimes = true
          this.isDisable = true
          setTimeout(() => {
            let top = document.querySelector(`.planning-wrapper`).offsetTop
            scrollTo({ top: top, left: 0, behavior: 'smooth' })
          }, 250)
        }
        else{
          this.activeOptimalTimes = false
          this.refreshOptimalTimes()
        }
      }
    },

    refreshOptimalTimes(){
      if(this.bot.length) {
        this.$vs.loading({
          container: this.$refs.loadableButton.$el,
          scale: 0.45
        })
  
        const { VUE_APP_API_HOST } = process.env
        this.$http
          .get(
            `${VUE_APP_API_HOST}/reporting?pageid=${this.getPageInfoByBot(this.bot[0]).id}&since=${moment().subtract(29, 'days').unix()}&until=${moment().unix()}&timezone=${new Date().getTimezoneOffset()}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
              }
            },
            {}
          )
          .then(async (response) => {
            this.$vs.loading.close(this.$refs.loadableButton.$el)
            if (response.ok && response.body.success && !response.body.stats.error && response.body.stats) {
              let optimalTimes = localStorage.optimalTimes ? JSON.parse(localStorage.optimalTimes) : []
              if(!Array.isArray(optimalTimes)) optimalTimes = []
              let optimalTimesElement = {
                page : this.getPageInfoByBot(this.bot).id,
                value: response.body.stats.page.optimalTimes
              }
              let indexUpdate = optimalTimes.findIndex(t => t.page == this.getPageInfoByBot(this.bot).id)
              if(indexUpdate < 0)
                optimalTimes.push(optimalTimesElement)
              else
                optimalTimes[indexUpdate] = optimalTimesElement
              localStorage.setItem('optimalTimes', JSON.stringify(optimalTimes))
              this.optimalTimes = response.body.stats.page.optimalTimes
              this.activeOptimalTimes = true
              setTimeout(() => {
                let top = document.querySelector(`.planning-wrapper`).offsetTop
                scrollTo({ top: top, left: 0, behavior: 'smooth' })
              }, 250)
            }else{
              this.activeOptimalTimes = false
            }
          })
      }
    },

    captureNeedeed() {
      return false
    },
    
    updateTextWithStory(text, idx, w, h) {
      console.log(text);
      if (!text || text.length === 0) {
        this.instagramTexts = [];
        return;
      }

      if (this.instagramTexts.length === 0 && (this.form.title || this.form.description) && this.typePost === 'story') {
        this.instagramTexts = text;
        this.instagramTexts[0].content = this.form.title || this.form.description || ''
        this.instagramTexts[0].x = 0
        this.instagramTexts[0].y = this.instagramTexts[0].y/3
      } else {
        this.instagramTexts = text;
      }
      this.instagramTexts[idx].w = w;
      this.instagramTexts[idx].h = h;
    },

    cropImage(base64, isUrl) {
      this.isNewImage = !isUrl;
      let img = this.base64toFile(base64, 'instagram_picture')
      // TODO: Surveiller
      this.form.enclosure = `${base64}`;
      this.form.file = img; //Blob to file
      this.url = `${base64}`; // Blob to URL
      console.log("form",this.form, this.form.enclosure);
    },

    base64toFile(base64, filename) {
        let arr = base64.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), 
            n = bstr.length, 
            u8arr = new Uint8Array(n);
            
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        
        return new File([u8arr], `${filename}${mime.replace('image/', '.')}`, {type:mime});
    },

    sendInstagramCredentials() {
      const body = {
          type: this.bot.length > 0 ? this.getPageInfoByBot(this.bot[0]).network : this.getPageInfo.network,
          instagramUsername: this.instagramUsername,
          instagramPassword: this.instagramPassword,
          network_id: this.bot.length > 0 ? this.getPageInfoByBot(this.bot[0]).network_id : this.getPageInfo.network_id,
      }
      this.addInstagramCredentials(body).then(result => {
        let {succes} = result.body
        this.instagramCredentialsPopup = false;
        if (succes) {
          this.credentialsKnown = true;
          this.notify({
            title:'Identifiants sauvegardés',
            text:'Vos identifiants ont bien été enregistrés',
            color:'success',
            time: 10000,
            id: 'norepeat'
          })
        } else {
          this.credentialsKnown = false;
          this.notify({
            title:'Erreur lors de la sauvegarde',
            text:'Il y a eu un problème lors de la sauvegrde de vos identifiants, veuillez reesayer',
            color:'danger',
            time: 10000,
            id: 'norepeat'
          }, {
            component: "PostsOverlay",
            action: "addInstagramCredentials",
            params: {
              type: body.type,
              instagramUsername: body.instagramUsername,
              instagramPassword: 'XXXX',
              network_id: body.network_id,
              resultBody: result.body
            }
          })
        }
      });
    },

    showConciergerieForm() {      
      let instaBot = this.bot.find( (item) => {
        // let isLocked = await this.checkLockDirectApi(this.getPageInfoByBot(item));
        return this.getPageInfoByBot(item).network === 'instagram' && !(this.getPageInfoByBot(item).story_config && this.getPageInfoByBot(item).story_config.created && (!this.getPageInfoByBot(item).story_config.lock || this.getPageInfoByBot(item).story_config.lock < Date.now()));
      });
      this.activeConciergerie = instaBot ? this.getPageInfoByBot(instaBot) : this.getPageInfo
    },

    standardPostEnabled() {
      if (this.bot.length === 0) return false;
       return (!this.bot.every((item) => {
        return ['instagram', 'google', 'tiktok', 'youtube'].includes(this.getPageInfoByBot(item).network);
      }) && !this.bot.some((item) => {
        return ['tiktok', 'youtube'].includes(this.getPageInfoByBot(item).network);
      }));
    },

    atLeastGoogleSelected() {
      if (this.bot.length === 0) return false;
      return this.bot.some((item) => {
        return this.getPageInfoByBot(item).network === 'google';
      });
    },

    onlyPinterestSelected() {
      if (this.bot.length === 0) return false;
      return this.bot.every((item) => {
        return this.getPageInfoByBot(item).network === 'pinterest';
        });
    },

    onlyInstagramSelected() {
      if (this.bot.length === 0) return false;
      return this.bot.every((item) => {
        let page = this.getPageInfoByBot(item)
        return page && page.network === 'instagram';
      });
    },

    onlyListNetworkSelected(networks) {
      if (this.bot.length === 0) return false;
      return this.bot.every((item) => {
        let page = this.getPageInfoByBot(item)
        return page && networks.includes(page.network);
      });
    },

    onlyLinkedinSelected() {
      if (this.bot.length === 0) return false;
      return this.bot.every((item) => {
        let page = this.getPageInfoByBot(item)
        return page && page.network === 'linkedin';
      });
    },

    onlyWhatsappSelected() {
      if (this.bot.length === 0) return false;
      return this.bot.every((item) => {
        let page = this.getPageInfoByBot(item)
        return page && page.network === 'whatsapp';
      });
    },

    onlyTiktokSelected() {
      if (this.bot.length === 0) return false;
      return this.bot.every((item) => {
        let page = this.getPageInfoByBot(item)
        return page && page.network === 'tiktok';
      });
    },

    atLeastInstagramSelected() {
      if (this.bot.length === 0) return false;
      return this.bot.some((item) => {
        return this.getPageInfoByBot(item).network === 'instagram';
      });
    },

    atLeastFacebookSelected() {
      if (this.bot.length === 0) return false;
      return this.bot.some((item) => {
        return this.getPageInfoByBot(item).network === 'facebook';
      });
    },

    atLeastTiktokSelected() {
      if (this.bot.length === 0) return false;
      return this.bot.some((item) => {
        return this.getPageInfoByBot(item).network === 'tiktok';
      });
    },

    atLeastWonderpushSelected() {
      if (this.bot.length === 0) return false;
      return this.bot.some((item) => {
        return this.getPageInfoByBot(item).network === 'wonderpush';
      });
    },

    atLeastNetworkSelected(network) {
      if (this.bot.length === 0) return false;
      return this.bot.some((item) => {
        return this.getPageInfoByBot(item).network === network;
      });
    },

    atLeastInstagramConciergerieSelected() {
      if (this.bot.length === 0) return false;
      return this.bot.some( (item) => {
        // let isLocked = await this.checkLockDirectApi(this.getPageInfoByBot(item));
        return this.getPageInfoByBot(item).network === 'instagram' && this.getPageInfoByBot(item).story_config && this.getPageInfoByBot(item).story_config.created && (!this.getPageInfoByBot(item).story_config.lock || this.getPageInfoByBot(item).story_config.lock < Date.now());
      });
    },

    onlyInstagramConciergerieSelected() {
      if (this.bot.length === 0) return false;
      return this.bot.every( (item) => {
        // let isLocked = await this.checkLockDirectApi(this.getPageInfoByBot(item));
        return this.getPageInfoByBot(item).network !== 'instagram' || (this.getPageInfoByBot(item).story_config && this.getPageInfoByBot(item).story_config.created && (!this.getPageInfoByBot(item).story_config.lock || this.getPageInfoByBot(item).story_config.lock < Date.now()));
      });
    },

    atLeastInstagramFullConciergerieSelected(checkFBAffected=true) {
      if (this.bot.length === 0) return false;
      return this.bot.some( (item) => {
        let page = this.getPageInfoByBot(item);
        let affected_to = page.affected_to;
        let fbAffected = this.bots.find(e => e.page && e.page.network_id === affected_to)
        // let isLocked = await this.checkLockDirectApi(this.getPageInfoByBot(item));
        return page.network === 'instagram' && page.story_config && page.story_config.created && (!this.getPageInfoByBot(item).story_config.lock || this.getPageInfoByBot(item).story_config.lock < Date.now()) && (page.isGroup || (page.story_config && page.story_config.onlyConciergerie) || (!affected_to || (!fbAffected && checkFBAffected)));
      });
    },

    isThreadable() {
      if (this.bot.length === 0) return false;
      return this.bot.find((item) => {
        let page = this.getPageInfoByBot(item);
        return ['instagram', 'facebook', 'linkedin', 'twitter', 'bluesky'].includes(page.network) && this.typePost !== 'story';
      })
    },

    thumbPossible() {
      if (this.bot && this.bot.length) 
        return this.bot.some((item) => {
          let page = this.getPageInfoByBot(item)
          // return page && ((['facebook', 'linkedin', 'instagram'].includes(page.network) && !this.videoReelFB) || (page.network == 'instagram' && this.videoReel)) ;
          return page && ['facebook', 'linkedin', 'instagram'].includes(page.network);
        })
      return false
    },

    carouselPossible() {
      if (this.bot.length === 0 || this.typePost === 'video') return false;
      return this.bot.every((item) => {
        return ['instagram', 'linkedin', 'facebook', 'twitter', 'google', 'pinterest', 'threads', 'bluesky'].includes(this.getPageInfoByBot(item).network);
      });
    },

    getScheduledDate(bot){ 
      console.log('getScheduledDate')
      bot = this.bots.find(b => b.id == bot)
      let scheduledDate
      if (this.scheduling.show === true) {
        scheduledDate = moment(this.scheduling.date).set(
          'hour',
          this.scheduling.time.HH
        )
        scheduledDate = scheduledDate.set('minute', this.scheduling.time.mm)
        scheduledDate = scheduledDate.utc().format()
      } else {
        scheduledDate = moment()
          .utc()
          .format()
      }

      let indexEdit = this.editPostValue.findIndex(p => p.page == bot.page.id)
      if(this.editPostValue[indexEdit] && this.editPostValue[indexEdit].scheduling && this.editPostValue[indexEdit].scheduling.date && this.editPostValue[indexEdit].scheduling.time.HH && this.editPostValue[indexEdit].scheduling.time.mm) {
        scheduledDate = moment(this.editPostValue[indexEdit].scheduling.date).set(
          'hour',
          this.editPostValue[indexEdit].scheduling.time.HH
        )
        scheduledDate = scheduledDate.set('minute', this.editPostValue[indexEdit].scheduling.time.mm)
        scheduledDate = scheduledDate.utc().format()
      }
      
      console.log('getScheduledDate', scheduledDate)

      return moment(scheduledDate).local(this.$i18n.locale).format('LLL')
    },

    getMessage(bot, str=null){
      if(!bot.id) bot = this.bots.find(b => b.id == bot)
      let message = str ? str : this.form.title
      //if edit on preview
      let indexEdit = this.editPostValue.findIndex(p => p.page == bot.page.id)
      if(!str && this.editPostValue[indexEdit] && this.editPostValue[indexEdit].title)
        message = this.editPostValue[indexEdit].title
      if(message){
        let regPonctuaction = "[.,!?:;\\-_]*"
        //mentions
        if(this.activeMentionsAutoReplace && bot && bot.mentions && Array.isArray(bot.mentions)){
          bot.mentions.forEach(mention => {
            mention.correspondences.some(correspondence => {
              if(message.toLowerCase().includes(correspondence.toLowerCase())){
                //insensitive case
                message = " "+message+" " //add start & end space 
                let mentionPrefix = ['twitter', 'instagram', 'bluesky'].includes(this.getNetwork) ? "@" : "@["
                let mentionSuffix = ['twitter', 'instagram', 'bluesky'].includes(this.getNetwork) ? "" : "]"

                let reg = new RegExp(` ${regPonctuaction}${correspondence}${regPonctuaction} `, 'gi')
                let reg2 = new RegExp(correspondence, 'i')
                let match = reg.exec(message)
                if (match) {
                  //if need space before and/or after corespondence
                  let change = mentionPrefix+mention.mention+mentionSuffix
                  let match2 = new RegExp("[.,!?:;\\-_]", 'gi').exec(match[0])
                  if(match2){
                    if(match2 && match2.index > 1) change = change+' '
                    else if(match2) change = ' '+change
                  }
                  message = message.replace(reg2, change)
                  message = message.slice(1, message.length-1) //remove start & end space 
                  message = message.replace("@@", "@")
                }

                return true
              }
            })
          })
        }
        //find & replace @hashtagsAuto
        if(this.activeHashtagsAutoAdd && bot && bot.hashtagsAuto && Array.isArray(bot.hashtagsAuto)){
          bot.hashtagsAuto.forEach(hashtagAuto => {
            hashtagAuto.correspondences.some(correspondence => {
              if(message.toLowerCase().includes(correspondence.toLowerCase())){
                //insensitive case
                message = " "+message+" " //add start & end space 

                let reg = new RegExp(` ${regPonctuaction}${correspondence}${regPonctuaction} `, 'gi')
                let reg2 = new RegExp(correspondence, 'i')
                let match = reg.exec(message)
                if (match) {
                  //if need space before and/or after corespondence
                  let change = " #"+hashtagAuto.hashtag
                  let match2 = new RegExp("[.,!?:;\\-_]", 'gi').exec(match[0])
                  if(match2){
                    if(match2 && match2.index > 1) change = change+' '
                    else if(match2) change = ' '+change
                  }
                  message = message.replace(reg2, change)
                  message = message.slice(1, message.length-1) //remove start & end space 
                  message = message.replace("##", "#")
                }

                return true
              }
            })
          })
        }
        //replace multi-mention
        let maxWhile = 100
        let countWhile = 0
        while(message.includes('@[MENTIONS-') && countWhile<maxWhile){
          countWhile++
          let start = message.indexOf('@[MENTIONS')
          let end = message.indexOf(']', start)
          let index = parseInt(message.substr(start, end+1).replace('@[MENTIONS-', '').replace(']', ''))
          let mention = {value: ''}
          if(this.validMentions[index-1])
            mention = this.validMentions[index-1].find(m => m.network == bot.page.network) 
          message = message.substr(0, start) + (mention ? (mention.value ? mention.value : mention.word) : this.validMentions[index-1][0].word) + message.substr(end+1)
        }
        //replace multi-hashtags
        countWhile = 0
        while(message.includes('#[HASHTAGS-') && countWhile<maxWhile){
          countWhile++
          let start = message.indexOf('#[HASHTAGS')
          let end = message.indexOf(']', start)
          let index = parseInt(message.substr(start, end+1).replace('#[HASHTAGS-', '').replace(']', ''))
          let mention = {value: ''}
          if(this.validHashtags[index-1])
            mention = this.validHashtags[index-1].find(m => m.network == bot.page.network) 
          message = message.substr(0, start) + (mention ? (mention.value ? mention.value : `#${mention.word}`) : this.validHashtags[index-1][0].word) + message.substr(end+1)
        }
        //hashtags
        if(this.activePrefixSuffix && !str){
          if(bot.hashtagPrefix) message = bot.hashtagPrefix + ' ' + message
          if(bot.hashtag) message += ' ' + bot.hashtag
        }
        
        message = message.replace('null', '')
      }
      return message
    },

    getMessageOLD(bot){
      if(this.form.title){
        //mentions
        if(this.activeMentionsAutoReplace && bot && bot.mentions && Array.isArray(bot.mentions)){
          bot.mentions.forEach(mention => {
            mention.correspondences.some(correspondence => {
              if(this.form.title.toLowerCase().includes(correspondence.toLowerCase())){
                //insensitive case
                this.form.title = " "+this.form.title+" " //add start & end space 
                let reg = new RegExp(" "+correspondence+" ", 'gi')
                let mentionPrefix = this.getNetwork == 'twitter' ? " @" : " @["
                let mentionSuffix = this.getNetwork == 'twitter' ? " " : "] "
                this.form.title = this.form.title.replace(reg, mentionPrefix+mention.mention+mentionSuffix)
                this.form.title = this.form.title.slice(1, this.form.title.length-1) //remove start & end space 
                this.form.title = this.form.title.replace("@@", "@")
                return true
              }
            })
          })
        }
        //find & replace @hashtagsAuto
        if(this.activeHashtagsAutoAdd && bot && bot.hashtagsAuto && Array.isArray(bot.hashtagsAuto)){
          bot.hashtagsAuto.forEach(hashtagAuto => {
            hashtagAuto.correspondences.some(correspondence => {
              if(this.form.title.toLowerCase().includes(correspondence.toLowerCase())){
                //insensitive case
                this.form.title = " "+this.form.title+" " //add start & end space 
                let reg = new RegExp(" "+correspondence+" ", 'gi')
                this.form.title = this.form.title.replace(reg, " #"+hashtagAuto.hashtag+" ")
                this.form.title = this.form.title.slice(1, this.form.title.length-1) //remove start & end space 
                this.form.title = this.form.title.replace("##", "#")
                return true
              }
            })
          })
        }
        //hashtags
        if(this.activePrefixSuffix){
          if(bot.hashtagPrefix) this.form.title = bot.hashtagPrefix + ' ' + this.form.title
          if(bot.hashtag) this.form.title += ' ' + bot.hashtag
        }
      }
      return this.form.title
    },

    async updateLastBotsSelected(item, idx){
      if (this.typePost === 'story' && item.page.network !== 'instagram') {
        this.bot = this.bot.filter(e => e != item.id)
        this.$vs.dialog({
          type:'confirm',
          color: 'danger',
          title: `Supprimer la story ?`,
          text: 'Si vous selectionnez un autre reseau qu Instagram, vous perdrez votre story.',
          acceptText: "OK",
          accept: () => this.acceptRemoveStory(item.id, idx)
        })
      }
      this.activeOptimalTimes = false

     
    },

    acceptRemoveStory(id, idx) {
      this.typePost = 'standard';
      document.getElementById('bot-index-'+idx).checked = true
      this.bot.push(id)
    },

    /**
     * Get a moment formatted date
     */
    getFormatedDate(date) {
      return moment(date)
        .local()
        .format('DD/MM/YY HH:mm')
    },

    /**
     * Fill form on edit mode
     */
    async fillForm() {
      console.log("fillForm");

      if (this.post.page && this.post.page.length && this.post.page[0].story && this.post.original && this.post.original_news && this.state.includes('duplicate-post')) {
        let botInsta = this.post._bots[0];
        if (this.post.page[0].network === 'facebook') {
          botInsta = this.bots.find(bot => bot.page.network == 'instagram' && bot.page.affected_to === this.getPageInfo.network_id);
          console.log(botInsta);
          this.bot = this.bot.filter(e => e !== this.post._bots[0].id);
          this.bot.push(botInsta.id);
        }
        if (botInsta && botInsta.id) {
          let originalPost = await this.getPost(botInsta.id, this.post.original_news);
          if (originalPost && originalPost.body && originalPost.body.success && originalPost.body.post) {
            console.log(originalPost.body.post);
            this.post = originalPost.body.post;
          }
        }
      }

      if(this.state === 'edit-draft' || (this.state.includes('duplicate-post') && this.post.draft)) return this.fillFormWithDraft()
      else if(['edit-posted', 'edit', 'duplicate-post', 'duplicate-post-unique'].includes(this.state) && this.post.page && this.post.page.length && this.post.page[0].draft) return this.fillFormWithScheduledPost()
      console.log("APRES");
      let botIndex
      if (this.state === 'inqueue-edit' || this.state === 'search') {
        botIndex = 0
      } 
      else {
        if(this.post && this.post._bots){
          let bot = this.bots.find(element => {
            return element.id === this.post._bots.id
          })
          botIndex = this.bots.indexOf(bot)
        }
        else botIndex = 0
      }

      this.selectedGroups = []
      this.onUpload = false;
      this.isThumbUpload = false;
      this.messageUpload = ''

      this.form.page = botIndex
      let isLocked = await this.checkLockDirectApi(this.getPageInfo);

      if(['reshare', 'retweet'].includes(this.state))
        this.typePost = 'standard'
      else if(this.post.status == 'direct') {
        if(this.post.page[0].video)
          this.typePost = 'video'
        else if(this.post.page[0].carousel || this.post.page[0].enclosure){
          this.typePost = 'image'
          if(this.post.page[0].carousel){
            this.multipleImages = this.post.page[0].carousel.map(c => {
              let id = Math.random().toString(36).substr(2, 9)
              this.compressedImages.push(id);
              return {
                ...c,
                id
                // ext: c.filename.slice(c.filename.lastIndexOf('.')+1).toLocaleLowerCase()
              }
            })
          }
        }
      }
      else
        switch(this.samePageBots[0].mode) {
          case 'image':
            this.typePost = 'image'
            this.url = this.form.enclosure ? `${this.form.enclosure}` : null
            this.form.enclosure = null
            break
          case 'video':
            this.typePost = 'video'
            break
          case 'story': 
            this.typePost = this.getPageInfo.story_config && this.getPageInfo.story_config.created && !isLocked.locked ? 'story' : 'image';
            break
          case 'standard':
          default:
            console.log("default", this.getPageInfo);
            this.getPageInfo && ['instagram', 'google'].includes(this.getPageInfo.network) ? this.typePost = 'image' : this.typePost = 'standard'
        }

      this.form = {
        page: botIndex,
        title: this.post 
                  ? this.samePageBots[0].post_text_layout == 'title' && this.post.title 
                    ? this.post.title 
                    : this.samePageBots[0].post_text_layout == 'description'
                      ? this.post.description || this.post.title
                      : this.post.title || this.post.description
                  : '',
        url: this.post && this.post.url ? this.post.url : '',
        description: this.post && this.post.description
                      ? this.post.description
                      : this.post && this.post.page && this.post.page[0] && this.post.page[0].description
                        ? this.post.page[0].description
                        : '',

        enclosure: this.post && this.post.page && this.post.page[0] && this.post.page[0].carousel && this.post.page[0].carousel[0] && this.post.page[0].carousel[0].url 
          ? `${this.post.page[0].carousel[0].url}`
          : this.post && this.post.page && this.post.page[0] && this.post.page[0].enclosure
                      ? `${this.post.page[0].enclosure}`
                      : this.post && this.post.enclosure && !this.post.enclosure.includes('.mp3')
                        ? `${this.post.enclosure}`
                        : '',

        file: null,
        comments: []
      }

      if(!(this.post.page && this.post.page.length) && this.post.enclosure && this.post.enclosure.endsWith(".mp4")){
        this.typePost = 'video'
        this.form.video = this.post.enclosure
      }

      this.editPostValue= []

      if(this.state == 'reshare'){
        this.form.url = this.getPostUrl()
        this.form.title = ''
        this.form.enclosure = ''
        this.form.video = null
      }

      if (this.state === 'inqueue-edit' && this.post && this.post._bots){
        this.form._bots = this.post._bots
        if(this.post._bots[0] && this.post._bots[0].linkInComments && this.form.url) {
          this.form.comments = [this.form.url]
          this.editPostValue = [{"page": this.post._bots[0].page.id, "removeUrlInMessage": true}]
        }
      }

      // post error
      else if(this.state == 'duplicate-post-unique' && this.post._bots && this.post._bots[0] && this.post._bots[0].linkInComments) {
        this.form.comments = [this.form.url]
        this.editPostValue = [{"page": this.post._bots[0].page.id, "removeUrlInMessage": true}]
      }

      let scheduleDate
      if (this.post && this.post.status === 1) {
        scheduleDate = this.post.page[0].scheduled_date
      } else {
        // scheduleDate = moment().add(12, 'minutes').format()
        scheduleDate = moment().add(1, 'minutes').format()
      }
      this.scheduling.date = moment.utc(scheduleDate).local().format()

      this.scheduling.time.HH = moment.utc(scheduleDate).local().hour() < 10 
                                ? `0${moment.utc(scheduleDate).local().hour()}`
                                : `${moment.utc(scheduleDate).local().hour()}`
      this.scheduling.time.mm = moment.utc(scheduleDate).local().minute() < 10 
                                ?`0${moment.utc(scheduleDate).local().minute()}`
                                : `${moment.utc(scheduleDate).local().minute()}`

      this.templateManual = null;

      if (this.post && this.post.page && this.post.page[0] && this.post.page[0].location) {
        console.log("SENDD");
        this.getInstagramPageName(this.getPageInfo.id, this.post.page[0].location).then(e => {
          if(e && e.body)
            this.selectedLocation = {instagram: e.body};
            this.searchLocationInput = {
              instagram: e.body.name
            };
        })
      }

      if (this.post && this.post.page && this.post.page[0] && this.post.page[0].productTags) {
        this.productTags = this.post.page[0].productTags ? JSON.parse(this.post.page[0].productTags) : [];
        this.productTags = this.productTags.filter(p => p.id && p.merchantId)
        let instaBot = this.bots.find(b => this.bot.includes(b.id) && b.page.network == 'instagram' && b.page.story_config && b.page.story_config.created);
        for (let it of this.productTags) {
          let item = await this.chooseItemShopInstagram(instaBot.page.id, it.id, it.merchantId);
          console.log("product items", item);
          it.image = item.body.items[0].image
        }
      }

      if(this.post && this.post.page && this.post.page[0] && (this.post.page[0].enclosure || this.post.page[0].carousel) && !this.post.page[0].story) {
        this.typePost = 'image'
        this.url = this.post.page[0].enclosure 
                          ? `${this.post.page[0].enclosure}` 
                          : (this.post.page[0].carousel && this.post.page[0].carousel.length
                                ? this.post.page[0].carousel[0].url
                                : null)
      }

      if(this.post && this.post.page && this.post.page[0] && this.post.page[0].video && this.state != 'reshare') {
        this.typePost = 'video';
        this.form.video = this.post.page[0].video;
        this.videoname = this.post.page[0].enclosure;
        console.log(this.post.page[0].enclosure);
        if (this.post.page[0].enclosure) {
          this.filename = this.post.page[0].enclosure.split('/')[this.post.page[0].enclosure.split('/').length - 1]
          this.url = `${this.post.page[0].enclosure}`;
        }
      }

      if (this.post && this.post.page && this.post.page[0] && this.post.page[0].story && this.getPageInfo.story_config && !isLocked.locked && this.getPageInfo.story_config.created) {
        this.typePost = 'story';
        if (this.post.page[0].enclosure && this.post.page[0].enclosure.endsWith(".mp4")) {
          this.storyVideo = true
          this.form.enclosure = null;
          this.form.url = null;
          this.form.video = this.post.page[0].enclosure;
          this.videoname = this.post.page[0].enclosure;
          this.videos = `{"twitter":null,"facebook":null,"facebook_reel":null,"linkedin":null,"instagram":null,"instagram_reel":null,"story":"${this.post.page[0].enclosure}}"}`
        }
      }

      if (this.storyShare) {
        this.typePost = "story"
      }

      if (this.post && this.post.page && this.post.page.some(e => e.storification)) {
        this.post._bots = [this.post._bots.find(e => e.type === 'instagram')];
        this.typePost = "image";
        this.shareAfterPost = true;
        if (this.post.page.some(e => e.storificationData)) {
          this.$store.commit("updateStorification", this.post.page.find(e => e.storificationData).storificationData)
        }
        // this.bot = this.bot.filter
        if (this.post.page.some(e => e && e.storification && e.network === 'facebook')) {
          this.storyShareToFacebook = true;
        }
        
      }

      //init manual mentions
      this.searchMention = []
      this.selectedBotMention = 0
      this.validMentions = []
      localStorage.setItem('mentionsAdded', JSON.stringify([]))
      localStorage.setItem('hashtagsAdded', JSON.stringify([]))
        
      console.log(this.state, this.typePost);

      if (this.typePost === 'story' && ['edit', 'duplicate-post', 'duplicate-post-unique'].includes(this.state) && this.post && this.post.page && this.post.page[0] && this.post.page[0].story) {
        let story = JSON.parse(this.post.page[0].story);
        console.log(story);
        this.isNewImage = true;
        this.enclosure = story.texts[0].originalImage ? story.texts[0].originalImage : story.screenshot;
        if (story.texts[0].originalImage && story.texts[0].originalImage !== 'undefined' && story.texts[0].isCapture) {
          this.form.enclosure = story.texts[0].originalImage ? `${story.texts[0].originalImage}` : null;
        }
        this.instagramLinkPosition = {
          x: story.texts[0].linkX,
          y: story.texts[0].linkY,
          angle: story.texts[0].linkAngle,
          scale: story.texts[0].linkScale,
          color: story.texts[0].linkColor || 0,
        } 
        this.instagramTextsUpdater = story.texts.map(e=> {
          e.x = parseFloat(e.x)
          e.y = parseFloat(e.y)
          e.size = parseInt(e.size)
          e.font = parseInt(e.font)
          e.angle = parseInt(e.angle)
          e.background = parseInt(e.background)
          e.content = e.content || ""
          return e;
        });
        if (story.texts[0].layers) {
          this.layers = story.texts[0].layers.map(e => {
            e.x = parseFloat(e.x)
            e.y = parseFloat(e.y)
            e.w = parseFloat(e.w)
            e.h = parseFloat(e.h)
            return e;
          });
        }
        if (story.share) {
          console.log(story.share, typeof story.share);
          this.sharedStoryUrl = story.share;
          this.storySharedVisual = story.visualShare;
        }
        if (story.texts[0].poll && JSON.parse(story.texts[0].poll)) {
          this.pollStory = JSON.parse(story.texts[0].poll);
          this.pollStory.question = this.pollStory.question.join(' ');
          console.log(this.pollStory);
        }
        if (story.texts[0].slider && JSON.parse(story.texts[0].slider)) {
          this.sliderStory = JSON.parse(story.texts[0].slider);
          this.sliderStory.question = this.sliderStory.question.join(' ');
          console.log(this.sliderStory);
        }
        if (story.texts[0].music) {
          console.log(JSON.parse(story.texts[0].music));
          // this.selectedMusic = JSON.parse(story.texts[0].music);
          if (this.selectedMusic && this.selectedMusic.track) {
            let instaBot = this.bots.find(b => this.bot.includes(b.id) && b.page.network == 'instagram' && b.page.story_config && b.page.story_config.created);
            if (!instaBot || isLocked.locked) {
              // this.selectedMusic = null;
                this.notify({
                  title: "Music error",
                  text: this.$t('dash.notifications.story.music.error'),
                  color:'success',
                  time: 10000,
                  id: 'norepeat'
                })
            }
            this.getMusicsByApi(instaBot.page.id, this.selectedMusic.track.title).then(resultMusic => {
              if (resultMusic && resultMusic.body && resultMusic.body.musics) {
                let newMusicUrl = resultMusic.body.musics.find(e => e.track.id === this.selectedMusic.track.id);
                if (newMusicUrl) {
                  let music = this.videoReel && this.typePost === 'video' ? this.$store.getters.storificationMusicReel : this.$store.getters.storificationMusic;
                  music.metadata = newMusicUrl.metadata;
                  music.track = newMusicUrl.track;
                  this.videoReel && this.typePost === 'video' ? this.$store.commit("updateStorificationMusicReel", music) : this.$store.commit("updateStorificationMusic", music);
                  // if (this.$refs.storymaker && this.$refs.storymaker[0]) {
                  //   this.$refs.storymaker[0].pauseMusic();
                  //   setTimeout(() => this.$refs.storymaker[0].playMusic(), 100);
                    
                  // }
                }
              } else {
                // this.selectedMusic = null;
                this.notify({
                  title: "Music error",
                  text: this.$t('dash.notifications.story.music.error'),
                  color:'success',
                  time: 10000,
                  id: 'norepeat'
                })
              }
            }).catch(e => {
              console.log("ERROR MUSIC", e);
              // this.selectedMusic = null;
              this.notify({
                title: "Music error",
                text: this.$t('dash.notifications.story.music.error'),
                color:'success',
                time: 10000,
                id: 'norepeat'
              });
            });
          }
          this.storyVideo = true;
          if (this.post.page[0].enclosure && !this.post.page[0].enclosure.endsWith('.mp4')) {
            this.form.video = null;
          }
        }
        if (story.poll) {
          this.pollStory = story.poll;
          this.pollStory.question = this.pollStory.question.join(' ');
          this.pollStory.x = (this.pollStory.x * 324)/1440
          this.pollStory.y = (this.pollStory.y * 576)/2560
          console.log(this.pollStory);
        }
        if (story.slider) {
          this.sliderStory = story.slider;
          this.sliderStory.question = this.sliderStory.question.join(' ');
          this.sliderStory.x = (this.sliderStory.x * 324)/1440
          this.sliderStory.y = (this.sliderStory.y * 576)/2560
          console.log(this.sliderStory);
        }
        if (story.question) {
          this.questionStory = story.question;
          this.questionStory.text = this.questionStory.text.join(' ');
          this.questionStory.x = (this.questionStory.x * 324)/1440
          this.questionStory.y = (this.questionStory.y * 576)/2560
          console.log(this.questionStory);
        }
        if (story.music) {
          console.log(JSON.parse(story.music));
          // this.selectedMusic = JSON.parse(story.music);
          this.storyVideo = true;
          if (this.post.page[0].enclosure && !this.post.page[0].enclosure.endsWith('.mp4')) {
            this.form.video = null;
          }
        }
        if (story.texts[0].gifs) {
          this.selectedGifs = JSON.parse(story.texts[0].gifs);
        }
        if (story.texts[0].mentionsWidget) {
          this.storyMentions = JSON.parse(story.texts[0].mentionsWidget);
        }
        if (this.post.page[0].video) {
          this.storyVideo = true;
        }
        console.log(this.layers);
        // this.instagramTexts = this.instagramTextsUpdater;
        
      }
      else if (this.typePost === 'story') {
        this.instagramTextsUpdater[0] = {
          content: '',
          x: 50,
          y: 70,
          color: 'white',
          size: 20,
          font:  0,
          background:  null,
          angle:  0
        };

      }

      if (this.state === 'share-story') {
        this.storyVideo = false;
        this.videoReel = false;
      }

      if (['edit', 'duplicate-post', 'duplicate-post-unique'].includes(this.state) && this.typePost === "standard" && this.post && this.post.page && this.post.page[0] && this.post.page[0].snippet) {
        this.snippet = this.post.page[0].snippet
      }
      if (['edit', 'duplicate-post', 'duplicate-post-unique'].includes(this.state) && this.typePost === "standard" && this.post && this.post.page && this.post.page[0] && this.post.page[0].snippet_title) {
        this.snippetTitle = this.post.page[0].snippet_title;
      }
      if (['edit', 'duplicate-post', 'duplicate-post-unique'].includes(this.state) && this.post && this.post.page && this.post.page[0] && this.post.page[0].carousel) {
        this.multipleImages = this.post.page[0].carousel.map(c => {
          return {
            ...c,
            ext: c.filename.slice(c.filename.lastIndexOf('.')+1).toLocaleLowerCase()
          }
        })
        this.carrouselRatio = this.multipleImages.length && this.multipleImages[0].ratio ? this.multipleImages[0].ratio : 4/5
      }

      if (this.post && this.post.page && this.post.page[0] && this.post.page[0].userTags) {
        this.userTags = JSON.parse(this.post.page[0].userTags);
        this.userTags.list = this.userTags.list.map(l => {
          l.image = this.multipleImages[l.index].id
          return l
        })
      }

      if (['edit', 'duplicate-post', 'duplicate-post-unique'].includes(this.state) && this.post && this.post.page && this.post.page[0] && this.post.page[0].enclosure && this.post.page[0].document_title) {
        this.url = `${this.post.page[0].enclosure}`;
        this.typePost = 'document'
        this.form.documentTitle = this.post.page[0].document_title
      }
      if (['edit', 'duplicate-post', 'duplicate-post-unique'].includes(this.state) && this.post && this.post.page && this.post.page[0] && this.post.page[0].poll) {
        this.poll = JSON.parse(this.post.page[0].poll);
        this.typePost = 'poll'
      }

      if (this.post && this.post.flux && this.post.page && this.post.page[0] && !this.post.page[0].isManualPost && this.post.page[0].story) {
        const storyObject = JSON.parse(this.post.page[0].story)
        console.log(this.post.page[0].story, storyObject)
        if (storyObject && storyObject.templateAuto && storyObject.templateAuto.configuration) {
          if (storyObject.templateAuto.configuration.text) {
            let width = Math.min(360, storyObject.texts[0].text.length * ((storyObject.templateAuto.configuration.text.size) - 3)/2)
            let height = ((storyObject.texts[0].text.length * ((storyObject.templateAuto.configuration.text.size) - 3)/2)/360) * 25
            this.$store.commit("addStorificationText", {
              angle: 0,
              background: storyObject.templateAuto.configuration.text.background || 0,
              color: storyObject.templateAuto.configuration.text.color,
              content: storyObject.texts[0].text,
              font: storyObject.templateAuto.configuration.text.font,
              h: height,
              scale: 1,
              size: (storyObject.templateAuto.configuration.text.size) - 3,
              visible:true,
              w: width,
              x: ((storyObject.templateAuto.configuration.text.x / 4) - (width/2)),
              y: ((storyObject.templateAuto.configuration.text.y / 4) - (height/2)),

            })
          }
          if (storyObject.templateAuto.configuration.link) {
            this.$store.commit("updateStorificationLink",{
              active: true,
              angle: 0,
              color: 0,
              text: storyObject.templateAuto.configuration.link.custom_cta || null,
              // h: storyObject.templateAuto.configuration.link.h/4,
              index: null,
              scale: 1,
              // w: storyObject.templateAuto.configuration.link.w/4,
              x: ((storyObject.templateAuto.configuration.link.x / 4) - (storyObject.templateAuto.configuration.link.w / 3 / 2)),
              y: ((storyObject.templateAuto.configuration.link.y / 4) - (storyObject.templateAuto.configuration.link.h / 4 / 2))
            })
          }
          if (storyObject.templateAuto.configuration.background) {
            this.$store.commit("updateStorificationBackgroundColor", storyObject.templateAuto.configuration.background)
          }
          if (storyObject.templateAuto.configuration.layers) {
            this.$store.commit("updateStorificationLayers", storyObject.templateAuto.configuration.layers.map(layer => {
              return {
                url: layer.url,
                x: layer.x/3,
                y: layer.y/3,
                w: layer.w/3,
                h: layer.h/3,
                angle: 0,
                color: 0,
                scale: 1,
              }
            }))
          }
        }
      }

      if (this.post.status === 'preview' && this.post._bots[0] && this.post._bots[0].mode === 'story' && this.post._bots[0].storyTemplate) {
        let config = this.post._bots[0].storyTemplate.configuration;
        this.$nextTick(() => {
          console.log("preview");
          this.templateManual = 'custom';
          this.$store.commit('updateStorificationTemplate','custom');
          if (config.background) {
            this.$store.commit('updateStorificationBackgroundColor', config.background);
          }
          const screenSize = {width: 360, height: 640};
          const templateSize = {width: 281, height: 500};
          const scale = 0.195;
          if ((this.post.description || this.post.title) && config.text) {
            this.$store.commit('addStorificationText', {
              content: this.post.title || this.post.description,
              color: config.text.color,
              font: config.text.font,
              size: config.text.size,
              x: (((config.text.x * 0,126)/templateSize.width)*screenSize.width) - ((((config.text.w * 0,126)/templateSize.width)*screenSize.width)/2),
              y: (((config.text.y * 0,126)/templateSize.height)*screenSize.height) - ((((config.text.h * 0,126)/templateSize.height)*screenSize.height)/2),
              // y:(config.text.y / scale) - (config.text.h / (2 * scale)),
              // w: config.text.w / textScale,
              // h: config.text.h / textScale,
              // minWidth: config.text.w / textScale,
              visible: true,
              scale: 1,
              angle: 0,
              background: config.text.background || 0,
            });
          }
          if (config.link && this.post.url) {
            this.$store.commit('updateStorificationLink', {
              url: this.post.url,
              color: 0,
              active: true,
              x: (((config.link.x * scale)/templateSize.width)*screenSize.width) - ((((config.link.w * scale)/templateSize.width)*screenSize.width)/2),
              y: (((config.link.y * scale)/templateSize.height)*screenSize.height) - ((((config.link.h * scale)/templateSize.height)*screenSize.height)/2),
              // w: config.link.w / textScale,
              // h: config.link.h / textScale,
              visible: true,
              // scale: (config.link.w / textScale)/776,
              angle: 0,
              text: config.link.custom_cta || null,
            });
          }
          if (config.highlight) {
            this.$store.commit('updateStorificationHightlight', config.highlight);
          }
          this.$forceUpdate();
        })
        
      }

      this.compressedImages = this.multipleImages.filter(e => e.uploaded).map(e => e.id);
      
      this.isDisable = false

      this.$nextTick(() => this.allTextAreasAdjust())
    },

    async fillFormWithDraft(locale=false){
      
      let postData = locale ? JSON.parse(localStorage.last_post_draft) : JSON.parse(JSON.stringify(this.post.data))
      console.log(postData);
      
      postData.bot.map(async item => {
        let page = this.getPageInfoByBot(item)
        if (page.network === 'instagram' && page.story_config && page.story_config.created) {
          let isLocked = await this.checkLockDirectApi(page);
          if ((postData.typePost === "story" || postData.shareAfterPost) && isLocked.locked) {
            let date = new Date(page.story_config.lock)
            this.notify({
                  title: "Account error",
                  text: this.$t('dash.story.account.locked') + date.toLocaleString(),
                  color:'warning',
                  time: 10000,
                })
            return;
          } 
        }
      })

      this.form = {...postData.form}
      if(!this.form.comments)
        this.form.comments = []
      this.url = postData.form.enclosure ? `${postData.form.enclosure}` : null; //postData.form.url
      this.typePost = postData.typePost
      if(this.state == 'duplicate-post-unique')
        this.bot = [this.bots.find(b => b.page.id == this.page).id]
      else {
        // this.bot = postData.bot.filter(bId => this.bots.find(b => b.id == bId))
        this.bot = postData.bot.filter(bId => this.bots.find(b => b.id == bId)).map(botCurr => {
          botCurr = this.bots.find(b => b.id == botCurr)
          return this.listPages.find(l => l.page.id == botCurr.page.id).id
        })
      }
      this.activeHashtagsAutoAdd = postData.activeHashtagsAutoAdd
      this.activeMentionsAutoReplace = postData.activeMentionsAutoReplace
      this.activePrefixSuffix = postData.activePrefixSuffix
      // this.editPostValue = postData.editPostValue
      this.editPostValue = postData.editPostValue.map(e => {
        if(e.scheduling) {
          let draftSchedulingInfo = moment(e.scheduling.date);
          draftSchedulingInfo.hours(e.scheduling.time.HH);
          draftSchedulingInfo.minutes(e.scheduling.time.mm);
          if(moment(draftSchedulingInfo).isBefore(moment())) {
            delete e.scheduling
          }
        }
        return e
      })
      // this.scheduling = postData.scheduling
      if(postData.scheduling && postData.scheduling.date && postData.scheduling.time.HH && postData.scheduling.time.mm){
        let draftSchedulingInfo = moment(postData.scheduling.date);
        draftSchedulingInfo.hours(postData.scheduling.time.HH);
        draftSchedulingInfo.minutes(postData.scheduling.time.mm);
        // if scheduling date is passed => init
        console.log('chhhh', moment(draftSchedulingInfo).isBefore(moment()), draftSchedulingInfo)
        if(moment(draftSchedulingInfo).isBefore(moment())) {     
          // let scheduleDate = moment().add(12, 'minutes').format()
          let scheduleDate = moment().add(1, 'minutes').format()
          this.scheduling.date = moment.utc(scheduleDate).local().format()
          this.scheduling.show = true
          this.scheduling.lastScheduled = moment.utc(scheduleDate).local().format()
          this.scheduling.time.HH = moment.utc(scheduleDate).local().hour() < 10 
                                    ? `0${moment.utc(scheduleDate).local().hour()}`
                                    : `${moment.utc(scheduleDate).local().hour()}`
          this.scheduling.time.mm = moment.utc(scheduleDate).local().minute() < 10 
                                    ?`0${moment.utc(scheduleDate).local().minute()}`
                                    : `${moment.utc(scheduleDate).local().minute()}`
           
        console.log('update', this.scheduling)                         
        }
        else this.scheduling = postData.scheduling
      }
      // if no scheduling date => init
      else {
        // let scheduleDate = moment().add(12, 'minutes').format()
        let scheduleDate = moment().add(1, 'minutes').format()
        this.scheduling.date = moment.utc(scheduleDate).local().format()
        this.scheduling.lastScheduled = moment.utc(scheduleDate).local().format()
        this.scheduling.time.HH = moment.utc(scheduleDate).local().hour() < 10 
                                  ? `0${moment.utc(scheduleDate).local().hour()}`
                                  : `${moment.utc(scheduleDate).local().hour()}`
        this.scheduling.time.mm = moment.utc(scheduleDate).local().minute() < 10 
                                  ?`0${moment.utc(scheduleDate).local().minute()}`
                                  : `${moment.utc(scheduleDate).local().minute()}`
      }
      this.validMentions = postData.validMentions
      this.multipleImages = postData.multipleImages.map(c => {
          return {
            ...c,
            ext: c.filename.slice(c.filename.lastIndexOf('.')+1).toLocaleLowerCase()
          }
        })
      this.multipleMedias = postData.multipleMedias || []
      this.templateManual = postData.templateManual
      this.layers = postData.layers
      this.carrouselRatio = postData.carrouselRatio
      // this.instagramTexts = postData.instagramTexts
      this.instagramTextsUpdater = postData.instagramTexts
      this.storyLinkText = postData.storyLinkText
      this.storyShareToFacebook = postData.storyShareToFacebook
      this.shareAfterPost = postData.shareAfterPost || (postData.storyShareToFacebook && this.typePost !== "story")
      this.storyMultiple = postData.storyMultiple

      
      for (let [idx, e] of this.storyMultiple.entries()) {
        if (e.story) {
          this.storyMultiple[idx].story = {...e.story, ...this.convertOldStoryMakerInformations(e.story)};
        }
      }
      
      postData = this.convertOldStoryMakerInformations(postData);

      if (postData.storificationData && postData.storificationData.product && postData.storificationData.product.items) {
        let instaBot = this.bots.find(b => this.bot.includes(b.id) && b.page.network == 'instagram' && b.page.story_config && b.page.story_config.created);
        postData.storificationData.product.items = postData.storificationData.product.items.filter(p => p.id && p.merchantId)
        for (let it of postData.storificationData.product.items) {
          let item = await this.chooseItemShopInstagram(instaBot.page.id, it.id, it.merchantId);
          console.log("product items", item);
          it.image = item.body.items[0].image
        }
      }

      this.$store.commit(`updateStorification`, postData.storificationData)
      this.snippetTitle = postData.snippetTitle
      this.snippet = postData.snippet
      this.carouselOrderDragElement = postData.carouselOrderDragElement
      this.poll = postData.poll
      this.instagramLinkPosition = postData.instagramLinkPosition
      this.highlightInstagram = postData.highlightInstagram
      this.instagramBackgroundColor = postData.instagramBackgroundColor
      this.sharedStoryUrl = postData.sharedStoryUrl
      this.storySharedVisual = postData.storySharedVisual
      this.videoReel = postData.videoReel
      this.videoReelFB = postData.videoReelFB
      if (postData.typePost === 'story') {
        this.videos = postData.storyVideo && postData.videos ? JSON.parse(postData.videos) : []
      } else {
        this.videos = postData.videos ? JSON.parse(postData.videos) : []
      }
      // this.selectedLocation = postData.location ? JSON.parse(postData.location) : null
      if(postData.location) {
        let location = JSON.parse(postData.location)
        if(location.facebook || location.instagram) {
          this.selectedLocation = location;
          this.searchLocationInput = {
            instagram: location.instagram && location.instagram.name,
            facebook: location.facebook && location.facebook.name
          };
        }
        else {
          this.selectedLocation = {
            facebook: location,
            instagram: location
          };
        }
      }
      else this.selectedLocation = null
      this.userTags = postData.userTags ? JSON.parse(postData.userTags) :  {list: [],collab: []};
      this.userTags.list = this.userTags.list.map(l => {
        l.image = this.multipleImages[l.index].id
        return l
      })

      if (postData.productTags) {
        this.productTags = postData.productTags ? JSON.parse(postData.productTags) : [];
        this.productTags = this.productTags.filter(p => p.id && p.merchantId)
        let instaBot = this.bots.find(b => this.bot.includes(b.id) && b.page.network == 'instagram' && b.page.story_config && b.page.story_config.created);
        for (let it of this.productTags) {
          let item = await this.chooseItemShopInstagram(instaBot.page.id, it.id, it.merchantId);
          console.log("product items", item);
          it.image = item.body.items[0].image
        }

      }
      if (this.form && (!this.form.file || !this.form.file.name) && (!this.form.enclosure || this.form.enclosure.includes('blob:')) && this.multipleImages && this.multipleImages[0] && this.multipleImages[0].url) {
        this.form.enclosure = this.multipleImages[0].url;
        this.form.file = null;
      }
      this.storyVideo = postData.storyVideo;
      this.pollStory = postData.pollStory;
      if (this.pollStory && this.pollStory.question && Array.isArray(this.pollStory.question)) {
        this.pollStory.question = this.pollStory.question.join(' ');
      }
      this.sliderStory = postData.sliderStory;
      if (this.sliderStory && this.sliderStory.question && Array.isArray(this.sliderStory.question)) {
        this.sliderStory.question = this.sliderStory.question.join(' ');
      }
      this.questionStory = postData.questionStory;
      if (this.questionStory && this.questionStory.text && Array.isArray(this.questionStory.text)) {
        this.questionStory.text = this.questionStory.text.join(' ');
      }
     
      // this.selectedMusic = postData.musicStory
      if (this.selectedMusic && this.selectedMusic.track) {
        let instaBot = this.bots.find(b => this.bot.includes(b.id) && b.page.network == 'instagram' && b.page.story_config && b.page.story_config.created);
        if (!instaBot) {
          // this.selectedMusic = null;
            this.notify({
              title: "Music error",
              text: this.$t('dash.notifications.story.music.error'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
        }
        this.getMusicsByApi(instaBot.page.id, this.selectedMusic.track.title).then(resultMusic => {
          if (resultMusic && resultMusic.body && resultMusic.body.musics) {
            let newMusicUrl = resultMusic.body.musics.find(e => e.track.id === this.selectedMusic.track.id);
            if (newMusicUrl) {
              let music = this.videoReel && this.typePost === 'video' ? this.$store.getters.storificationMusicReel : this.$store.getters.storificationMusic;
              music.metadata = newMusicUrl.metadata;
              music.track = newMusicUrl.track;
              this.videoReel && this.typePost === 'video' ? this.$store.commit("updateStorificationMusicReel", music) : this.$store.commit("updateStorificationMusic", music);
              // if (this.$refs.storymaker && this.$refs.storymaker[0]) {
              //   this.$refs.storymaker[0].pauseMusic();
              //   setTimeout(() => this.$refs.storymaker[0].playMusic(), 100);
                
              // }
            }
          } else {
            // this.selectedMusic = null;
            this.notify({
              title: "Music error",
              text: this.$t('dash.notifications.story.music.error'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          }
        });
      }
      this.selectedGifs = postData.gifsStory
      this.storyMentions = this.post.data.mentionsWidget
      this.filename = postData.filename
      this.videoname = postData.videoname
      this.tiktokOptions = postData.tiktokOptions ? JSON.parse(postData.tiktokOptions) : null
      this.youtubeOptions = postData.youtubeOptions ? JSON.parse(postData.youtubeOptions) : null
      this.twitterOptions = postData.twitterOptions ? JSON.parse(postData.twitterOptions) : {reply_settings: null}
      this.facebookOptions = postData.facebookOptions ? JSON.parse(postData.facebookOptions) : null
      this.validHashtags = postData.validHashtags
      this.compressedImages = postData.compressedImages
      
      this.affectedTo = postData.affectedTo ? (typeof postData.affectedTo == 'object' ? postData.affectedTo : JSON.parse(postData.affectedTo)) : null
      if(['duplicate-post-unique', 'duplicate-post'].includes(this.state)) this.affectedTo = null

      for (let [idx, e] of this.storyMultiple.entries()) {
        if (e.isActive) {
          await this.getMultipleStory(idx);
        }
      }


      localStorage.setItem('mentionsAdded', JSON.stringify(postData.mentionsAdded ? postData.mentionsAdded : []))
      localStorage.setItem('hashtagsAdded', JSON.stringify(postData.hashtagsAdded ? postData.hashtagsAdded : []))
      
      this.$nextTick(() => this.allTextAreasAdjust())

      if(!locale && this.post && this.post.toSchedule)
        this.storyMultiple.length > 1 ? this.validateMultipleStory('post') : this.validate('posts')
    },

    async fillFormWithScheduledPost(){
      let draft = JSON.parse(this.post.page[0].draft)
      console.log("fillFormWithScheduledPost", draft);

      draft.bot.map(async item => {
        let page = this.getPageInfoByBot(item)
        if (page.network === 'instagram' && page.story_config && page.story_config.created) {
          let isLocked = await this.checkLockDirectApi(page);
          if ((draft.typePost === "story" || draft.shareAfterPost) && isLocked.locked) {
            let date = new Date(page.story_config.lock)
            this.notify({
                  title: "Account error",
                  text: this.$t('dash.story.account.locked') + date.toLocaleString(),
                  color:'warning',
                  time: 10000,
                })
            return;
          } 
        }
      })
      
      this.form = draft.form
      
      if(!this.form.comments)
        this.form.comments = []

      this.url = draft.form.enclosure || this.post.page[0].enclosure || draft.form.enclosure //this.post.data.form.url
      this.typePost = draft.typePost
      if(this.state == 'duplicate-post-unique')
        this.bot = [this.bots.find(b => b.page.id == this.page).id]
      else
        this.bot = draft.bot.filter(bId => this.bots.find(b => b.id == bId))
      this.activeHashtagsAutoAdd = draft.activeHashtagsAutoAdd
      this.activeMentionsAutoReplace = draft.activeMentionsAutoReplace
      this.activePrefixSuffix = draft.activePrefixSuffix
      // this.editPostValue = draft.editPostValue
      this.editPostValue = draft.editPostValue.map(e => {
        if(e.scheduling) {
          let draftSchedulingInfo = moment(e.scheduling.date);
          draftSchedulingInfo.hours(e.scheduling.time.HH);
          draftSchedulingInfo.minutes(e.scheduling.time.mm);
          if(moment(draftSchedulingInfo).isBefore(moment())) {
            delete e.scheduling
          }
        }
        return e
      })
      // this.scheduling = draft.scheduling
      if(draft.scheduling && draft.scheduling.date && draft.scheduling.time.HH && draft.scheduling.time.mm){
        let draftSchedulingInfo = moment(draft.scheduling.date);
        draftSchedulingInfo.hours(draft.scheduling.time.HH);
        draftSchedulingInfo.minutes(draft.scheduling.time.mm);
        // if scheduling date is passed => init
        console.log('chhheck', draftSchedulingInfo, moment(draftSchedulingInfo).isBefore(moment()))
        if(moment(draftSchedulingInfo).isBefore(moment())) {     
          // let scheduleDate = moment().add(12, 'minutes').format()
          let scheduleDate = moment().add(1, 'minutes').format()
          this.scheduling.date = moment.utc(scheduleDate).local().format()
          this.scheduling.show = true
          this.scheduling.lastScheduled = moment.utc(scheduleDate).local().format()
          this.scheduling.time.HH = moment.utc(scheduleDate).local().hour() < 10 
                                    ? `0${moment.utc(scheduleDate).local().hour()}`
                                    : `${moment.utc(scheduleDate).local().hour()}`
          this.scheduling.time.mm = moment.utc(scheduleDate).local().minute() < 10 
                                    ?`0${moment.utc(scheduleDate).local().minute()}`
                                    : `${moment.utc(scheduleDate).local().minute()}`
        console.log('this.scheduling', this.scheduling)
        }
        else this.scheduling = draft.scheduling
      }
      // if no scheduling date => init
      else {
        // let scheduleDate = moment().add(12, 'minutes').format()
        let scheduleDate = moment().add(1, 'minutes').format()
        this.scheduling.date = moment.utc(scheduleDate).local().format()
        this.scheduling.lastScheduled = moment.utc(scheduleDate).local().format()
        this.scheduling.time.HH = moment.utc(scheduleDate).local().hour() < 10 
                                  ? `0${moment.utc(scheduleDate).local().hour()}`
                                  : `${moment.utc(scheduleDate).local().hour()}`
        this.scheduling.time.mm = moment.utc(scheduleDate).local().minute() < 10 
                                  ?`0${moment.utc(scheduleDate).local().minute()}`
                                  : `${moment.utc(scheduleDate).local().minute()}`
      }
      
      this.validMentions = draft.validMentions
      this.multipleImages = this.post.page[0].carousel || []
      if(this.typePost == 'image' && this.url && !this.multipleImages.length)
        this.multipleImages = draft.multipleImages.map(i => {
          return {
            ...i,
            url: this.url
          }
        })
      this.compressedImages = this.multipleImages.filter(e => e.uploaded).map(e => e.id);
      this.multipleMedias = draft.multipleMedias || []
      this.templateManual = draft.templateManual
      this.layers = draft.layers
      this.carrouselRatio = draft.carrouselRatio
      // this.instagramTexts = draft.instagramTexts
      this.instagramTextsUpdater = draft.instagramTexts
      this.storyLinkText = draft.storyLinkText
      this.storyShareToFacebook = draft.storyShareToFacebook
      this.shareAfterPost = draft.shareAfterPost || (draft.storyShareToFacebook && this.typePost !== 'story')

      // this.storyMultiple = draft.storyMultiple

      
      // for (let [idx, e] of this.storyMultiple.entries()) {
      //   if (e.story) {
      //     this.storyMultiple[idx].story = {...e.story, ...this.convertOldStoryMakerInformations(e.story)};
      //   }
      // }

      draft = this.convertOldStoryMakerInformations(draft);
      if (draft.storificationData && draft.storificationData.product && draft.storificationData.product.items) {
        let instaBot = this.bots.find(b => this.bot.includes(b.id) && b.page.network == 'instagram' && b.page.story_config && b.page.story_config.created);
        draft.storificationData.product.items = draft.storificationData.product.items.filter(p => p.id && p.merchantId)
        for (let it of draft.storificationData.product.items) {
          let item = await this.chooseItemShopInstagram(instaBot.page.id, it.id, it.merchantId);
          console.log("product items", item);
          it.image = item.body.items[0].image
        }
      }
      this.$store.commit(`updateStorification`, draft.storificationData)
      this.snippetTitle = draft.snippetTitle
      this.snippet = this.post.page[0].snippet //draft.snippet
      this.carouselOrderDragElement = draft.carouselOrderDragElement
      this.poll = draft.poll
      this.instagramLinkPosition = draft.instagramLinkPosition
      this.highlightInstagram = draft.highlightInstagram
      this.instagramBackgroundColor = draft.instagramBackgroundColor
      this.sharedStoryUrl = draft.sharedStoryUrl
      this.storySharedVisual = draft.storySharedVisual
      this.videoReel = draft.videoReel
      this.videoReelFB = draft.videoReelFB
      this.videos = draft.videos ? JSON.parse(draft.videos) : []
      // this.selectedLocation = draft.location ? JSON.parse(draft.location) : null
      if(draft.location) {
        let location = JSON.parse(draft.location)
        if(location.facebook || location.instagram) {
          this.selectedLocation = location;
          this.searchLocationInput = {
            instagram: location.instagram && location.instagram.name,
            facebook: location.facebook && location.facebook.name
          };
        }
        else {
          this.selectedLocation = {
            facebook: location,
            instagram: location
          };
        }
      }
      else this.selectedLocation = null
      this.userTags = draft.userTags ? JSON.parse(draft.userTags) :  {list: [],collab: []};
      this.userTags.list = this.userTags.list.map(l => {
        l.image = this.multipleImages[l.index].id
        return l
      })
      if (draft.productTags) {
        this.productTags = draft.productTags ? JSON.parse(draft.productTags) : [];
        this.productTags = this.productTags.filter(p => p.id && p.merchantId)
        let instaBot = this.bots.find(b => this.bot.includes(b.id) && b.page.network == 'instagram' && b.page.story_config && b.page.story_config.created);
        for (let it of this.productTags) {
          let item = await this.chooseItemShopInstagram(instaBot.page.id, it.id, it.merchantId);
          console.log("product items", item);
          it.image = item.body.items[0].image
        }
      }
      if(this.post.enclosure && this.post.page && this.post.page[0] && this.post.page[0].story && !this.post.page[0].story_standard_api && !this.post.page[0].new_story_creation) {
        this.isNewImage = true;
        this.form.enclosure = this.post.enclosure;
        this.url = this.post.enclosure
        if (this.post.enclosure.endsWith(".mp4")) {
          this.form.video = this.post.enclosure;
          this.form.enclosure = null;
          this.url = null;
        }
        this.form.file = null;
      } else if (this.form && (!this.form.file || !this.form.file.name) && (!this.form.enclosure || this.form.enclosure.includes('blob:')) && this.multipleImages && this.multipleImages[0] && this.multipleImages[0].url) {
        this.form.enclosure = `${this.multipleImages[0].url}`;
        this.form.file = null;
      }
      else if(this.post.page[0].enclosure && !this.post.page[0].story_standard_api && !this.post.page[0].new_story_creation) {
        this.form.enclosure = `${this.post.page[0].enclosure}`;
        if (this.post.page[0].enclosure.endsWith(".mp4")) {
          this.form.video = this.post.page[0].enclosure;
          this.form.enclosure = null;
          this.url = null;
        }
        this.form.file = null;
      } else if (this.post.page[0].video && !this.form.video) {
        this.form.video = this.post.page[0].video;
        this.form.enclosure = null;
        this.url = null;
      }
      this.storyVideo = draft.storyVideo
      // this.selectedMusic = draft.musicStory
      if (this.selectedMusic && this.selectedMusic.track) {
        let instaBot = this.bots.find(b => this.bot.includes(b.id) && b.page.network == 'instagram' && b.page.story_config && b.page.story_config.created);
        if (!instaBot) {
          // this.selectedMusic = null;
          this.notify({
            title: "Music error",
            text: this.$t('dash.notifications.story.music.error'),
            color:'success',
            time: 10000,
            id: 'norepeat'
          })
        }
        this.getMusicsByApi(instaBot.page.id, this.selectedMusic.track.title).then(resultMusic => {
          if (resultMusic && resultMusic.body && resultMusic.body.musics) {
            let newMusicUrl = resultMusic.body.musics.find(e => e.track.id === this.selectedMusic.track.id);
            if (newMusicUrl) {
              let music = this.videoReel && this.typePost === 'video' ? this.$store.getters.storificationMusicReel : this.$store.getters.storificationMusic;
              music.metadata = newMusicUrl.metadata;
              music.track = newMusicUrl.track;
              this.videoReel && this.typePost === 'video' ? this.$store.commit("updateStorificationMusicReel", music) : this.$store.commit("updateStorificationMusic", music);
              // if (this.$refs.storymaker && this.$refs.storymaker[0]) {
              //   this.$refs.storymaker[0].pauseMusic();
              //   setTimeout(() => this.$refs.storymaker[0].playMusic(), 100);
                
              // }
            }
          } else {
            // this.selectedMusic = null;
            this.notify({
              title: "Music error",
              text: this.$t('dash.notifications.story.music.error'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          }
        });
      }
      this.selectedGifs = draft.gifsStory
      this.storyMentions = draft.mentionsWidget
      this.pollStory = draft.pollStory
      if (this.pollStory && this.pollStory.question) {
        this.pollStory.question = this.pollStory.question.join(' ')
      }
      this.sliderStory = draft.sliderStory
      if (this.sliderStory && this.sliderStory.question) {
        this.sliderStory.question = this.sliderStory.question.join(' ')
      }
      this.questionStory = draft.questionStory
      if (this.questionStory && this.questionStory.text) {
        this.questionStory.text = this.questionStory.text.join(' ')
      }
      this.filename = draft.filename
      this.videoname = draft.videoname
      this.tiktokOptions = draft.tiktokOptions ? JSON.parse(draft.tiktokOptions) : null
      this.youtubeOptions = draft.youtubeOptions ? JSON.parse(draft.youtubeOptions) : null
      this.twitterOptions = draft.twitterOptions ? JSON.parse(draft.twitterOptions) : {reply_settings: null}
      this.facebookOptions = draft.facebookOptions ? JSON.parse(draft.facebookOptions) : null
      this.validHashtags = draft.validHashtags

      this.affectedTo = draft.affectedTo ? JSON.parse(draft.affectedTo) : null
      if(['duplicate-post-unique', 'duplicate-post'].includes(this.state)) this.affectedTo = null

      // this.storyMultiple = draft.storyMultiple
      if (this.post.page[0].story_multiple) {
        let loadedStoryMultiple = JSON.parse(this.post.page[0].story_multiple)
        console.log("loadedStoryMultiple", loadedStoryMultiple);
        this.storyMultiple = JSON.parse(loadedStoryMultiple.allStories[0].draft).storyMultiple.map((e, i) => {
          if (e.story.enclosure && e.story.enclosure.includes('blob:')) {
            e.story.enclosure = null;
          }
          if (e.video && e.video.includes('blob:')) {
            e.video = null;
          }
          return {...e, isActive: i == loadedStoryMultiple.nbCurrent-1}
        });
        console.log("storyMultiple", this.storyMultiple);
      }
      for (let [idx, e] of this.storyMultiple.entries()) {
        if (e.isActive) {
          console.log(e, idx);
          await this.getMultipleStory(idx);
        }
      }

      if (this.state === 'edit-posted') {
        this.scheduling.show = false;
        this.bot = this.bot.filter(b => {
          let page = this.getPageInfoByBot(b)
          return this.canUpdatePostedPost(page)
        })
        this.shareAfterPost = false;
        this.storyShareToFacebook = false;
      }

      this.bot.map(async item => {
        let page = this.getPageInfoByBot(item)
        if (page.network === 'instagram' && page.story_config && page.story_config.created) {
          if (this.state === 'edit-posted' && ((this.multipleImages && this.multipleImages.length) || (this.multipleMedias && this.multipleMedias.length))) {
            let uidPage = this.bots.find(b => b.id == item).uid;
            console.log(page, item, uidPage);
            let pageEmbed = this.post.page.find(p => p.id == uidPage);
            console.log(pageEmbed.post_number);
            let infosResponse = await this.getInstagramMediaInfoByAPI(page.id, pageEmbed.post_number);
            console.log("infosInstagramMedia", infosResponse);
            if (infosResponse.infos && infosResponse.infos.carousel_media) {
              await new Promise(resolve => setTimeout(resolve, 1000));
              if (this.multipleImages && this.multipleImages.length) {
                this.multipleImages = this.multipleImages.map((img, idx) => {
                  if (infosResponse.infos.carousel_media[idx] && infosResponse.infos.carousel_media[idx].id) {
                    img.instagramMediaId = infosResponse.infos.carousel_media[idx].id;
                    img.instagramPk = infosResponse.infos.carousel_media[idx].pk;
                  }
                  return img;
                });
              } else if (this.multipleMedias && this.multipleMedias.length) {
                this.multipleMedias = this.multipleMedias.map((img, idx) => {
                  if (infosResponse.infos.carousel_media[idx] && infosResponse.infos.carousel_media[idx].id) {
                    img.instagramMediaId = infosResponse.infos.carousel_media[idx].id;
                    img.instagramPk = infosResponse.infos.carousel_media[idx].pk;
                  }
                  return img;
                });
              }
            }
          }
        }
      })
      
      // post error
      if(this.state == 'duplicate-post-unique' && this.post._bots && this.post._bots[0] && this.post._bots[0].linkInComments) {
        this.form.comments = [this.form.url]
        this.editPostValue = [{"page": this.post._bots[0].page.id, "removeUrlInMessage": true}]
      }

      localStorage.setItem('mentionsAdded', JSON.stringify(draft.mentionsAdded ? draft.mentionsAdded : []))
      localStorage.setItem('hashtagsAdded', JSON.stringify(draft.hashtagsAdded ? draft.hashtagsAdded : []))
      
      if(this.post && this.post.toPost) {
        this.scheduling.show = false
        this.storyMultiple.length > 1 ? this.validateMultipleStory('post') : this.validate('posts')
      }

      this.$nextTick(() => this.allTextAreasAdjust())
    },

    canUpdatePostedPost(page) {
      let possibleNetwork = ['facebook', 'linkedin']
      let isStory = this.post.page && this.post.page.find(p => p.network == 'instagram' && p.story);
      return (page.network == 'instagram' && page.story_config && page.story_config.created && !isStory) || possibleNetwork.includes(page.network);
    },

    convertOldStoryMakerInformations(postData) {
      if (!postData.storificationData) {
        postData.storificationData = {};
      }
      if (postData.instagramBackgroundColor && !postData.storificationData.backgroundColor) {
        postData.storificationData.backgroundColor = postData.instagramBackgroundColor;
      }
      if (postData.background_color && !postData.storificationData.backgroundColor) {
        const rgbToHex = (r, g, b) => `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`
        postData.storificationData.backgroundColor = rgbToHex(postData.background_color[0], postData.background_color[1], postData.background_color[2]);
      }
      if (postData.instagramLinkPosition && !postData.storificationData.link) {
        postData.storificationData.link = {
          active: true,
          angle: postData.instagramLinkPosition.angle,
          scale: postData.instagramLinkPosition.scale,
          color: postData.instagramLinkPosition.color,
          x: (postData.instagramLinkPosition.x * 1.11111111111) - (150/2),
          y: (postData.instagramLinkPosition.y * 1.11111111111) - (30/2),
        }
        if (postData.storyLinkText) {
          postData.storificationData.link.text = postData.storyLinkText;
        }
      }
      if (postData.link && !postData.storificationData.link) {
        postData.storificationData.link = {
          active: true,
          angle: postData.link.angle || 0,
          scale: postData.link.scale || 1,
          color: postData.link.color,
          x: (postData.link.x * 1.11111111111) - (150/2),
          y: (postData.link.y * 1.11111111111) - (30/2),
        }
        if (postData.storyLinkText) {
          postData.storificationData.link.text = postData.storyLinkText;
        }
        if (postData.linkText) {
          postData.storificationData.link.text = postData.linkText;
        }
      }
      if (postData.instagramTexts && !postData.storificationData.texts) {
        postData.storificationData.texts = postData.instagramTexts.map(e => {
          e.visible = e.visible || true;
          e.x = (e.x * 1.11111111111);
          e.y = (e.y * 1.11111111111);
          e.w = (e.w * 1.11111111111);
          e.h = (e.h * 1.11111111111);
          return e;
        });
      }
      if (postData.story_instagram && !postData.storificationData.texts) {
        postData.storificationData.texts = postData.story_instagram.map(e => {
          e.visible = e.visible || true;
          e.x = (e.x * 1.11111111111);
          e.y = (e.y * 1.11111111111);
          e.w = (e.w * 1.11111111111);
          e.h = (e.h * 1.11111111111);
          return e;
        });
      }
      if (postData.layers && !postData.storificationData.layers) {
        postData.storificationData.layers = postData.layers.map(e => {
          e.x = (e.x/3.33 * 1.11111111111);
          e.y = (e.y/3.33 * 1.11111111111);
          e.w = (e.w/3.33 * 1.11111111111);
          e.h = (e.h/3.33 * 1.11111111111);
          return e;
        });
      }
      if (postData.gifsStory && !postData.storificationData.gifs) {
        postData.storificationData.gifs = postData.gifsStory.map(e => {
          e.x = (e.x/3.33 * 1.11111111111);
          e.y = (e.y/3.33 * 1.11111111111);
          e.w = (e.w/3.33 * 1.11111111111);
          e.h = (e.h/3.33 * 1.11111111111);
          return e;
        });
      }
      if (postData.mentionsWidget && !postData.storificationData.mentions) {
        postData.storificationData.mentions = postData.mentionsWidget.map(e => {
          e.x = (e.x/3.33 * 1.11111111111);
          e.y = (e.y/3.33 * 1.11111111111);
          e.w = (e.w/3.33 * 1.11111111111);
          e.h = (e.h/3.33 * 1.11111111111);
          return e;
        });
      }
      if (postData.musicStory && !postData.storificationData.music) {
        postData.storificationData.music = postData.musicStory;
      }
      if (postData.pollStory && !postData.storificationData.poll) {
        postData.storificationData.poll = postData.pollStory;
        postData.storificationData.poll.x = (postData.storificationData.poll.x * 1.11111111111) - (180/2);
        postData.storificationData.poll.y = (postData.storificationData.poll.y * 1.11111111111) - (120/2);
      } 
      else if (postData.poll && postData.poll.x && postData.poll.y && !postData.poll.duration && !postData.storificationData.poll) {
        postData.storificationData.poll = postData.poll;
        postData.storificationData.poll.x = (postData.storificationData.poll.x * 1.11111111111) - (180/2);
        postData.storificationData.poll.y = (postData.storificationData.poll.y * 1.11111111111) - (120/2);
      }
      if (postData.sliderStory && !postData.storificationData.slider) {
        postData.storificationData.slider = postData.sliderStory;
        postData.storificationData.slider.x = (postData.storificationData.slider.x * 1.11111111111) - (250/2);
        postData.storificationData.slider.y = (postData.storificationData.slider.y * 1.11111111111) - (70/2);
        postData.storificationData.slider.color = ["#ffffff", '#000000', "#E50075", "#d734cd", "#8147f6", "#ee8132", "#5ece55", "#47a1f8", "#59c5f7"].findIndex((c) => c === postData.sliderStory.color)
        if (postData.storificationData.slider.color === -1) postData.storificationData.slider.color = 0;
      } else if (postData.slider && !postData.storificationData.slider) {
        postData.storificationData.slider = postData.slider;
        postData.storificationData.slider.x = (postData.storificationData.slider.x * 1.11111111111) - (250/2);
        postData.storificationData.slider.y = (postData.storificationData.slider.y * 1.11111111111) - (70/2);
        postData.storificationData.slider.color = ["#ffffff", '#000000', "#E50075", "#d734cd", "#8147f6", "#ee8132", "#5ece55", "#47a1f8", "#59c5f7"].findIndex((c) => c === postData.sliderStory.color)
        if (postData.storificationData.slider.color === -1) postData.storificationData.slider.color = 0;
      }
      if (postData.questionStory && !postData.storificationData.question) {
        postData.storificationData.question = postData.questionStory;
        postData.storificationData.question.x = (postData.storificationData.question.x * 1.11111111111) - (250/2);
        postData.storificationData.question.y = (postData.storificationData.question.y * 1.11111111111) - (70/2);
        postData.storificationData.question.color = ["#ffffff", '#000000', "#E50075", "#d734cd", "#8147f6", "#ee8132", "#5ece55", "#47a1f8", "#59c5f7"].findIndex((c) => c === postData.questionStory.color)
        if (postData.storificationData.question.color === -1) postData.storificationData.question.color = 0;
      } else if (postData.question && !postData.storificationData.question) {
        postData.storificationData.question = postData.question;
        postData.storificationData.question.x = (postData.storificationData.question.x * 1.11111111111) - (250/2);
        postData.storificationData.question.y = (postData.storificationData.question.y * 1.11111111111) - (70/2);
        postData.storificationData.question.color = ["#ffffff", '#000000', "#E50075", "#d734cd", "#8147f6", "#ee8132", "#5ece55", "#47a1f8", "#59c5f7"].findIndex((c) => c === postData.question.color)
        if (postData.storificationData.question.color === -1) postData.storificationData.question.color = 0;
      }
      if (postData.templateManual && !postData.storificationData.template) {
        postData.storificationData.template = postData.templateManual;
      }
      if (postData.template && !postData.storificationData.template) {
        postData.storificationData.template = postData.template;
      }
      if (postData.highlightInstagram && !postData.storificationData.hightlight) {
        postData.storificationData.hightlight = postData.highlightInstagram;
      }
      if (postData.highlight && !postData.storificationData.hightlight) {
        postData.storificationData.hightlight = postData.highlight;
      }
      return postData;
    },

    getPostUrl(){
      const { page, linked, post } = this
      let network = linked.find(l => l.id == page).network
      let url = ''
      if(network == 'facebook'){
        url = `https://www.facebook.com/${post.page[0].post_number}`
      }
      else if(network == 'twitter'){
        const username = post._bots.find(b => b.uid == post.page[0].id).page.name
        url = `https://www.twitter.com/${username}/status/${post.page[0].post_number}`
      }
      return url
    },

    initSchedulingDate(day, hour, minute) {
      if(day!=null && hour!=null && minute!=null) {
        this.scheduling.show = true
        this.scheduling.date = moment(day).format()
        this.scheduling.time.HH = hour < 10 ? `0${hour}` : `${hour}`
        this.scheduling.time.mm = minute < 10 ? `0${minute}` : `${minute}`
      }
      else {
        this.scheduling.show = false
      }
    },

    /**
     * Fill form on edit mode
     */
    setPage() {
      let page = this.linked.find(element => {
        return element.id === this.page
      })
      this.form.page = this.linked.indexOf(page)
    },

    initInputFile(e){
      e.target.value = null
    },


    async uploadImage(file) {
      return new Promise((resolve, reject) => {
        this.onUpload = true
        this.messageUpload = this.$t("dash.message.convert.part1");
        this.uploadFileWithProgress(file, true).then(res => {

          const { success, file_url } = res.body

          if(success && file_url) {
            this.percentUpload = 105;
            this.messageUpload = this.$t("dash.message.convert.part2");

            this.compressImage(file_url).then(res => {
              console.log("Commpress Imgae res : ", res);
              console.log(this.compressedImages.length + 1, this.multipleImages.length);
              if (this.compressedImages.length + 1 >= this.multipleImages.length) {
                this.onUpload = false;
                this.isThumbUpload = false;
                this.messageUpload = '';
              }
              this.percentUpload = 0;
              if (res.ok && res.body.success) {
                resolve(res.body.url)
              } else {
                this.form.file = null
                this.form.encolsure = null
                this.filename = null
                this.notify({
                  title: "Encoding error",
                  text: res.error,
                  color:'success',
                  time: 10000,
                  id: 'norepeat'
                })
                reject();
              }
            });
            this.form.enclosure = file_url
            this.keyRefresh = Math.random().toString(36)
          }
          else {
            this.form.file = null
            this.form.encolsure = null
            this.filename = null
            this.notify({
                  title: "Encoding error",
                  text: res.error,
                  color:'success',
                  time: 10000,
                  id: 'norepeat'
            })
            reject();
          }
        })
      })
    },

    /**
     * Select file
     */
    async select(thumb = false) {  
        const checkResolution = async (file) => {{
          if (!file.type.startsWith('image/')) return null
          let img = new Image();
          img.src = window.URL.createObjectURL( file );
          return new Promise((resolve, reject) => {
            img.onload = function() {
              let width = img.naturalWidth,
                  height = img.naturalHeight;
              window.URL.revokeObjectURL( img.src );
              resolve({width, height})
            }
          })
        }}

        if (this.$refs.myFiles.files[0].type !== 'application/pdf' && this.typePost === 'document') {
            return this.notify({
              title:"Erreur de format du document",
              text:`Seul les documents au format PDF sont acceptés`,
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
        } else if (this.typePost === 'image' && this.$refs.myFiles.files[0].type === "application/pdf") {
            return this.notify({
              title:"Erreur de format d'image",
              text:`Pour poster des documents PDF sur Linkedin, vous pouvez souscrire à l'offre <a href="http://${location.host}/#/dash/settings" style="color: #0645AD; font-weight: bold">Conciergerie</a>`,
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
        }
        let resolution = await checkResolution(this.$refs.myFiles.files[0]);
        if (resolution && (resolution.width > 8000 || resolution.height > 8000)) {
          return this.notify({
            title:"Resolution error",
            text: this.$t('dash.notifications.limit_image_resolution'),
            color:'success',
            time: 10000,
          })
        }

        
        this.isThumbUpload = thumb;
        
        console.log(this.$refs.myFiles.files[0]);
        this.form.file = this.$refs.myFiles.files[0]
        this.filename = this.form.file.name
        this.url = URL.createObjectURL(this.form.file) || this.url
        if (this.typePost === 'story') {
          this.form.enclosure = URL.createObjectURL(this.form.file) || this.form.enclosure
          if (this.form.file/*  && !this.form.fileUploaded */) {
            // console.log("Upload Story Image", this.form.file)
            this.uploadImage(this.form.file).then(compressedUrl => {
              this.form.file = null;
              this.form.enclosure = `${compressedUrl}`;
              this.url = `${compressedUrl}`;
              console.log("Uploaded story image :", compressedUrl);
            });
          }
          this.videos['instagram'] = undefined;
        }
        this.isNewImage = true;
        this.instagramBackgroundColor = null;
        
        if (this.typePost === "document" && !this.form.documentTitle) {
          this.form.documentTitle = this.filename;
        }
        if ((this.$refs.myFiles.files.length > 1 || this.multipleImages.length > 0) && this.typePost !== 'story' && this.typePost !== 'document') {
          let allFiles = [...this.$refs.myFiles.files];
          allFiles.sort((a,b) => a.name - b.name);
          console.log(allFiles);
          for (let [idx, file] of allFiles.entries()) {
            let id = Math.random().toString(36).substr(2, 9);
            file.id = id;
            this.multipleImages.push({
              url: URL.createObjectURL(file),
              // type: file.name.split('.').pop()
              filename: file.name,
              file: file,
              size: file.size,
              id,
              ratio: this.carrouselRatio,
              facebook: idx + this.multipleImages.length,
              twitter: idx + this.multipleImages.length,
              linkedin: idx + this.multipleImages.length,
            })
          }
          for (let [idx, file] of allFiles.entries()) {
            // let id = Math.random().toString(36).substr(2, 9);
            await this.uploadImage(file).then(compressedUrl => {
              this.form.file = null;
              this.compressedImages.push(file.id);
              this.multipleImages.find(e => e.id === file.id).url = compressedUrl;
              this.multipleImages.find(e => e.id === file.id).uploaded = true;
            });
            // this.multipleImages.push({
            //   url: URL.createObjectURL(file),
            //   filename: file.name,
            //   file: file,
            //   size: file.size,
            //   id,
            //   ratio: this.carrouselRatio,
            //   facebook: idx + this.multipleImages.length,
            //   twitter: idx + this.multipleImages.length,
            //   linkedin: idx + this.multipleImages.length,
            // })
          }
          // this.multipleImages = [...this.multipleImages, ...allFiles.map((file, idx) => {
          //   return {
          //     url: URL.createObjectURL(file),
          //     filename: file.name,
          //     file: file,
          //     size: file.size,
          //     id: Math.random().toString(36).substr(2, 9),
          //     ratio: this.carrouselRatio,
          //     facebook: idx + this.multipleImages.length,
          //     twitter: idx + this.multipleImages.length,
          //     linkedin: idx + this.multipleImages.length,
          //   }
          // })];
        } else if (this.multipleImages.length === 0 && this.typePost !== 'story' && this.typePost !== 'document') {
          let id = Math.random().toString(36).substr(2, 9);
          this.uploadImage(this.form.file).then(compressedUrl => {
            this.form.file = null;
            this.form.enclosure = compressedUrl;
            this.url = compressedUrl;
            this.compressedImages.push(id);
            this.multipleImages.find(e => e.id === id).url = compressedUrl;
            this.multipleImages.find(e => e.id === id).uploaded = true;
          });
          this.multipleImages = [{
            url: URL.createObjectURL(this.form.file),
            filename: this.form.file.name,
            file: this.form.file,
            size: this.form.file.size,
            id,
            ratio: this.carrouselRatio,
            facebook: 0,
            twitter: 0,
            linkedin: 0,
          }];
        }
    },

    async normalizeVideo(type, url) {
      const {VUE_APP_VIDEO_API_HOST, VUE_APP_API_HOST} = process.env
      
      const eventSource = new EventSource(`${VUE_APP_VIDEO_API_HOST}${VUE_APP_API_HOST !== 'https://api.saas.mashup-web.com' ? '/v2' : ''}/video/normalize?type=${type}&url=${encodeURIComponent(url)}`);
      eventSource.onopen = () => {
        console.log("opened");
      };
      eventSource.onerror = (error) => {
        console.log("error", error);
        eventSource.close();
        this.messageUpload = '';
        this.onUpload = false;
        this.isThumbUpload = false;
      };
      
      eventSource.onmessage = (event) => {
        let response = JSON.parse(event.data);
        console.log(response);
        if (response.end) {
          eventSource.close();
          console.log('res video encoding', response);
          if (response.success) {
            this.videos[type] = response.url;
            this.setMusicDuration();
            this.$forceUpdate()
            if (!Object.values(this.videos).includes('encoding...')) {
              this.onUpload = false;
              this.isThumbUpload = false;

            }
          } else {
            this.form.video = null
            this.videoname = null
            this.notify({
              title: "Encoding error",
              text: response.error,
              color:'success',
              time: 10000,
              id: 'norepeat'
            }, {
              component: "PostsOverlay",
              action: "normalizeVideo"
            })
          }
        } else if (response.upload && response.percent) {
            this.messageUpload = this.$t("dash.message.convert.part3");       
            this.percentUpload = response.percent;
        } else if (response.queue) {
          this.messageUpload = this.$t("dash.message.convert.waiting");
          this.percentUpload = 1000;
        } 
        else if (response.percent) {
          this.messageUpload = this.$t("dash.message.convert.part2");
          if (response.percent > this.percentUpload) {
            this.percentUpload = response.percent;
          }
        }
      };
    },

    async selectStoryFile(fileArg = null) {
      console.log(this.$refs.storyFile);
      let file = fileArg;
      if (!file) {
        file = this.$refs.storyFile.files[0];
      }
      console.log(file);
      if (file.type.includes('video') || file.type.includes('gif')) {
        this.$refs.myVideo = {files: [file]};
        this.storyVideo = true;
        this.layers = [];
        this.form.file = null;
        this.form.enclosure = null;
        if (this.typePost !== 'story') {
          this.form.url = null;
        }
        this.url = null;
        // this.pollStory = null;
        this.filename = file && file.name ? file.name : null;
        this.multipleImages = [];
        this.multipleMedias = []
        this.selectVideo();
      } else if (file.type.includes('image')) {
        this.$refs.myFiles = {files: [file]};
        this.storyVideo = ((!!this.selectedMusic && !!this.selectedMusic.track) || this.selectedGifs.length > 0);
        console.log(this.storyVideo);
        this.form.video = null;
        this.videoname = null;
        this.select();
      }
    },

    async selectVideo() {
      if(this.multipleMedias.length || this.$refs.myVideo.files.length > 1)
        this.videoReel = false

      for(let i=0;  i<this.$refs.myVideo.files.length; i++) {
        
        // if(this.$refs.myVideo.files[i].type.includes('image') && this.onlyInstagramSelected()) { 
        if(this.$refs.myVideo.files[i].type.includes('image') && this.onlyListNetworkSelected(['instagram', 'threads'])) {           
          let id = Math.random().toString(36).substr(2, 9)
          this.multipleMedias.unshift({
            id,
            url: URL.createObjectURL(this.$refs.myVideo.files[i]),
            name: this.$refs.myVideo.files[i].name,
            type: this.$refs.myVideo.files[i].type,
            size: this.$refs.myVideo.files[i].size,
            // ratio: this.carrouselRatio,
          })
          await this.uploadImage(this.$refs.myVideo.files[i]).then(compressedUrl => {
            this.compressedImages.push(id);
            this.multipleMedias.find(e => e.id === id).url = compressedUrl;
            this.multipleMedias.find(e => e.id === id).uploaded = true;
          });
          continue
        }

        //get duration
        let video = document.createElement('video');
        video.preload = 'metadata';
        let duration
        video.onloadedmetadata = function() {
          window.URL.revokeObjectURL(video.src);
          duration = video.duration;
          uploadVideo(duration)
        }
        video.onerror = (e) => {
          console.log(e);
          this.onUpload = true;
          this.getVideoInformations(this.$refs.myVideo.files[i]).then(response => {
            this.onUpload = false;
            this.isThumbUpload = false;
            console.log(response);
            if (response.status === 200 && response.body && response.body.success) {
              let infos = response.body.informations;
              console.log(infos.format);
              uploadVideo(infos.duration, infos.size/1000000, `video/${infos.format}`);
            }
          });
        }
        video.src = URL.createObjectURL(this.$refs.myVideo.files[i]);
  
        let uploadVideo = (duration, size=null, type=null) => {
          if (!size) {
            size = this.$refs.myVideo.files[i].size;
          }
          if (!type) {
            type = this.$refs.myVideo.files[i].type;
          }
  
          //check limit duration FB 20min & TW 30sec
          let bots = this.selectedBotPages()
  
          // let limit = bots.find(b => ['instagram'].includes(b.page.network))
          //               ? (this.videoReel ? 15*60 : 60) //60
          let limit = bots.find(b => ['instagram'].includes(b.page.network) && !this.videoReel)
                        ? 60
                        : (bots.find(b => b.page.network == 'twitter') 
                            ? 140
                            : (bots.find(b => b.page.network == 'tiktok') && this.tiktokRequirements && this.tiktokRequirements.max_video_post_duration_sec
                                ? this.tiktokRequirements.max_video_post_duration_sec 
                                : (bots.find(b => ['instagram'].includes(b.page.network) && this.videoReel)
                                    ? 15*60
                                    : (bots.find(b => b.page.network == 'linkedin') ? 30*60 // 900
                                                                                : 1200))))
  
          let min = bots.find(b => ['instagram', 'tiktok'].includes(b.page.network))
                        ? 3
                        : 1
  
          let sizeLimit = bots.find(b => b.page.network == 'tiktok') 
              ? 5000 
              : (bots.find(b => b.page.network == 'instagram')
                        ? 1000 // 100
                        : (bots.find(b => b.page.network == 'twitter') 
                            ? 512
                            : (bots.find(b => b.page.network == 'linkedin') ? (this.hasStoryConfigLinkedin ? 5000 : 200)
                            : 1000)))
  
          if (this.storyVideo) {
            limit = 60;
          }
          console.log(size, duration, limit);
          if(min < duration && duration < limit) {
            if(size < sizeLimit * 1024 * 1024 && type.includes('video')){
              this.form.video = this.$refs.myVideo.files[i]
              this.videoname = this.form.video.name
    
              this.onUpload = true
              this.messageUpload = this.$t("dash.message.convert");
              this.uploadFileWithProgress(this.form.video).then(async res => {

                this.videos = {
                  twitter: null,
                  facebook: null,
                  facebook_reel: null,
                  linkedin: null,
                  instagram: null,
                  instagram_reel: null,
                  story: null,
                };
    
                const { success, file_url } = res.body
    
                if(success && file_url) {
                  // let types = [...new Set(this.bots.filter(e => this.bot.includes(e.id)).map(e => e.type))];
                  // if (types.length === 0) {
                  //   this.onUpload = false
                  //   this.isThumbUpload = false;
                  //   this.messageUpload = '';
                  // }
                  // for (let t of types) {
                  //   if (t == 'instagram' && this.videoReel) {
                  //     t = 'instagram_reel'
                  //   }
                  //   if (t == 'instagram' && this.storyVideo) {
                  //     t = 'story'
                  //   }
                  //   if (t == 'facebook' && this.videoReelFB) {
                  //     t = 'facebook_reel'
                  //   }
                  //   if (!this.videos[t]) {
                  //       this.videos[t] = 'encoding...';
                        
                  //       this.percentUpload = 0;
                  //       this.messageUpload = this.$t("dash.message.convert.part2");
                  //       this.normalizeVideo(t, file_url);
                  //   } 
                  // }
                  let types = [...new Set(this.bots.filter(e => this.bot.includes(e.id)).map(e => e.type))];
                  for (let t of types) {
                    if (t == 'instagram' && this.videoReel) {
                      t = 'instagram_reel'
                    }
                    if (t == 'instagram' && this.storyVideo) {
                      t = 'story'
                    }
                    if (t == 'facebook' && this.videoReelFB) {
                      t = 'facebook_reel'
                    }
                    this.videos[t] = file_url;
                  }
                  this.form.video = file_url
                  this.keyRefresh = Math.random().toString(36);
                  this.onUpload = false;
                  this.isThumbUpload = false;



                  ////////////////

                  // if (this.$refs.myVideo.files.length > 1) {
                  // if(this.onlyInstagramSelected()) { 
                  if(this.onlyListNetworkSelected(['instagram', 'threads'])) {
                    if(this.$refs.myVideo.files[i].type.includes('video')) {
                      this.multipleMedias.unshift({
                        id: Math.random().toString(36).substr(2, 9),
                        url: file_url,
                        name: this.$refs.myVideo.files[i].name,
                        type: this.$refs.myVideo.files[i].type,
                        size: this.$refs.myVideo.files[i].size,
                      })
                    }
                  }


                  ///////////
                }
                else {
                  this.form.video = this.multipleMedias.length ? this.multipleMedias[0].url : null
                  this.videoname = this.multipleMedias.length ? this.multipleMedias[0].name : null
                  this.storyVideo = false
                  this.notify({
                    title: this.$t('dash.notifications.error_title'),
                    text: this.$t('dash.notifications.limit_file_exceeded'),
                    color:'success',
                    time: 10000,
                id: 'norepeat'
                  })
                }
              })
            }
            else {
              this.form.video = this.multipleMedias.length ? this.multipleMedias[0].url : null
              this.videoname = this.multipleMedias.length ? this.multipleMedias[0].name : null
              this.storyVideo = false
              this.notify({
                title: this.$t('dash.notifications.error_title'),
                text: this.$t('dash.notifications.limit_file_exceeded'),
                color:'success',
                time: 10000,
                id: 'norepeat'
              })
            }
          }
          else {
            this.form.video = this.multipleMedias.length ? this.multipleMedias[0].url : null
            this.videoname = this.multipleMedias.length ? this.multipleMedias[0].name : null
            this.storyVideo = false
            this.notify({
              title: this.$t('dash.notifications.error_title'),
              text: this.$t('dash.notifications.limit_duration_file_exceeded'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          }
        }
      }
    },

    uploadFile(file) {
      const { VUE_APP_API_HOST } = process.env 

      let formData = new FormData()
      formData.append('file', file)

      return this.$http
        .post(`${VUE_APP_API_HOST}/posts/upload/file`, formData, {
          progress: (e) => {
              if (e.lengthComputable) 
                this.percentUpload = Math.floor(e.loaded / e.total * 100)
          }
        })
        .then(res => res, err => err)
    },

    uploadFileWithProgress(file, multi=false) {
      const { VUE_APP_VIDEO_API_HOST } = process.env 

      let formData = new FormData()
      formData.append('file', file)
      const user = JSON.parse(localStorage.user)

      console.log("DEBUT");
      let source = new SSE(`${VUE_APP_VIDEO_API_HOST}/image/progress?u=${user.id}`, {payload: formData});
    
      return new Promise(async (resolve, reject) => {
        source.onopen = () => {
          console.log("opened");
          if (multi && Math.max(this.percentUpload, 1) === 1) {
            this.messageUpload = this.$t("dash.message.convert.part1");
          }
          this.percentUpload = multi ? Math.max(this.percentUpload, 1) : 1;
        };
        source.onmessage = (event) => {
          console.log(event);
          let response = JSON.parse(event.data);
          console.log(response);
          if (response.file_url) {
            source.close();
            resolve({body: response});
          } else if (response.percent) {
            // this.percentUpload = (response.percent/2) + 50;
            if (multi && Math.max(this.percentUpload,  ((response.percent/2) + 50)) === ((response.percent/2) + 50)) {
              this.messageUpload = this.$t("dash.message.convert.part1");
            }
            this.percentUpload = multi ? Math.max(this.percentUpload,  ((response.percent/2) + 50)) : ((response.percent/2) + 50);

          } else if (response.error) {
            reject(response.error);
          }
        };
        source.stream((progress) => {
          if (progress.lengthComputable) {
              // (this.percentUpload = (progress.loaded / progress.total)*50);
            if (multi &&  Math.max(this.percentUpload,  ((progress.loaded / progress.total)*50)) === ((progress.loaded / progress.total)*50)) {
              this.messageUpload = this.$t("dash.message.convert.part1");
            }
            this.percentUpload = multi ? Math.max(this.percentUpload,  ((progress.loaded / progress.total)*50)) : ((progress.loaded / progress.total)*50);

          }
        });
      }); 
    },

    confirmReset(typePost) {
      if(typePost == this.typePost) return

      let noResetableField = !(this.form.file || this.form.video || this.selectedLocation 
                                || (this.userTags && this.userTags.collab && this.userTags.collab.length) || this.poll.question != '' 
                                || this.layers.length || this.multipleImages.length || this.multipleMedias.length || this.storyLinkText != '' 
                                || this.pollStory || this.sliderStory || this.storyVideo || this.sharedStoryUrl != '')

      if(this.typePost == 'standard' || noResetableField) {
        this.typePost = typePost 
        this.resetFields(typePost)
      }
      else {
        this.$vs.dialog({
          type:'confirm',
          color: 'primary',
          title: this.$t('dash.posts.change_type_post.title'),
          text: this.$t('dash.posts.change_type_post.body'),
          cancelText: this.$t('dash.button.cancel'),
          // cancel: async () => {        
          //   this.typePost = typePostOriginal
          // },
          acceptText: this.$t('dash.pages.overlay.validate'),
          accept: async () => {  
            this.typePost = typePost     
            this.resetFields(typePost)
          }
        })
      }
    },

    resetFields(typePost){
      console.log("resetFields");
      if (this.form.title && this.form.title.length > 0) {
        // this.instagramTexts = []
      } else {
        this.instagramTextsUpdater = this.instagramTexts
      }
      this.form.file = null
      this.filename = null
      this.videoname = null
      this.url = null
      this.form.enclosure = null
      this.userTags = {
        list: [],
        collab: []
      };
      this.productTags = [];
      this.userTagPage = 0;
      // }
      if(['standard', 'image', 'story', 'poll', 'document'].includes(typePost)) this.form.video = null
      if(['story', 'poll', 'document'].includes(typePost)) {
        this.locations = [];
        this.searchLocationInput = null;
        this.selectedLocation = null;
      }

      if(typePost === "story") {
        this.form.title = Fonts.normalize(this.form.title);
        this.videoReel = false;
      }

      if (typePost === 'video')
        this.videoReel = true;

      if(['image'].includes(typePost)) {
        this.url = this.form.enclosure || null
        this.form.video = null
      }

      if (typePost === 'image' && this.form.file && this.form.file.type === 'application/pdf') {
        this.form.file = null
        this.filename = null
      }

      this.poll = {
          question: '',
          options: ['', ''],
          duration: 604800
      }
      this.layers = [];
      this.carrouselRatio = 4/5;
      this.multipleImages = [];
      this.multipleMedias = [];
      this.storyLinkText = '';
      this.storyShareToFacebook = false;
      this.snippetTitle = '';
      this.videos = {
        twitter: null,
        facebook: null,
        facebook_reel: null,
        linkedin: null,
        instagram: null,
        instagram_reel: null,
        story: null,
      }
      this.pollStory = null;
      this.sliderStory = null;
      this.storyVideo = false;
      this.sharedStoryUrl = '';
      this.storySharedVisual = null;
      this.shareAfterPost = false;
      this.setStoryShare(null);
      this.$store.dispatch("resetStorification");
      this.storyMultiple = [{id: uuidv4(), isActive: true}];
      // this.selectedMusic = null;
      this.selectedGifs = [];
      
    },

    /**
     * Date picked
     */
    picked(date) {
      this.scheduling.date = date
      const today = moment().hour(0).minute(0).second(0)
      if(today.unix() == moment(date).unix()){
        this.rangeHour = [
          [
            // moment().minute()+12 >= 60 
            moment().minute()+1 >= 60 
              ? (moment().hour()+1 > 23 ? 0 : moment().hour()+1) 
              : moment().hour(), 
            23
          ]
        ]
        this.rangeMinute = [
          [
            // moment().minute()+12 >= 60 
            //   ? `0${moment().minute()+12-60}` 
            //   : moment().minute()+12, 
            // 59
            moment().minute()+1 >= 60 
              ? `0${moment().minute()+1-60}` 
              : moment().minute()+1, 
            59
          ]
        ]
      }
      else {
        this.rangeHour = [[0, 23]]
        this.rangeMinute = [[0, 59]]
      }
    },

    changeRangeSchedulingTime(eventData) {
      const today = moment().hour(0).minute(0).second(0)
      if(today.unix() == moment(this.scheduling.date).hour(0).minute(0).second(0).unix()){
        if(parseInt(moment().hour()) < parseInt(eventData.data.HH))
          this.rangeMinute = [[0, 59]]
        else
          this.rangeMinute = [
            [
              // moment().minute()+12 >= 60 
              //   ? `0${moment().minute()+12-60}` 
              //   : moment().minute()+12, 
              // 59
              moment().minute()+1 >= 60 
                ? `0${moment().minute()+1-60}` 
                : moment().minute()+1, 
              59
            ]
          ]
      }
    },

    async confirmPost(){
      if(this.bot.length) {
        //close any edit preview
        this.currentPostFieldEdit = { page: 0}
        if (this.typePost == 'story') {
          // this.layers = await this.$refs.storymaker[0].getLayersInformations();
          // this.selectedGifs = await this.$refs.storymaker[0].getGifsInformations();
          // this.storyMentions = await this.$refs.storymaker[0].getMentionsWidgetInformations();
        }
        // if (this.videoReel && this.typePost == 'video' && this.atLeastInstagramConciergerieSelected()) {
        //   this.selectedGifs = await this.$refs.storymaker[0].getGifsInformations();
        // }

        if(this.scheduling.show){
          const today = moment().add(1, 'minutes')
          const scheduledDate = moment(this.scheduling.date).hour(parseInt(this.scheduling.time.HH)).minute(parseInt(this.scheduling.time.mm)).second(0)
          if(scheduledDate.unix() > today.unix()){
            this.showConfirmPost = true
          }
          else{
            this.notify({
              title: this.$t('dash.notifications.error_title'),
              text: this.$t('dash.notifications.scheduled_time_must_more_than_10min'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          }
        }
        else 
          this.showConfirmPost = true
      }
    },

    /**
     * Schedule post
     */
    schedule() {
      this.scheduling.show = true
    },

    deleteScheduled() {
      // this.$emit('deleteScheduled', this.post, true)
      this.$emit('deleteScheduled', this.post, false)
      this.close()
    },

    /**
     * Close overlay
     */
    close() {
      // Send cancel event
      this.$emit('close')
      this.initForm()
    },

    /**
     * Add post
     */
    async add(body) {
      this.$ga.event('posts', 'post')
      if(this.post && this.post.title && !this.storyShare){
        body.data['original'] = this.post._id || this.post.id
      }

      if(this.state == "reshare"){
        body.data['is_reshare'] = true
        body.data['reshare_message'] = body.data.title
        body.data['news_title'] = this.post.title
        body.data['news_url'] = this.post.url
        body.data['reshare_post_id'] = this.post.page[0].post_number
      }
      else if(this.state == "retweet"){
        body.data['is_retweet'] = true
        body.data['retweet_id'] = this.post.page[0].post_number
      }

      if(['edit-draft', 'edit'].includes(this.state)) {
        body.wait_validation = this.state == 'edit-draft' ? (this.post.data.wait_validation ? JSON.stringify(this.post.data.wait_validation) : null) 
                                                          : (this.post.page[0].wait_validation ?  JSON.stringify(this.post.page[0].wait_validation) : null)
        body.data.wait_validation = body.wait_validation ? body.wait_validation : body.data.wait_validation
        body.affectedTo = this.state == 'edit-draft' ? (this.post.data.affectedTo ? JSON.stringify(this.post.data.affectedTo) : null)
                                                     : (this.post.page[0].affectedTo ?  JSON.stringify(this.post.page[0].affectedTo) : null)
        body.data.affectedTo = body.affectedTo ? body.affectedTo : body.data.affectedTo
      }
      
      if(this.post && (this.post.toSchedule || this.isAffectedPost())){
        const user = JSON.parse(localStorage.user)
        body.wait_validation = JSON.stringify({
          name: `${user.firstname} ${user.lastname}`,
          email: user.email,
          date: moment().format()
        })
      }

      if(['edit-draft'].includes(this.state)) {
        body.comments_post = JSON.stringify(this.post.data.comments)
      }

      body.log = []
      let differences = []
      if((this.state == 'edit-draft' && this.post.data.log) || (this.state == 'edit' && this.post.page[0].log)) {
        body.log = this.state == 'edit-draft' ? this.post.data.log : this.post.page[0].log || []
        differences = this.compareDrafts(this.post.data ? {...this.post.data} : JSON.parse(this.post.page[0].draft), JSON.parse(body.draft))    
        console.log('differences', differences)
      }
      const user = JSON.parse(localStorage.user)
      body.log.push(JSON.stringify({
        user: {
          id: user.id,
          name: `${user.firstname} ${user.lastname}`,
          email: user.email,
          avatar: user.avatar
        },
        created_at: moment().format(),
        isDraft: false,
        isScheduled: this.scheduling.show,
        differences
      }))
      body.log = JSON.stringify(body.log)
      
      this.$emit('add', body)
    },

    compareDrafts(oldDraft, newDraft) {      
      let differences = []

      const checkAndAddDifference = (name, oldValue, newValue) => {
        if(!(!oldValue && !newValue) && !((!oldValue && newValue == '') || (oldValue == '' && !newValue)) && JSON.stringify(oldValue) != JSON.stringify(newValue))
          differences.push({ name, oldValue, newValue })
      }

      checkAndAddDifference('bot', oldDraft.bot, newDraft.bot)
      checkAndAddDifference('typePost', oldDraft.typePost, newDraft.typePost)
      checkAndAddDifference('name', oldDraft.form.name, newDraft.form.name)
      checkAndAddDifference('page', oldDraft.form.page, newDraft.form.page)
      checkAndAddDifference('time', oldDraft.form.time, newDraft.form.time)
      checkAndAddDifference('activeHashtagsAutoAdd', oldDraft.activeHashtagsAutoAdd, newDraft.activeHashtagsAutoAdd)
      checkAndAddDifference('activeMentionsAutoReplace', oldDraft.activeMentionsAutoReplace, newDraft.activeMentionsAutoReplace)
      checkAndAddDifference('activePrefixSuffix', oldDraft.activePrefixSuffix, newDraft.activePrefixSuffix)
      checkAndAddDifference('title', oldDraft.form.title, newDraft.form.title)
      checkAndAddDifference('validMentions', oldDraft.validMentions, newDraft.validMentions)
      checkAndAddDifference('url', oldDraft.form.url, newDraft.form.url)
      checkAndAddDifference('scheduling', oldDraft.scheduling, newDraft.scheduling)
      checkAndAddDifference('editPostValue', oldDraft.editPostValue, newDraft.editPostValue)
      checkAndAddDifference('videoReel', oldDraft.videoReel, newDraft.videoReel)
      checkAndAddDifference('videoReelFB', oldDraft.videoReelFB, newDraft.videoReelFB)
      checkAndAddDifference('videoname', oldDraft.videoname, newDraft.videoname)
      checkAndAddDifference('videos', oldDraft.videos, newDraft.videos)
      checkAndAddDifference('youtubeOptions', oldDraft.youtubeOptions, newDraft.youtubeOptions)
      checkAndAddDifference('twitterOptions', oldDraft.twitterOptions, newDraft.twitterOptions)
      checkAndAddDifference('tiktokOptions', oldDraft.tiktokOptions, newDraft.tiktokOptions)
      checkAndAddDifference('facebookOptions', oldDraft.facebookOptions, newDraft.facebookOptions)
      checkAndAddDifference('filename', oldDraft.filename, newDraft.filename)
      checkAndAddDifference('multipleImages', oldDraft.multipleImages, newDraft.multipleImages)
      checkAndAddDifference('multipleMedias', oldDraft.multipleMedias, newDraft.multipleMedias)
      // checkAndAddDifference('file', oldDraft.form.file, newDraft.form.file)
      // checkAndAddDifference('video', oldDraft.form.video, newDraft.form.video)
      // checkAndAddDifference('carrouselRatio', oldDraft.carrouselRatio, newDraft.carrouselRatio)
      checkAndAddDifference('boardSelected', oldDraft.form.boardSelected, newDraft.form.boardSelected)
      checkAndAddDifference('description', oldDraft.form.description, newDraft.form.description)
      checkAndAddDifference('documentTitle', oldDraft.form.documentTitle, newDraft.form.documentTitle)
      checkAndAddDifference('poll', oldDraft.poll, newDraft.poll)
      checkAndAddDifference('snippet', oldDraft.snippet, newDraft.snippet)
      checkAndAddDifference('snippetTitle', oldDraft.snippetTitle, newDraft.snippetTitle)
      checkAndAddDifference('instagramBackgroundColor', oldDraft.instagramBackgroundColor, newDraft.instagramBackgroundColor)
      checkAndAddDifference('instagramLinkPosition', oldDraft.instagramLinkPosition, newDraft.instagramLinkPosition)
      checkAndAddDifference('instagramTexts', oldDraft.instagramTexts, newDraft.instagramTexts)
      checkAndAddDifference('pollStory', oldDraft.pollStory, newDraft.pollStory)
      checkAndAddDifference('selectedGifs', oldDraft.gifsStory, newDraft.gifsStory)
      checkAndAddDifference('selectedMusic', oldDraft.musicStory, newDraft.musicStory)
      checkAndAddDifference('sliderStory', oldDraft.sliderStory, newDraft.sliderStory)
      checkAndAddDifference('storyMentions', oldDraft.mentionsWidget, newDraft.mentionsWidget)
      checkAndAddDifference('shareAfterPost', oldDraft.shareAfterPost, newDraft.shareAfterPost)
      checkAndAddDifference('storyShareToFacebook', oldDraft.storyShareToFacebook, newDraft.storyShareToFacebook)
      checkAndAddDifference('sharedStoryUrl', oldDraft.sharedStoryUrl, newDraft.sharedStoryUrl)
      checkAndAddDifference('storyLinkText', oldDraft.storyLinkText, newDraft.storyLinkText)
      checkAndAddDifference('storyVideo', oldDraft.storyVideo, newDraft.storyVideo)
      checkAndAddDifference('highlightInstagram', oldDraft.highlightInstagram, newDraft.highlightInstagram)
      checkAndAddDifference('templateManual', oldDraft.templateManual, newDraft.templateManual)
      checkAndAddDifference('selectedLocation', oldDraft.location, newDraft.location)

       // 'date', 'file', 'video', 'carrouselRatio' carouselOrderDragElement, compressedImages,  gifsStory, mentionsAdded, hashtagsAdded, highlightInstagram, instagramTextsUpdater
      // layers, location, mentionsWidget, musicStory, pollStory, sliderStory, storificationData, storyMultiple 
      // storySharedVisual, templateManual, userTags, validHashtags, ???


      // selectedMusic <= oldDraft.musicStory
      // highlightInstagram
      // location

      // layers
      // storyMultiple
      // storySharedVisual ?
      // templateManual
      // userTags
      // validHashtags


      return differences
    },

    /**
     * Edit post
     */
    async update(body) {
      let differences = []
      if(this.post.page[0].draft && body.draft)
        differences = this.compareDrafts(JSON.parse(this.post.page[0].draft), JSON.parse(body.draft))    
      console.log('differences', differences)
      const user = JSON.parse(localStorage.user)
      body.log = JSON.stringify({
        user: {
          id: user.id,
          name: `${user.firstname} ${user.lastname}`,
          email: user.email,
          avatar: user.avatar
        },
        updated_at: moment().format(),
        isDraft: false,
        isScheduled: this.scheduling.show,
        differences
      })

      let post = null
      if(body.draft && this.post.page[0].posts_multipages && this.post.page[0].posts_multipages)
        post = this.post.page[0].posts_multipages.find(p => p.bot == body.bot && ((body.storyIdentification && p.story && body.storyIdentification.id === p.story.id) || !p.story))
      body.id = post ? post._id : this.post._id
      body.postId = post ? post.postId : this.post.page[0].post_number

      // Using lock mechanism to only prompt once for multipage post
      while (this.resendOrResetValidationLock) {
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
      const askReset = this.post.page[0].wait_validation && this.post.page[0].wait_validation != 'null' && (typeof this.post.page[0].wait_validation == 'object' || (!['undefined', 'null'].includes(this.post.page[0].wait_validation) && JSON.parse(this.post.page[0].wait_validation)));
      const askResend = this.post.page[0].affectedTo;
      if (typeof this.resendOrResetValidationResponse === 'boolean') {
        if (askReset) {
          body.data.resetWaitValidation = this.resendOrResetValidationResponse;
        } else if (askResend) {
          body.data.resendUpdateNotif = this.resendOrResetValidationResponse;
        }
      } else {
        this.resendOrResetValidationLock = true;
        if(askReset) {
          body.data.resetWaitValidation = await new Promise((resolve, reject) => {
            this.$vs.dialog({
              type:'confirm',
              color: 'primary',
              title: this.$t('dash.post.resetWaitValidation.title'),
              text: this.$t('dash.post.resetWaitValidation.body'),
              cancelText: this.$t('dash.post.resetWaitValidation.btn-cancel'),
              cancel: async () => {        
                resolve(false);
              },
              acceptText: this.$t('dash.post.resetWaitValidation.btn-accept'),
              accept: async () => {        
                resolve(true);
              }
            })
          })
          this.resendOrResetValidationResponse = body.data.resetWaitValidation;
        }
        else if(askResend) {
          body.data.resendUpdateNotif = this.isAffectedPost() ? 'false' : await new Promise((resolve, reject) => {
            this.$vs.dialog({
              type:'confirm',
              color: 'primary',
              title: this.$t('dash.post.resendUpdateNotif.title'),
              text: this.$t('dash.post.resendUpdateNotif.body'),
              cancelText: this.$t('dash.post.resendUpdateNotif.btn-cancel'),
              cancel: async () => {        
                resolve(false);
              },
              acceptText: this.$t('dash.post.resendUpdateNotif.btn-accept'),
              accept: async () => {        
                resolve(true);
              }
            })
          })
          this.resendOrResetValidationResponse = body.data.resendUpdateNotif;
        }
        this.resendOrResetValidationLock = false;
      }

      if(this.post && !body.data.resetWaitValidation && (this.post.toSchedule || this.isAffectedPost())){
        const user = JSON.parse(localStorage.user)
        body.wait_validation = JSON.stringify({
          name: `${user.firstname} ${user.lastname}`,
          email: user.email,
          date: moment().format()
        })
      }
      
      this.$emit('update', body)
    },

    /**
     * Initaialize form value
     */
    initForm(){
      console.log("initForm");
      this.form = {
        page: 0,
        name: null,
        url: '',
        description: null,
        file: null,
        date: null,
        time: null,
        title: '',
        enclosure: null,
        video: null
      }
      this.filename = null
      this.videoname = null
      this.videos = {
        twitter: null,
        facebook: null,
        facebook_reel: null,
        linkedin: null,
        instagram: null,
        instagram_reel: null,
        story: null,
      },
      this.url = null
      this.layers = [];
      if (this.form.title && this.form.title.length > 0) {
        // this.instagramTexts = []
      } else {
        this.instagramTextsUpdater = this.instagramTexts
      }

      this.layers = [];
      this.carrouselRatio = 4/5;
      this.multipleImages = [];
      this.multipleMedias = [];
      this.pollStory = null;
      this.sliderStory = null;
      this.snippetTitle = null;
      this.snippet = null;
      this.storyVideo = false;
      this.sharedStoryUrl = '';
      this.storySharedVisual = null;
      this.shareAfterPost = false;
      this.$store.dispatch("resetStorification");
      this.locations = [];
      this.searchLocationInput = null;
      this.selectedLocation = null;
      this.userTags = {
        list: [],
        collab: []
      };
      this.productTags = [];
      this.storyMultiple = [{id: uuidv4(), isActive: true}];
      
      this.editPostValue= []

      this.affectedTo = null,
      this.doScreenshot = false

      localStorage.setItem('mentionsAdded', JSON.stringify([]))
      localStorage.setItem('hashtagsAdded', JSON.stringify([]))

      this.$validator.reset('posts')
    },

    /**
     * Retrieve checked pages
     */
    selectedBotPages() {
    const { bots, bot } = this
      let botsTmp = []
      bot.forEach(bId => {
        let tmp = bots.find(b => b.id == bId)
        if(tmp) botsTmp.push(tmp)
      })
      return botsTmp
    },

    getPageInfoByBot(botId) {
      const { bots, linked } = this
      let bot = bots.find(b => b.id == botId)
      return bot ? linked.find(x => x.id === bot.page.id) : linked[0]
    },

    async fileToArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = function(e) {
            let arrayBuffer = new Uint8Array(reader.result);
            resolve(arrayBuffer)
        }

        reader.readAsArrayBuffer(file);
      });
    },

    async saveDraft(localeSave=false) {
      console.log(this.form.file)

      const FBvalid = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/bmp', 'image/tiff'];
      const TWvalid = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
      const LKvalid = ['image/png', 'image/jpeg', 'image/jpg', "image/gif"];

      if(this.state == 'edit' && !localeSave){
        let noDraft = await new Promise((resolve, reject) => {
          this.$vs.dialog({
            type:'confirm',
            color: 'primary',
            title: this.$t('dash.posts.save-draft_or_scheduled-post.prompt.title'),
            text: this.$t('dash.posts.save-draft_or_scheduled-post.prompt.body'),
            cancelText: this.$t('dash.posts.save-draft_or_scheduled-post.prompt.btn-duplicate'),
            cancel: async () => {        
              resolve(false);
            },
            acceptText: this.$t('dash.posts.save-draft_or_scheduled-post.prompt.btn-save-scheduled-post'),
            accept: async () => {        
              resolve(true);
            }
          })
        }) 
        if(noDraft)
          return this.storyMultiple.length > 1 ? this.validateMultipleStory('post') : this.validate('posts')
      }
      
      let bot = this.selectedBotPages()
      let gif = null;
      let frames = null;
      if(this.typePost === 'image' && this.form.file && this.form.file.type && ((bot.find(bot => ['bluesky'].includes(bot.page.network))) || (bot.find(bot => ['linkedin', 'twitter'].includes(bot.page.network)) && this.form.file.type === "image/gif"))) {
        let buffer = await this.fileToArrayBuffer(this.form.file);
        gif = parseGIF(buffer);
        frames = decompressFrames(gif, false);
        if ((bot.some(e => e.page.network === 'linkedin') && frames.length > 250) || (bot.some(e => e.page.network === 'twitter') && frames.length > 350)) {
          return this.notify({
            title: this.$t('dash.post.error.format_image.title'),
            text: this.$t('dash.post.error.format_image_gif.frames', {frames: frames.length} ),
            color:'success',
            time: 10000,
          })
        }
        if (bot.some(e => e.page.network === 'twitter') && (gif.lsd.width > 1280 || gif.lsd.height > 1080 || buffer.length > 15000000)) {
          return this.notify({
            title: this.$t('dash.notifications.limit_file_exceeded'),
            text: this.$t('dash.post.error.format_image_gif.size'),
            color:'success',
            time: 10000,
          })
        }  
        if (bot.some(e => e.page.network === 'bluesky') && (buffer.length > 1000000)) {
          return this.notify({
            title: this.$t('dash.notifications.limit_file_exceeded'),
            text: this.$t('dash.post.error.format_image_gif.size'),
            color:'success',
            time: 10000,
          })
        }  
      }

      if (!this.bot.length) 
        return this.notify({
          title: this.$t('dash.notifications.error_title'),
          text: this.$t('dash.notifications.need_at_least_one_page'),
          color:'success',
          time: 10000,
          id: 'norepeat'
        }) 
      else if((this.post && this.post.status == 'direct') === false) {
        if (this.typePost === 'image' && this.form.file && this.form.file.type === "application/pdf")
          return this.notify({
            title: this.$t('dash.post.error.format_image.title'),
            text: this.$t('dash.post.error.format_image.content'),
            color:'success',
            time: 10000,
            id: 'norepeat'
          })
        else if(this.typePost === 'image' && bot.find(bot => !['linkedin', 'twitter'].includes(bot.page.network)) && ((this.form.file && this.form.file.type === "image/gif") || (this.form.enclosure && this.form.enclosure.includes('.gif'))))
          return this.notify({
            title: this.$t('dash.post.error.format_image.title'),
            //text:"Le format GIF n'est pas autorisé sur l'ensemble des resaux sociaux selectionné",
            text: this.$t('dash.post.error.format_image_gif.content', { pages: [...new Set(bot.filter(bot => !['linkedin', 'twitter'].includes(bot.page.network)).map(bot => ` ${bot.page.name} (${bot.page.network.charAt(0).toUpperCase()}${bot.page.network.slice(1)})`))].toString() }),
            color:'success',
            time: 10000,
            id: 'norepeat'
          })
        else if(this.typePost === 'video' && Object.values(this.videos).includes("encoding..."))
          return this.notify({
            title: this.$t('dash.post.error.need_video.title'),
            text: this.$t('dash.tooltip.upload_media'),
            color:'success',
            time: 10000,
            id: 'norepeat'
          })
        else if(this.typePost === 'document' && (!(this.form.file || this.url) || !this.form.documentTitle)) 
          return this.notify({
            title: this.$t('dash.post.error.need_doc_or_title.title'),
            text: this.$t('dash.post.error.need_doc_or_title.content'),
            color:'success',
            time: 10000,
            id: 'norepeat'
          })
        else if(this.typePost === 'document' && !((this.form.file && this.form.file.type === "application/pdf") || (this.url && this.url.includes('.pdf'))))
          return this.notify({
            title: this.$t('dash.post.error.format_doc_pdf.title'),
            text: this.$t('dash.post.error.format_doc_pdf.content'),
            color:'success',
            time: 10000,
            id: 'norepeat'
          })
        else if(this.typePost === 'poll' && (this.poll.options.length < 2 || this.poll.options.some(e => e === ''))) 
          return this.notify({
            title: this.$t('dash.post.error.need_elements_poll.title'),
            text: this.$t('dash.post.error.need_elements_poll.content'),
            color:'success',
            time: 10000,
            id: 'norepeat'
          })
        else if(this.multipleImages && this.multipleImages.length > 1 && this.typePost === 'image' && !this.multipleImages.filter(e => e.file).every(e => FBvalid.includes(e.file.type) || FBvalid.find(v => v.includes(e.ext)) || FBvalid.find(v => v.includes(e.url.split('.').pop()))) && bot.some(bot => bot.page.network === 'facebook')) {
          return this.notify({
            title: this.$t('dash.post.error.format_image.title'),
            text: this.$t('dash.post.error.format_image_facebook.content'),
            color:'success',
            time: 10000,
            id: 'norepeat'
          })
        }
        else if(this.multipleImages && this.multipleImages.length > 1 && this.typePost === 'image' && !this.multipleImages.filter(e => e.file).every(e => TWvalid.includes(e.file.type) || TWvalid.find(v => v.includes(e.ext)) || TWvalid.find(v => v.includes(e.url.split('.').pop()))) && bot.some(bot => bot.page.network === 'twitter')) {
          return this.notify({
            title: this.$t('dash.post.error.format_image.title'),
            text: this.$t('dash.post.error.format_image_twitter.content'),
            color:'success',
            time: 10000,
            id: 'norepeat'
          })
        }
        else if(this.multipleImages && this.multipleImages.length > 1 && this.typePost === 'image' && !this.multipleImages.filter(e => e.file).every(e => LKvalid.includes(e.file.type) || LKvalid.find(v => v.includes(e.ext)) || LKvalid.find(v => v.includes(e.url.split('.').pop()))) && bot.some(bot => bot.page.network === 'linkedin')) {
          return this.notify({
            title: this.$t('dash.post.error.format_image.title'),
            text: this.$t('dash.post.error.format_image_linkedin.content'),
            color:'success',
            time: 10000,
            id: 'norepeat'
          })
        }
      }

      if(!localeSave) 
        this.showLoader = true;
      let screenshot = null;  
      if (this.typePost === 'story') {

        //ICI!
        // if (this.selectedMusic && this.selectedMusic.config) {
        //   // this.toggleMusicConfig(false);
        //   this.selectedMusic.config = false;
        //   let audio = this.$refs[`music-preview-mention`];
        //   if (audio) {
        //     audio.pause();
        //   }
        // }
        if ((!(this.videoReel && this.typePost === 'video') && this.$store.getters.storificationMusic) || (this.videoReel && this.typePost === 'video' && this.$store.getters.storificationMusicReel)) {
          this.videoReel && this.typePost === 'video' ? this.$store.commit('updateStorificationMusicReel', {config: false, paused: true}) : this.$store.commit('updateStorificationMusic', {config: false, paused: true});
        }
        // this.layers = await this.$refs.storymaker[0].getLayersInformations();
        // this.selectedGifs = await this.$refs.storymaker[0].getGifsInformations();
        // this.storyMentions = await this.$refs.storymaker[0].getMentionsWidgetInformations();
        let layers = this.$store.getters.storificationLayers;
        const { VUE_APP_API_HOST } = process.env
        for (let k = 0; k < layers.length; k++) {
            if (layers[k].url) {
              continue
            }
            let formData = new FormData()
            formData.append('file', layers[k].file)
            console.log(layers[k].file);

            await this.$http
              .post(`${VUE_APP_API_HOST}/posts/upload/file`, formData, {
                progress: (e) => {
                    if (e.lengthComputable) {
                        console.log(Math.floor(e.loaded / e.total * 100));
                        this.percentUpload = Math.floor(e.loaded / e.total * 100)
                    }
                }
              })
              .then(res => {
                layers[k].url = res.body.file_url;
                delete layers[k].file;
                delete layers[k].reader;
                layers[k].index = k;
                this.$store.commit('updateStorificationLayer', layers[k]);

              }, err => err)
        }
        // if (!this.storyVideo) {
          // screenshot = await this.$refs.storymaker[0].captureActualAsPicture();
          // screenshot = this.base64toFile(screenshot, 'instagram_screenshot')
          // let formData = new FormData()
          // formData.append('file', screenshot)
          // await this.$http
          //       .post(`${VUE_APP_API_HOST}/posts/upload/file`, formData, {
          //         progress: (e) => {
          //             if (e.lengthComputable) {
          //                 console.log(Math.floor(e.loaded / e.total * 100));
          //                 this.percentUpload = Math.floor(e.loaded / e.total * 100)
          //             }
          //         }
          //       })
          //       .then(res => {
          //         console.log("screen", res.body);
          //         screenshot = res.body.file_url;
          //       }, err => err)
          
          // Screenshots done in backend
          // if (!(this.storyVideo && (this.videos['story'] || this.form.video))) {
          //   await this.screenshotStory();
          // }
          console.log("END SCREEN");

        // }
      } else if (this.typePost === 'video' && this.videoReel) {
        // if (this.selectedMusic && this.selectedMusic.config) {
        //   this.toggleMusicConfig(false);
        //   let audio = this.$refs[`music-preview-mention`];
        //   if (audio) {
        //     audio.pause();
        //   }
        // }
        // if (this.atLeastInstagramConciergerieSelected())
        //   this.selectedGifs = await this.$refs.storymaker[0].getGifsInformations();
      } else if (this.typePost === 'image' && this.shareAfterPost) {
        // await this.screenshotStory();
        console.log("END SCREEN");
      }
      //!! TODO: Vérifier
      if (this.form.enclosure && this.form.enclosure.includes('blob:') /* && !(this.storyMultiple && this.storyMultiple.length > 1 && this.typePost === 'story')*/) {
        const newImageBlob = await fetch(this.form.enclosure).then(res => res.blob())
        const newFile = new File([newImageBlob], `enclosure-post-${bot[0].id}.${newImageBlob.type.split("/").pop()}`, {type: newImageBlob.type}); //Blob to file
        let formData = new FormData()
        formData.append('file', newFile)
        console.log('formData', formData)
        let resFile = await this.$http.post(`${process.env.VUE_APP_API_HOST}/posts/upload/file`, formData)
        if(resFile && resFile.body && resFile.body.file_url) {
          this.form.enclosure = resFile.body.file_url;
          this.form.file = null;
        }
      }

      if (this.storyMultiple && this.storyMultiple.length > 1 && this.typePost === 'story') {
        for (let [idx, e] of this.storyMultiple.entries()) {
          if (e.isActive) {
            // console.log("e:", e);
            //!! TODO: Verifier
            // console.log("before fill and get", this.form.enclosure)
            await this.fillMultipleStory(idx);
            await this.getMultipleStory(idx);
            this.form.enclosure = `${e.story.enclosure}`;
            // console.log("after fill and get", this.form.enclosure)
          }
        }
        // for (let k=0; k<this.storyMultiple.length; k++) {
        //   if(this.storyMultiple[k].story.enclosure) {
            // console.log(`SAVE DRAFT this.storyMultiple[${k}].story.enclosure`, this.storyMultiple[k].story.enclosure)
            // let file = await this.urlToFile(this.storyMultiple[k].story.enclosure);
            // let {success, file_url} = (await this.uploadFile(file)).body;
            // console.log("SAVE DRAFT file_url", file_url);
            // if(success && file_url) {
            //   this.$set(this.storyMultiple[k].story, 'enclosure', file_url)
            //   this.form.enclosure = file_url;
            //   this.form.file = file;
            // }
          // }
        // }
      }

      await new Promise(async (resolve, reject) => {
        console.log("enter promise")
        if(this.multipleImages.length && (this.post && this.post.status == 'direct') === false) {
          let countImagesUploaded = 0
          for(let index=0; index<this.multipleImages.length; index++) {
            if(this.multipleImages[index].uploaded || this.multipleImages[index].url.includes('https://s3-eu-west-1.amazonaws.com/saas.mashup') ) {
              countImagesUploaded++
              if(countImagesUploaded == this.multipleImages.length)
                resolve()
            }
            else {
              this.uploadFile(this.multipleImages[index].file).then(res => {
                countImagesUploaded++
                this.onUpload = false;
                this.isThumbUpload = false;

                const { success, file_url } = res.body

                if(success && file_url) { 
                  this.$set(this.multipleImages[index], 'url', file_url)
                }
                else {
                  this.form.video = null
                  this.videoname = null
                  this.notify({
                    title: this.$t('dash.notifications.error_title'),
                    text: this.$t('dash.notifications.limit_file_exceeded'),
                    color:'success',
                    id: 'norepeat'
                  })
                  reject()
                }
                
                if(countImagesUploaded == this.multipleImages.length)
                  resolve()
              })
            }
          }
        }
        else if(this.form.file && this.form.file.type && this.typePost !== "story"){
          this.uploadFile(this.form.file).then(res => {
            this.onUpload = false
            this.isThumbUpload = false;
            const { success, file_url } = res.body
            // console.log("ELSE IF upload file into enclosure", file_url);
            if(success && file_url) {
              this.form.enclosure = file_url
              resolve()
            }
            else {
              this.form.video = null
              this.videoname = null
              this.notify({
                title: this.$t('dash.notifications.error_title'),
                text: this.$t('dash.notifications.limit_file_exceeded'),
                color:'success',
                id: 'norepeat'
              })
              reject()
            }
          })
        }
        else resolve()
      })
      .then(async () => {

        if(!this.scheduling.show && !localeSave) this.scheduling.show = true

        let body = this.getBodyDraft(screenshot)
        // this.$store.dispatch("resetStorification");
        if(localeSave)  
          localStorage.last_post_draft = JSON.stringify(body)
        else {
          const user = JSON.parse(localStorage.user)
          body.log = {
            user: {
              id: user.id,
              name: `${user.firstname} ${user.lastname}`,
              email: user.email,
              avatar: user.avatar
            },
            isDraft: true
          }

          if(this.affectedTo) {
            // if(this.state === 'edit-draft')
            //   body.affectedTo = this.affectedTo
            // else {
              // this.onUpload = true
              body.affectedTo = {
                user: this.affectedTo.user && this.affectedTo.user.id ? this.affectedTo.user.id : this.affectedTo.id,
                optionValidation: typeof this.affectedTo.optionValidation == 'boolean' ? this.affectedTo.optionValidation : true
              }
              if(this.affectedTo.users)
                body.affectedTo.users = this.affectedTo.users.map(u => u.id)
              //screenshot
              // try {
              //   this.doScreenshot = true
              //   await this.convertImagePreviewToBase64(this.bot[0])
              //   let canvas = await html2canvas(this.$refs[`preview-post-${this.bot[0]}`][0], {allowTaint: true, useCORS:true})
              //   let imageB64 = canvas.toDataURL('image/png')
              //   const newImageBlob = await fetch(imageB64).then(res => res.blob())
              //   const newFile = new File([newImageBlob], `preview-post-${this.bot[0]}.png`); //Blob to file
              //   let formData = new FormData()
              //   formData.append('file', newFile)  
              //   console.log('formData', formData)
              //   let resFile = await this.$http.post(`${process.env.VUE_APP_API_HOST}/posts/upload/file`, formData)
              //   console.log('resFile', resFile)
              //   if(resFile && resFile.body && resFile.body.file_url)
              //     body.affectedTo.screenshot = resFile.body.file_url;      
              //   this.onUpload = false
              // } catch (e) {
              //   console.log("screenshot", e)
              //   this.doScreenshot = false
              //   this.onUpload = false
              // }
            // }
          }
          
          if(this.state === 'edit-draft'){
            body.log.updated_at = moment().format()
            let differences = this.compareDrafts(this.post.data ? {...this.post.data} : JSON.parse(this.post.page[0].draft), {...body})    
            console.log('differences', differences)
            body.log.differences = differences
            body.log = JSON.stringify(body.log)
            body.id = this.post.id

            if(!localeSave) {
              if(this.post.data.wait_validation && this.post.data.wait_validation != 'null' && (!['undefined', 'null'].includes(this.post.data.wait_validation) && JSON.parse(this.post.data.wait_validation))) {
                body.resetWaitValidation = await new Promise((resolve, reject) => {
                  this.$vs.dialog({
                    type:'confirm',
                    color: 'primary',
                    title: this.$t('dash.post.resetWaitValidation.title'),
                    text: this.$t('dash.post.resetWaitValidation.body'),
                    cancelText: this.$t('dash.post.resetWaitValidation.btn-cancel'),
                    cancel: async () => {        
                      resolve(false);
                    },
                    acceptText: this.$t('dash.post.resetWaitValidation.btn-accept'),
                    accept: async () => {        
                      resolve(true);
                    }
                  })
                })
              }
              else if(this.post.data.affectedTo && body.affectedTo) {
                body.resendUpdateNotif = this.isAffectedPost() ? 'false' : await new Promise((resolve, reject) => {
                  this.$vs.dialog({
                    type:'confirm',
                    color: 'primary',
                    title: this.$t('dash.post.resendUpdateNotif.title'),
                    text: this.$t('dash.post.resendUpdateNotif.body'),
                    cancelText: this.$t('dash.post.resendUpdateNotif.btn-cancel'),
                    cancel: async () => {        
                      resolve('false');
                    },
                    acceptText: this.$t('dash.post.resendUpdateNotif.btn-accept'),
                    accept: async () => {        
                      resolve('true');
                    }
                  })
                })
              }
            }

            this.updateDraft(body)
            .then(res => {
              this.notify({
                title: this.$t('dash.notifications.success_title'),
                text: this.$t('dash.notifications.draft_updated'),
                color:'success',
                time: 10000,
                id: 'norepeat'
              })

              // add log
              if(!localeSave) {
                let messageLog = `${res.url} --- ${JSON.stringify(body)} --- ${res.bodyText}`
                this.addLog(JSON.parse(localStorage.user), 'update-draft', messageLog)
              }
            })
          }
          else {
            body.log.created_at = moment().format()
            body.log = [JSON.stringify(body.log)]
            this.newDraft(body)
            .then(res => {            
              this.notify({
                title: this.$t('dash.notifications.success_title'),
                text: this.$t('dash.notifications.draft_created'),
                color:'success',
                time: 10000,
                id: 'norepeat'
              })              

              // add log
              if(!localeSave) {
                let messageLog = `${res.url} --- ${JSON.stringify(body)} --- ${res.bodyText}`
                this.addLog(JSON.parse(localStorage.user), 'create-draft', messageLog)
              }
            })
          }


        }

      })
      .then(() => {
        if(this.state == 'edit' && !localeSave){
          this.showLoader = false;
          this.storyMultiple.length > 1 ? this.validateMultipleStory('post') : this.validate('posts')
        }
        else if(!localeSave) {
          this.showLoader = false;
          this.$emit('updateDrafts', this.bot)
          this.close()
          // document.querySelector(`.vs-tooltip`).remove()
        }
      })
      
    },

    async convertImagePreviewToBase64(botId) {
      console.log('convertImagePreviewToBase64', botId, this.$refs[`preview-post-${botId}`])
      const getImageBase64 = async (src) => {
        if(src.includes('http://') || src.includes('https://')) {
          let res = await this.getImageFromUrl(src)
          if(res && res.body.image) return res.body.image
        }
        return src
      }
      
      const transformImages = async el => {
        let tagImages = el.getElementsByTagName('img')
        for(let tagImage of tagImages) {
          tagImage.setAttribute('src', await getImageBase64(tagImage.getAttribute('src')))
        }
      }

      await transformImages(this.$refs[`preview-post-${botId}`][0]);

      // const transformVideo = async el => {
      //   let tagVideos = el.getElementsByTagName('video');
      //   for(let tagVideo of tagVideos) {
      //     console.log('tagVideo', tagVideo)
      //     console.log('tagVideo2', tagVideo.src)
      //     tagVideo.setAttribute('src', await getImageBase64(tagVideo.getAttribute('src')))
      //     console.log('tagVideo3', tagVideo.src)
      //     let canvas = document.getElementById(`canvas-video-${botId}`)
      //     let ctx = canvas.getContext('2d');
      //     let w = tagVideo.videoWidth
      //     let h = tagVideo.videoHeight
      //     canvas.width = w
      //     canvas.height = h
      //     ctx.fillRect(0, 0, w, h)
      //     ctx.drawImage(tagVideo, 0, 0, w, h)
      //     tagVideo.style.backgroundImage = `url(${canvas.toDataURL()})` // here is the magic
      //     tagVideo.style.backgroundSize = 'cover'
      //     ctx.clearRect(0, 0, w, h); // clean the canvas
      //   }
      // }
      
      // await transformVideo(this.$refs[`preview-post-${botId}`][0]);
    },

    getBodyDraft(screenshot=null) {
      console.log('this.affectedTo', this.affectedTo);

      return {
        form: this.form,
        bot: this.bot,
        typePost: this.typePost,
        multipleImages: this.multipleImages,
        multipleMedias: this.multipleMedias,
        scheduling: this.scheduling,
        editPostValue: this.editPostValue,
        activeMentionsAutoReplace: this.activeMentionsAutoReplace,
        activeHashtagsAutoAdd: this.activeHashtagsAutoAdd,
        validMentions: this.validMentions,
        mentionsAdded: localStorage.mentionsAdded ? JSON.parse(localStorage.mentionsAdded) : [],
        hashtagsAdded: localStorage.hashtagsAdded ? JSON.parse(localStorage.hashtagsAdded) : [],
        activePrefixSuffix: this.activePrefixSuffix,

        layers: this.layers,
        carrouselRatio: this.carrouselRatio,
        instagramTexts: this.instagramTexts,
        instagramTextsUpdater: this.instagramTextsUpdater,
        storyLinkText: this.storyLinkText,
        snippetTitle: this.snippetTitle,
        snippet: this.snippet,
        carouselOrderDragElement: this.carouselOrderDragElement,
        poll: this.poll,
        templateManual: this.templateManual,
        instagramLinkPosition: this.instagramLinkPosition,
        highlightInstagram: this.highlightInstagram,
        instagramBackgroundColor: this.instagramBackgroundColor,
        sharedStoryUrl: this.sharedStoryUrl,
        storySharedVisual: this.storySharedVisual, 
        screenshot,
        videoReel: this.videoReel,
        videoReelFB: this.videoReelFB,
        videos: this.videos ? JSON.stringify(this.videos) : null,
        location: this.selectedLocation && this.selectedLocation != 'undefined' ? JSON.stringify(this.selectedLocation) : null,
        userTags: this.userTags && this.userTags.list && this.userTags.list.length > 0 ? JSON.stringify(this.userTags) : null,
        productTags: this.productTags && this.productTags.length > 0 ? JSON.stringify(this.productTags.map(e => {return {...e,image: null}})) : null,
        storyVideo: this.storyVideo,
        pollStory: this.pollStory,
        sliderStory: this.sliderStory,
        musicStory: this.selectedMusic,
        gifsStory: this.selectedGifs,
        mentionsWidget: this.storyMentions,
        filename: this.filename,
        videoname: this.videoname,
        validHashtags: this.validHashtags,
        storyMultiple: this.storyMultiple,
        shareAfterPost: this.shareAfterPost,
        storificationData: this.$store.getters['storification'],
        storyShareToFacebook: this.storyShareToFacebook,

        compressedImages: this.compressedImages,

        tiktokOptions: JSON.stringify(this.tiktokOptions),
        youtubeOptions: JSON.stringify(this.youtubeOptions),
        twitterOptions: JSON.stringify(this.twitterOptions),
        facebookOptions: this.facebookOptions ? JSON.stringify(this.facebookOptions) : null,

        affectedTo: this.affectedTo ? JSON.stringify(this.affectedTo) : null
      }
    },

    getTextMetrics(text, font) {
      // re-use canvas object for better performance
      const canvas = this.getTextMetrics.canvas || (this.getTextMetrics.canvas = document.createElement("canvas"));
      const context = canvas.getContext("2d");
      context.font = font;
      const metrics = context.measureText(text);
      return metrics;
    },

    splitByBreakWords(text, maxWidth) {
      const words = text.split(' ');
      let currentLine = '';
      const splitedText = [];
      let startIdx = 0
      const font = '700 16px "Araboto"'
      for (let [idx ,word] of words.entries()) {
        currentLine += word;
        let width = this.getTextMetrics(currentLine, font).width;
        if (width >= maxWidth-1) {
          let t = words.slice(startIdx, idx)
          startIdx = idx;
          splitedText.push(t.join(' '));
          currentLine = '';
        } else {
          currentLine += ' ';
        }
      }
      console.log('FIN', splitedText);
      let tt = words.slice(startIdx).join(' ');
      console.log(tt, 'AA');
      splitedText.push(tt);
      return splitedText;
    },

    async validateMultipleStory(scope) {
      console.log("multiple validate", this.scheduling.date);
      // let postScheduling = this.scheduling.show;
      // let schedulingInfo = moment();
      // for (let [idx, e] of this.storyMultiple.entries()) {
      //   if (e.isActive) {
      //     await this.fillMultipleStory(idx);
      //   }
      // }
      // for (let k=0; k<this.storyMultiple.length; k++) {
      //   if (!this.storyMultiple[k].story) this.storyMultiple[k].story = {};
      //   if (this.storyMultiple[k].story.enclosure) {
      //     let {success, file_url} = (await this.uploadFile(this.storyMultiple[k].story.enclosure)).body;
      //     if(success && file_url) { 
      //       this.$set(this.storyMultiple[k].story, 'enclosure', file_url)
      //     }
      //   }
      // }
      for (let [idx, el] of  this.storyMultiple.entries()) {
        this.$vs.loading({color : 'primary'});
        console.log("loop ent",idx, el);
        // await this.getMultipleStory(idx);
        await this.selectMultipleStory(idx);
        await this.$nextTick();
        await new Promise(resolve => setTimeout(resolve, 1000));
        // if (idx > 0) {
        //   this.scheduling.show = true;

        //   let randomDuration = Math.floor(Math.random() * (90 - 60 + 1) + 60);
        //   console.log(postScheduling);
        //   if (postScheduling) {
        //     schedulingInfo = moment(this.scheduling.date);
        //     schedulingInfo.hours(this.scheduling.time.HH);
        //     schedulingInfo.minutes(this.scheduling.time.mm);
        //   } 
        //   console.log(schedulingInfo.toDate());
          
        //   schedulingInfo.add(randomDuration, "seconds");
        //   console.log(schedulingInfo.toDate());
        //   this.scheduling.date = schedulingInfo;
        //   this.scheduling.time.HH = schedulingInfo.format("HH");
        //   this.scheduling.time.mm = schedulingInfo.format("mm");
          
        // }
        await this.validate(scope, {
          id: el.id,
          order: idx,
        });
        this.cleanMultipleStory();
        
      }

      // if(this.state === 'edit-draft'){
      //   this.deleteDraft(this.post.id)
      //   this.$emit('removeDrafts', this.post.id)
      // }
      this.$vs.loading.close()
      for (let k = 0; k < this.bodyAddStorage.length; k++) {
        let bodyDraft = JSON.parse(this.bodyAddStorage[k].draft);
        for (let i = 0; i < bodyDraft.storyMultiple.length; i++) {
          if(bodyDraft.storyMultiple[i].story.enclosure && (bodyDraft.storyMultiple[i].story.enclosure.includes('blob:') || bodyDraft.storyMultiple[i].story.enclosure === null)) {
            bodyDraft.storyMultiple[i].story.enclosure = this.bodyAddStorage[i].data.enclosure;
          }
        }
        // if(bodyDraft.storyMultiple[k].story.enclosure && bodyDraft.storyMultiple[k].story.enclosure.includes('blob:')) {
        //   bodyDraft.storyMultiple[k].story.enclosure = this.bodyAddStorage[k].data.enclosure;
        // }
        this.bodyAddStorage[k].draft = JSON.stringify(bodyDraft);
      }
      console.log(this.bodyAddStorage);
      // let postScheduling = this.bodyAddStorage[0].scheduled && this.bodyAddStorage[0].data.scheduled_date && moment(this.bodyAddStorage[0].data.scheduled_date).isAfter(moment());
      let mainBody = this.bodyAddStorage[0];
      mainBody.data.storyMultiple = JSON.stringify(this.bodyAddStorage.slice(1));
      if(this.state === 'edit-draft')
        mainBody.data.removeDraft = this.post.id
      // this.bodyAddStorage.forEach((el, i) => {
      //   let schedulingInfo = moment();
      //   console.log(el);
      //   console.log(el.scheduled);
      //   console.log(el.data.scheduled_date);
      //   if (i > 0) {
      //     el.scheduled = true;

      //     let randomDuration = Math.floor(Math.random() * (90 - 60 + 1) + 60) * i;
      //     console.log(postScheduling);
      //     if (postScheduling) {
      //       schedulingInfo = moment(this.bodyAddStorage[0].data.scheduled_date);
      //       // schedulingInfo.hours(this.scheduling.time.HH);
      //       // schedulingInfo.minutes(this.scheduling.time.mm);
      //     } 
      //     console.log(schedulingInfo.toDate());
          
      //     schedulingInfo.add(randomDuration, "seconds");
      //     console.log(schedulingInfo.toDate());
      //     el.data.scheduled_date = schedulingInfo.utc().format();
      //     // this.scheduling.date = schedulingInfo;
      //     // this.scheduling.time.HH = schedulingInfo.format("HH");
      //     // this.scheduling.time.mm = schedulingInfo.format("mm");
          
      //   }
        
      if (this.state !== 'edit') {
        // Add
        setTimeout(() => this.add(mainBody), 500)
      } else {
        // Update
        setTimeout(() => this.update(mainBody), 500)
      }
      // });

    },

    /**
     * Check form data before submit
     * @param {Object} scope - Form scope to check
     */
    validate(scope, storyIdentification=null) {
      return new Promise((resolve, reject) => {
      console.log(this.form);

      this.$validator.validateAll(scope).then(async result => {
        if (!result && this.$validator.errors.items.length) 
          return this.notify({
            title: this.$t('dash.notifications.error_title'),
            text: this.$t(this.$validator.errors.items.map(i => i.msg).join(", ")),
            color:'success',
            time: 10000,
            id: 'norepeat'
          })

        let bot = this.selectedBotPages()
        console.log('bot list', bot, this.form.file)

        const FBvalid = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/bmp', 'image/tiff'];
        const TWvalid = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
        const LKvalid = ['image/png', 'image/jpeg', 'image/jpg', "image/gif"];

        let gif = null;
        let frames = null;
        if(this.typePost === 'image' && this.form.file && this.form.file.type && bot.find(bot => ['linkedin', 'twitter'].includes(bot.page.network)) && this.form.file && this.form.file.type === "image/gif") {
          let buffer = await this.fileToArrayBuffer(this.form.file);
          gif = parseGIF(buffer);
          frames = decompressFrames(gif, false);
          if ((bot.some(e => e.page.network === 'linkedin') && frames.length > 250) || (bot.some(e => e.page.network === 'twitter') && frames.length > 350)) {
            return this.notify({
              title: this.$t('dash.post.error.format_image.title'),
              text: this.$t('dash.post.error.format_image_gif.frames',  {frames: frames.length}),
              color:'success',
              time: 10000,
            })
          }
          if (bot.some(e => e.page.network === 'twitter') && (gif.lsd.width > 1280 || gif.lsd.height > 1080 || buffer.length > 15000000)) {
            return this.notify({
              title: this.$t('dash.notifications.limit_file_exceeded'),
              text: this.$t('dash.post.error.format_image_gif.size'),
              color:'success',
              time: 10000,
            })
          }   
        }

        if(!['reshare', 'retweet'].includes(this.state) || this.post.status != 'direct') {
          if (this.typePost === 'image' && !this.form.enclosure && !this.form.url && !this.form.file) 
            return this.notify({
              title: this.$t('dash.post.error.need_image.title'),
              text: this.$t('dash.post.error.need_image.content'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          else if (this.typePost === 'image' && this.form.file && this.form.file.type === "application/pdf") {
            return this.notify({
              title: this.$t('dash.post.error.format_image.title'),
              text: this.$t('dash.post.error.format_image.content'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          }
          else if (this.typePost === 'video' && !this.form.video) 
            return this.notify({
              title: this.$t('dash.post.error.need_video.title'),
              text: this.$t('dash.post.error.need_video.content'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          else if(this.typePost === 'video' && Object.values(this.videos).includes("encoding..."))
            return this.notify({
              title: this.$t('dash.post.error.need_video.title'),
              text: this.$t('dash.tooltip.upload_media'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          else if(this.typePost === 'image' && bot.find(bot => !['linkedin', 'twitter'].includes(bot.page.network)) && ((this.form.file && this.form.file.type === "image/gif") || (this.form.enclosure && this.form.enclosure.includes('.gif'))))
            return this.notify({
              title: this.$t('dash.post.error.format_image.title'),
              text: this.$t('dash.post.error.format_image_gif.content', { pages: [...new Set(bot.filter(bot => !['linkedin', 'twitter'].includes(bot.page.network)).map(bot => ` ${bot.page.name} (${bot.page.network.charAt(0).toUpperCase()}${bot.page.network.slice(1)})`))].toString() }),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          else if(this.typePost === 'standard' && bot.find(bot => ['instagram'].includes(bot.page.network)) && !this.form.enclosure && !this.form.url && !this.form.file)
            return this.notify({
              title: this.$t('dash.post.error.need_image.title'),
              text: this.$t('dash.post.error.need_image.content'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          else if(this.typePost === 'document' && (!(this.form.file || this.url) || !this.form.documentTitle)) 
            return this.notify({
              title: this.$t('dash.post.error.need_doc_or_title.title'),
              text: this.$t('dash.post.error.need_doc_or_title.content'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          else if(this.typePost === 'document' && !((this.form.file && this.form.file.type === "application/pdf") || (this.url && this.url.includes('.pdf'))))
            return this.notify({
              title: this.$t('dash.post.error.format_doc_pdf.title'),
              text: this.$t('dash.post.error.format_doc_pdf.content'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          else if(this.typePost === 'poll' && (!this.poll.question || this.poll.options.length < 2 || this.poll.options.some(e => e === ''))) 
            return this.notify({
              title: this.$t('dash.post.error.need_elements_poll.title'),
              text: this.$t('dash.post.error.need_elements_poll.content'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          else if(this.multipleImages && this.multipleImages.length > 1 && this.typePost === 'image' && !this.multipleImages.filter(e => e.file).every(e => FBvalid.includes(e.file.type) || FBvalid.find(v => v.includes(e.ext)) || FBvalid.find(v => v.includes(e.url.split('.').pop()))) && bot.some(bot => bot.page.network === 'facebook')) {
            return this.notify({
              title: this.$t('dash.post.error.format_image.title'),
              text: this.$t('dash.post.error.format_image_facebook.content'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          }
          else if(this.multipleImages && this.multipleImages.length > 1 && this.typePost === 'image' && !this.multipleImages.filter(e => e.file).every(e => TWvalid.includes(e.file.type) || TWvalid.find(v => v.includes(e.ext)) || TWvalid.find(v => v.includes(e.url.split('.').pop()))) && bot.some(bot => bot.page.network === 'twitter')) {
            return this.notify({
              title: this.$t('dash.post.error.format_image.title'),
              text: this.$t('dash.post.error.format_image_twitter.content'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          }
          else if(this.multipleImages && this.multipleImages.length > 1 && this.typePost === 'image' && !this.multipleImages.filter(e => e.file).every(e => LKvalid.includes(e.file.type) || LKvalid.find(v => v.includes(e.ext)) || LKvalid.find(v => v.includes(e.url.split('.').pop()))) && bot.some(bot => bot.page.network === 'linkedin')) {
            return this.notify({
              title: this.$t('dash.post.error.format_image.title'),
              text: this.$t('dash.post.error.format_image_linkedin.content'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          }
          else if(bot.some(bot => bot.page.network === 'pinterest') && !this.form.boardSelected) {
            return this.notify({
              title: this.$t('dash.notifications.error_title'),
              text: this.$t('dash.post.error.board_required'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })
          }
        }

        // limit hashtag (30 insta)
        if(bot.find(bot => ['instagram'].includes(bot.page.network)) 
        // eslint-disable-next-line
                && this.form.title && (this.form.title.match(new RegExp("#[^\s]", "g")) || []).filter(m => m != '# ').length > 30)
            return this.notify({
              title: this.$t('dash.notifications.error_title'),
              text: this.$t('dash.post.error.max_hashtags_instagram.content'),
              color:'success',
              time: 10000,
              id: 'norepeat'
            })

        // limit mention (25 linkedin)
        if(bot.find(bot => ['linkedin'].includes(bot.page.network)) 
        // eslint-disable-next-line
              && this.form.title && (this.form.title.match(new RegExp("@[^\s]", "g")) || []).filter(m => m != '@ ').length > 25)
          return this.notify({
            title: this.$t('dash.notifications.error_title'),
            text: this.$t('dash.post.error.max_mentions_linkedin.content'),
            color:'success',
            time: 10000,
            id: 'norepeat'
          })

        console.log(this.form.file);

        // if (this.selectedMusic) {
        //   // this.form.url = null;
        //   // this.pollStory = null;
        //   // this.instagramTexts = [{"x":147,"y":238,"content":"","color":"white","size":22,"font":1,"background":0,"angle":0,"w":10,"h":36}];
        //   if (this.selectedMusic.config) {
        //     this.selectedMusic.config = false;
        //   }
        //   let audio = this.$refs[`music-preview-mention`];
        //   if (!audio) {
        //     audio = document.querySelectorAll('audio');
        //     audio.forEach(e => e.pause());
        //   }
        //   else {
        //     audio.pause();
        //   }
          
        // }
        if ((!(this.videoReel && this.typePost === 'video') && this.$store.getters.storificationMusic) || (this.videoReel && this.typePost === 'video' && this.$store.getters.storificationMusicReel)) {
          this.videoReel && this.typePost === 'video' ? this.$store.commit('updateStorificationMusicReel', {config: false, paused: true}) : this.$store.commit('updateStorificationMusic', {config: false, paused: true});
        }

        if(!this.carouselPopupMessage && this.multipleImages && this.multipleImages.filter(e => e.file).length > 4 && bot.some(bot => bot.page.network === 'twitter')) {
          this.carouselPopupMessage = this.$t('dash.notifications.limit_carousel.twitter');
          return
        }
        else if(!this.carouselPopupMessage && this.multipleImages && this.multipleImages.filter(e => e.file).length > 9 && bot.some(bot => bot.page.network === 'linkedin')) {
          this.carouselPopupMessage = this.$t('dash.notifications.limit_carousel.linkedin');
          return
        }
        else if(!this.carouselPopupMessage && ((this.multipleImages && this.multipleImages.filter(e => e.file).length > 20) || (this.multipleMedias && this.multipleMedias.filter(e => e.url).length > 20)) && bot.some(bot => ['instagram'].includes(bot.page.network) && bot.page.story_config && bot.page.story_config.created)) {
          this.carouselPopupMessage = this.$t('dash.notifications.limit_carousel.instagram_conciergerie');
          return
        }
        else if(!this.carouselPopupMessage && ((this.multipleImages && this.multipleImages.filter(e => e.file).length > 10) || (this.multipleMedias && this.multipleMedias.filter(e => e.url).length > 10)) && bot.some(bot => ['instagram', 'threads'].includes(bot.page.network) && !(bot.page.story_config && bot.page.story_config.created))) {
          this.carouselPopupMessage = this.$t('dash.notifications.limit_carousel.instagram');
          return
        }
        this.carouselPopupMessage = null;

        this.showConfirmPost = false

        let scheduledDate
        let screenshot = null;
        if (this.scheduling.show === true) {
          scheduledDate = moment(this.scheduling.date).set(
            'hour',
            this.scheduling.time.HH
          )
          scheduledDate = scheduledDate.set('minute', this.scheduling.time.mm)
          scheduledDate = scheduledDate.utc().format()
          
          if (this.typePost === 'story' && !this.storyVideo) {
            // screenshot = await this.$refs.storymaker[0].captureActualAsPicture();
          }
        } else {
          scheduledDate = moment()
            .utc()
            .format()
        }

        let isInstaCapture = null;
        let originalImage = null;
        // this.instagramTexts = this.instagramTexts.filter((e, idx) => {
        //   return idx === 0 || e.content !== '';
        // });
        // if (this.typePost === 'story' && this.captureNeedeed()) {
        //   this.$vs.loading({color : 'primary', text: this.$t('dash.post.loading.text')})
        //   let base64 = await this.$refs.storymaker[0].captureActualAsPicture();
        //   let formData = new FormData()
        //   formData.append('file', this.form.file)
        //   const { VUE_APP_API_HOST } = process.env

        //   await this.$http.post(`${VUE_APP_API_HOST}/posts/upload/file`, formData).then(res => {
        //         originalImage = res.body.file_url;
        //   }, err => err)
        //   this.form.file = this.base64toFile(base64, 'instagram_picture')
        //   this.form.enclosure = this.form.file
        //   isInstaCapture = true;
        //   this.$vs.loading.close();
        // }

        let storyMultipleEnclosure = null;
        // TODO: à sureveiller
        if ((/* this.typePost === 'story' || */ (this.typePost === 'image' && this.shareAfterPost)) && typeof this.form.enclosure === 'string') {
          if (this.form.file && this.form.file.size) {
            this.form.enclosure = null;
          // eslint-disable-next-line no-useless-escape
          } else if (this.form.enclosure && this.form.enclosure != '' && !/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gm.test(this.form.enclosure)) {
            this.form.file = this.base64toFile(`${this.form.enclosure}`, 'instagram_picture')
          }
          // console.log("VALIDATE enclosure overritten", this.form.enclosure);
        }
        // Images déjà uploadés pour le fix multistory transformé en video avec gif, mais nécéssaire pour les videos.
        if (this.storyMultiple && this.storyMultiple.length > 1 && this.form.file && this.form.video) {
          let {success, file_url} = (await this.uploadFile(this.form.file)).body;
          if (success && file_url) { 
            storyMultipleEnclosure = file_url;
            // console.log("VALIDATE upload video", storyMultipleEnclosure);
          }
        }

        if (this.typePost === 'story') {
          const { VUE_APP_API_HOST } = process.env
          let layers = this.$store.getters.storificationLayers;
          if (layers.filter(e => !e.url).length > 0) {
            this.$vs.loading({color : 'primary', text: this.$t('dash.post.loading.text')});
          }
          for (let k = 0; k < layers.length; k++) {
            if (layers[k].url) {
              continue
            }
            let formData = new FormData()
            formData.append('file', layers[k].file)

            await this.$http
              .post(`${VUE_APP_API_HOST}/posts/upload/file`, formData, {
                progress: (e) => {
                    if (e.lengthComputable) {
                        console.log(Math.floor(e.loaded / e.total * 100));
                        this.percentUpload = Math.floor(e.loaded / e.total * 100)
                    }
                }
              })
              .then(res => {
                layers[k].url = res.body.file_url;
                delete layers[k].file;
                delete layers[k].reader;
                layers[k].index = k;
                this.$store.commit("updateStorificationLayer", layers[k]);
              }, err => err)
          }
          this.$vs.loading.close();

        }


        // if (this.reverseBot.length > 1 && this.highlightInstagram) {
        //   this.highlightInstagram = null;
        // }
        if (this.reverseBot.length > 1 && this.$store.getters.storificationHightlight) {
          this.$store.commit("updateStorificationHightlight", null);
      }

        // if (this.pollStory && this.typePost === 'story') {
        //   if (!this.pollStory.question) this.pollStory.question = "Question ?";
        //   if (!this.pollStory.options[0]) this.pollStory.options[0] = "Oui";
        //   if (!this.pollStory.options[1]) this.pollStory.options[1] = "Non";
        //   this.pollStory.options = this.pollStory.options.filter(e => e.length > 0);
        //   console.log(this.$refs.storymaker);
        //   let el1 = this.$refs.storymaker[0].$el.querySelector('#poll-option-1')
        //   let el2 = this.$refs.storymaker[0].$el.querySelector('#poll-option-2')
        //   this.pollStory.size = [el1.style.fontSize, el2.style.fontSize]
          // this.pollStory.question = this.splitByBreakWords(this.pollStory.question, 245);
        // }
        // if (this.sliderStory && this.typePost === 'story') {
        //   if (!this.sliderStory.question) this.sliderStory.question = "";
        //   if (!this.sliderStory.emoji) this.sliderStory.emoji = "😍";
        //   if (!this.sliderStory.color) this.sliderStory.color = "#ffffff";
          // this.sliderStory.question = this.splitByBreakWords(this.sliderStory.question, 245);
        // }
        let pollStory = this.$store.getters.storificationPoll;
        if (pollStory) {
          if (!pollStory.question) pollStory.question = "";
          if (!pollStory.options[0]) pollStory.options[0] = "Oui";
          if (!pollStory.options[1]) pollStory.options[1] = "Non";
          pollStory.x = pollStory.x + (pollStory.w / 2);
          pollStory.y = pollStory.y + (pollStory.h / 2);
          pollStory.size = [];
          pollStory.options = pollStory.options.filter(e => e.length > 0);
          pollStory.question = this.splitByBreakWords(pollStory.question, 245);
        }
        let sliderStory = this.$store.getters.storificationSlider;
        if (sliderStory) {
          if (!sliderStory.color) sliderStory.color = 0;
          sliderStory.color = ["#ffffff", '#000000', "#E50075", "#d734cd", "#8147f6", "#ee8132", "#5ece55", "#47a1f8", "#59c5f7"][sliderStory.color];
          if (!sliderStory.emoji) sliderStory.emoji = "😍";
          if (!sliderStory.question) sliderStory.question = "";
          sliderStory.x = sliderStory.x + (sliderStory.w / 2);
          sliderStory.y = sliderStory.y + (sliderStory.h / 2);
          sliderStory.question = this.splitByBreakWords(sliderStory.question, 245);
        }
        let questionStory = this.$store.getters.storificationQuestion;
        if (questionStory) {
          if (!questionStory.text) questionStory.text = "Posez-moi une question";
          if (!questionStory.color) questionStory.color = 0;
          questionStory.color = ["#ffffff", '#000000', "#E50075", "#d734cd", "#8147f6", "#ee8132", "#5ece55", "#47a1f8", "#59c5f7"][questionStory.color];
          questionStory.x = questionStory.x + (questionStory.w / 2);
          questionStory.y = questionStory.y + (questionStory.h / 2);
          questionStory.text = this.splitByBreakWords(questionStory.text, 245);
        }

        if (this.form && this.form.enclosure && this.form.enclosure.startsWith('data:video/mp4;base64') && this.form.video) {
          this.form.enclosure = null;
        }

        //if at least a bot exist for the current page and bots are selected 
        // console.log(bot, bot.length, this.samePageBots.length)
        // if(bot && bot.length && this.samePageBots.length){

        await this.saveDraft(true);

        if(bot && bot.length){
          bot.forEach(async (b,i) => {
            //if edit on preview
            let indexEdit = this.editPostValue.findIndex(p => p.page == b.page.id)
            let imageModif = null;
            let scheduledDatePreview
            if(this.editPostValue[indexEdit] && this.editPostValue[indexEdit].scheduling && this.editPostValue[indexEdit].scheduling.date && this.editPostValue[indexEdit].scheduling.time.HH && this.editPostValue[indexEdit].scheduling.time.mm) {
              scheduledDatePreview = moment(this.editPostValue[indexEdit].scheduling.date).set(
                'hour',
                this.editPostValue[indexEdit].scheduling.time.HH
              )
              scheduledDatePreview = scheduledDatePreview.set('minute', this.editPostValue[indexEdit].scheduling.time.mm)
              scheduledDatePreview = scheduledDatePreview.utc().format()
            }
            if (this.editPostValue[indexEdit] && this.editPostValue[indexEdit].image) {
              console.log(this.editPostValue[indexEdit]);
              imageModif = this.editPostValue[indexEdit].image;
            }
           
            let instaTextMention = [];
            // let currentTexts = (!this.instagramTexts || !this.instagramTexts.length) ? [{x:0,y:0,w:0,h:0,content:'',color:'white',size:20,font:0,background:null,angle:0}] : this.instagramTexts;
            let currentTexts = (!this.$store.getters.storificationTexts || !this.$store.getters.storificationTexts.length) ? [{x:0,y:0,w:0,h:0,content:'',color:'white',size:20,font:0,background:null,angle:0}] : this.$store.getters.storificationTexts;
            if (this.typePost === 'story') {
              for (let txt of currentTexts) {
                this.form.title = txt.content;
                instaTextMention.push({
                  x: txt.x,
                  y: txt.y,
                  content: this.getMessage(b),
                  color: txt.color,
                  size: parseFloat(txt.size) + 2,
                  font: txt.font,
                  background: txt.background,
                  angle: txt.angle || 0, 
                  w: txt.w,
                  h: txt.h,
                  // linkX: this.$store.getters.storificationLink ? (this.$store.getters.storificationLink.x + (this.$store.getters.storificationLink.w/3)) : null,
                  linkX: this.$store.getters.storificationLink ? (this.$store.getters.storificationLink.x + ((this.$store.getters.storificationLink.w/this.$store.getters.storificationLink.scale)/2)) : null,
                  // linkY: this.$store.getters.storificationLink ? (this.$store.getters.storificationLink.y - (this.$store.getters.storificationLink.h/3)) : null,
                  linkY: this.$store.getters.storificationLink ? (this.$store.getters.storificationLink.y + ((this.$store.getters.storificationLink.h/this.$store.getters.storificationLink.scale)/2)) : null,
                  linkAngle: this.$store.getters.storificationLink ? this.$store.getters.storificationLink.angle : 0,
                  linkScale: this.$store.getters.storificationLink ? this.$store.getters.storificationLink.scale : null,
                  linkColor: this.$store.getters.storificationLink ? this.$store.getters.storificationLink.color : null,
                  linkText: this.$store.getters.storificationLink ? this.$store.getters.storificationLink.text || '' : null,
                  template: this.$store.getters.storificationTemplate,
                  layers: this.$store.getters.storificationLayersFormated,
                  poll: pollStory ? JSON.stringify(pollStory): null,
                  slider: sliderStory ? JSON.stringify(sliderStory): null,
                  question: questionStory ? JSON.stringify(questionStory): null,
                  music: this.$store.getters.storificationMusic ? JSON.stringify(this.$store.getters.storificationMusic): null,
                  location: this.$store.getters.storificationLocation ? JSON.stringify(this.$store.getters.storificationLocation): null,
                  product: this.$store.getters.storificationProductWithoutImage ? JSON.stringify(this.$store.getters.storificationProductWithoutImage): null,
                  gifs: this.$store.getters.storificationGifsFormated.length ? JSON.stringify(this.$store.getters.storificationGifsFormated) : [],
                  mentionsWidget: this.$store.getters.storificationMentionsFormated.length ? JSON.stringify(this.$store.getters.storificationMentionsFormated) : [],
                  hashtagsWidget: this.$store.getters.storificationHashtagsFormated.length ? JSON.stringify(this.$store.getters.storificationHashtagsFormated) : [],
                  // linkX: this.instagramLinkPosition.x,
                  // linkY: this.instagramLinkPosition.y,
                  // linkAngle: this.instagramLinkPosition.angle,
                  // linkScale: this.instagramLinkPosition.scale,
                  // linkColor: this.instagramLinkPosition.color,
                  // template: this.templateManual || null,
                  // layers: this.layers,
                  // poll: this.pollStory ? JSON.stringify(this.pollStory) : null,
                  // slider: this.sliderStory ? JSON.stringify(this.sliderStory) : null,
                  // linkText: this.storyLinkText || null,
                  shareToFacebook: this.storyShareToFacebook,
                  // music: this.selectedMusic ? JSON.stringify(this.selectedMusic) : null,
                  // gifs: this.selectedGifs && this.selectedGifs.length > 0 ? JSON.stringify(this.selectedGifs) : null,
                  // mentionsWidget: this.storyMentions && this.storyMentions.length > 0 ? JSON.stringify(this.storyMentions) : null,
                  isCapture: isInstaCapture,
                  originalImage: isInstaCapture && originalImage ? originalImage : undefined,
                })
              }
              console.log(instaTextMention);
            }

            let reelStickerConfig = null;
            if (this.typePost === 'video' && this.videoReel && b.page.network === 'instagram') {
              reelStickerConfig = {
                texts: this.instagramTexts.filter(e => e.content),
                music: this.selectedMusic,
                gifs: this.$store.getters.storificationGifsFormatedReel,
              }
            }
           
            if (this.typePost === 'standard' && this.snippet && this.form.enclosure && this.form.url) {
              this.form.enclosure = '';
            }
            //!! TODO: Vérifier
            if (this.form.enclosure && this.form.enclosure.includes('blob:') /*&& !(this.storyMultiple && this.storyMultiple.length > 1 && this.typePost === 'story')*/) {
              const newImageBlob = await fetch(this.form.enclosure).then(res => res.blob())
              const newFile = new File([newImageBlob], `enclosure-post-${bot[0].id}.${newImageBlob.type.split("/").pop()}`, {type: newImageBlob.type}); //Blob to file
              let formData = new FormData()
              formData.append('file', newFile)
              console.log('formData', formData)
              let resFile = await this.$http.post(`${process.env.VUE_APP_API_HOST}/posts/upload/file`, formData)
              if(resFile && resFile.body && resFile.body.file_url) {
                this.form.enclosure = resFile.body.file_url;
                this.form.file = null;
              }
            }
            if (this.multipleImages && this.multipleImages.length) {
              this.multipleImages = await Promise.all(this.multipleImages.map(async (e, i) => {
                if (e.url && e.url.includes('blob:')) {
                  const newImageBlob = await fetch(e.url).then(res => res.blob())
                  const newFile = new File([newImageBlob], `multiple-image-${e.filename || i}-post-${bot[0].id}.${newImageBlob.type.split("/").pop()}`, {type: newImageBlob.type}); //Blob to file
                  let formData = new FormData()
                  formData.append('file', newFile)
                  console.log('formData', formData)
                  let resFile = await this.$http.post(`${process.env.VUE_APP_API_HOST}/posts/upload/file`, formData)
                  if(resFile && resFile.body && resFile.body.file_url) {
                    e.url = resFile.body.file_url;
                  }
                }
                return e
              }))
            }
            
            if(this.form.file // 👈 null and undefined check
                && Object.keys(this.form.file).length === 0
                && Object.getPrototypeOf(this.form.file) === Object.prototype)
              this.form.file = null

            let body = {
              bot: b.id,
              service: b.service,
              data: {
                boardSelected: this.form.boardSelected && b.page.network === 'pinterest' ? this.form.boardSelected.id : null,
                childBoardSelected: this.form.boardSelected && b.page.network === 'pinterest' && this.form.boardSelected.childs && this.form.boardSelected.childs.selected ? this.form.boardSelected.childs.selected.id : null,
                title: this.getMessage(b),
                url: this.validURL(this.form.url) ? this.form.url : '',  
                description: this.form.description || null,
                scheduled_date: scheduledDatePreview || scheduledDate,
                enclosure: (this.typePost === 'image' && this.multipleImages && this.multipleImages.length > 1 && this.multipleImages[0].url && this.multipleImages[1].url) ? null : (imageModif || storyMultipleEnclosure || (this.multipleImages && this.multipleImages.length == 1 ? this.multipleImages[0].url : null) || this.form.enclosure || this.form.file),
                postImage: this.typePost == 'image' ? true : false,
                video: this.videos[this.videoType(b)] || this.form.video || null,
                videoType: b.page.network === 'instagram' && this.videoReel ? 'instagram_reel': (b.page.network === 'facebook' && this.videoReelFB ? 'facebook_reel' : b.page.network),
                // background_color: this.instagramBackgroundColor,
                background_color: this.$store.getters.storificationBackgroundColor,
                // highlight: this.highlightInstagram || null,
                highlight: this.$store.getters.storificationHightlight,
                typePost: this.typePost,
                documentTitle: this.form.documentTitle,
                editPostAlreadyPosted: this.state === 'edit-posted' ? true : false,
              },
              storyIdentification,
              last: i == bot.length-1 ? true : false,
              nbPosts: bot.length ,
              scheduled: this.scheduling.show || (this.editPostValue[indexEdit] && this.editPostValue[indexEdit].scheduling && this.editPostValue[indexEdit].scheduling.date && this.editPostValue[indexEdit].scheduling.time.HH && this.editPostValue[indexEdit].scheduling.time.mm) ? true : false
            }
            // console.log("VALIDATE enclosure in body", body.data.enclosure);

            if(this.form.comments && this.form.comments.length){
              if (this.editPostValue[indexEdit] && this.editPostValue[indexEdit].comment) 
                body.data.comments = JSON.stringify(this.form.comments.filter((c,i) => this.editPostValue[indexEdit].comment[i] !== false)
                                                              .map((c,i) => this.getMessage(b, this.editPostValue[indexEdit].comment[i] ? this.editPostValue[indexEdit].comment[i] : c)))
              else
                body.data.comments = JSON.stringify(this.form.comments.map(comment => this.getMessage(b, comment)))
            }

            if(['image', 'video'].includes(this.typePost) && this.editPostValue[indexEdit] && this.editPostValue[indexEdit].removeUrlInMessage) {
              body.data.removeUrlInMessage = true
            }

            if(b.page.network === 'instagram' && body.data.video) {
              let video = document.getElementById(`video-${b.page.id}`)
              if(video)
                body.data.thumb_offset = (video.currentTime * 100).toFixed(0)
            }

            if(this.videoReel && b.page.network == 'instagram') {
              body.data.videoReel = true
              if (reelStickerConfig) {
                body.data.reelStickerConfig = JSON.stringify(reelStickerConfig);
              }
            }
            if(this.videoReelFB && b.page.network == 'facebook') {
              body.data.videoReel = true
            }

            if (["instagram", "facebook"].includes(b.page.network) && this.selectedLocation && this.selectedLocation[b.page.network]) {
              body.data.location = this.selectedLocation[b.page.network].id;
            }

            if (['image'].includes(this.typePost) && ["instagram"].includes(b.page.network) && this.selectedMusic && this.selectedMusic.track) {
              body.data.music = JSON.stringify(this.selectedMusic);
            }

            if (["instagram", "facebook"].includes(b.page.network) && this.userTags && this.userTags.list && this.userTags.list.length > 0 ) {
              body.data.userTags = JSON.stringify(this.userTags);
            }
             if (["instagram", "facebook"].includes(b.page.network) && this.productTags && this.productTags.length > 0 ) {
              body.data.productTags = JSON.stringify(this.productTags.map(e => {
                return {
                  ...e,
                  image: null
                }
              }));
            }

            if (this.storyShare && b.page.network == 'instagram') {
                body.data.sharedStory = this.storyShare;
                body.data.sharedVisual = this.storySharedVisual;
                body.data.sharedStoryUrl = this.sharedStoryUrl;
            }

            if (this.shareAfterPost && b.page.network == 'instagram' && b.page.story_config && b.page.story_config.created) {
              let scheduledDatePreviewStorification
              if(this.editPostValue[indexEdit] && this.editPostValue[indexEdit].storification && this.editPostValue[indexEdit].storification.date && this.editPostValue[indexEdit].storification.time.HH && this.editPostValue[indexEdit].storification.time.mm) {
                scheduledDatePreviewStorification = moment(this.editPostValue[indexEdit].storification.date).set(
                  'hour',
                  this.editPostValue[indexEdit].storification.time.HH
                )
                scheduledDatePreviewStorification = scheduledDatePreviewStorification.set('minute', this.editPostValue[indexEdit].storification.time.mm)
                scheduledDatePreviewStorification = scheduledDatePreviewStorification.utc().format()
              }
              console.log(this.$store.getters['storificationLinkText']);
              body.data.storification = {
                scheduling: scheduledDatePreviewStorification || scheduledDatePreview || scheduledDate,
                link: this.validURL(this.form.url) ? this.$store.getters.storificationLink : null,
                poll: pollStory ? pollStory: null,
                slider: sliderStory ? sliderStory: null,
                question: questionStory ? questionStory: null,
                mentions: this.$store.getters.storificationMentionsFormated.length ? this.$store.getters.storificationMentionsFormated : [],
                hashtags: this.$store.getters.storificationHashtagsFormated.length ? this.$store.getters.storificationHashtagsFormated : [],
                location: this.$store.getters.storificationLocation ? this.$store.getters.storificationLocation : null,
                product: this.$store.getters.storificationProductWithoutImage ? this.$store.getters.storificationProductWithoutImage : null,
                texts: currentTexts.filter(e => e.content).map(e => {
                  e.size = parseFloat(e.size) + 2;
                  e.angle = e.angle || 0;
                  return e;
                })
              };
              if (body.data.storification.link) {
                body.data.storification.link.x = (body.data.storification.link.x + ((body.data.storification.link.w/body.data.storification.link.scale)/2))
                body.data.storification.link.y = (body.data.storification.link.y + ((body.data.storification.link.h/body.data.storification.link.scale)/2))
              }
              if (this.storyShareToFacebook) {
                body.data.storification.facebook = true;
                // body.data.shareToFacebook = this.storyShareToFacebook
              }
              body.data.storification = JSON.stringify(body.data.storification)
            }

            //if post image without file
            if(!['reshare', 'retweet'].includes(this.state) && this.typePost == 'image' && !(this.form.enclosure || this.form.file) && this.form.url && this.meta) { 
              if(this.meta.og && this.meta.og.image)
                body.data.enclosure = this.meta.og.image
              else if(this.meta.images && this.meta.images[0] && this.meta.images[0].url)
                body.data.enclosure = this.meta.images[0].url
            }        
            
            if (this.typePost === 'standard' && this.snippet && ['linkedin', 'facebook', 'whatsapp'].includes(b.page.network) && this.form.url) {
              body.data.snippet = this.snippet;
            }

            if (this.typePost === 'standard' && this.snippetTitle && ['linkedin', 'facebook', 'whatsapp'].includes(b.page.network) && this.form.url) {
              body.data.snippetTitle = this.snippetTitle;
            }

            let messageLength = body.data.title.length
            if(b.page.network == 'twitter') {
              // let regexUrl = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|www\.[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z\u00C0-\u017F0-9]+\.[^\s]{2,}|www\.[a-zA-Z\u00C0-\u017F0-9]+\.[^\s]{2,})/g
              // if(body.data.title && body.data.title.match(regexUrl))
              //   messageLength = body.data.title.length - body.data.title.match(regexUrl).reduce((previous, current) => previous + current.length, 0)
              const twttr = require('twitter-text')
              messageLength = twttr.default.parseTweet(body.data.title).weightedLength
            }

            // if(['twitter', 'google', 'linkedin', 'instagram', 'facebook'].includes(b.page.network) && messageLength > this.limitTextByBot(b))
            if(['google', 'linkedin', 'instagram', 'facebook', 'threads', 'bluesky', 'youtube'].includes(b.page.network) && messageLength > this.limitTextByBot(b))
              body.data.title = body.data.title.substr(0, body.data.title.substr(0, this.limitTextByBot(b) - 4).lastIndexOf(" ")) + " ..."

            if(b.page.network == 'twitter' && messageLength > this.limitTextByBot(b)) {
              const twttr = require('twitter-text')
              let limitText = this.limitTextByBot(b)
              let limitTextTmp = limitText
              do {
                body.data.title = body.data.title.substr(0, body.data.title.substr(0, limitTextTmp - 4).lastIndexOf(" ")) + " ..."
                messageLength = twttr.default.parseTweet(body.data.title).weightedLength
                limitTextTmp--
              }
              while(messageLength > limitText)
            }

            if (this.typePost === 'story') {
              body.data.story_instagram = instaTextMention;
              body.data.story_standard_api = (this.typePost === 'story' && !this.atLeastInstagramConciergerieSelected())
            }

            if (this.typePost === 'poll' && this.poll.question && this.poll.options.length >= 2) {
              body.data.poll = JSON.stringify(this.poll);
            }

            if (this.typePost === 'image' && this.multipleImages && this.multipleImages.length > 1 && this.multipleImages[0].url && this.multipleImages[1].url) {
              console.log(this.multipleImages[1].file);
              body.data.carrousel = this.multipleImages.filter(i => i.url);
              body.data.enclosure = body.data.carrousel[0].url
            }
            else if (this.typePost === 'image' && this.multipleImages && this.multipleImages.length > 0 && this.multipleImages[0].url && this.state === 'edit-posted' && this.post && this.post.page[0] && this.post.page[0].carousel && this.post.page[0].carousel.length > 0) {
              body.data.carrousel = this.multipleImages.filter(i => i.url);
              body.data.enclosure = body.data.carrousel[0].url
            }
            
            if (this.typePost === 'video' && this.multipleMedias && this.multipleMedias.length > 1 && this.multipleMedias[0].url && this.multipleMedias[1].url) {
              body.data.multipleMedias = JSON.stringify(this.multipleMedias.filter(i => i.url));
            }

            if (screenshot) {
              body.data.screenshot = this.base64toFile(screenshot);
            }

            if (this.post && this.post.flux && this.post.flux.id)
              body.data.flux = this.post.flux.id

            if (b.page.network === "tiktok") {
              body.data.tiktokOptions = JSON.stringify({
                comment_disabled: this.tiktokOptions.comment_disabled,
                duet_disabled: this.tiktokOptions.duet_disabled,
                privacy_level: this.tiktokOptions.privacy_level,
                stitch_disabled: this.tiktokOptions.stitch_disabled
              });
            }
            else if (b.page.network === "youtube") {
              body.data.youtubeOptions = JSON.stringify(this.youtubeOptions);
            }
            else if (b.page.network === "twitter") {
              body.data.twitterOptions = JSON.stringify(this.twitterOptions);
            }
            else if (b.page.network === "facebook" && this.facebookOptions) {
              body.data.facebookOptions = JSON.stringify(this.facebookOptions);
            }

            this.scheduling.lastScheduled = scheduledDate

            if(this.bot.length >= 1)
              body.draft = JSON.stringify(this.getBodyDraft(null))

            body.data.allBots = bot.map(b => b.uid)

            if(this.state === 'edit-draft')
              body.data.removeDraft = this.post.id

            if(this.affectedTo) {
              // this.showLoader = true
              body.data.affectedTo = {
                user: this.affectedTo.user ?  this.affectedTo.user.id : this.affectedTo.id,
                optionValidation: typeof this.affectedTo.optionValidation == 'boolean' ? this.affectedTo.optionValidation : true
              }
              if(this.affectedTo.users)
                body.data.affectedTo.users = this.affectedTo.users.map(u => u.id)
              // //screenshot
              // try {
              //   this.doScreenshot = true
              //   await this.convertImagePreviewToBase64(b.id)
              //   let canvas = await html2canvas(this.$refs[`preview-post-${b.id}`][0], {allowTaint: true, useCORS:true})
              //   let imageB64 = canvas.toDataURL('image/png')
              //   const newImageBlob = await fetch(imageB64).then(res => res.blob())
              //   const newFile = new File([newImageBlob], `preview-post-${b.id}.png`); //Blob to file
              //   let formData = new FormData()
              //   formData.append('file', newFile)
              //   console.log('formData', formData)
              //   let resFile = await this.$http.post(`${process.env.VUE_APP_API_HOST}/posts/upload/file`, formData)
              //   console.log('resFile', resFile)
              //   if(resFile && resFile.body && resFile.body.file_url)
              //     body.data.affectedTo.screenshot = resFile.body.file_url;
              // } catch (e) {
              //   console.log("screenshot", e)
              //   this.doScreenshot = false
              // }
              body.data.affectedTo = JSON.stringify(body.data.affectedTo)
              // this.showLoader = false
            }

            if (this.storyMultiple.length > 1) {
              if (this.state !== 'edit' 
                || (this.state === 'edit' && this.post.page && this.post.page.length && (
                        (this.post.page[0].posts_multipages && !this.post.page[0].posts_multipages.find(p => p.bot == b.id)) 
                        || (!this.post.page[0].posts_multipages && this.post.page[0].id != b.uid && !this.post.page[0].shared_to_facebook)))) {
                //add page to scheduled post => no exclude original news/post
                body.noExclude = this.state === 'edit'
              }
              this.bodyAddStorage.push(body);
              if (i === bot.length-1) {
                return resolve();
              }
            }
            else if ((this.state !== 'edit' && this.state !== 'edit-posted') 
                      || (this.state === 'edit' && this.post.page && this.post.page.length && (
                              (this.post.page[0].posts_multipages && !this.post.page[0].posts_multipages.find(p => p.bot == b.id)) 
                              || (!this.post.page[0].posts_multipages && this.post.page[0].id != b.uid && !this.post.page[0].shared_to_facebook)))) {
              //add page to scheduled post => no exclude original news/post
              body.noExclude = this.state === 'edit'
              // Add
              this.add(body)
              // setTimeout(() => this.add(body), i*2000)
            } else {
              // Update
              this.update(body)
              // setTimeout(() => this.update(body), i*2000)
            }
          })
          localStorage.postingInProgress = 'true'
          // this.$store.dispatch("resetStorification");
          
          // if(this.state === 'edit-draft'){
          //   this.deleteDraft(this.post.id)
          //   this.$emit('removeDrafts', this.post.id)
          // }
        }
        else {
          return this.notify({
            title: this.$t('dash.notifications.error_title'),
            text: this.$t('dash.bots.error.title'),
            color:'success',
            time: 10000,
            id: 'norepeat'
          })
          

          // let body = {
          //   page: this.page,
          //   data: {
          //     title: this.form.title,
          //     url: this.form.url || '',
          //     scheduled_date: scheduledDate,
          //     enclosure: this.form.enclosure || this.form.file
          //   }
          // }
          
          // this.scheduling.lastScheduled = scheduledDate

          // //this.$ga.event('posts', 'post')
          // body = { ...body, scheduled: this.scheduling.show }
          // this.$emit('addWithoutBot', body)
        }
      })
      });
    },

    validURL(str) {
      // var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      //   '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      //   '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      //   '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      //   '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      //   '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      // return !!pattern.test(str);

      if(str == '') return true
      try {
        return Boolean(new URL(str)); 
      }
      catch(e){ 
        return false; 
      }
    },

    removeDraft(){
      this.deleteDraft(this.post.id)
      this.close()
      this.$emit('removeDrafts', this.post.id)
    },

    /**
     * Set the pages section scrollable if needed
     */
    setPages() {
      if (!document.querySelector('.linked-pages')) return
      let width = document.querySelector('.linked-pages').offsetWidth
      let count = this.linked.length
      let pageOutterWidth = 126 + 10 // page width + margin
      let pagesWidth = count * pageOutterWidth
    },

    /**
     * Scroll pages section on left arrow click
     */
    left() {
      let pages = document.querySelector('.linked-pages')
      let number = 2
      let pageOutterWidth = 124 + 10 // page width + margin
      let end = pages.scrollLeft + number * pageOutterWidth
      let maxLeft =
        this.linked.length * pageOutterWidth - pages.clientWidth + 70

      if (end > maxLeft) {
        end = maxLeft
      }
      let timer = setInterval(() => {
        pages.scrollLeft += 1
        if (pages.scrollLeft >= end) {
          clearInterval(timer)
        }
      }, 1)
    },

    /**
     * Scroll pages section on right arrow click
     */
    right() {
      let pages = document.querySelector('.linked-pages')
      let number = 2
      let pageOutterWidth = 124 + 10 // page width + margin
      let end = pages.scrollLeft - number * pageOutterWidth
      let maxLeft = 0

      if (end < maxLeft) {
        end = maxLeft
      }
      let timer = setInterval(() => {
        pages.scrollLeft -= 1
        if (pages.scrollLeft <= end) {
          clearInterval(timer)
        }
      }, 1)
    },

    findVanityNameByUrl(url){
      console.log('url', url)
      try {
        if(url && new URL(url) && new URL(url).pathname.includes('/company/')){
          // return decodeURI(new URL(url).pathname.replace('/company/', '').replace('/admin', '').replace('/', ''))
          return url.replace("https://www.linkedin.com/company/", '').split('/').shift()
        }
      }
      catch (e) {
        return url;
      }
      return ''
    },

    findInstagramUserByUrl(url){
      if(url && url.includes('https://www.instagram.com/')){
        return new URL(url).pathname.replaceAll('/', '')
      }
      // return url
      return ''
    },

    async searchMentions(type='Mention', now=false){
      if(this[`search${type}`][this[`selectedBot${type}`]] && this[`search${type}`][this[`selectedBot${type}`]].search && this[`search${type}`][this[`selectedBot${type}`]].search != '') {        
        this[`search${type}`][this[`selectedBot${type}`]].results = null
        // eslint-disable-next-line no-useless-escape
        const urlRegex = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
        const isUrl = urlRegex.test(this[`search${type}`][this[`selectedBot${type}`]].search);
        console.log(this[`search${type}`][this[`selectedBot${type}`]].bot.page);
        let page = this[`search${type}`][this[`selectedBot${type}`]].bot.page;
        let storyConf = this[`search${type}`][this[`selectedBot${type}`]].bot.page.story_config;
        let myId = this[`search${type}`][this[`selectedBot${type}`]].bot.id
        let network = this[`search${type}`][this[`selectedBot${type}`]].bot.page.network
        let mention = Fonts.normalize(
                        type == 'Mention'
                            ? (network == 'linkedin' && (!storyConf || !storyConf.cookies || !storyConf.created) && isUrl
                                ? this.findVanityNameByUrl(this[`search${type}`][this[`selectedBot${type}`]].search)
                                : (network == 'instagram' && (!storyConf || !storyConf.session_state || !storyConf.created) && isUrl
                                    ? this.findInstagramUserByUrl(this[`search${type}`][this[`selectedBot${type}`]].search)
                                    : (this[`search${type}`][this[`selectedBot${type}`]] ? this[`search${type}`][this[`selectedBot${type}`]].search : '')))
                            : (this[`search${type}`][this[`selectedBot${type}`]] ? this[`search${type}`][this[`selectedBot${type}`]].search : '')
                      )

        let funcToCall = async (typeToUse, pageId, mention, isUrl) => {
          switch(typeToUse) {
            case 'Mention' : return await this.getMentionsByApi(pageId, mention, isUrl);
            case 'Hashtag' : return await this.getHashtagsByApi(pageId, mention, isUrl); 
            case 'Location' : return await this.getLocationsByApi(pageId, mention, isUrl); 
            case 'Music' : return await this.getMusicsByApi(pageId, mention, isUrl); 
            default: return
          }
        }
        // console.log('test func mention', type, `get${type}sByApi`, funcToCall)

        setTimeout(async () => { 
          let currentMention = Fonts.normalize(                        
                                type == 'Mention'
                                    ? (network == 'linkedin' && (!storyConf || !storyConf.cookies || !storyConf.created) && isUrl
                                          ? this.findVanityNameByUrl(this[`search${type}`][this[`selectedBot${type}`]].search)
                                          : (network == 'instagram' && (!storyConf || !storyConf.session_state || !storyConf.created) && isUrl
                                              ? this.findInstagramUserByUrl(this[`search${type}`][this[`selectedBot${type}`]].search)
                                              : (this[`search${type}`][this[`selectedBot${type}`]] ? this[`search${type}`][this[`selectedBot${type}`]].search : '')))
                                    : (this[`search${type}`][this[`selectedBot${type}`]] ? this[`search${type}`][this[`selectedBot${type}`]].search : '')
                                )
          //user stop typing
          if(mention == currentMention){
            if(mention.length >= 2){
 
              if(['linkedin', 'instagram'].includes(network) && (!storyConf || !storyConf.created || (!storyConf.cookies && !storyConf.session_state)) && !isUrl && type !== 'Location') {
                this[`search${type}`][this[`selectedBot${type}`]].search = ''
               if(this.activeLinkedinConciergerie || this.activeInstagramConciergerie)
                return this.activeConciergerie = page   
               else
                return this.changePlanConciergerie = true
              }


              this.$vs.loading({
                color: 'primary',
                container: `#loadableContent-list-mentions`
              })

              // copy input all empty inputs (if not insta/linkedin without conciergerie)
             if(!(['linkedin', 'instagram'].includes(network) && (!storyConf || !storyConf.created || (!storyConf.cookies && !storyConf.session_state)) && isUrl))
                this[`search${type}`] = this[`search${type}`].map(m => { 
                  return {
                    ...m,
                    search: m.selected ? m.search : this[`search${type}`][this[`selectedBot${type}`]].search
                  }
                })

              this[`search${type}`][this[`selectedBot${type}`]].selected = null
              // let needSimulate = false;
              // if (type === "Mention" && this[`search${type}`][this[`selectedBot${type}`]].bot.page.network === 'instagram') {
              //   let simulate = localStorage.simulateInstagram;
              //   console.log("Simulate", simulate);
              //   let currentPageId = this[`search${type}`][this[`selectedBot${type}`]].bot.page.id;
              //   if (!simulate) {
              //     needSimulate = true;
              //     localStorage.setItem('simulateInstagram', JSON.stringify({[currentPageId]: Date.now()}))
              //   } else {
              //     simulate = JSON.parse(simulate)
              //     let currentSimulate = simulate[currentPageId];
              //     if (!currentSimulate ||  Math.floor(Math.abs(Date.now() - currentSimulate) / (1000 * 60)) > 10) {
              //       needSimulate = true;
              //       simulate[currentPageId] = Date.now();
              //       localStorage.setItem('simulateInstagram', JSON.stringify(simulate))
              //     }
              //   }
              // }
              // console.log("NEED SIMULATE", needSimulate);

              await funcToCall(type, this[`search${type}`][this[`selectedBot${type}`]].bot.page.id, mention, isUrl)
              // await this[`get${type}sByApi`](this[`search${type}`][this[`selectedBot${type}`]].bot.page.id, mention, isUrl)
              .then((res) => {  

                const body = res.body ? res.body : res; //temporary fix for new mixin response form simple mention

                this.$vs.loading.close(`#loadableContent-list-mentions > .con-vs-loading`) 
                this[`search${type}`][this[`selectedBot${type}`]].results = []

                if (body.error
                        && (!this.lastNotif.text || body.lock || (this.lastNotif.text 
                              && this.lastNotif.text == body.error
                              && moment(this.lastNotif.date).isBefore(moment())))) {
                  if (body.error === 'dash.story.account.locked' && body.lock) {
                    this.notify({
                      title:'Erreur',
                      text: this.$t(body.error) + new Date(body.lock).toLocaleString(),
                      color:'danger',
                      time: 10000,
                      id: 'repeat'
                    })
                  } else {
                    this.notify({
                      title:'Erreur',
                      text: this.$t(body.error),
                      color:'danger',
                      time: 10000,
                      id: this[`search${type}`][this[`selectedBot${type}`]].bot.page.id
                    }, {
                      component: "PostsOverlay",
                      action: `search${type}`,
                      params: {
                        page: this[`search${type}`][this[`selectedBot${type}`]].bot.page.name,
                        network: this[`search${type}`][this[`selectedBot${type}`]].bot.page.network,
                        type: type,
                        search: mention
                      }
                    })
                  }
                  this.lastNotif = {
                    text: body.error,
                    date: moment().add(20, 'seconds')
                  }

                  if (body.disconnectDirect) {
                    this.bots.find(e => e.id === myId).page.story_config = null
                    if (network === 'instagram') {
                      this.linked.find(e => e.id === this[`search${type}`][this[`selectedBot${type}`]].bot.page.id).story_config = null
                    }
                    this.$forceUpdate()
                  }
                }
                console.log(currentMention, body, type);
                if(body.word == currentMention)  {
                  if(type == 'Mention') {
                    this.searchMention[this.selectedBotMention].results = Object.values(body.mentions).map(m => {
                      switch(network){
                        case 'twitter':
                          return  {
                                    // id: m.id_str,
                                    // name: m.name,
                                    // screen_name: m.screen_name,
                                    // description: m.description,
                                    // location: m.location,
                                    // image: m.profile_image_url_https,
                                    // verified: m.verified

                                    id: m.id,
                                    name: m.name,
                                    screen_name: m.username,
                                    description: m.description,
                                    location: m.location,
                                    image: m.profile_image_url,
                                    verified: m.verified_type
                                  }
                        case 'facebook':
                          return {
                            id: m.id,
                            name: m.name,
                            image: m.image && m.image.data && m.image.data.url ? m.image.data.url : null
                          }
                        case 'linkedin':
                        case 'instagram':
                        case 'bluesky':
                          return m
                        default:
                          break
                      }
                    })
                    if(network == 'facebook') {
                      this.queue = new Queuer({
                        data: JSON.parse(JSON.stringify(this.searchMention[this.selectedBotMention].results)),
                        task:(m) => {
                          let ind = this.searchMention[this.selectedBotMention].results.findIndex(c => c.id == m.id)
                          this.getAvatarMentionByApi(this.searchMention[this.selectedBotMention].bot.page.id, m.id).then((res) => {
                            if(res && res.body && res.body.avatar && res.body.avatar.data && res.body.avatar.data.url) {
                              this.$set(this.searchMention[this.selectedBotMention].results[ind], 'image', res.body.avatar.data.url)
                              this.$forceUpdate()
                            }
                            this.queue.unlock()
                          })
                        }
                      })
                      this.queue.init()
                    }
                  }
                  else if (type === 'Location') {
                    this.searchLocation[this.selectedBotLocation].results = body.locations
                  } else if (type === 'Music') {
                    console.log(body.musics);
                    this.searchMusic[this.selectedBotMusic].results = body.musics;
                  } 
                  else {
                    this.searchHashtag[this.selectedBotHashtag].results = body.hashtags
                  }

                  if(network == 'twitter' && type == 'Mention'){
                    //filter last entry null
                    this[`search${type}`][this[`selectedBot${type}`]].results = this[`search${type}`][this[`selectedBot${type}`]].results.filter(m => m.screen_name)
                  }
                }
              })
              .then(() => {
                if(this[`search${type}`][this[`selectedBot${type}`]].results.length == 1) 
                  this[`search${type}`][this[`selectedBot${type}`]].selected = this[`search${type}`][this[`selectedBot${type}`]].results[0]
              })
            }
          }
        }, now ? 250 : 1500);
      }
    },

    closeAutoMentions(){
      this.openAutoMentions = false
      this.openAutoHashtags = false
      this.openAutoLocations = false
      this.openAutoMusics = false
      this.searchMention = []
      this.searchHashtag = []
      this.selectedBotMention = 0
      this.selectedBotHashtag = 0
      this.previewEdited = null
      this.showEmojiPicker = false
      this.showEmojiPickerInstagram = -1
      this.showEmojiPickerComment = -1
    },

    checkAddMention(idx=null, commentIdx=null) {
      let textarea = idx !== null
                      ? document.getElementById(`title-post${idx}`)
                      : document.getElementById("title-post")
      if(commentIdx!=null && commentIdx>=0)
        textarea = document.getElementById(`comment-post-${commentIdx}`)
      let cursorPosition = this.getInputSelection(textarea)
      if(cursorPosition.start == cursorPosition.end){
        
        let regexMention = new RegExp('@\\[MENTIONS-\\b([0-9]|[1-9][0-9]|100)\\b(?!\\])'
                                + '|@\\[ENTiONS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[MNTiONS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[METiONS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[MENiONS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[MENTONS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[MENTiNS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[MENTiOS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[MENTiON-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[MENTiONS\\b([0-9]|[1-9][0-9]|100)\\b\\]', 'g')

        let regexHashtag = new RegExp('#\\[HASHTAGS-\\b([0-9]|[1-9][0-9]|100)\\b(?!\\])'
                                + '|#\\[ASHTAGS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HSHTAGS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HAHTAGS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HASTAGS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HASHAGS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HASHTGS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HASHTAS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HASHTAG-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HASHTAGS\\b([0-9]|[1-9][0-9]|100)\\b\\]', 'g')
        
        if (idx !== null) {
          this.instagramTexts[idx].content = this.instagramTexts[idx].content.replace(regexMention, "").replace(regexHashtag, "");
        } else if(commentIdx!=null && commentIdx>=0){
          this.form.comments[commentIdx] = this.form.comments[commentIdx].replace(regexMention, "").replace(regexHashtag, "");
        } else {
          this.form.title = this.form.title.replace(regexMention, "").replace(regexHashtag, "");
        }
        let mytext = idx !== null ? this.instagramTexts[idx].content : this.form.title;
        if(commentIdx!=null && commentIdx>=0)
          mytext = this.form.comments[commentIdx]

        let message = ' ' + mytext
        let indexStartSpace = message.lastIndexOfRegex(/[\]\n ]/g, cursorPosition.start)
        let indexEndSpace = message.indexOfRegex(/[\n ]/g, cursorPosition.start)
        indexEndSpace = indexEndSpace >= 0 ? indexEndSpace : message.length - 1 
        let indexStartMentions = message.indexOf(`@[`, indexStartSpace)
        let indexEndMentions = message.indexOf(']', indexStartMentions)
        let indexStartHashtags = message.indexOf(`#[`, indexStartSpace)
        let indexEndHashtags = message.indexOf(']', indexStartHashtags)
        let mentions = null
        //edit mentions
        if((indexStartMentions <= cursorPosition.start && indexEndMentions >= cursorPosition.start) 
              && (indexStartMentions >= 0 && indexStartMentions < indexEndSpace) 
              && indexStartMentions < indexEndMentions 
              && mytext.substr(cursorPosition.start - 1, 1) != "]" 
              && mytext.substr(cursorPosition.start - 2, 1) != "]"){
          let index = parseInt(message.substr(indexStartMentions, indexEndMentions+2).replace('@[MENTIONS-', '').replace(']', ''))
          mentions = this.validMentions[index-1]
          this.editMention('Mention', idx, commentIdx, message, indexStartMentions, indexEndMentions, index)
        }
        //add mentions
        else if((mytext.substr(cursorPosition.start - 1, 1) == `@` 
                  && mytext.substr(cursorPosition.start - 1, 2) != `@[` 
                  && (cursorPosition.start == 1 || [" ", "\n"].includes(mytext.substr(cursorPosition.start - 2, 1))))) {  
          this.addMention('Mention', idx, commentIdx)
        }
        //edit hashtags
        else if((indexStartHashtags <= cursorPosition.start && indexEndHashtags >= cursorPosition.start) 
              && (indexStartHashtags >= 0 && indexStartHashtags < indexEndSpace) 
              && indexStartHashtags < indexEndHashtags 
              && mytext.substr(cursorPosition.start - 1, 1) != "]" 
              && mytext.substr(cursorPosition.start - 2, 1) != "]"){
          let index = parseInt(message.substr(indexStartHashtags, indexEndHashtags+2).replace('#[HASHTAGS-', '').replace(']', ''))
          mentions = this.validMentions[index-1]
          this.editMention('Hashtag', idx, commentIdx, message, indexStartHashtags, indexEndHashtags, index)
        }
      }
    },

    isAddOrEditMentions(type='Mention', idx=null, commentIdx=null){
      let mytext = type === "Music" ? '' : idx !== null ? this.instagramTexts[idx].content : this.form.title;
      let symbol = type == 'Mention' ? '@' : '#'
      let textarea = idx !== null
                      ? document.getElementById(`title-post${idx}`)
                      : document.getElementById("title-post")      
      if(commentIdx!=null && commentIdx>=0) {
        textarea = document.getElementById(`comment-post-${commentIdx}`)
        mytext = this.form.comments[commentIdx]
      }
      let cursorPosition = this.getInputSelection(textarea)
      if(cursorPosition.start == cursorPosition.end){
        let message = ' ' + mytext
        let indexStartSpace = message.lastIndexOfRegex(/[\]\n ]/g, cursorPosition.start)
        let indexEndSpace = message.indexOfRegex(/[\n ]/g, cursorPosition.start)
        indexEndSpace = indexEndSpace >= 0 ? indexEndSpace : message.length - 1 
        let indexStartMentions = message.indexOf(`${symbol}[`, indexStartSpace)
        let indexEndMentions = message.indexOf(']', indexStartMentions)
        let mentions = null
        //edit mentions
        if((indexStartMentions <= cursorPosition.start && indexEndMentions >= cursorPosition.start) 
              && (indexStartMentions >= 0 && indexStartMentions < indexEndSpace) 
              && indexStartMentions < indexEndMentions 
              && mytext.substr(cursorPosition.start - 1, 1) != "]" 
              && mytext.substr(cursorPosition.start - 2, 1) != "]"){
                return 'edit'
        }
        //add mentions
        else if(mytext.substr(cursorPosition.start - 1, 1) == symbol 
                  && mytext.substr(cursorPosition.start - 1, 2) != `${symbol}[` 
                  && (cursorPosition.start == 1 || mytext.substr(cursorPosition.start - 2, 1) == " ")) {
                    return 'add'
        }
      }
      return null
    },

    removeMentions(type='Mention', idx=null, commentIdx=null) {
      let mytext = idx !== null ? this.instagramTexts[idx].content : this.form.title;
      let textarea = idx !== null
                      ? document.getElementById(`title-post${idx}`)
                      : document.getElementById("title-post")
      if(commentIdx!=null && commentIdx>=0) {
        textarea = document.getElementById(`comment-post-${commentIdx}`)
        mytext = this.form.comments[commentIdx]
      }
      let cursorPosition = this.getInputSelection(textarea)
      
      if(this.previewEdited && this.previewEdited[type.toLowerCase()]) {
        let value = this.previewEdited[type.toLowerCase()].start + this.previewEdited[type.toLowerCase()].end
        this.editPostLive(this.previewEdited.page.id, this.previewEdited.commentId != null && this.previewEdited.commentId >= 0 ? 'comment' : 'title', value, null, this.previewEdited.commentId)
        // document.querySelector(`.vs-tooltip`).remove()
        this.closeAutoMentions()
      }
      else if(cursorPosition.start == cursorPosition.end){
        let symbol = type == 'Mention' ? '@' : '#'
        let message = ' ' + mytext
        let indexStartSpace = message.lastIndexOfRegex(/[\]\n ]/g, cursorPosition.start+1)
        let indexEndSpace = message.indexOfRegex(/[\n ]/g, cursorPosition.start+1)
        indexEndSpace = indexEndSpace >= 0 ? indexEndSpace : message.length - 1 
        let indexStartMentions = message.indexOf(`${symbol}[`, indexStartSpace)
        let indexEndMentions = message.indexOf(']', indexStartMentions)

        message = message.slice(0, indexStartSpace) + message.slice(indexEndMentions+1)

        if (idx) {
          this.instagramTexts[idx].content = message.slice(1)
        } else if(commentIdx!=null && commentIdx>=0) {
          this.form.comments[commentIdx] = message.slice(1)
        } else {
          this.form.title = message.slice(1)
        }

        // document.querySelector(`.vs-tooltip`).remove()

        this.closeAutoMentions()
      }
    },

    toggleShowMentions(type='Mention', idx=null, commentIdx=null) {
      if(type == 'Hashtag' && !this.activeSearchHashtags) return
      if(this[`openAuto${type}s`] || this[`openAuto${type}s`] === 0) this.closeAutoMentions()
      else this.addMention(type, idx, commentIdx)
    },

    editMention(type='MENTION', idx=null, commentIdx=null, message, indexStartMentions, indexEndMentions, index, preview=null) {
      
      let botsTMP = this.bots.filter(b => this.bot.includes(b.id) && ['facebook', 'instagram', 'linkedin', 'twitter', 'bluesky'].includes(b.page.network) && !(b.page.isGroup && b.page.network == 'facebook'))

      const getBotByNetwork = (network) => botsTMP.find(bot => bot.page.network == network)

      let bots = []
      if(getBotByNetwork('twitter')) bots.push(getBotByNetwork('twitter'))
      if(getBotByNetwork('facebook') && type == 'Mention') bots.push(getBotByNetwork('facebook'))
      if(getBotByNetwork('instagram')) bots.push(getBotByNetwork('instagram'))
      if(getBotByNetwork('linkedin') && type == 'Mention') bots.push(getBotByNetwork('linkedin'))
      if(getBotByNetwork('bluesky') && type == 'Mention') bots.push(getBotByNetwork('bluesky'))

      if(preview) {
        bots = bots.filter(b => b.page.network == preview.page.network)
        this.previewEdited = preview
      }

      //edit mentions
      let start = message.substr(0, indexStartMentions)
      let end = message.substr(indexEndMentions+1)
      let mentions = this[`valid${type}s`][index-1]
     
      const getMentionValue = (network) => {
        let mention = mentions.find(m => m.network == network)
        if(mention)
          return mention.value
        return null
      }

      const getMentionSearch = (network) => {
        if(mentions){
          let mention = mentions.find(m => m.network == network)
          if(mention)
            return mention.word
        }
        return null
      }

      let mentionsAdded = localStorage[`${type.toLowerCase()}sAdded`] ? JSON.parse(localStorage[`${type.toLowerCase()}sAdded`]) || [] : []

      this[`search${type}`] = bots.map((bot, idBot) => {
        let mentionsAddedExist = mentionsAdded[index-1] ? mentionsAdded[index-1].find(m => m.network == bot.page.network) : null
        let mentionsSelected  = mentionsAddedExist && (mentionsAddedExist.name || type == 'Hashtag') ? mentionsAddedExist : null

        return {
          bot,
          start,
          end,
          selected: mentionsSelected ? mentionsSelected : (mentions ? getMentionValue(bot.page.network) : null),
          search: mentions ? getMentionSearch(bot.page.network) : null,
          results: mentionsSelected ? (type == 'Mention' ? [mentionsSelected] : mentionsSelected) : null,
        }
      })
  
      // this[`openAuto${type}s`] = idx && idx >= 0 ? idx : true
      // this[`openAuto${type}s`] = (idx && idx >= 0) || (commentIdx && commentIdx >= 0) ? idx || commentIdx : true
      if(commentIdx!=null && commentIdx>=0)
        this[`openAuto${type}s`] = commentIdx
      else
        this[`openAuto${type}s`] = idx && idx >= 0 ? idx : true
      
      setTimeout(() => {
        let inputSearchMention = this.$refs.inputSearchMention || document.getElementById("storyMentionsInput")
        if (!inputSearchMention.focusInput) {
          inputSearchMention.focus();
        }
        else if(idx !== null && inputSearchMention)
          inputSearchMention.focusInput()
        else if(this.$refs.inputSearchMention)
          inputSearchMention.focusInput()
      }, 100)
      
    },

    addMention(type='Mention', idx=null, commentIdx=null, preview=null) {
      let selected, end, start
      if (type === "Music") {
        selected = '';
      } else {
        let mytext = idx !== null ? this.instagramTexts[idx].content : this.form.title;
        let textarea = idx !== null
                        ? document.getElementById(`title-post${idx}`)
                        : document.getElementById("title-post")
        if(commentIdx!=null && commentIdx>=0) {
          textarea = document.getElementById(`comment-post-${commentIdx}`)
          mytext = this.form.comments[commentIdx]
        }
        let cursorPosition = this.getInputSelection(textarea);
        start = mytext.substring(0, cursorPosition.start)
        end = mytext.substring(cursorPosition.end)

        selected = mytext.substring(cursorPosition.start, cursorPosition.end)
      }

      let botsTMP = this.bots.filter(b => this.bot.includes(b.id) && ['facebook', 'instagram', 'linkedin', 'twitter', 'bluesky'].includes(b.page.network) && !(b.page.isGroup && b.page.network == 'facebook'))

      const getBotByNetwork = (network) => botsTMP.find(bot => bot.page.network == network)

      let bots = []
      if(getBotByNetwork('twitter') && type !== 'Location' && type !== 'Music') bots.push(getBotByNetwork('twitter'))
      if(getBotByNetwork('facebook') && (type == 'Mention' || type == 'Location')) bots.push(getBotByNetwork('facebook'))
      if(getBotByNetwork('instagram')) bots.push(getBotByNetwork('instagram'))
      if(getBotByNetwork('linkedin') && type == 'Mention') bots.push(getBotByNetwork('linkedin'))
      if(getBotByNetwork('bluesky') && type == 'Mention') bots.push(getBotByNetwork('bluesky'))

      if(preview) {
        bots = bots.filter(b => b.page.network == preview.page.network)
        this.previewEdited = preview
        selected = preview[type.toLowerCase()].selected
      }

      //edit mentions
      let mentions = null

      const getMentionValue = (network) => {
        let mention = mentions.find(m => m.network == network)
        if(mention)
          switch(mention.network){
            case 'twitter':
            case 'insatgram':
              return mention.value
            case 'facebook':
            case 'linkedin':
              return mention.value ? mention.value.substring(2, mention.value.indexOf('(')) : null
          }
        return null
      }

      const getMentionSearch = (network) => {
        if(mentions){
          let mention = mentions.find(m => m.network == network)
          if(mention)
            return mention.word
        }
        return null
      }


      this[`search${type}`] = bots.map(bot => {
        return {
          bot,
          start,
          end,
          selected: mentions ? getMentionValue(bot.page.network) : null,
          search: mentions ? getMentionValue(bot.page.network) : ((['facebook', 'twitter'].includes(bot.page.network) || (bot.page.network === 'linkedin' && bot.page.story_config && bot.page.story_config.created) || (bot.page.network === 'instagram' && bot.page.story_config && bot.page.story_config.created)) ? selected : getMentionSearch(bot.page.network)),
          results: null,
        }
      })
      console.log(this[`search${type}`]);
  
      console.log(type, this[`openAuto${type}s`], idx)
      if(commentIdx!=null && commentIdx>=0)
        this[`openAuto${type}s`] = commentIdx
      else
        this[`openAuto${type}s`] = idx !== null && idx >= 0 ? idx : true
      console.log(type, this[`openAuto${type}s`], idx)
      this.searchMentions(type)

      if (type !== "Music") {
        setTimeout(() => {
          let inputSearchMention = this.$refs.inputSearchMention || document.getElementById("storyMentionsInput")
          if (!inputSearchMention.focusInput) {
            inputSearchMention.focus();
          }
          else if(idx !== null && inputSearchMention)
            inputSearchMention.focusInput()
          else if(inputSearchMention)
            inputSearchMention.focusInput()
        }, 100)
      } else {
        this.$nextTick(() => {
          this.$vs.loading({
            container: this.$refs["loadableContent-list-music"],
          })
          let myId = this.searchMusic[this.selectedBotMusic].bot.id
          let network = this.searchMusic[this.selectedBotMusic].bot.page.network
          this.getMusicTrendByApi(this.searchMusic[this.selectedBotMusic].bot.page.id).then(res => {
            this.$vs.loading.close(this.$refs["loadableContent-list-music"]);
                  this[`searchMusic`][this[`selectedBotMusic`]].results = []
                  if (res.body.error
                          && (!this.lastNotif.text || res.body.lock || (this.lastNotif.text 
                                && this.lastNotif.text == res.body.error
                                && moment(this.lastNotif.date).isBefore(moment())))) {
                    if (res.body.error === 'dash.story.account.locked' && res.body.lock) {
                      this.notify({
                        title:'Erreur',
                        text: this.$t(res.body.error) + new Date(res.body.lock).toLocaleString(),
                        color:'danger',
                        time: 10000,
                        id: 'repeat'
                      })
                    } else {
                      this.notify({
                        title:'Erreur',
                        text: this.$t(res.body.error),
                        color:'danger',
                        time: 10000,
                        id: this[`search${type}`][this[`selectedBot${type}`]].bot.page.id
                      }, {
                        component: "PostsOverlay",
                        action: `search${type}`,
                        params: {
                          page: this[`search${type}`][this[`selectedBot${type}`]].bot.page.name,
                          network: this[`search${type}`][this[`selectedBot${type}`]].bot.page.network,
                          type: type,
                        }
                      })
                    }
                    this.lastNotif = {
                      text: res.body.error,
                      date: moment().add(20, 'seconds')
                    }

                    if (res.body.disconnectDirect) {
                      this.bots.find(e => e.id === myId).page.story_config = null
                      if (network === 'instagram') {
                        this.linked.find(e => e.id === this[`search${type}`][this[`selectedBot${type}`]].bot.page.id).story_config = null
                      }
                      this.$forceUpdate()
                    }
                  }
            this.searchMusic[this.selectedBotMusic].results = res.body.musics;
          })
        })
      }
    },

    changeMentionNetwork(type='Mention', index) {
      this[`selectedBot${type}`] = index

      if(type == 'Mention' && ['linkedin', 'instagram'].includes(this[`searchMention`][this[`selectedBotMention`]].bot.page.network)) { 
        let storyConf = this[`searchMention`][this[`selectedBotMention`]].bot.page.story_config;   
        // eslint-disable-next-line no-useless-escape
        const urlRegex = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
        const isUrl = urlRegex.test(this[`searchMention`][this[`selectedBotMention`]].search);
        if(!storyConf || !storyConf.created || (!storyConf.cookies && !storyConf.session_state)) {
          if(!isUrl)
            this[`searchMention`][this[`selectedBotMention`]].search = ''
          if(isUrl && (
                this[`searchMention`][this[`selectedBotMention`]].bot.page.network == 'linkedin' && !this[`searchMention`][this[`selectedBotMention`]].search.includes('linkedin.com/company/')
                || this[`searchMention`][this[`selectedBotMention`]].bot.page.network == 'instagram' && !this[`searchMention`][this[`selectedBotMention`]].search.includes('instagram.com/')
              )
            )
            this[`searchMention`][this[`selectedBotMention`]].search = ''
        }
        
      }
      
      if(!this[`search${type}`][this[`selectedBot${type}`]].selected || (this[`search${type}`][this[`selectedBot${type}`]].search && this[`search${type}`][this[`selectedBot${type}`]].results.length == 0)){
        this.searchMentions(type, true)
      }
    },

    selectMention(type='Mention', mention) {
      if(type == 'Mention' || type == 'Location' || type == 'Music')
        this[`search${type}`][this[`selectedBot${type}`]].selected = this.mentionIsSelected(type, mention) == true ? null : mention
      else {
        if(!Array.isArray(this.searchHashtag[this.selectedBotHashtag].selected))
          this.searchHashtag[this.selectedBotHashtag].selected = []
        if(this.searchHashtag[this.selectedBotHashtag].selected.findIndex(s => s.hashtag == mention.hashtag) >= 0)
          this.searchHashtag[this.selectedBotHashtag].selected = this.searchHashtag[this.selectedBotHashtag].selected.filter(s => s.hashtag != mention.hashtag)
        else
          this.searchHashtag[this.selectedBotHashtag].selected.push(mention)
      }

    },
    
    mentionIsSelected(type='Mention', mention) {
      if(type == 'Music'){
        if (this.searchMusic[this.selectedBotMusic].selected) {
          return this.searchMusic[this.selectedBotMusic].selected.track.id === mention.track.id
        }
        else return 'show'
      }
      if(type == 'Location'){
        if(this.searchLocation[this.selectedBotLocation].selected && this.searchLocation[this.selectedBotLocation].selected.length)
          return !!this.searchLocation[this.selectedBotLocation].selected.find(s => s.location == mention.location)
        else if(this.searchLocation[this.selectedBotLocation].selected && typeof this.searchLocation[this.selectedBotLocation].selected === 'object'){
          return this.searchLocation[this.selectedBotLocation].selected.id === mention.id
        }
        else return 'show'
      }
      if(type == 'Hashtag'){
        if (this.searchHashtag[this.selectedBotHashtag].selected && Array.isArray(this.searchHashtag[this.selectedBotHashtag].selected) && this.searchHashtag[this.selectedBotHashtag].selected.length === 0 && this.searchHashtag[this.selectedBotHashtag].results && (!this.searchHashtag[this.selectedBotHashtag].results.length || this.searchHashtag[this.selectedBotHashtag].results.length < 2)) {
          console.log("REFRESH");
          this.searchMentions(type);
        }
        if(this.searchHashtag[this.selectedBotHashtag].selected && this.searchHashtag[this.selectedBotHashtag].selected.length)
          return !!this.searchHashtag[this.selectedBotHashtag].selected.find(s => s.hashtag == mention.hashtag)
        else if(this.searchHashtag[this.selectedBotHashtag].selected && typeof this.searchHashtag[this.selectedBotHashtag].selected === 'object'){
          return !!Object.values(this.searchHashtag[this.selectedBotHashtag].selected).filter(h => h.hashtag).find(s => s.hashtag == mention.hashtag)
        } 
        else return 'show'
      }


      if(type == 'Hashtag'){
        // if(this.searchHashtag[this.selectedBotHashtag].selected && this.searchHashtag[this.selectedBotHashtag].selected.length)
        // console.log(this.searchHashtag[this.selectedBotHashtag].selected.find(s => s.hashtag == mention.hashtag))
        if(this.searchHashtag && this.searchHashtag.length)
          return !!this.searchHashtag.find(s => s.hashtag == mention.hashtag)
        else return 'show'
      }


      
      if(this.searchMention[this.selectedBotMention].selected && this.searchMention[this.selectedBotMention].selected.id)
        return this.searchMention[this.selectedBotMention].selected.id == mention.id
      else if(this.searchMention[this.selectedBotMention].bot.page.network == 'instagram' 
                && this.searchMention[this.selectedBotMention].selected && this.searchMention[this.selectedBotMention].selected.name)
        return this.searchMention[this.selectedBotMention].selected.name == mention.name
      else return 'show'
    },

    validateMentions(type='Mention', idx = null, commentIdx=null){

      if(!this[`search${type}`].find(m => m.selected))
        return this.toggleShowMentions(type, idx, commentIdx)

      let textarea = idx !== null 
                        ? document.getElementById(`title-post${idx}`) 
                        : document.getElementById("title-post")
      let formTitle = idx !== null 
                        ? this.instagramTexts[idx].content 
                        : this.form.title

      if(commentIdx!=null && commentIdx>=0) {
        textarea = document.getElementById(`comment-post-${commentIdx}`)
        formTitle = this.form.comments[commentIdx]
      }

      let cursorPosition = this.getInputSelection(textarea);
      let start = formTitle.substring(0, cursorPosition.start)
      let end = formTitle.substring(cursorPosition.end)

      let mentionsNetwork = []
      let wordToSearch = this[`search${type}`].find(m => !!m.search)
      if(wordToSearch) {
        this[`search${type}`].forEach(mention => {
          if(type == 'Hashtag') {
            if (mention.selected && typeof mention.selected === 'object' && !mention.selected.length && mention.selected['0']) {
              mention.selected = [mention.selected['0']];
            }
            if(mention.selected && mention.selected.length) {
              mentionsNetwork.push({
                network: mention.bot.page.network, 
                value: `#${mention.selected.map(s => s.hashtag).join(' #')}`,
                word: mention.search && mention.search != '' ? mention.search : wordToSearch.search
              })
            }
            else
              mentionsNetwork.push({
                network: mention.bot.page.network, 
                value: mention.selected,
                word: mention.search && mention.search != '' ? mention.search : wordToSearch.search
              }) 
          }
          else if(type == 'Mention') {
            if(mention.selected && (mention.selected.screen_name || mention.selected.name || (mention.bot.page.network == 'instagram' && mention.selected.id))) {
              switch(mention.bot.page.network){
                case 'facebook':
                case 'linkedin':
                  mentionsNetwork.push({
                    network: mention.bot.page.network, 
                    value: mention.selected.name && mention.selected.id ? `@[${mention.selected.name} (${mention.selected.id})]` : '',
                    word: mention.search && mention.search != '' ? mention.search : wordToSearch.search
                  }) 
                  break
                case 'twitter':
                case 'instagram':
                  if (mention.selected.id) {
                    mentionsNetwork.push({
                      network: mention.bot.page.network, 
                      value: mention.selected.screen_name || mention.selected.id ? `@${mention.bot.page.network == 'twitter' ? mention.selected.screen_name : mention.selected.id}` : '',
                      word: mention.search && mention.search != '' ? mention.search : wordToSearch.search
                    })
                  } else {
                    mentionsNetwork.push({
                      network: mention.bot.page.network, 
                      value: mention.selected.screen_name || mention.selected.name ? `@${mention.bot.page.network == 'twitter' ? mention.selected.screen_name : mention.selected.name}` : '',
                      word: mention.search && mention.search != '' ? mention.search : wordToSearch.search
                    })
                  }
                  
                  break
                case 'bluesky':
                  mentionsNetwork.push({
                    network: mention.bot.page.network, 
                    value: `@${mention.selected.subtitle}`,
                    word: mention.search && mention.search != '' ? mention.search : wordToSearch.search
                  })
                  break
                default:
              }
            }
            else
              mentionsNetwork.push({
                network: mention.bot.page.network, 
                value: mention.selected,
                word: mention.search && mention.search != '' ? mention.search : wordToSearch.search
              }) 
          }
        })
      }
      
      if(mentionsNetwork.length > 0){

        if(this.previewEdited && this.previewEdited[type.toLowerCase()]) {
          let mentionsAdded = localStorage[`${type.toLowerCase()}sAdded`] ? JSON.parse(localStorage[`${type.toLowerCase()}sAdded`]) || [] : []
          if(this.previewEdited[type.toLowerCase()].edit) {
            let indexMention = this[`valid${type}s`][this.previewEdited[type.toLowerCase()].index-1].findIndex(m => m.network == this.previewEdited.page.network)
            if(indexMention >= 0) this[`valid${type}s`][this.previewEdited[type.toLowerCase()].index-1][indexMention] = mentionsNetwork[0]
            else this[`valid${type}s`][this.previewEdited[type.toLowerCase()].index-1].push(mentionsNetwork[0])
            mentionsAdded[this.previewEdited[type.toLowerCase()].index-1] = this[`search${type}`].map(m => {
              return { ...m.selected, network: m.bot.page.network}
            })
          }
          else {
            this[`valid${type}s`].push(mentionsNetwork)
            mentionsAdded.push(this[`search${type}`].map(m => {
              return { ...m.selected, network: m.bot.page.network}
            }))
            let value = this.previewEdited[type.toLowerCase()].start + ` ${type == 'Mention' ? '@[MENTIONS-' : '#[HASHTAGS-'}${this[`valid${type}s`].length}]` + this.previewEdited[type.toLowerCase()].end
            this.editPostLive(this.previewEdited.page.id, this.previewEdited.commentId != null && this.previewEdited.commentId >= 0 ? 'comment' : 'title', value, null, this.previewEdited.commentId)
          }
          localStorage.setItem(`${type.toLowerCase()}sAdded`, JSON.stringify(mentionsAdded))
          
          this.toggleShowMentions(type, idx, commentIdx)
          this.previewEdited = null
          return
        }

        let mytext = idx !== null ? this.instagramTexts[idx].content : this.form.title;
        if(commentIdx!=null && commentIdx>=0) 
          mytext = this.form.comments[commentIdx]
        
        //check if edit mentions
        let mentionToAdd
        let message = ' ' + mytext
        let indexStartSpace = message.lastIndexOfRegex(/[\]\n ]/g, cursorPosition.start)
        let indexEndSpace = message.indexOfRegex(/[\n ]/g, cursorPosition.start)
        indexEndSpace = indexEndSpace >= 0 ? indexEndSpace : message.length - 1 
        let indexStartMentions = message.indexOf('@[', indexStartSpace)
        let indexEndMentions = message.indexOf(']', indexStartMentions)
        let indexStartHashtags = message.indexOf(`#[`, indexStartSpace)
        let indexEndHashtags = message.indexOf(']', indexStartHashtags)

        // edit mention
        if(cursorPosition.start == cursorPosition.end && (indexStartMentions >= 0 && indexStartMentions < indexEndSpace) && indexStartMentions < indexEndMentions && mytext.substr(cursorPosition.start - 1, 1) != "]"){
          start = message.substr(0, indexStartMentions)
          end = message.substr(indexEndMentions+1)
          let index = parseInt(message.substr(indexStartMentions, indexEndMentions+2).replace('@[MENTIONS-', '').replace(']', ''))
          this.validMentions[index-1] = mentionsNetwork
          mentionToAdd = mentionsNetwork.length == 0 ? '' : `@[MENTIONS-${index}]`

          let mentionsAdded = localStorage.mentionsAdded ? JSON.parse(localStorage.mentionsAdded) || [] : []
          mentionsAdded[index-1] = this.searchMention.map(m => {
            return { ...m.selected, network: m.bot.page.network}
          })
          localStorage.setItem('mentionsAdded', JSON.stringify(mentionsAdded))
        }
        //add mention
        else if((mytext.substr(cursorPosition.start - 1, 1) == `@` 
                && mytext.substr(cursorPosition.start - 1, 2) != `@[` 
                && (cursorPosition.start == 1 || [" ", "\n"].includes(mytext.substr(cursorPosition.start - 2, 1))))
                || type == 'Mention') {  
          let addSpace = message.substr(cursorPosition.start, cursorPosition.end - cursorPosition.start + 1).slice(-1) == " " ? " " : ""

          this.validMentions.push(mentionsNetwork)
          mentionToAdd = mentionsNetwork.length == 0 ? '' : `@[MENTIONS-${this.validMentions.length}]${addSpace}`

          let mentionsAdded = localStorage.mentionsAdded ? JSON.parse(localStorage.mentionsAdded) || [] : []
          mentionsAdded.push(this.searchMention.map(m => {
            return { ...m.selected, network: m.bot.page.network}
          }))
          localStorage.setItem('mentionsAdded', JSON.stringify(mentionsAdded))
        }
        //edit hashtag
        else if(cursorPosition.start == cursorPosition.end 
                  && (indexStartHashtags >= 0 && indexStartHashtags < indexEndSpace)
                  && indexStartHashtags < indexEndHashtags 
                  && mytext.substr(cursorPosition.start - 1, 1) != "]"
                  && indexStartHashtags <= cursorPosition.start && cursorPosition.start <= indexEndHashtags){
          start = message.substr(0, indexStartHashtags)
          end = message.substr(indexEndHashtags+1)
          let index = parseInt(message.substr(indexStartHashtags, indexEndHashtags+2).replace('#[HASHTAGS-', '').replace(']', ''))
          this.validHashtags[index-1] = mentionsNetwork
          mentionToAdd = mentionsNetwork.length == 0 ? '' : `#[HASHTAGS-${index}]`

          let mentionsAdded = localStorage.hashtagsAdded ? JSON.parse(localStorage.hashtagsAdded) || [] : []
          mentionsAdded[index-1] = this.searchHashtag.map(m => {
            return { ...m.selected, network: m.bot.page.network}
          })
          localStorage.setItem('hashtagsAdded', JSON.stringify(mentionsAdded))
        }
        //add hashtag
        else if((mytext.substr(cursorPosition.start - 1, 1) == `#` 
                && mytext.substr(cursorPosition.start - 1, 2) != `#[` 
                && (cursorPosition.start == 1 || [" ", "\n"].includes(mytext.substr(cursorPosition.start - 2, 1))))
                || type == 'Hashtag') {
          let addSpace = message.substr(cursorPosition.start, cursorPosition.end - cursorPosition.start + 1).slice(-1) == " " ? " " : ""

          this.validHashtags.push(mentionsNetwork)
          mentionToAdd = mentionsNetwork.length == 0 ? '' : `#[HASHTAGS-${this.validHashtags.length}]${addSpace}`

          let mentionsAdded = localStorage.hashtagsAdded ? JSON.parse(localStorage.hashtagsAdded) || [] : []
          mentionsAdded.push(this.searchHashtag.map(m => {
            return { ...m.selected, network: m.bot.page.network}
          }))
          localStorage.setItem('hashtagsAdded', JSON.stringify(mentionsAdded))
        }
        
        if(commentIdx!=null && commentIdx>=0){
          this.form.comments[commentIdx] = start + end
          this.form.comments[commentIdx] = start + mentionToAdd + end
          this.form.comments[commentIdx] = this.form.comments[commentIdx].replace("@@", "@").replace("##", "#")
        }
        else {
          //force update preview and save
          if (idx !== null) {
            this.instagramTexts[idx].content = start + end;
            this.instagramTexts[idx].content = start + mentionToAdd + end;
            this.instagramTexts[idx].content = this.instagramTexts[idx].content.replace("@@", "@").replace("##", "#")
            this.instagramTexts[idx].content = this.instagramTexts[idx].content.trim()
          }
          this.form.title = start + end
          this.form.title = start + mentionToAdd + end
          this.form.title = this.form.title.replace("@@", "@").replace("##", "#")
        }

        if (cursorPosition.start !== cursorPosition.end) {
          this.editPostValue = this.editPostValue.map(e => {
            if(e.title)
              e.title = e.title.replace(`${wordToSearch.search}`, mentionToAdd);
            return e;
          })
        }
      }

      this.toggleShowMentions(type, idx, commentIdx)
    },

    toggleEmojiPicker (e, idx, commentIdx) {
      console.log('toggleEmojiPicker',idx, commentIdx)
      if (idx === undefined && commentIdx === undefined) {
        this.showEmojiPicker = !this.showEmojiPicker
      } else if (commentIdx >= 0) {
        this.showEmojiPickerComment = commentIdx
      } else {
        this.showEmojiPickerInstagram = idx
      }
      
    },
    hideEmojiPicker(e) {
      console.log('hideEmojiPicker')
      if(e.target.tagName == 'TEXTAREA' || (e.target.tagName == 'SPAN' && e.target.className.includes("add-mention"))) return 
      this.showEmojiPicker = false
      this.showEmojiPickerInstagram = -1

      // this.closeAutoMentions()
    },
    hideEmojiPickerComment(e) {
      console.log('hideEmojiPickerComment')
      this.showEmojiPickerComment = -1
    },

    addEmoji (emoji, idx, commentIdx) {
      console.log('addEmoji', emoji, idx, commentIdx)
      let textarea = idx !== undefined ? document.getElementById(`title-post${idx}`) : document.getElementById("title-post");
      if(commentIdx!=null && commentIdx>=0)
        textarea = document.getElementById(`comment-post-${commentIdx}`)
      const cursorPosition = this.getInputSelection(textarea);
      // let start = idx !== undefined 
      let start = idx !== undefined && idx !== null && idx >= 0
                      ? this.instagramTexts[idx].content.substring(0, cursorPosition.start) 
                      : (commentIdx !== undefined && commentIdx !== null && commentIdx >= 0
                            ? this.form.comments[commentIdx].substring(0, cursorPosition.start)
                            : this.form.title.substring(0, cursorPosition.start))
      // let end = idx !== undefined 
      let end = idx !== undefined && idx !== null && idx >= 0 
                      ? this.instagramTexts[idx].content.substring(cursorPosition.end) 
                      : (commentIdx !== undefined && commentIdx !== null && commentIdx >= 0
                            ? this.form.comments[commentIdx].substring(cursorPosition.end)
                            : this.form.title.substring(cursorPosition.end))
      
      // if (idx !== undefined) {
      if(idx !== undefined && idx !== null && idx >= 0) {
        this.instagramTexts[idx].content = start + emoji.native + end
      } else if(commentIdx !== undefined && commentIdx !== null && commentIdx >= 0) {
        // start = this.form.comments[commentIdx].substring(0, cursorPosition.start)
        // end = this.form.comments[commentIdx].substring(cursorPosition.end)
        this.form.comments[commentIdx] = start + emoji.native + end
      } else {
        this.form.title = start + emoji.native + end
      }
      textarea.focus()
      this.$nextTick(() => {
        textarea.selectionStart = (start + emoji.native).length
        textarea.selectionEnd = (start + emoji.native).length
      });
      commentIdx !== undefined && commentIdx !== null && commentIdx >= 0 ? this.hideEmojiPickerComment() : this.hideEmojiPicker()
    },

    /**
     * Return an 
     * @param {DOMElement} el A dom element of a textarea or input text.
     * @return {Object} reference Object with 2 properties (start and end) with the identifier of the location of the cursor and selected text.
     **/
    getInputSelection(el) {
      console.log(el);
      if (el === null) {
        return {start: 0, end: 0}
      }
      var start = 0, end = 0, normalizedValue, range,
      textInputRange, len, endRange;

      if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
          start = el.selectionStart;
          end = el.selectionEnd;
      } else {
          range = document.selection.createRange();

          if (range && range.parentElement() == el) {
              len = el.value.length;
              normalizedValue = el.value.replace(/\r\n/g, "\n");

              // Create a working TextRange that lives only in the input
              textInputRange = el.createTextRange();
              textInputRange.moveToBookmark(range.getBookmark());

              // Check if the start and end of the selection are at the very end
              // of the input, since moveStart/moveEnd doesn't return what we want
              // in those cases
              endRange = el.createTextRange();
              endRange.collapse(false);

              if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
                  start = end = len;
              } else {
                  start = -textInputRange.moveStart("character", -len);
                  start += normalizedValue.slice(0, start).split("\n").length - 1;

                  if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
                      end = len;
                  } else {
                      end = -textInputRange.moveEnd("character", -len);
                      end += normalizedValue.slice(0, end).split("\n").length - 1;
                  }
              }
          }
      }

      return {
          start: start,
          end: end
      };
  },

    getHostName(url){
      return new URL(url).hostname
    },

    switchInterface() {
        this.close()
        localStorage.setItem('version_', 'beta')
        this.$router.push({
            name: 'postCreator',
        })
    }
  }
}
</script>

<style scoped>

.styles-text-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 10px;
  left: 40%;
  flex-direction: row;
}

.styles-text-buttons > span {
  position: static;
  width: 30px;
  margin-right: 3px;
}

.textarea-emoji-picker {
  position: relative;
  margin: 0 auto;
  clear: both;
}
.textarea {
  width: 100%;
  min-height: 300px;
  outline: none;
  box-shadow: none;
  padding: 10px 28px 10px 10px;
  font-size: 15px;
  border: 1px solid #BABABA;
  color: #333;
  border-radius: 2px;
  box-shadow: 0px 2px 4px 0 rgba(0,0,0,0.1) inset;
  resize: vertical;
}
.emoji-mart {
  position: absolute;
  top: 0px;
  right: calc(-100% + 45px);
  z-index: 11;
  right: -355px;
}
.emoji-trigger {
  position: absolute;
  bottom: 10px;
  right: 20px;
  cursor: pointer;
  height: 20px;
  z-index: 1;
}
.emoji-trigger path {
  transition: 0.1s all;
}
.emoji-trigger {
  background: #fff;
  border-radius: 7px;
  width: 33px;
  height: 33px;
  padding: 6px 5px;
}
.emoji-trigger:hover,
.emoji-trigger.triggered {
  background: #6a1f4c;
}
.emoji-trigger path {
  fill: #6a1f4c;
}
.emoji-trigger:hover path,
.emoji-trigger.triggered path {
  fill: #fff;
}
</style>
